(function() {
  angular.module('stock', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap', 'ui.bootstrap.tooltip', 'ui.bootstrap.modal', 'toastr', 'pouchdb', 'ui.grid', 'ui.grid.selection', 'ui.grid.resizeColumns', 'ui.grid.saveState', 'ui.grid.cellNav', 'ui.grid.edit', 'ui.grid.moveColumns', 'ui.grid.pagination', 'ui.grid.autoResize', 'mgo-angular-wizard', 'ngDropzone', 'angular-md5', 'ngStorage', 'barcodeListener', 'cfp.hotkeys', 'angularMoment', 'base64', 'ui.select', 'angular-storage', 'ngImgCrop', 'flow', 'angular-loading-bar', 'ui.mask', 'angular-js-xlsx', 'xeditable']);

}).call(this);

(function() {
  angular.module('stock').controller('InsuranceCompanyController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirUnitController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirServiceCategoryController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirServiceController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
    vm.dirUnits = [];
    vm.dirServiceCategories = [];
    RequestService.post('dictionarya.listing', {
      type: 'DirServiceCategory'
    }).then(function(response) {
      vm.dirServiceCategories = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirUnit'
    }).then(function(response) {
      vm.dirUnits = response.docs;
    }, function(response) {
      console.log(response);
    });
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirReportCategoriesController', function($scope, RequestService, toastr) {
    var vm;
    vm = this;
    vm.dirReportCategories = [];
    RequestService.post('reporta.category_listing', {}).then(function(response) {
      vm.dirReportCategories = response.docs;
    });
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirRelativeDegreeController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirProductAController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirPolicyaStatusController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirOrganizationController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirInsuranceProgrammeController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirDoctorController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirDiagnosisController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ClientCompanyController', function($scope, toastr, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ServiceController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ReportCategoryController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('InsurancetypesController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('IndustryController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('FactorsController', function($scope, RequestService) {
    'ngInject';
    var addValue, deleteValue, vm;
    vm = this;
    vm.value = '';
    addValue = function() {
      if ($scope.edit.dictionary.values === null || $scope.edit.dictionary.values === void 0) {
        $scope.edit.dictionary.values = [];
      } else {
        if ($scope.edit.dictionary.values.includes(vm.value)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      $scope.edit.dictionary.values.push(vm.value);
      vm.value = '';
    };
    deleteValue = function(index) {
      $scope.edit.dictionary.values.splice(index, 1);
    };
    vm.addValue = addValue;
    vm.deleteValue = deleteValue;
  });

}).call(this);

(function() {
  angular.module('stock').controller('EnumController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DirReportCategoriesController', function($scope, RequestService, toastr) {
    var vm;
    vm = this;
    vm.dirReportCategories = [];
    RequestService.post('reporta.category_listing', {}).then(function(response) {
      vm.dirReportCategories = response.docs;
    });
  });

}).call(this);

(function() {
  angular.module('stock').controller('CurrencyController', function($scope) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('CountriesController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('AssistanceController', function($scope, RequestService) {
    'ngInject';
    var addAddress, addEmail, addPhone, addWebsite, deleteAddress, deleteEmail, deletePhone, deleteWebsite, vm;
    vm = this;
    vm.address = '';
    if ($scope.edit.dictionary.services_id === null || $scope.edit.dictionary.services_id === void 0) {
      $scope.edit.dictionary.services_id = [];
    }
    addAddress = function() {
      if ($scope.edit.dictionary.data === null || $scope.edit.dictionary.data === void 0) {
        $scope.edit.dictionary.data = {};
        $scope.edit.dictionary.data.addresses = [];
      }
      if ($scope.edit.dictionary.data.addresses === null || $scope.edit.dictionary.data.addresses === void 0) {
        $scope.edit.dictionary.data.addresses = [];
      } else {
        if ($scope.edit.dictionary.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      $scope.edit.dictionary.data.addresses.push(vm.address);
      vm.address = '';
    };
    deleteAddress = function(index) {
      $scope.edit.dictionary.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if ($scope.edit.dictionary.data === null || $scope.edit.dictionary.data === void 0) {
        $scope.edit.dictionary.data = {};
        $scope.edit.dictionary.data.email = [];
      }
      if ($scope.edit.dictionary.data.email === null || $scope.edit.dictionary.data.email === void 0) {
        $scope.edit.dictionary.data.email = [];
      } else {
        if ($scope.edit.dictionary.data.email.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      $scope.edit.dictionary.data.email.push(vm.email);
      vm.email = '';
    };
    deleteEmail = function(index) {
      $scope.edit.dictionary.data.email.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if ($scope.edit.dictionary.data === null || $scope.edit.dictionary.data === void 0) {
        $scope.edit.dictionary.data = {};
        $scope.edit.dictionary.data.website = [];
      }
      if ($scope.edit.dictionary.data.website === null || $scope.edit.dictionary.data.website === void 0) {
        $scope.edit.dictionary.data.website = [];
      } else {
        if ($scope.edit.dictionary.data.website.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      $scope.edit.dictionary.data.website.push(vm.website);
      vm.website = '';
    };
    deleteWebsite = function(index) {
      $scope.edit.dictionary.data.website.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if ($scope.edit.dictionary.data === null || $scope.edit.dictionary.data === void 0) {
        $scope.edit.dictionary.data = {};
        $scope.edit.dictionary.data.phone = [];
      }
      if ($scope.edit.dictionary.data.phone === null || $scope.edit.dictionary.data.phone === void 0) {
        $scope.edit.dictionary.data.phone = [];
      } else {
        if ($scope.edit.dictionary.data.phone.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      $scope.edit.dictionary.data.phone.push(vm.phone);
      vm.phone = '';
    };
    deletePhone = function(index) {
      $scope.edit.dictionary.data.phone.splice(index, 1);
    };
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
  });

}).call(this);

(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('stock').controller('FileLoadController', function($scope, $rootScope, RequestService, flowFactory, $base64, Session, toastr) {
    'ngInject';
    var getFileSize, initFlow, rmFile, vm;
    vm = this;
    vm.api = $rootScope.api;
    initFlow = function() {
      var auth_token, company, companyID, companyName;
      company = Session.getCompany() || {};
      companyName = company.name ? company.name : 'unknown';
      companyID = company._id ? company._id : 'unknown';
      auth_token = 'Basic ' + $base64.encode('web' + ':' + Session.getToken());
      vm.flow = flowFactory.create({
        target: $rootScope.api + 'upload/' + companyName + '/' + companyID,
        singleFile: true,
        headers: {
          Authorization: auth_token
        },
        withCredentials: true,
        testChunks: false
      });
      vm.flow.on('fileAdded', function(file, event) {
        var allowedFiles, ext;
        allowedFiles = $scope.allow.split(',');
        ext = file.getExtension();
        if (indexOf.call(allowedFiles, ext) < 0) {
          toastr.warning('Выберите файл ' + $scope.allow);
          event.preventDefault();
          return false;
        }
        if (file.size > 15 * 1024 * 1024) {
          toastr.warning('Файл слишком большой');
          event.preventDefault();
          return false;
        }
      });
      vm.flow.on('filesSubmitted', function(array, event) {
        if (array.length > 0) {
          vm.flow.upload();
        }
      });
      vm.flow.on('complete', function() {
        vm.flow.files.clear();
      });
      vm.flow.on('fileSuccess', function(file, message, chunk) {
        $scope.fileSrc = message;
      });
      return vm.flow.on('error', function(message, file, chunk) {
        console.log(message, file, chunk);
      });
    };
    initFlow();
    getFileSize = function() {
      RequestService.post('doc_templates.file_size', {
        bobject: $scope.fileSrc
      }).then(function(result) {
        if (vm.file) {
          return vm.file.size = result.bobject;
        }
      });
    };
    $scope.$watch('fileSrc', function(newVal) {
      if (newVal && newVal.lastIndexOf('/') > -1) {
        vm.file = {
          name: newVal.substring(1 + newVal.lastIndexOf('/')),
          size: 0
        };
        getFileSize();
      } else {
        delete vm.file;
      }
    });
    rmFile = function() {
      vm.flow.files.clear();
      delete $scope.fileSrc;
      delete vm.file;
    };
    vm.rmFile = rmFile;
  }).directive('fileLoad', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        fileSrc: '=',
        type: '@',
        allow: '@'
      },
      controller: 'FileLoadController',
      controllerAs: 'file',
      templateUrl: 'app/components/fileLoad/file-load.html'
    };
  }).directive('fileLink', function($rootScope) {
    return {
      restrict: 'A',
      scope: {
        fileLink: '@'
      },
      link: function(scope, elem, attr) {
        attr.$observe('fileLink', function(val) {
          if (!angular.isEmpty(val)) {
            scope.file_link = $rootScope.api + val;
            return scope.file_name = val && val.length > 0 ? val.substring(val.lastIndexOf('/') + 1) : '';
          }
        });
      },
      templateUrl: 'app/components/fileLoad/file-link.html'
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('UsersController', function(RequestService, product_types, $scope, $uibModal, toastr) {
    'ngInject';
    var editUser, getUsers, newUser, removeUser, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 20;
    vm.usersGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'username',
          displayName: 'Имя'
        }, {
          name: 'email',
          displayName: 'Емайл'
        }, {
          name: 'role',
          displayName: 'Важность'
        }, {
          name: 'rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "username") {
          filter.filter.username = v;
        }
        if (k === "email") {
          filter.filter.email = v;
        }
        if (k === "surname") {
          filter.filter.data.surname = v;
        }
        if (k === "name") {
          filter.filter.data.name = v;
        }
        if (k === "patronymic") {
          filter.filter.data.patronymic = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      RequestService.post('user.listing', filter).then(function(result) {
        vm.usersGridOptions.data = result.users;
        vm.usersGridOptions.totalItems = result.count;
        console.log(vm.users);
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/users/edit.html',
        controller: 'UsersEditController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/users/create.html',
        controller: 'UsersEditController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    removeUser = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление пользователя</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите продолжить?</h5><span>примечание: можно удалить нового пользователя</span></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('user.remove', {
          id: row.id
        }).then(function(result) {
          toastr.success('Вы успешно удалили пользователя');
          getUsers();
        });
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getUsers();
    });
    vm.removeUser = removeUser;
    vm.editUser = editUser;
    vm.newUser = newUser;
    vm.getUsers = getUsers;
    getUsers();
  }).controller('UsersEditController', function(RequestService, product_types, user, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createUser, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user;
    }
    createUser = function() {
      RequestService.post('user.register', vm.user).then(function(result) {
        console.log("createUser ->result.token = " + result.token);
        $uibModalInstance.close(result);
      });
    };
    updateUser = function() {
      RequestService.post('user.put', vm.user).then(function(result) {
        console.log("updateUser ->result.user = ");
        console.log(result.user);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
  });

}).call(this);

(function() {
  angular.module('stock').controller('TripController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('TripListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var getEquipments, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.equipments = null;
    vm.equipment_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 50;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.equipmentsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'client',
          displayName: 'Клиент'
        }, {
          name: 'uid_client',
          displayName: 'ID клиента'
        }, {
          name: 'uid_trip',
          displayName: 'ID поездки'
        }, {
          name: 'birthday',
          displayName: 'Дата рождения',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'number',
          displayName: 'Номер'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      }
    };
    getEquipments = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "client") {
          filter.filter.client = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      RequestService.post('trippolicies.listing', filter).then(function(data) {
        delete vm.selected_equipment;
        vm.equipmentsGridOptions.data = angular.copy(data.list);
        vm.equipmentsGridOptions.totalItems = data.count;
        toastr.info("Полисы загружены.");
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_equipment = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getEquipments();
    });
    vm.getEquipments = getEquipments;
    getEquipments();
  });

}).call(this);

(function() {
  angular.module('stock').controller('TehnikaController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('TehnikaListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteequipment, downloadPDF, editBranch, fiterequipment, getAgents, getEquipments, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.equipments = null;
    vm.equipment_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/tehnika/view.html',
        controller: 'TehnikaViewController',
        controllerAs: 'view',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_equipment
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_equipment = angular.copy(row.entity);
      goToShow();
    };
    vm.equipmentsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'status',
          displayName: 'Статус'
        }, {
          name: 'client',
          displayName: 'ФИО клиента'
        }, {
          name: 'model',
          displayName: 'Модель'
        }, {
          name: 'price',
          displayName: 'Стоимость'
        }, {
          name: 'sum',
          displayName: 'Страховая сумма'
        }, {
          name: 'premium',
          displayName: 'Страховая премия'
        }, {
          name: 'period.start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'period.end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.created',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'employee_id',
          displayName: 'Продавец'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.tehnika.create');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/tehnika/edit.html',
        controller: 'TehnikaEditController',
        controllerAs: 'tehnika',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_equipment
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getEquipments = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'insurance_company') {
        filter.with_related = true;
        filter.filter = {
          company_id: vm.company._id
        };
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "status") {
          if (v === "Все") {
            if (filter.filter) {
              delete filter.filter;
            }
            continue;
          } else {
            filter.filter = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "name") {
          filter.filter.client = v;
        }
      }
      filter.filter.edit_user_id = $scope.app.ua.id;
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      RequestService.post('tehpolicies.listing', filter).then(function(data) {
        delete vm.selected_equipment;
        vm.equipments = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.equipmentsGridOptions.data = angular.copy(data.docs);
        vm.equipmentsGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      ReportService.printReport('TP', {
        'policyNumber': vm.selected_equipment.policy_no
      });
    };
    deleteequipment = function() {
      return RequestService.post('tehequipments.delete', vm.selected_equipment).then(function(data) {
        getEquipments();
      });
    };
    resetFilter = function() {
      vm.equipment_filtered = [];
      vm.filter = {};
      vm.equipmentsGridOptions.data = angular.copy(vm.equipments);
    };
    fiterequipment = function() {
      var equipment, j, len, ref;
      vm.equipment_filtered = [];
      if (vm.equipments) {
        ref = vm.equipments;
        for (j = 0, len = ref.length; j < len; j++) {
          equipment = ref[j];
          if (vm.filter.policy_no) {
            if (equipment.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (equipment.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (equipment.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.equipment_status) {
            if (equipment.data.status !== vm.filter.equipment_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (equipment.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.equipment_filtered.push(equipment);
        }
        vm.equipmentsGridOptions.data = angular.copy(vm.equipment_filtered);
      } else {
        console.log("vm.equipments is falsy");
      }
      if (!vm.filter.equipment_status) {
        return vm.filter.equipment_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_equipment = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getEquipments
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'equipmentDialogController',
        controllerAs: 'equipment_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteequipment();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getEquipments();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deleteequipment = deleteequipment;
    vm.resetFilter = resetFilter;
    vm.fiterequipment = fiterequipment;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.editBranch = editBranch;
    vm.getEquipments = getEquipments;
    getAgents();
    getEquipments();
  }).controller('TehnikaPrevController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteequipment, downloadPDF, editBranch, fiterequipment, getAgents, getEquipments, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.equipments = null;
    vm.equipment_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/tehnika/slide.html',
        controller: 'TehnikaViewController',
        controllerAs: 'slide',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_equipment
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_equipment = angular.copy(row.entity);
      goToShow();
    };
    vm.equipmentsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'status',
          displayName: 'Статус'
        }, {
          name: 'client',
          displayName: 'ФИО клиента'
        }, {
          name: 'model',
          displayName: 'Модель'
        }, {
          name: 'price',
          displayName: 'Стоимость'
        }, {
          name: 'sum',
          displayName: 'Страховая сумма'
        }, {
          name: 'premium',
          displayName: 'Страховая премия'
        }, {
          name: 'period.start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'period.end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.created',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'employee_id',
          displayName: 'Продавец'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.tehnika.create');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/tehnika/edit.html',
        controller: 'TehnikaEditController',
        controllerAs: 'tehnika',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_equipment
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getEquipments = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'insurance_company') {
        filter.with_related = true;
        filter.filter = {
          company_id: vm.company._id
        };
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "status") {
          if (v === "Все") {
            if (filter.filter) {
              delete filter.filter;
            }
            continue;
          } else {
            filter.filter = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "name") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      RequestService.post('tehpolicies.listing', filter).then(function(data) {
        delete vm.selected_equipment;
        vm.equipments = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.equipmentsGridOptions.data = angular.copy(data.docs);
        vm.equipmentsGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      ReportService.printReport('TP', {
        'policyNumber': vm.selected_equipment.policy_no
      });
    };
    deleteequipment = function() {
      return RequestService.post('tehequipments.delete', vm.selected_equipment).then(function(data) {
        getEquipments();
      });
    };
    resetFilter = function() {
      vm.equipment_filtered = [];
      vm.filter = {};
      vm.equipmentsGridOptions.data = angular.copy(vm.equipments);
    };
    fiterequipment = function() {
      var equipment, j, len, ref;
      vm.equipment_filtered = [];
      if (vm.equipments) {
        ref = vm.equipments;
        for (j = 0, len = ref.length; j < len; j++) {
          equipment = ref[j];
          if (vm.filter.policy_no) {
            if (equipment.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (equipment.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (equipment.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.equipment_status) {
            if (equipment.data.status !== vm.filter.equipment_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (equipment.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.equipment_filtered.push(equipment);
        }
        vm.equipmentsGridOptions.data = angular.copy(vm.equipment_filtered);
      } else {
        console.log("vm.equipments is falsy");
      }
      if (!vm.filter.equipment_status) {
        return vm.filter.equipment_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_equipment = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getEquipments
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'equipmentDialogController',
        controllerAs: 'equipment_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteequipment();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getEquipments();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deleteequipment = deleteequipment;
    vm.resetFilter = resetFilter;
    vm.fiterequipment = fiterequipment;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.editBranch = editBranch;
    vm.getEquipments = getEquipments;
    getAgents();
    getEquipments();
  }).controller('TehnikaCreateController', function($stateParams, RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var formatLabel, getEmployees, putPolicy, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.today = moment().add(1, 'days').format("DD-MM-YYYY");
    vm.end_date = moment().add(184, 'days').format("DD-MM-YYYY");
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    vm.policy = {
      sum: 0,
      employee_id: ($scope.app.ua.data.surname || '') + ' ' + ($scope.app.ua.data.name || '') + ' ' + ($scope.app.ua.data.patronymic || ''),
      period: {
        start: vm.today,
        end: vm.end_date
      },
      data: {
        created: vm.today
      }
    };
    vm.insure_sum = [
      {
        name: "3000",
        summ: 3000
      }, {
        name: "5000",
        summ: 5000
      }, {
        name: "8000",
        summ: 8000
      }, {
        name: "10000",
        summ: 10000
      }, {
        name: "14000",
        summ: 14000
      }, {
        name: "25000",
        summ: 25000
      }
    ];
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    $scope.$watch('create.policy.sum', function(search_name, oldVal) {
      if (vm.policy.price <= search_name) {
        toastr.warning('Данная страховая сумма недоступна для указанной стоимости');
        vm.policy.sum = 0;
        vm.policy.premium = 0;
      } else if (vm.policy.price <= 4999) {
        toastr.warning('Данная страховая сумма недоступна для указанной стоимости');
        vm.policy.sum = 0;
        vm.policy.premium = 0;
      } else if (search_name !== oldVal) {
        if (search_name === 3000) {
          vm.policy.premium = 250;
        } else if (search_name === 5000) {
          vm.policy.premium = 350;
        } else if (search_name === 8000) {
          vm.policy.premium = 500;
        } else if (search_name === 10000) {
          vm.policy.premium = 650;
        } else if (search_name === 14000) {
          vm.policy.premium = 800;
        } else if (search_name === 25000) {
          vm.policy.premium = 1100;
        } else if (search_name === 0 && (search_name = null)) {
          vm.policy.premium = 0;
        }
      }
    });
    $scope.$watch('create.policy.price', function(search_name, oldVal) {
      if (search_name !== oldVal) {
        if (search_name >= 0 && search_name <= 4999) {
          vm.policy.sum = 0;
        } else if (search_name >= 5000 && search_name <= 8000) {
          vm.policy.sum = 3000;
        } else if (search_name >= 8001 && search_name <= 10000) {
          vm.policy.sum = 5000;
        } else if (search_name >= 10001 && search_name <= 15000) {
          vm.policy.sum = 8000;
        } else if (search_name >= 15001 && search_name <= 20000) {
          vm.policy.sum = 10000;
        } else if (search_name >= 20001 && search_name <= 35000) {
          vm.policy.sum = 14000;
        } else if (search_name >= 35001) {
          vm.policy.sum = 25000;
        } else if (search_name === 0) {
          vm.policy.sum = 0;
        }
      }
    });
    formatLabel = function(model) {
      var i;
      i = 0;
      while (i < vm.insure_sum.length) {
        if (model === vm.insure_sum[i].name) {
          return vm.insure_sum[i].summ;
        }
        i++;
      }
    };
    putPolicy = function() {
      vm.policy.status = 'Оформлен';
      vm.policy.issue_date = new Date();
      RequestService.post('tehpolicies.save', vm.policy).then(function(result) {
        toastr.success('Полис сохранен успешно');
        vm.policy_id = result.tehpolicy.id;
        return $state.go('app.tehnika.show', {
          id: vm.policy_id
        });
      });
      return false;
    };
    getEmployees = function() {
      RequestService.post('employee.listing', {
        company_id: vm.company._id
      }).then(function(data) {
        return vm.employees = data.docs;
      });
    };
    vm.putPolicy = putPolicy;
    vm.formatLabel = formatLabel;
    vm.getEmployees = getEmployees;
    getEmployees();
  }).controller('TehnikaViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, goToForm, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.policy = product;
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    downloadPDF = function() {
      ReportService.printReport('TP', {
        policyNumber: vm.policy.policy_no
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    spoilPolicy = function() {
      vm.policy.status = "Испорчен";
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис испорчен успешно');
      });
      return false;
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    termPolicy = function(moneyBack) {
      vm.policy.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис расторжен успешно');
      });
      return false;
    };
    goToForm = function() {
      $state.go('app.tehnika.edit', {
        policy: vm.policy
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          FormPolicy();
        }
      });
    };
    FormPolicy = function() {
      vm.policy.status = 'Оформлен';
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        vm.policy.data.status = 'Оформлен';
        sendMail();
        $scope.list.getEquipments();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    vm.cancel = cancel;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.spoilPolicy = spoilPolicy;
    vm.confirmActionTerm = confirmActionTerm;
    vm.goToForm = goToForm;
    vm.confirmActionForm = confirmActionForm;
  }).controller('TehnikaDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TehnikaShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, getPolicy, goToForm, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.policy = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getPolicy = function(policy_id) {
      var filter;
      filter = {
        with_related: true,
        filter: {
          _id: policy_id
        }
      };
      RequestService.post('equipment.listing', filter).then(function(result) {
        return vm.policy = result.docs[0];
      });
    };
    vm.policy_id = $stateParams.id;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.tehnika.list");
    } else {
      getPolicy(vm.policy_id);
    }
    downloadPDF = function() {
      ReportService.printReport('TP', {
        policyNumber: vm.policy.policy_no
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    spoilPolicy = function() {
      vm.policy.status = "Испорчен";
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис испорчен успешно');
      });
      return false;
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    termPolicy = function(moneyBack) {
      vm.policy.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис расторжен успешно');
      });
      return false;
    };
    goToForm = function() {
      $state.go('app.tehnika.edit', {
        policy: vm.policy
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          FormPolicy();
        }
      });
    };
    FormPolicy = function() {
      vm.policy.status = 'Оформлен';
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        vm.policy.data.status = 'Оформлен';
        sendMail();
        $scope.list.getEquipments();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.cancel = cancel;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.spoilPolicy = spoilPolicy;
    vm.confirmActionTerm = confirmActionTerm;
    vm.goToForm = goToForm;
    vm.confirmActionForm = confirmActionForm;
  });

}).call(this);

(function() {
  angular.module('stock').controller('RoleController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var editRole, getRoles, newRole, removeRole, vm;
    vm = this;
    vm.rolesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.approval_name',
          displayName: 'Наим. для одобрения'
        }, {
          name: 'data.read',
          displayName: 'Чтение'
        }, {
          name: 'data.write',
          displayName: 'Редактирование'
        }, {
          name: 'data.delete',
          displayName: 'Удаление'
        }
      ]
    };
    getRoles = function() {
      var filter;
      filter = {};
      RequestService.post('role.listing', filter).then(function(result) {
        delete vm.selected_role;
        vm.roles = result.docs;
        vm.rolesGridOptions.data = vm.roles;
      });
    };
    editRole = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/role/edit.html',
        controller: 'RoleEditController',
        controllerAs: 'role',
        size: 'lg',
        resolve: {
          role: angular.copy(vm.selected_role)
        }
      });
      editModal.result.then(function() {
        return getRoles();
      });
      return false;
    };
    newRole = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/role/edit.html',
        controller: 'RoleEditController',
        controllerAs: 'role',
        size: 'lg',
        resolve: {
          role: void 0
        }
      });
      editModal.result.then(function() {
        return getRoles();
      });
    };
    removeRole = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление роли</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите удалить?</h5></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('role.remove', vm.selected_role).then(function(result) {
          getRoles();
        });
      });
    };
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить роль',
      callback: newRole
    }).add({
      combo: 'r',
      description: 'Обновить список ролей',
      callback: getRoles
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_role = row.entity;
    });
    vm.getRoles = getRoles;
    vm.editRole = editRole;
    vm.newRole = newRole;
    vm.removeRole = removeRole;
    getRoles();
  });

  angular.module('stock').controller('RoleEditController', function($scope, RequestService, AppStorage, toastr, role, $uibModalInstance) {
    'ngInject';
    var menuParentGroup, saveRole, vm;
    vm = this;
    vm.role = role || {
      type: 'Roles',
      data: {
        read: true
      }
    };
    vm.menus = AppStorage.getObject('menus') || [];
    saveRole = function() {
      vm.role.type = 'Roles';
      RequestService.post('role.save', vm.role).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    menuParentGroup = function(menu) {
      if (menu && menu.parent && menu.parent.name) {
        return menu.parent.name;
      }
    };
    vm.saveRole = saveRole;
    vm.menuParentGroup = menuParentGroup;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('ReporttehnikaController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadPDFRPA, getEquipments, m, vm, y;
    vm = this;
    vm.today = new Date();
    vm.company = Session.getCompany();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 10;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'status',
          displayName: 'Статус'
        }, {
          name: 'client',
          displayName: 'ФИО клиента'
        }, {
          name: 'model',
          displayName: 'Модель'
        }, {
          name: 'price',
          displayName: 'Стоимость'
        }, {
          name: 'sum',
          displayName: 'Страховая сумма'
        }, {
          name: 'premium',
          displayName: 'Страховая премия'
        }, {
          name: 'period.start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'period.end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.created',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'employee.name',
          displayName: 'Продавец'
        }, {
          name: 'company.name',
          displayName: 'Страховщик'
        }
      ]
    };
    downloadPDFRPA = function() {
      ReportService.printReport('RPC', {
        'company_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    getEquipments = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.filter.company_id = vm.company._id;
      filter.filter.date_start = vm.date_start;
      filter.filter.date_end = vm.date_end;
      filter.filter.report_period = ['Оформлен', 'Истек'];
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      RequestService.post('tehpolicies.listing', filter).then(function(data) {
        delete vm.selected_equipment;
        vm.equipments = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getEquipments();
    });
    vm.downloadPDFRPA = downloadPDFRPA;
    vm.getEquipments = getEquipments;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ReportperiodController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadExcelRPA, downloadExcelRPAP, downloadPDFRPA, downloadPDFRPAP, getAgents, getPolicies, m, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 10;
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'client.surname',
          displayName: 'Фамилия клиента'
        }, {
          name: 'client.name',
          displayName: 'Имя клиента'
        }, {
          name: 'client.passport_no',
          displayName: 'Пасспорт'
        }, {
          name: 'client.date_of_birth',
          displayName: 'Дата рождения'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_amount',
          displayName: 'Сумма страховки'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'data.currency_name',
          displayName: 'Валюта'
        }, {
          name: 'data.insurance_premium_kgs',
          displayName: 'Премия в сомах '
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'company.name',
          displayName: 'Страховщик',
          visible: false
        }, {
          name: 'agent',
          displayName: 'Агент'
        }, {
          name: 'employee.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.employee.surname}} {{row.entity.employee.name}}</span>',
          width: 150
        }
      ]
    };
    downloadPDFRPA = function() {
      if (vm.company.company_type !== 'agent') {
        ReportService.printReport('RPC', {
          'company_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
        return;
      } else {
        ReportService.printReport('RPA', {
          'agent_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
      }
    };
    downloadExcelRPA = function() {
      if (vm.company.company_type !== 'agent' && vm.company._id === vm.agent_id) {
        ReportService.saveReportExcel('RPC', {
          'company_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
        return;
      } else {
        ReportService.saveReportExcel('RPA', {
          'agent_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
      }
    };
    downloadPDFRPAP = function() {
      ReportService.printReport('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    downloadExcelRPAP = function() {
      ReportService.saveReportExcel('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    getPolicies = function() {
      if (!vm.company) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true
        };
      } else if (vm.company.company_type === 'agent') {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            date_start: vm.date_start,
            date_end: vm.date_end,
            agent_id: vm.company._id,
            report_period: ['Оформлен', 'Истек']
          }
        };
      } else if (vm.company.company_type === 'insurance_company') {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            company_id: vm.company._id,
            date_start: vm.date_start,
            date_end: vm.date_end,
            agent_id: vm.agent_id,
            report_period: ['Оформлен', 'Истек']
          }
        };
      }
      RequestService.post('policies.listing', vm.filter).then(function(data) {
        delete vm.selected_policy;
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadExcelRPA = downloadExcelRPA;
    vm.downloadExcelRPAP = downloadExcelRPAP;
    vm.downloadPDFRPA = downloadPDFRPA;
    vm.downloadPDFRPAP = downloadPDFRPAP;
    vm.getPolicies = getPolicies;
    getAgents();
  });

}).call(this);

(function() {
  angular.module('stock').controller('Report_templateEditController', function($scope, RequestService, $uibModalInstance, report_template, toastr) {
    var save, vm;
    vm = this;
    vm.template = report_template || {
      "ReportVersion": "2016.2.5",
      "ReportGuid": "fa01abce0ca5d18ec4ad5a91c86cf9ed",
      "ReportName": "Report",
      "ReportAlias": "Report",
      "ReportCreated": "/Date(1480997975000+0600)/",
      "ReportChanged": "/Date(1480997975000+0600)/",
      "EngineVersion": "EngineV2",
      "CalculationMode": "Interpretation",
      "Pages": {
        "0": {
          "Ident": "StiPage",
          "Name": "Page1",
          "Guid": "4c037a5bc82cc89b8aaeaca0d31be61e",
          "Interaction": {
            "Ident": "StiInteraction"
          },
          "Border": ";;2;;;;;solid:Black",
          "Brush": "solid:Transparent",
          "PageWidth": 21.01,
          "PageHeight": 29.69,
          "Watermark": {
            "TextBrush": "solid:50,0,0,0"
          },
          "Margins": {
            "Left": 1,
            "Right": 1,
            "Top": 1,
            "Bottom": 1
          }
        }
      }
    };
    save = function() {
      if (vm.saving) {
        return;
      }
      vm.saving = true;
      if (!vm.template.code) {
        toastr.warning('Укажите код');
        vm.saving = false;
        return;
      }
      if (!vm.template.name) {
        toastr.warning('Укажите наименование');
        vm.saving = false;
        return;
      }
      if (!vm.template.report_category_id) {
        toastr.warning('Укажите категорию');
        vm.saving = false;
        return;
      }
      if (!vm.template.template) {
        toastr.warning('Заполните шаблон');
        vm.saving = false;
        return;
      }
      return RequestService.post('report.put', vm.template).then(function(data) {
        vm.saving = false;
        return $uibModalInstance.close(data);
      }, function() {
        return vm.saving = false;
      });
    };
    vm.save = save;
    vm.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('Report_templateController', function($scope, RequestService, $uibModal) {
    var editQuery, editTemplate, getQueries, getTemplates, newQuery, newTemplate, vm;
    vm = this;
    vm.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          field: 'code',
          displayName: 'Код'
        }, {
          field: 'name',
          displayName: 'Наименование'
        }, {
          field: 'report_category.name',
          displayName: 'Категория'
        }
      ]
    };
    vm.queriesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          field: 'code',
          displayName: 'Код'
        }, {
          field: 'name',
          displayName: 'Наименование'
        }, {
          field: 'result_key',
          displayName: 'Ключ возврата'
        }
      ]
    };
    getTemplates = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('report.listing', filter).then(function(data) {
        delete vm.selected_template;
        vm.gridOptions.data = data.report_list;
        return vm.gridOptions.totalItems = data.count;
      });
    };
    newTemplate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/template_edit.html',
        controller: 'Report_templateEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_template: null
        }
      });
      return editModal.result.then(function() {
        return getTemplates();
      });
    };
    editTemplate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/template_edit.html',
        controller: 'Report_templateEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_template: vm.selected_template
        }
      });
      return editModal.result.then(function() {
        delete vm.selected_template;
        return getTemplates();
      });
    };
    getQueries = function() {
      var filter;
      filter = {};
      return RequestService.post('report.query_listing', filter).then(function(data) {
        delete vm.selected_query;
        vm.queriesGridOptions.data = data.docs;
        return vm.queriesGridOptions.totalItems = data.count;
      });
    };
    newQuery = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/query_edit.html',
        controller: 'ReportQueryEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_query: null
        }
      });
      return editModal.result.then(function() {
        return getQueries();
      });
    };
    editQuery = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/query_edit.html',
        controller: 'ReportQueryEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_query: vm.selected_query
        }
      });
      return editModal.result.then(function() {
        delete vm.selected_query;
        return getQueries();
      });
    };
    $scope.$on('data-selected', function(event, data) {
      if (data.grid.id === vm.gridOptions.gridApi.grid.id) {
        vm.selected_template = data.entity;
      } else if (data.grid.id === vm.queriesGridOptions.gridApi.grid.id) {
        vm.selected_query = data.entity;
      }
    });
    getTemplates();
    getQueries();
    vm.getTemplates = getTemplates;
    vm.newTemplate = newTemplate;
    vm.editTemplate = editTemplate;
    vm.getQueries = getQueries;
    vm.newQuery = newQuery;
    vm.editQuery = editQuery;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ReportQueryEditController', function($scope, RequestService, $uibModalInstance, report_query, toastr) {
    var save, vm;
    vm = this;
    vm.query = report_query || {};
    save = function() {
      if (vm.saving) {
        return;
      }
      vm.saving = true;
      if (!vm.query.code) {
        toastr.warning('Укажите код');
        vm.saving = false;
        return;
      }
      if (!vm.query.name) {
        toastr.warning('Укажите наименование');
        vm.saving = false;
        return;
      }
      if (!vm.query.result_key) {
        toastr.warning('Укажите ключ возврата');
        vm.saving = false;
        return;
      }
      if (!vm.query.query) {
        toastr.warning('Заполните запрос');
        vm.saving = false;
        return;
      }
      return RequestService.post('report.query_put', vm.query).then(function(data) {
        vm.saving = false;
        return $uibModalInstance.close(data);
      }, function() {
        return vm.saving = false;
      });
    };
    vm.save = save;
    vm.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('ReportaController', function($scope, RequestService, $timeout, $document, $stateParams) {
    var createDesigner, createViewer, designer, designerFullWindowToggle, getCategoryList, getReportList, reportObj, reportTemp, search, setReport, setSelected, viewer, vm;
    vm = this;
    viewer = null;
    designer = null;
    reportTemp = {
      "ReportVersion": "2016.2.5",
      "ReportGuid": "fa01abce0ca5d18ec4ad5a91c86cf9ed",
      "ReportName": "Report",
      "ReportAlias": "Report",
      "ReportCreated": "/Date(1480997975000+0600)/",
      "ReportChanged": "/Date(1480997975000+0600)/",
      "EngineVersion": "EngineV2",
      "CalculationMode": "Interpretation",
      "Pages": {
        "0": {
          "Ident": "StiPage",
          "Name": "Page1",
          "Guid": "4c037a5bc82cc89b8aaeaca0d31be61e",
          "Interaction": {
            "Ident": "StiInteraction"
          },
          "Border": ";;2;;;;;solid:Black",
          "Brush": "solid:Transparent",
          "PageWidth": 21.01,
          "PageHeight": 29.69,
          "Watermark": {
            "TextBrush": "solid:50,0,0,0"
          },
          "Margins": {
            "Left": 1,
            "Right": 1,
            "Top": 1,
            "Bottom": 1
          }
        }
      }
    };
    reportObj = {};
    search = {};
    Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("stimulsoft/ru.xml");
    createViewer = function() {
      var options;
      options = new Stimulsoft.Viewer.StiViewerOptions();
      options.height = "100%";
      options.appearance.scrollbarsMode = true;
      options.toolbar.showDesignButton = false;
      options.toolbar.showFullScreenButton = false;
      options.toolbar.showAboutButton = false;
      options.exports.showExportToPdf = true;
      options.exports.showExportToExcel2007 = true;
      options.exports.ShowExportToWord2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToDocument = false;
      viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
      viewer.renderHtml("viewerContent");
      viewer.jsObject.postInteractionOld = viewer.jsObject.postInteraction;
      viewer.jsObject.postInteraction = function(params) {
        var report;
        if (params.action === 'Variables' && reportObj.code) {
          report = viewer.report;
          RequestService.post('reporta/get_query_result', {
            code: reportObj.code,
            parameters: params.variables
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(reportObj.code, reportObj.code, response.data);
          });
        }
        viewer.jsObject.postInteractionOld(params);
      };
      setReport(reportTemp);
      document.getElementById("StiViewerReportPanel").style.cssText = "text-align: center;bottom: 0px;position: static;top: 35px;overflow: auto;margin-top: 0px;";
    };
    designerFullWindowToggle = function() {
      var body, reportDesigner;
      body = $document.find('body');
      reportDesigner = $document.find('#designerContent');
      if (body.hasClass('report-designer-fullscreen')) {
        body.removeClass('report-designer-fullscreen');
        reportDesigner.removeClass('fullscreen');
      } else {
        body.addClass('report-designer-fullscreen');
        reportDesigner.addClass('fullscreen');
      }
    };
    createDesigner = function() {
      var options, resizeBtn;
      options = new Stimulsoft.Designer.StiDesignerOptions();
      options.appearance.fullScreenMode = false;
      options.appearance.htmlRenderMode = Stimulsoft.Report.Export.StiHtmlExportMode.Table;
      options.appearance.showSaveDialog = false;
      options.toolbar.showFileMenuExit = false;
      options.toolbar.showFileMenu = false;
      options.toolbar.showPreviewButton = true;
      options.toolbar.showAboutButton = false;
      designer = new Stimulsoft.Designer.StiDesigner(options, "StiDesigner", false);
      designer.onSaveReport = function(event) {
        var _params;
        if (!reportObj.code) {
          return;
        }
        reportObj.template = event.report.saveToJsonString();
        RequestService.post('reporta.put', reportObj).then(function(response) {});
        _params = {};
        angular.forEach(event.report.dictionary.variables.list, function(variable) {
          _params[variable.name] = variable.value;
        });
        RequestService.post('reporta.get_query_result', {
          code: reportObj.code,
          parameters: _params
        }).then(function(response) {
          event.report.dictionary.databases.clear();
          event.report.regData(reportObj.code, reportObj.code, response.data);
        });
      };
      designer.renderHtml("designerContent");
      viewer = designer.jsObject.options.viewerContainer.firstChild;
      viewer.jsObject.postInteractionOld = viewer.jsObject.postInteraction;
      viewer.jsObject.postInteraction = function(params) {
        var report;
        if (params.action === 'Variables' && reportObj.code) {
          report = viewer.jsObject.viewer.report;
          RequestService.post('reporta.get_query_result', {
            code: reportObj.code,
            parameters: params.variables
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(reportObj.code, reportObj.code, response.data);
          });
        }
        viewer.jsObject.postInteractionOld(params);
      };
      resizeBtn = $document.find('#StiDesignerresizeDesigner');
      resizeBtn[0].action = designerFullWindowToggle;
      setReport(reportTemp);
    };
    getCategoryList = function() {
      RequestService.post('reporta.category_listing', {}).then(function(response) {
        vm.report_categories = response.docs;
      });
    };
    getReportList = function() {
      var filter;
      filter = {
        filter: {
          report_category_id: vm.search.report_category_id
        }
      };
      RequestService.post('reporta.listing', filter).then(function(data) {
        vm.reports = data.report_list;
      });
    };
    setReport = function(reportObject) {
      $timeout(function() {
        var report;
        report = new Stimulsoft.Report.StiReport();
        report.load(reportObject);
        if (viewer) {
          viewer.report = report;
        }
        if (designer) {
          designer.report = report;
        }
      });
    };
    setSelected = function(selectedReport) {
      if (selectedReport === void 0) {
        return;
      }
      reportObj = selectedReport;
      setReport(JSON.parse(reportObj.template));
    };
    vm.getReportList = getReportList;
    vm.getCategoryList = getCategoryList;
    vm.setSelected = setSelected;
    getCategoryList();
    if ($stateParams.reportMode && $stateParams.reportMode === 'designer') {
      createDesigner();
    } else {
      createViewer();
    }
  });

}).call(this);

(function() {
  angular.module('stock').controller('ReportController', function($scope, RequestService) {
    var createViewer, getReportList, setReport, showReport, viewer, vm;
    vm = this;
    viewer = null;
    Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("app/stimullib/ru.xml");
    createViewer = function() {
      var options;
      options = new Stimulsoft.Viewer.StiViewerOptions();
      options.height = "100%";
      options.appearance.scrollbarsMode = true;
      options.toolbar.showDesignButton = false;
      options.toolbar.showFullScreenButton = false;
      options.exports.showExportToPdf = true;
      options.exports.showExportToExcel2007 = true;
      options.exports.ShowExportToWord2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToDocument = false;
      viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
      viewer.renderHtml("reportViewer");
    };
    setReport = function(reportObject) {
      viewer.showProcessIndicator();
      setTimeout(function() {
        var report;
        report = new Stimulsoft.Report.StiReport();
        report.load(reportObject);
        viewer.report = report;
      }, 50);
    };
    getReportList = function() {
      var filter;
      filter = {
        filter: {
          report_category_id: vm.report_category_id
        }
      };
      RequestService.post('report.listing', filter).then(function(data) {
        vm.reports = data.report_list;
      });
    };
    showReport = function(report) {
      var reportObject;
      reportObject = JSON.parse(report.template) || {};
      return setReport(reportObject);
    };
    $scope.$watch('report.report_category_id', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        return getReportList();
      }
    });
    $scope.$watch('report.selected_report', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        return showReport(newVal);
      }
    });
    vm.getReportList = getReportList;
    vm.showReport = showReport;
    createViewer();
    setReport({});
    document.getElementById("StiViewerReportPanel").style.cssText = "text-align: center;bottom: 0px;position: static;top: 35px;overflow: auto;margin-top: 0px;";
  });

}).call(this);

(function() {
  angular.module('stock').controller('ProfileController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ProfileEditController', function(Session, hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $log) {
    'ngInject';
    var putData, vm;
    vm = this;
    vm.profile = angular.copy($scope.app.ua);
    vm.profile.data.phones = vm.profile.data.phones || [];
    vm.tempPhone = '';
    vm.addPhone = function() {
      if (vm.tempPhone === '' || vm.tempPhone === void 0) {
        console.log("Пароль пустой или неопределен");
      } else {
        vm.profile.data.phones.push(vm.tempPhone);
        return vm.tempPhone = '';
      }
    };
    vm.deletePhone = function(index) {
      return vm.profile.data.phones.splice(index, 1);
    };
    putData = function() {
      console.log(vm.profile);
      RequestService.post('user.put', vm.profile).then(function(result) {
        vm.profile = result.user;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return $state.go('app.profile.view');
      });
    };
    vm.putData = putData;
  }).controller('ProfileViewController', function(Session, hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $log) {
    'ngInject';
    var open, vm;
    vm = this;
    open = function(templ) {
      var modalInstance;
      modalInstance = $uibModal.open({
        templateUrl: templ,
        controller: 'ModalInstanceCtrl',
        controllerAs: '$ctrl',
        size: '',
        resolve: {
          cUser: function() {
            return $scope.app.ua;
          }
        }
      });
      return modalInstance.result;
    };
    vm.profile = angular.copy($scope.app.ua);
    vm.Show = function() {
      console.log($scope.app.ua);
    };
    vm.changePassword = function() {
      var result;
      result = open('changePassword.html');
      result.then((function(res) {
        vm.profile = res;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return alert('Ok');
      }), (function(reasn) {
        return console.log("da of " + reasn);
      }));
    };
    vm.changeUsername = function() {
      var result;
      result = open('changeUsername.html');
      result.then((function(res) {
        console.log(res);
        vm.profile = res;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return alert('Ok');
      }), (function(reson) {
        return console.log("da of " + reson);
      }));
    };
    vm.changeEmail = function() {
      var result;
      result = open('changeEmail.html');
      result.then((function(res) {
        vm.profile = res;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return alert('Ok');
      }), (function(reson) {
        return console.log("da of " + reson);
      }));
    };
  }).controller('ModalInstanceCtrl', function($uibModalInstance, cUser, $log, RequestService) {
    'ngInject';
    var $ctrl;
    $ctrl = this;
    $ctrl.cUser = cUser;
    $ctrl.password = {
      currentPswd: '',
      newPswd: '',
      confirmPswd: ''
    };
    $ctrl.email = $ctrl.cUser.email;
    $ctrl.username = $ctrl.cUser.username;
    $ctrl.passwordSave = function() {
      var data;
      if ($ctrl.password.newPswd !== $ctrl.password.confirmPswd) {
        alert("Пароль не подтвержден");
        return;
      }
      data = {
        password: $ctrl.password.currentPswd,
        newpswd: $ctrl.password.newPswd
      };
      return RequestService.post('user.putPassword', data).then(function(result) {
        $uibModalInstance.close(result.user);
      });
    };
    $ctrl.usernameSave = function() {
      var data;
      data = {
        password: $ctrl.password.currentPswd,
        username: $ctrl.username
      };
      return RequestService.post('user.putUsername', data).then(function(result) {
        $uibModalInstance.close(result.user);
      });
    };
    $ctrl.emailSave = function() {
      var data;
      data = {
        password: $ctrl.password.currentPswd,
        email: $ctrl.email
      };
      return RequestService.post('user.putEmail', data).then(function(result) {
        $uibModalInstance.close(result.user);
      });
    };
    $ctrl.cancel = function() {
      return $uibModalInstance.dismiss("Canceled");
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('ProductmController', function($scope, Session, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var confirmAction, deleteProduct, getProducts, gotoedit, vm;
    vm = this;
    $scope.g;
    vm.offset = 0;
    vm.limit = 10;
    vm.productsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'description',
          displayName: 'описание'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'date_update',
          displayName: 'Дата обновления',
          visible: false
        }, {
          name: 'date_close',
          displayName: 'Закрытие',
          visible: false
        }, {
          name: 'user_update',
          displayName: 'Пользователь',
          visible: false
        }, {
          name: 'user_entry',
          displayName: 'Залогинившийся',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    deleteProduct = function() {
      RequestService.post('productm.delete', vm.selected_product).then(function(result) {
        toastr.success('Продукт Удален успешно');
        getProducts();
      });
    };
    getProducts = function() {
      var company, filter, filter1;
      company = Session.getCompany();
      filter1 = {};
      if (company !== null && company !== void 0) {
        filter1.company_id = company._id;
      }
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: filter1
      };
      RequestService.post('productm.listing', filter).then(function(result) {
        var i, item, len, ref;
        delete vm.selected_product;
        vm.products = result.docs;
        ref = vm.products;
        for (i = 0, len = ref.length; i < len; i++) {
          item = ref[i];
          item.date_start = new Date(item.date_start);
          item.date_end = new Date(item.date_end);
        }
        console.log(vm.products);
        vm.productsGridOptions.data = vm.products;
        vm.productsGridOptions.totalItems = result.count;
      });
    };
    gotoedit = function(item) {
      return $state.go('app.productm_new', {
        product: item
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_product = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getProducts();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот продукт"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteProduct();
        }
      });
    };
    vm.confirmAction = confirmAction;
    vm.deleteProduct = deleteProduct;
    vm.gotoedit = gotoedit;
    vm.getProducts = getProducts;
    getProducts();
  }).controller('ProductmNewController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addField, addPricing, confirmAction, removeField, removePricing, resetField, saveField, saveProduct, selectField, vm;
    vm = this;
    vm.fields = {};
    vm.currentField = {};
    vm.pricing = [];
    vm.priceRule = {
      days: 0,
      price: 0
    };
    vm.product = $stateParams.product;
    if (!vm.product) {
      vm.product = {
        services_id: [],
        name: '',
        insurance_type: '',
        date_start: '',
        date_end: '',
        description: '',
        data: {}
      };
    } else {
      vm.fields = angular.copy(vm.product.fields);
      vm.pricing = angular.copy(vm.product.pricing);
    }
    addField = function() {
      var field;
      field = {
        label: 'New Field',
        type: 'text',
        placeholder: 'enter text'
      };
      vm.fields.push(field);
    };
    selectField = function(key) {
      vm.currentField = vm.fields[key];
    };
    saveField = function() {
      vm.fields[vm.currentField.key] = vm.currentField;
      resetField();
    };
    removeField = function(key) {
      delete vm.fields[key];
    };
    resetField = function() {
      vm.currentField = {};
    };
    addPricing = function() {
      vm.pricing.push(vm.priceRule);
      vm.priceRule = {
        days: 0,
        price: 0
      };
    };
    removePricing = function(index) {
      vm.pricing.splice(index, 1);
    };
    saveProduct = function() {
      var company, company_id, product_code;
      company = Session.getCompany();
      company_id = null;
      product_code = null;
      if (company !== null && company !== void 0) {
        company_id = company._id;
        if (vm.product.insurance_type !== null && vm.product.insurance_type !== void 0) {
          product_code = company.code + vm.product.insurance_type + '00';
          vm.product.code = product_code;
        } else {
          console.log("vm.insurance_type_code isnt null and vm.insurance_type_code isnt undefined");
          return;
        }
      }
      if (vm.product.company_id === null || vm.product.company_id === void 0) {
        vm.product.company_id = company_id;
      }
      vm.product.pricing = vm.pricing;
      vm.product.fields = vm.fields;
      RequestService.post('productm.save', vm.product).then(function(result) {
        toastr.success('Продукт Сохранен успешно');
        return $state.go("app.productm");
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот продукт ?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProduct();
        }
      });
    };
    vm.confirmAction = confirmAction;
    vm.addPricing = addPricing;
    vm.removePricing = removePricing;
    vm.addField = addField;
    vm.selectField = selectField;
    vm.saveField = saveField;
    vm.removeField = removeField;
    vm.resetField = resetField;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ProductController', function($scope, Session, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var confirmAction, deleteProduct, getProducts, gotoedit, gotoview, vm;
    vm = this;
    $scope.g;
    vm.offset = 0;
    vm.limit = 10;
    vm.productsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'description',
          displayName: 'описание'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'date_update',
          displayName: 'Дата обновления',
          visible: false
        }, {
          name: 'date_close',
          displayName: 'Закрытие',
          visible: false
        }, {
          name: 'user_update',
          displayName: 'Пользователь',
          visible: false
        }, {
          name: 'user_entry',
          displayName: 'Залогинившийся',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    deleteProduct = function() {
      RequestService.post('productsbasefactor.deleteall', {
        items: vm.selected_product.basefactors
      }).then(function(result) {});
      RequestService.post('productfactor.deleteall', {
        items: vm.selected_product.factors
      }).then(function(result) {});
      RequestService.post('product.delete', vm.selected_product).then(function(result) {
        getProducts();
      });
    };
    getProducts = function() {
      var company, filter, filter1;
      company = Session.getCompany();
      filter1 = {};
      if (company !== null && company !== void 0) {
        filter1.company_id = company._id;
      }
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: filter1
      };
      RequestService.post('product.listing', filter).then(function(result) {
        var item, j, len, ref;
        delete vm.selected_product;
        vm.products = result.docs;
        ref = vm.products;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          item.date_start = new Date(item.date_start);
          item.date_end = new Date(item.date_end);
        }
        console.log(vm.products);
        vm.productsGridOptions.data = vm.products;
        vm.productsGridOptions.totalItems = result.count;
      });
    };
    gotoedit = function(item) {
      return $state.go('app.product_new', {
        product: item
      });
    };
    gotoview = function(item) {
      return $state.go('app.product_view', {
        product: item
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_product = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getProducts();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот продукт"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteProduct();
        }
      });
    };
    vm.confirmAction = confirmAction;
    vm.deleteProduct = deleteProduct;
    vm.gotoview = gotoview;
    vm.gotoedit = gotoedit;
    vm.getProducts = getProducts;
    getProducts();
  }).controller('ProductNewController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addBF, initFunc, resetForm, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    if ($stateParams.product) {
      vm.product_id = $stateParams.product._id;
    }
    console.log(vm.product_id + 'Продукт _id');
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    addBF = function() {
      var i, item, j, k, len, len1, ref, ref1, temp_bf;
      temp_bf = null;
      if (vm.BFitem.from_day > vm.BFitem.to_day) {
        console.log("product.controller.coffee/ProductNewController/addBF: Такой промежуток НЕВОЗМОЖЕН");
        return;
      }
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ((item.to_day < vm.BFitem.from_day) || (item.from_day > vm.BFitem.to_day)) {
          null;
        } else {
          if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
            if (item._id === vm.BFitem._id) {
              continue;
            }
          }
          console.log("product.controller.coffee/ProductNewController/addBF: Конфлик интервалов");
          return;
        }
      }
      if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
        ref1 = vm.current_BF.values;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          item = ref1[i];
          if (item._id === vm.BFitem._id) {
            vm.current_BF.values.splice(i, 1);
          }
        }
      }
      vm.current_BF.values.push(vm.BFitem);
      return vm.BFitem = {};
    };
    initFunc = function() {
      if ($stateParams.product === null || $stateParams.product === void 0) {
        vm.new_product = {};
      } else {
        vm.new_product = $stateParams.product;
        vm.current_BF.product_id = vm.new_product._id | null;
        return vm.current_F.product_id = vm.new_product._id | null;
      }
    };
    vm.resetForm = resetForm;
    vm.addBF = addBF;
    initFunc();
  }).controller('ProductViewController', function($scope, Session, RequestService, $stateParams, $filter, $state) {
    'ngInject';
    var toDate, vm;
    vm = this;
    vm.product = $stateParams.product;
    if (vm.product) {
      console.log(vm.product);
    } else {
      console.log("Данные не получены");
    }
    toDate = function(arg) {
      return new Date(arg);
    };
    vm.toDate = toDate;
  }).controller('ProductMainController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addBF, deleteBF, deleteBFandDB, initFunc, removeAllFactors, removeFactor, resetForm, saveProduct, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    if ($stateParams.product) {
      vm.product_id = $stateParams.product._id;
    }
    console.log(vm.product_id + 'Продукт _id');
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    addBF = function() {
      var i, item, j, k, len, len1, ref, ref1, temp_bf;
      temp_bf = null;
      if (vm.BFitem.from_day > vm.BFitem.to_day) {
        console.log("product.controller.coffee/ProductNewController/addBF: Такой промежуток НЕВОЗМОЖЕН");
        return;
      }
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ((item.to_day < vm.BFitem.from_day) || (item.from_day > vm.BFitem.to_day)) {
          null;
        } else {
          if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
            if (item._id === vm.BFitem._id) {
              continue;
            }
          }
          console.log("product.controller.coffee/ProductNewController/addBF: Конфлик интервалов");
          return;
        }
      }
      if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
        ref1 = vm.current_BF.values;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          item = ref1[i];
          if (item._id === vm.BFitem._id) {
            vm.current_BF.values.splice(i, 1);
          }
        }
      }
      vm.current_BF.values.push(vm.BFitem);
      return vm.BFitem = {};
    };
    removeFactor = function(index, item, top) {
      vm.factorListTS.splice(index, 1);
      RequestService.post('productfactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {
        getProductsFactor();
      });
    };
    removeAllFactors = function(bf) {
      RequestService.post('productfactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsFactor();
      });
    };
    deleteBF = function(index) {
      return vm.current_BF.values.splice(index, 1);
    };
    deleteBFandDB = function(index, item) {
      vm.current_BF.values.splice(index, 1);
      RequestService.post('productsbasefactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {});
    };
    initFunc = function() {
      if ($stateParams.product === null || $stateParams.product === void 0) {
        vm.new_product = {};
      } else {
        vm.new_product = $stateParams.product;
        vm.current_BF.product_id = vm.new_product._id | null;
        return vm.current_F.product_id = vm.new_product._id | null;
      }
    };
    saveProduct = function() {
      var company, company_id, product_code;
      company = Session.getCompany();
      company_id = null;
      product_code = null;
      if (company !== null && company !== void 0) {
        company_id = company._id;
        if (vm.new_product.insurance_type !== null && vm.new_product.insurance_type !== void 0) {
          product_code = company.code + vm.new_product.insurance_type;
          vm.new_product.code = product_code;
        } else {
          console.log("vm.insurance_type_code isnt null and vm.insurance_type_code isnt undefined");
          return;
        }
      }
      if (vm.new_product.company_id === null || vm.new_product.company_id === void 0) {
        vm.new_product.company_id = company_id;
      }
      if (vm.new_product.basefactors) {
        delete vm.new_product.basefactors;
      }
      if (vm.new_product.factors) {
        delete vm.new_product.factors;
      }
      if (vm.new_product.services) {
        delete vm.new_product.services;
      }
      RequestService.post('product.save', vm.new_product).then(function(result) {
        vm.current_BF.product_id = result.id;
        vm.current_F.product_id = result.id;
        vm.new_product._id = result.id;
        return toastr.success('Продукт Сохранен успешно');
      });
      return false;
    };
    vm.removeAllFactors = removeAllFactors;
    vm.removeFactor = removeFactor;
    vm.resetForm = resetForm;
    vm.deleteBFandDB = deleteBFandDB;
    vm.saveProduct = saveProduct;
    vm.addBF = addBF;
    vm.deleteBF = deleteBF;
    initFunc();
  }).controller('ProductServiceController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var getProductsService, removeService, resetForm, saveProductsService, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    if ($stateParams.product) {
      vm.product_id = $stateParams.product._id;
    }
    console.log(vm.product_id + 'Продукт _id');
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    vm.new_product = {
      data: {}
    };
    vm.offset = 0;
    vm.limit = 50;
    vm.servicesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'service_name',
          displayName: 'Наименование'
        }, {
          name: 'insurance_sum',
          displayName: 'Сумма'
        }, {
          name: 'data.limit',
          displayName: 'Лимит'
        }
      ]
    };
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    getProductsService = function() {
      var filter;
      filter = {};
      filter = {
        order_by: ['insurance_sum DESC'],
        with_related: true,
        filter: {
          product_id: vm.product_id
        }
      };
      RequestService.post('productservice.listing', filter).then(function(result) {
        delete vm.selected_service;
        vm.servicesGridOptions.data = result.docs;
        return vm.servicesGridOptions.totalItems = result.count;
      });
      return false;
    };
    saveProductsService = function() {
      vm.new_product.product_id = vm.product_id;
      vm.new_product.service_id = vm.service._id;
      vm.new_product.service_name = vm.service.name;
      if (typeof vm.service_limit !== 'undefined' && vm.service_limit !== null) {
        vm.new_product.data.limit = vm.service_limit;
      } else {
        vm.new_product.data.limit = 'Not covered';
      }
      RequestService.post('productservice.save', vm.new_product).then(function(result) {
        vm.new_product = {
          data: {}
        };
        vm.service = {};
        vm.service_limit = null;
        getProductsService();
        toastr.success('Сервис успешно добавлен!');
      });
    };
    removeService = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление сервиса</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите удалить?</h5></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('productservice.delete', vm.selected_service).then(function(result) {
          getProductsService();
        });
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_service = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getProductsService();
    });
    vm.resetForm = resetForm;
    vm.getProductsService = getProductsService;
    vm.removeService = removeService;
    vm.saveProductsService = saveProductsService;
    getProductsService();
  }).controller('ProductCreateController', function($scope, RequestService, $uibModalInstance) {
    'ngInject';
    var saveProductsService, vm;
    vm = this;
    vm.new_product = {};
    saveProductsService = function() {
      RequestService.post('productservice.save', {
        items: vm.new_product
      }).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.saveProductsService = saveProductsService;
  }).controller('ProductBaseController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addBF, basefactorDelete, basefactorEdit, basefactorRowEdit, clearFactorValues, confirmActionBF, confirmActionBFdelete, confirmActionF, confirmActionFDeleteAll, confirmActionFdelete, confirmActionFinish, countryFilter, deleteBF, deleteBFandDB, factorValueFilter, getInsAmount, getProductsBaseFactor, initFunc, removeAllFactors, removeFactor, resetForm, saveProduct, saveProductsBaseFactor, saveProductsFactor, sortFactorValues, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    if ($stateParams.product) {
      vm.product_id = $stateParams.product._id;
    }
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    addBF = function() {
      var i, item, j, k, len, len1, ref, ref1, temp_bf;
      temp_bf = null;
      if (vm.BFitem.from_day > vm.BFitem.to_day) {
        console.log("product.controller.coffee/ProductNewController/addBF: Такой промежуток НЕВОЗМОЖЕН");
        return;
      }
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ((item.to_day < vm.BFitem.from_day) || (item.from_day > vm.BFitem.to_day)) {
          null;
        } else {
          if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
            if (item._id === vm.BFitem._id) {
              continue;
            }
          }
          console.log("product.controller.coffee/ProductNewController/addBF: Конфлик интервалов");
          return;
        }
      }
      if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
        ref1 = vm.current_BF.values;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          item = ref1[i];
          if (item._id === vm.BFitem._id) {
            vm.current_BF.values.splice(i, 1);
          }
        }
      }
      vm.current_BF.values.push(vm.BFitem);
      return vm.BFitem = {};
    };
    removeFactor = function(index, item, top) {
      vm.factorListTS.splice(index, 1);
      RequestService.post('productfactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {
        getProductsFactor();
      });
    };
    removeAllFactors = function(bf) {
      RequestService.post('productfactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsFactor();
      });
    };
    deleteBF = function(index) {
      return vm.current_BF.values.splice(index, 1);
    };
    deleteBFandDB = function(index, item) {
      vm.current_BF.values.splice(index, 1);
      RequestService.post('productsbasefactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {});
    };
    initFunc = function() {
      if ($stateParams.product === null || $stateParams.product === void 0) {
        vm.new_product = {};
      } else {
        vm.new_product = $stateParams.product;
        vm.current_BF.product_id = vm.new_product._id | null;
        return vm.current_F.product_id = vm.new_product._id | null;
      }
    };
    saveProduct = function() {
      var company, company_id, product_code;
      company = Session.getCompany();
      company_id = null;
      product_code = null;
      if (company !== null && company !== void 0) {
        company_id = company._id;
        if (vm.new_product.insurance_type !== null && vm.new_product.insurance_type !== void 0) {
          product_code = company.code + vm.new_product.insurance_type + '00';
          vm.new_product.code = product_code;
        } else {
          console.log("vm.insurance_type_code isnt null and vm.insurance_type_code isnt undefined");
          return;
        }
      }
      if (vm.new_product.company_id === null || vm.new_product.company_id === void 0) {
        vm.new_product.company_id = company_id;
      }
      if (vm.new_product.basefactors) {
        delete vm.new_product.basefactors;
      }
      if (vm.new_product.factors) {
        delete vm.new_product.factors;
      }
      if (vm.new_product.services) {
        delete vm.new_product.services;
      }
      RequestService.post('product.save', vm.new_product).then(function(result) {
        vm.current_BF.product_id = result.id;
        vm.current_F.product_id = result.id;
        vm.new_product._id = result.id;
        return toastr.success('Продукт Сохранен успешно');
      });
      return false;
    };
    basefactorRowEdit = function(bf) {
      vm.BFitem = angular.copy(bf);
    };
    basefactorDelete = function(index, bf) {
      RequestService.post('productsbasefactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsBaseFactor(vm.new_product._id);
      });
    };
    basefactorEdit = function(bf) {
      var item, item1, j, k, len, len1, ref, ref1;
      vm.current_BF.countries_id = [];
      ref = bf.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        vm.current_BF.countries_id.push(item._id);
      }
      vm.current_BF.insurance_amount = bf.data[0].insurance_amount;
      vm.current_BF.values = [];
      vm.current_BF.values = bf.data;
      ref1 = vm.current_BF.values;
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        item1 = ref1[k];
        item1.from_day = item1.interval.from_day;
        item1.to_day = item1.interval.to_day;
      }
    };
    saveProductsBaseFactor = function() {
      var arraytopass, item, j, len, ref, x;
      arraytopass = [];
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        x = {
          _id: item._id,
          product_id: vm.new_product._id,
          insurance_amount: vm.insurance_amount,
          countries_id: vm.current_BF.countries_id,
          base_price: item.base_price,
          is_per_day: item.is_per_day,
          interval: {
            from_day: item.from_day,
            to_day: item.to_day
          }
        };
        arraytopass.push(x);
      }
      RequestService.post('productsbasefactor.save', {
        items: arraytopass
      }).then(function(result) {
        var id;
        id = vm.current_BF.product_id;
        vm.current_BF.product_id = id;
        vm.current_BF.values = [];
        return getProductsBaseFactor(vm.new_product._id);
      });
      return false;
    };
    vm.basefactorList = [];
    getProductsBaseFactor = function(_id) {
      var filter, tmp_product_id;
      filter = {};
      if (_id === null || _id === void 0) {
        tmp_product_id = "1";
      } else {
        tmp_product_id = _id;
      }
      filter = {
        with_related: true,
        filter: {
          product_id: tmp_product_id
        }
      };
      RequestService.post('productsbasefactor.listing', filter).then(function(result) {
        var atom, atom1, is_included, item, item2, j, k, len, len1, ref, ref1, results, tempAtom;
        vm.basefactorList = result.docs;
        vm.basefactorListTS = [];
        is_included = false;
        ref = vm.basefactorList;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          ref1 = vm.basefactorListTS;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            item2 = ref1[k];
            item.countries = $filter('orderBy')(item.countries, 'name');
            item2.countries = $filter('orderBy')(item2.countries, 'name');
            if (angular.equals(item.countries, item2.countries)) {
              is_included = true;
              atom1 = {
                _id: item._id,
                _rev: item._rev,
                interval: item.interval,
                base_price: item.base_price,
                insurance_amount: item.insurance_amount,
                is_per_day: item.is_per_day
              };
              item2.data.push(atom1);
            }
          }
          if (is_included === false) {
            tempAtom = {
              countries: item.countries,
              data: []
            };
            atom = {
              _id: item._id,
              _rev: item._rev,
              interval: item.interval,
              base_price: item.base_price,
              insurance_amount: item.insurance_amount,
              is_per_day: item.is_per_day
            };
            tempAtom.data.push(atom);
            vm.basefactorListTS.push(tempAtom);
          }
          results.push(is_included = false);
        }
        return results;
      });
      return false;
    };
    saveProductsFactor = function() {
      vm.current_F.factor_id = vm.current_F.factor._id;
      RequestService.post('productfactor.save', vm.current_F).then(function(result) {
        var id;
        id = vm.current_F.product_id;
        vm.current_F = {
          product_id: id
        };
        return getProductsFactor(vm.product_id);
      });
      return false;
    };
    vm.factorList = [];
    getInsAmount = function() {
      var item, j, len, ref;
      vm.current_BF.insurance_amount = 0;
      ref = vm.tmp_countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (vm.current_BF.countries_id.indexOf(item._id) > -1 && item.min_insurance > vm.current_BF.insurance_amount) {
          vm.current_BF.insurance_amount = item.min_insurance;
        }
      }
    };
    factorValueFilter = function(f_value) {
      var f_item, j, len, ref;
      ref = vm.factorList;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        if (f_item.factor_id === vm.current_F.factor._id) {
          if (-1 !== f_item.values.indexOf(f_value)) {
            return false;
          }
        }
      }
      return true;
    };
    countryFilter = function(f_value) {
      var f_item, item2, j, k, len, len1, ref, ref1;
      if (vm.basefactorListTS === null || vm.basefactorListTS === void 0) {
        return true;
      }
      ref = vm.basefactorListTS;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        ref1 = f_item.countries;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          item2 = ref1[k];
          if (f_value._id === item2._id && vm.current_BF.countries_id.indexOf(f_value._id) < 0) {
            return false;
          }
        }
      }
      return true;
    };
    clearFactorValues = function() {
      vm.current_F.values = [];
    };
    sortFactorValues = function(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return parseInt(value, 10);
      }
    };
    confirmActionBF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsBaseFactor();
        }
      });
    };
    confirmActionF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsFactor();
        }
      });
    };
    confirmActionBFdelete = function(index, bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          basefactorDelete(index, bf);
        }
      });
    };
    confirmActionFDeleteAll = function(bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeAllFactors(bf);
        }
      });
    };
    confirmActionFdelete = function(index, item, top) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeFactor(index, item, top);
        }
      });
    };
    confirmActionFinish = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите закончить создание продукта"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          $state.go("app.product");
        }
      });
    };
    vm.confirmActionFinish = confirmActionFinish;
    vm.confirmActionBFdelete = confirmActionBFdelete;
    vm.confirmActionFdelete = confirmActionFdelete;
    vm.confirmActionFDeleteAll = confirmActionFDeleteAll;
    vm.confirmActionF = confirmActionF;
    vm.confirmActionBF = confirmActionBF;
    vm.sortFactorValues = sortFactorValues;
    vm.clearFactorValues = clearFactorValues;
    vm.removeAllFactors = removeAllFactors;
    vm.removeFactor = removeFactor;
    vm.basefactorDelete = basefactorDelete;
    vm.resetForm = resetForm;
    vm.deleteBFandDB = deleteBFandDB;
    vm.saveProductsFactor = saveProductsFactor;
    vm.getProductsBaseFactor = getProductsBaseFactor;
    vm.saveProduct = saveProduct;
    vm.saveProductsBaseFactor = saveProductsBaseFactor;
    vm.factorValueFilter = factorValueFilter;
    vm.getInsAmount = getInsAmount;
    vm.addBF = addBF;
    vm.deleteBF = deleteBF;
    vm.basefactorEdit = basefactorEdit;
    vm.basefactorRowEdit = basefactorRowEdit;
    vm.countryFilter = countryFilter;
    initFunc();
    getProductsBaseFactor(vm.product_id);
  }).controller('ProductAdditionallyController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addBF, clearFactorValues, confirmActionBF, confirmActionBFdelete, confirmActionF, confirmActionFDeleteAll, confirmActionFdelete, confirmActionFinish, countryFilter, deleteBF, deleteBFandDB, factorValueFilter, getInsAmount, getProductsFactor, initFunc, removeAllFactors, removeFactor, resetForm, saveProductsFactor, sortFactorValues, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    if ($stateParams.product) {
      vm.product_id = $stateParams.product._id;
    }
    console.log(vm.product_id + 'Продукт _id');
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    addBF = function() {
      var i, item, j, k, len, len1, ref, ref1, temp_bf;
      temp_bf = null;
      if (vm.BFitem.from_day > vm.BFitem.to_day) {
        console.log("product.controller.coffee/ProductNewController/addBF: Такой промежуток НЕВОЗМОЖЕН");
        return;
      }
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ((item.to_day < vm.BFitem.from_day) || (item.from_day > vm.BFitem.to_day)) {
          null;
        } else {
          if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
            if (item._id === vm.BFitem._id) {
              continue;
            }
          }
          console.log("product.controller.coffee/ProductNewController/addBF: Конфлик интервалов");
          return;
        }
      }
      if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
        ref1 = vm.current_BF.values;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          item = ref1[i];
          if (item._id === vm.BFitem._id) {
            vm.current_BF.values.splice(i, 1);
          }
        }
      }
      vm.current_BF.values.push(vm.BFitem);
      return vm.BFitem = {};
    };
    removeFactor = function(index, item, top) {
      vm.factorListTS.splice(index, 1);
      RequestService.post('productfactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {
        getProductsFactor(vm.product_id);
      });
    };
    removeAllFactors = function(bf) {
      RequestService.post('productfactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsFactor(vm.product_id);
      });
    };
    deleteBF = function(index) {
      return vm.current_BF.values.splice(index, 1);
    };
    deleteBFandDB = function(index, item) {
      vm.current_BF.values.splice(index, 1);
      RequestService.post('productsbasefactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {});
    };
    initFunc = function() {
      if ($stateParams.product === null || $stateParams.product === void 0) {
        vm.new_product = {};
      } else {
        vm.new_product = $stateParams.product;
        vm.current_BF.product_id = vm.new_product._id | null;
        return vm.current_F.product_id = vm.new_product._id | null;
      }
    };
    vm.basefactorList = [];
    saveProductsFactor = function() {
      vm.current_F.factor_id = vm.current_F.factor._id;
      vm.current_F.product_id = vm.new_product._id;
      RequestService.post('productfactor.save', vm.current_F).then(function(result) {
        var id;
        id = vm.current_F.product_id;
        vm.current_F = {
          product_id: id
        };
        return getProductsFactor(vm.product_id);
      });
      return false;
    };
    vm.factorList = [];
    getProductsFactor = function(_id) {
      var filter, tmp_product_id;
      filter = {};
      if (_id === null || _id === void 0) {
        tmp_product_id = "1";
      } else {
        tmp_product_id = _id;
      }
      filter = {
        with_related: true,
        filter: {
          product_id: tmp_product_id
        }
      };
      RequestService.post('productfactor.listing', filter).then(function(result) {
        var atom, atom1, index1, is_included, item, item2, item3, itemvalue, j, k, l, len, len1, len2, len3, m, ref, ref1, ref2, ref3, results, tempAtom;
        vm.factorList = result.docs;
        vm.factorListTS = [];
        is_included = false;
        ref = vm.factorList;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          ref1 = vm.factorListTS;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            item2 = ref1[k];
            if (item2.factor_name === item.factor.name) {
              is_included = true;
              atom1 = {
                _id: item._id,
                _rev: item._rev,
                values: item.values,
                coefficient: item.coefficient,
                coefficient_type: item.coefficient_type,
                is_default: item.is_default
              };
              ref2 = item2.data;
              for (l = 0, len2 = ref2.length; l < len2; l++) {
                item3 = ref2[l];
                ref3 = item3.values;
                for (m = 0, len3 = ref3.length; m < len3; m++) {
                  itemvalue = ref3[m];
                  index1 = atom1.values.indexOf(itemvalue);
                  if (index1 === !-1) {
                    atom1.values.splice(index1, 1);
                    console.log(item3 + " Уже содержится в списке значений факторов");
                  }
                }
              }
              item2.data.push(atom1);
            }
          }
          if (is_included === false) {
            tempAtom = {
              factor_name: item.factor.name,
              data: []
            };
            atom = {
              _id: item._id,
              _rev: item._rev,
              values: item.values,
              coefficient: item.coefficient,
              coefficient_type: item.coefficient_type,
              is_default: item.is_default
            };
            tempAtom.data.push(atom);
            vm.factorListTS.push(tempAtom);
          }
          results.push(is_included = false);
        }
        return results;
      });
      return false;
    };
    getInsAmount = function() {
      var item, j, len, ref;
      vm.current_BF.insurance_amount = 0;
      ref = vm.tmp_countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (vm.current_BF.countries_id.indexOf(item._id) > -1 && item.min_insurance > vm.current_BF.insurance_amount) {
          vm.current_BF.insurance_amount = item.min_insurance;
        }
      }
    };
    factorValueFilter = function(f_value) {
      var f_item, j, len, ref;
      ref = vm.factorList;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        if (f_item.factor_id === vm.current_F.factor._id) {
          if (-1 !== f_item.values.indexOf(f_value)) {
            return false;
          }
        }
      }
      return true;
    };
    countryFilter = function(f_value) {
      var f_item, item2, j, k, len, len1, ref, ref1;
      if (vm.basefactorListTS === null || vm.basefactorListTS === void 0) {
        return true;
      }
      ref = vm.basefactorListTS;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        ref1 = f_item.countries;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          item2 = ref1[k];
          if (f_value._id === item2._id && vm.current_BF.countries_id.indexOf(f_value._id) < 0) {
            return false;
          }
        }
      }
      return true;
    };
    clearFactorValues = function() {
      vm.current_F.values = [];
    };
    sortFactorValues = function(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return parseInt(value, 10);
      }
    };
    confirmActionBF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsBaseFactor();
        }
      });
    };
    confirmActionF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsFactor();
        }
      });
    };
    confirmActionBFdelete = function(index, bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          basefactorDelete(index, bf);
        }
      });
    };
    confirmActionFDeleteAll = function(bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeAllFactors(bf);
        }
      });
    };
    confirmActionFdelete = function(index, item, top) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeFactor(index, item, top);
        }
      });
    };
    confirmActionFinish = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите закончить создание продукта"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          $state.go("app.product");
        }
      });
    };
    vm.confirmActionFinish = confirmActionFinish;
    vm.confirmActionBFdelete = confirmActionBFdelete;
    vm.confirmActionFdelete = confirmActionFdelete;
    vm.confirmActionFDeleteAll = confirmActionFDeleteAll;
    vm.confirmActionF = confirmActionF;
    vm.confirmActionBF = confirmActionBF;
    vm.sortFactorValues = sortFactorValues;
    vm.clearFactorValues = clearFactorValues;
    vm.removeAllFactors = removeAllFactors;
    vm.removeFactor = removeFactor;
    vm.resetForm = resetForm;
    vm.deleteBFandDB = deleteBFandDB;
    vm.saveProductsFactor = saveProductsFactor;
    vm.factorValueFilter = factorValueFilter;
    vm.getInsAmount = getInsAmount;
    vm.addBF = addBF;
    vm.deleteBF = deleteBF;
    vm.countryFilter = countryFilter;
    initFunc();
    getProductsFactor(vm.product_id);
  });

}).call(this);

(function() {
  angular.module('stock').controller('ProdController', function($rootScope, $scope) {
    var vm;
    vm = this;
  }).controller('ProdEntryController', function(db, $stateParams, $state, $scope, $rootScope, md5) {
    var save, scanned, vm;
    vm = this;
    if (angular.isDefined($stateParams.id) && $stateParams.id.length > 0) {
      db.instance.get($stateParams.id).then(function(doc) {
        return vm.entity = doc;
      });
    } else {
      vm.entity = {
        type: 'product',
        data: {}
      };
    }
    save = function() {
      if (vm.entity.data.price) {
        try {
          vm.entity.data.price = parseFloat(vm.entity.data.price);
        } catch (error) {
          alert('Цена не цифра');
          return;
        }
      }
      if (angular.isUndefined(vm.entity._id)) {
        vm.entity._id = $rootScope.company.id + '-' + md5.createHash(vm.entity.data.name);
      }
      db.save('product', vm.entity.data, vm.entity._id, vm.entity._rev);
      return $state.go('app.prod.list');
    };
    scanned = function(e) {
      vm.entity.data.ean = e;
      $scope.$digest();
    };
    vm.handleScan = scanned;
    vm.save = save;
  }).controller('ProdListController', function(db, $scope, uiGridConstants, $state) {
    var edit, gridOptions, next, prev, refresh, reloadData, remove, search, vm;
    vm = this;
    gridOptions = {
      columnDefs: [
        {
          name: 'data.name',
          pinnedLeft: true,
          displayName: 'Наименование'
        }, {
          name: 'data.price',
          pinnedLeft: true,
          displayName: 'Цена'
        }
      ]
    };
    refresh = function() {
      vm.search = '';
      db.count('product').then(function(result) {
        if (result.rows.length > 0) {
          return vm.page_count = Math.ceil(result.rows[0].value / vm.page_size);
        }
      });
      return db.select('product', vm.page_size, vm.page_size * vm.page).then(function(result) {
        vm.gridOptions.data = result.docs;
        return vm.gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      });
    };
    prev = function() {
      if (vm.page > 0) {
        vm.page--;
        return reloadData();
      }
    };
    next = function() {
      if (vm.page < vm.page_count) {
        vm.page++;
        return reloadData();
      }
    };
    search = function() {
      return db.search('product', vm.search, ['data.name'], vm.page_size, vm.page_size * vm.page).then(function(result) {
        vm.gridOptions.data = result.docs;
        vm.page_count = Math.ceil(result.total_rows / vm.page_size);
        vm.gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      });
    };
    reloadData = function() {
      if (vm.search && vm.search.length > 0) {
        return search();
      } else {
        return refresh();
      }
    };
    edit = function() {
      $state.go('app.prod.entry', {
        id: vm.currentEntity._id
      });
    };
    remove = function() {
      vm.currentEntity._deleted = true;
      db.instance.put(vm.currentEntity).then(function() {
        return reloadData();
      });
    };
    vm.page_size = 50;
    vm.page = 0;
    vm.gridOptions = gridOptions;
    vm.refresh = refresh;
    vm.editRow = edit;
    vm.removeRow = remove;
    $scope.$on('data-next', next);
    $scope.$on('data-previous', prev);
    $scope.$on('data-search', function() {
      vm.page = 0;
      reloadData();
    });
    $scope.$on('data-selected', function(e, row) {
      return vm.currentEntity = row.entity;
    });
    refresh();
  }).controller('ProdImportController', function($log, $scope, db, md5, $rootScope) {
    var clear, read, vm, write;
    vm = this;
    vm.columns = [];
    $scope.gridOptions = {
      columnsDefs: vm.columns
    };
    read = function() {
      var e, importedData, k, ref, v, workbook;
      vm.alerts = [];
      vm.columns = [];
      try {
        workbook = XLS.read(vm.fileData, {
          type: 'binary'
        });
        importedData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
          header: 2
        });
        $log.log(importedData);
        if (importedData.length > 0) {
          ref = importedData[0];
          for (k in ref) {
            v = ref[k];
            vm.columns.push({
              name: k
            });
          }
          $scope.gridOptions.data = importedData;
          $scope.html = '<div id="grid" ui-grid="gridOptions" ui-grid-selection class="grid"></div>';
        }
      } catch (error) {
        e = error;
        $log.log(e.message);
        vm.alerts.push({
          type: 'danger',
          message: e.message
        });
      }
    };
    clear = function() {
      vm.alerts = [
        {
          type: 'default',
          message: 'Выберите файл'
        }
      ];
      vm.fileData = null;
      angular.element('#file').val('');
      return $scope.html = "Loading";
    };
    write = function() {
      vm.progress = 0;
      angular.forEach($scope.gridOptions.data, function(d) {
        var product;
        product = {
          data: {},
          type: 'product',
          company_id: $rootScope.company_id
        };
        angular.forEach(vm.columns, function(c) {
          product.data[c.bind] = d[c.name];
          if (c.bind === 'price') {
            try {
              product.data[c.bind] = parseFloat(d[c.name]);
            } catch (error) {
              return;
            }
          }
        });
        if (product.data.id) {
          product._id = $rootScope.company_id + '-' + product.data.id;
        } else {
          product._id = $rootScope.company_id + '-' + md5.createHash(product.data.name);
        }
        return db.instance.get(product._id, function(e, p) {
          if (p) {
            product._rev = p._rev;
          }
          $log.log(product);
          return db.instance.put(product, function(e) {
            $log.log(e);
            vm.progress += 100 / $scope.gridOptions.data.length;
          });
        });
      });
    };
    vm.clear = clear;
    vm.read = read;
    vm.write = write;
    clear();
  }).controller('ProdStockController', function() {
    var vm;
    return vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('PolicyaController', function($rootScope, $scope) {
    var vm;
    vm = this;
  }).controller('PolicyaMainController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal, IntermediateDataService, AppStorage) {
    'ngInject';
    var checkIfActive, checkIfSelected, confirmAction, deletePolicy, getPolicies, goToShow, openCreateForm, openExpenseHistoryModal, openImportModal, opneExpenseForm, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = {};
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.offset = 0;
    vm.limit = 10;
    vm.dirProducts = [];
    vm.dirPolicyAStatuses = [];
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    RequestService.post('dictionarya.listing', {
      type: 'DirProductA'
    }).then(function(response) {
      vm.dirProducts = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirPolicyAStatus'
    }).then(function(response) {
      vm.dirPolicyAStatuses = response.docs;
    }, function(response) {
      console.log(response);
    });
    vm.policiesGridOptions = {
      noUnselect: false,
      multiSelect: false,
      enableRowSelection: false,
      enableFullRowSelection: true,
      enableSelectAll: false,
      showGridFooter: true,
      columnDefs: [
        {
          name: 'patient_fullname',
          displayName: 'ФИО',
          width: '20%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'policy_no',
          displayName: 'Номер полиса',
          width: '8%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'status',
          displayName: 'Статус',
          width: '10%',
          editableCellTemplate: 'ui-grid/dropdownEditor',
          editDropdownValueLabel: 'name',
          editDropdownIdLabel: 'code',
          enableCellEdit: true,
          editDropdownOptionsFunction: function(rowEntity, colDef) {
            return vm.dirPolicyAStatuses;
          },
          cellTemplate: '<div style="height: 100%; text-align: center;vertical-align: middle;line-height: normal;" ng-style="{\'background-color\': row.entity.status_color}" ng-class="{red: row.getProperty(\'viewed\') < 1}"><div ng-style="{\'cursor\': row.cursor}" ng-repeat="col in renderedColumns" ng-class="col.colIndex()" class="ngCell "> <div class="ngVerticalBar" ng-style="{height: rowHeight}" ng-class="{ngVerticalBarVisible: !$last}"></div> <div ng-cell></div> </div> <div class="ui-grid-cell-contents">{{row.entity.status}}</div> </div>',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'patient_birthday',
          displayName: 'Дата рождения',
          cellFilter: 'date:"dd.MM.yyyy"',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'product',
          displayName: 'Продукт',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'amount',
          displayName: 'Лимит',
          width: '6%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'policy_balance',
          displayName: 'Остаток',
          width: '6%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'client_company',
          displayName: 'Клиент компания',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'valid_from',
          displayName: 'Действителен от',
          cellFilter: 'date:"dd.MM.yyyy"',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'valid_to',
          displayName: 'Действителен до',
          cellFilter: 'date:"dd.MM.yyyy"',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'insurance_programme',
          displayName: 'Страховая программа',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'insurance_company',
          displayName: 'Страховая компания',
          width: '10%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'relative_degree',
          displayName: 'Степень родства',
          width: '20%',
          enableCellEdit: false,
          maxWidth: 500,
          minWidth: 50
        }
      ],
      onRegisterApi: function(gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function(row) {
          vm.selectedRow = row;
        });
        gridApi.edit.on.afterCellEdit($scope, function(rowEntity, colDef, newValue, oldValue) {
          if (newValue !== oldValue) {
            rowEntity.status_code = newValue;
            RequestService.post('policiesa/put', rowEntity).then(function(response) {
              getPolicies();
            }, function(response) {
              console.log(response);
            });
          }
        });
        vm.gridApi = gridApi;
      }
    };
    checkIfActive = function() {
      return vm.selectedRow && vm.selectedRow.isSelected && vm.selectedRow.entity.status_code === 'AVE';
    };
    checkIfSelected = function() {
      return vm.selectedRow && vm.selectedRow.isSelected;
    };
    getPolicies = function() {
      var filter;
      filter = {
        'filter': vm.filter
      };
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["client_fullname ASC"];
      RequestService.post('policiesa.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
        AppStorage.setObject('policyFilterParams', vm.filter);
        toastr.info("Полисы загружены.");
      });
    };
    deletePolicy = function() {
      return RequestService.post('policiesa.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    openImportModal = function() {
      var modalInstance, onPressCancel, onPressOk;
      modalInstance = $uibModal.open({
        templateUrl: 'app/policya/import-modal.html',
        controller: 'ImportPoliciesController',
        size: 'lg'
      });
      onPressOk = function() {};
      onPressCancel = function() {};
      modalInstance.result.then(onPressOk, onPressCancel);
    };
    openExpenseHistoryModal = function() {
      var modalInstance, onPressCancel, onPressOk;
      modalInstance = $uibModal.open({
        templateUrl: 'app/policya/expenses-history-modal.html',
        controller: 'ExpensesHistoryModalController',
        size: 'lg',
        resolve: {
          policy: vm.selectedRow.entity
        }
      });
      onPressOk = function() {};
      onPressCancel = function() {};
      modalInstance.result.then(onPressOk, onPressCancel);
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    goToShow = function() {
      console.log(vm.policy_statuses);
      $state.go('app.policy_show', {
        product: vm.selected_policy
      });
    };
    openCreateForm = function() {
      $state.go('app.policya.new');
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    opneExpenseForm = function() {
      IntermediateDataService.set(vm.selectedRow.entity);
      $state.go('app.policya.expense');
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.goToShow = goToShow;
    vm.openCreateForm = openCreateForm;
    vm.getPolicies = getPolicies;
    vm.openImportModal = openImportModal;
    vm.openExpenseHistoryModal = openExpenseHistoryModal;
    vm.opneExpenseForm = opneExpenseForm;
    vm.checkIfActive = checkIfActive;
    vm.checkIfSelected = checkIfSelected;
    vm.filter = AppStorage.getObject('policyFilterParams');
    if (vm.filter) {
      getPolicies();
    } else {
      vm.filter;
    }
  }).controller('PolicyaNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var goBack, savePolicya, vm;
    vm = this;
    vm.policya = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    vm.cache = {};
    $("[name='birthday']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    $("[name='valid_from']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    $("[name='valid_to']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    $("[name='phone_number']").mask("(000)00-00-00", {
      placeholder: "(XXX)XX-XX-XX"
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirRelativeDegree'
    }).then(function(response) {
      vm.cache.relativeDegree = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirInsuranceProgramme'
    }).then(function(response) {
      vm.cache.insProgrammes = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'ClientCompany'
    }).then(function(response) {
      vm.cache.clientCompanies = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'InsuranceCompany'
    }).then(function(response) {
      vm.cache.insCompanies = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirProductA'
    }).then(function(response) {
      vm.cache.products = response.docs;
    }, function(response) {
      console.log(response);
    });
    goBack = function() {
      $state.go('app.policya.main');
    };
    savePolicya = function() {
      vm.policya.status_code = 'AVE';
      RequestService.post('policiesa/put', vm.policya).then(function(response) {
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    vm.goBack = goBack;
    vm.savePolicya = savePolicya;
  }).controller('ExpensesHistoryModalController', function($scope, $uibModalInstance, RequestService, policy) {
    'ngInject';
    $scope.policy = policy;
    $scope.expenses = [];
    RequestService.post('policiesa.get_expenses_history', {
      policy_id: policy._id
    }).then(function(response) {
      $scope.expenses = response.docs;
    }, function(response) {
      console.log(response);
    });
    $scope.ok = function() {
      $uibModalInstance.close();
    };
  }).controller('ImportPoliciesController', function($scope, $uibModalInstance, RequestService) {
    'ngInject';
    $scope.policies = [];
    $scope.disabled = false;
    $scope.policiesGridOptions = {
      data: 'policies',
      noUnselect: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полиса',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'amount',
          displayName: 'Общий лимит',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'product_id',
          displayName: 'Продукт',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'valid_from',
          displayName: 'Действителен от',
          cellFilter: 'date:"dd.MM.yyyy"',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'valid_to',
          displayName: 'Действителен до',
          cellFilter: 'date:"dd.MM.yyyy"',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'insurance_programme_id',
          displayName: 'Страховая программа',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'insurance_company_id',
          displayName: 'Страховая компания',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'client_company_id',
          displayName: 'Клиент компания',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }
      ]
    };
    $scope.readWorkbook = function(workbook) {
      if (workbook.SheetNames.length > 0) {
        $scope.policies = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      }
    };
    $scope.onWorkbookLoadError = function(e) {
      console.log(e);
    };
    $scope.cancel = function() {
      $uibModalInstance.dismiss('canceled');
    };
    return $scope.ok = function() {
      $scope.disabled = true;
      RequestService.post('policiesa.put_list', {
        list: $scope.policies
      }).then(function(result) {
        $uibModalInstance.close();
      });
    };
  }).controller('PolicyaExpenseController', function($scope, $state, RequestService, IntermediateDataService) {
    'ngInject';
    var addService, checkCost, checkQty, getServiceId, getServiceList, goBack, refreshDiagnosisList, removeService, saveExpense, searchPatient, vm;
    vm = this;
    vm.selectedPolicy = IntermediateDataService.get({});
    vm.buffer = {
      services: []
    };
    vm.dirDoctors = [];
    vm.dirDiagnosises = [];
    vm.dirOrganizations = [];
    vm.dirServices = [];
    vm.dirServiceCategories = [];
    vm.dateOptions = {
      opened: false
    };
    vm.patients = [];
    $("#exam_date").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    addService = function(form) {
      vm.buffer.services.push({});
    };
    removeService = function(index) {
      vm.buffer.services.splice(index, 1);
    };
    checkCost = function(amount) {
      if (amount <= 0) {
        return 'Укажите стоимость';
      }
    };
    checkQty = function(qty) {
      if (qty <= 0) {
        return 'Укажите кол-во';
      }
    };
    getServiceId = function(service, index) {
      vm.buffer.services[index].service_id = service._id;
      delete vm.buffer.services[index].service;
    };
    refreshDiagnosisList = function(search) {
      if (!search) {
        return;
      }
      RequestService.post('policiesa.get_diagnosis_list', {
        name: search
      }).then(function(response) {
        vm.dirDiagnosises = response.docs;
      }, function(response) {
        console.log(response);
      });
    };
    searchPatient = function(policyId) {
      if (!policyId) {
        return;
      }
      RequestService.post('policiesa.get_patient_list', {
        policy_id: policyId
      }).then(function(response) {
        vm.patients = response.docs;
      }, function(response) {
        console.log(response);
      });
    };
    RequestService.post('dictionarya.listing', {
      type: 'DirDoctor'
    }).then(function(response) {
      vm.dirDoctors = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirOrganization'
    }).then(function(response) {
      vm.dirOrganizations = response.docs;
    }, function(response) {
      console.log(response);
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirServiceCategory'
    }).then(function(response) {
      vm.dirServiceCategories = response.docs;
    }, function(response) {
      console.log(response);
    });
    getServiceList = function(categoryId) {
      RequestService.post('policiesa/get_service_list', {
        category_id: categoryId
      }).then(function(response) {
        vm.dirServices = response.list;
      }, function(response) {
        console.log(response);
      });
    };
    saveExpense = function() {
      vm.buffer.policy_id = vm.selectedPolicy._id;
      RequestService.post('policiesa/put_medexpense', vm.buffer).then(function(response) {
        console.log(response);
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    goBack = function() {
      $state.go('app.policya.main');
    };
    vm.addService = addService;
    vm.removeService = removeService;
    vm.checkCost = checkCost;
    vm.checkQty = checkQty;
    vm.getServiceId = getServiceId;
    vm.goBack = goBack;
    vm.saveExpense = saveExpense;
    vm.getServiceList = getServiceList;
    vm.searchPatient = searchPatient;
    vm.refreshDiagnosisList = refreshDiagnosisList;
  });

}).call(this);

(function() {
  angular.module('stock').controller('PolicyController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, downloadPDF3, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 25;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/show.html',
        controller: 'PolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'insurance_company') {
        filter.with_related = true;
        filter.filter = {
          company_id: vm.company._id
        };
      }
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "issue_date") {
          filter.filter.issue_date = v;
        }
        if (k === "name") {
          filter.filter.client.name = v;
        }
        if (k === "surname") {
          filter.filter.client.surname = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [25, 50, 100, 500],
      paginationPageSize: 25,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client.surname',
          displayName: 'Фамилия клиента'
        }, {
          name: 'client.name',
          displayName: 'Имя клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Страховщик'
        }, {
          name: 'agent',
          displayName: 'Агент'
        }, {
          name: 'employee.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.employee.surname}} {{row.entity.employee.name}}</span>',
          width: 150
        }, {
          name: 'data.buyer.surname',
          displayName: 'Страхователь',
          visible: false
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.issue_date > '2019-07-22 00:00:00+06') {
        ReportService.printReport('IIP', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        ReportService.printReport('IIP2', {
          'policyNumber': vm.selected_policy.policy_no
        });
      }
    };
    downloadPDF3 = function() {
      if (vm.selected_policy.issue_date > '2019-07-22 00:00:00+06') {
        ReportService.printReport('IIP3', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        ReportService.printReport('IIP2', {
          'policyNumber': vm.selected_policy.policy_no
        });
      }
    };
    savePDF = function() {
      if (vm.selected_policy.issue_date > '2019-07-22 00:00:00+06') {
        ReportService.saveReportPdf('IIP', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        ReportService.saveReportPdf('IIP2', {
          'policyNumber': vm.selected_policy.policy_no
        });
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, issue_d, j, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (j = 0, len = ref.length; j < len; j++) {
          policy = ref[j];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.downloadPDF3 = downloadPDF3;
    getAgents();
    getPolicies();
  }).controller('PolicyEditController', function($scope, hotkeys, $state, RequestService, Session, $uibModalInstance, branch, toastr) {
    'ngInject';
    var putBranch, vm;
    vm = this;
    vm.branch = branch || {
      type: 'Branches'
    };
    putBranch = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.branch.name === void 0 || vm.branch.name.trim().length === 0) {
        toastr.warning('Укажите имя филиала');
        vm.saving = false;
        return false;
      }
      if (angular.isUndefined(vm.branch.branch_type)) {
        toastr.warning('Выберите тип');
        vm.saving = false;
        return false;
      }
      RequestService.post('branch.save', vm.branch).then(function(result) {
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
      return false;
    };
    vm.putBranch = putBranch;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PolicyNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToSelect = function(item) {
      $state.go('app.policy_select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  }).controller('PolicySelectController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, AppStorage) {
    'ngInject';
    var changeArrow, changeArrow2, changeIcon, changedRadio, computePrice, findMinInsurance, getCurrencies, goToIssue, ifLessThanMin, recalculateOnEvent, recalculateOnEventAll, setProduct, sorterFunc, vm;
    vm = this;
    vm.today = new Date();
    vm.diffDays = 0;
    vm.diffDaysvalue = 0;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.maxdate = moment().add(364, 'day').toDate();
    vm.period = {
      date_start: new Date(),
      date_end: moment().add(1, 'day').toDate()
    };
    vm.selectedProduct = {};
    vm.selectedAge = [];
    vm.age = null;
    vm.selectedSport = [];
    vm.selectedGroup = [];
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.color = {
      name: 1
    };
    vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
    changedRadio = function(value) {
      vm.color = {
        name: value
      };
      if (value === 1) {
        vm.selectedtab = 'raw';
        vm.period.date_end = moment(vm.period.date_start).add(6, 'day').toDate();
        recalculateOnEventAll();
      }
      if (value === 2) {
        vm.selectedtab = 'summary';
        vm.period.date_end = moment(vm.period.date_start).add(365, 'day').toDate();
        return recalculateOnEventAll();
      }
    };
    ifLessThanMin = function(item) {
      if (parseInt(item.data.key) >= vm.min_insurance_amount) {
        return true;
      } else {
        return false;
      }
    };
    findMinInsurance = function() {
      var country, country_id, currency, currency_id, item, j, l, len, len1, len2, len3, local_min, m, n, ref, ref1, ref2, ref3;
      if (vm.product.country_id) {
        local_min = 0;
        currency_id = 0;
        ref = vm.countries;
        for (j = 0, len = ref.length; j < len; j++) {
          country = ref[j];
          ref1 = vm.product.country_id;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            country_id = ref1[l];
            if (country_id === country._id) {
              if (parseInt(country.min_insurance) > local_min) {
                local_min = parseInt(country.min_insurance);
                currency_id = country.currency_id;
              }
            }
          }
        }
        vm.min_insurance_amount = local_min;
        vm.insurance_amount = local_min;
        if (vm.currencies) {
          ref2 = vm.currencies;
          for (m = 0, len2 = ref2.length; m < len2; m++) {
            currency = ref2[m];
            if (currency._id === currency_id) {
              vm.currency_name = currency.data.name;
            }
          }
        }
        ref3 = vm.currenciesToday;
        for (n = 0, len3 = ref3.length; n < len3; n++) {
          item = ref3[n];
          if (item.currency === vm.currency_name) {
            vm.currencyRate1 = item.value;
          }
        }
      }
    };
    setProduct = function(item) {
      var itemx, j, len, ref;
      ref = vm.productsList;
      for (j = 0, len = ref.length; j < len; j++) {
        itemx = ref[j];
        if (itemx._id === vm.selectedProduct._id) {
          itemx.tmp_product = vm.product;
        }
      }
      if (item.tmp_product === null || item.tmp_product === void 0) {
        item.tmp_product = {};
        vm.product = {};
        vm.product.factors = {};
      } else {
        vm.product = item.tmp_product;
      }
      vm.selectedProduct = item;
    };
    computePrice = function(prod) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, j, l, len, len1, len2, len3, m, n, obj_x, ref, ref1, ref2, ref3, theprice, timeDiff;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = moment().toDate();
        date1 = prod.tmp_product.date_start;
      } else {
        date1 = new Date(prod.tmp_product.date_start).setHours(0, 0, 0, 0);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = moment(prod.tmp_product.date_start).add(1, 'day').toDate();
        date2 = prod.tmp_product.date_start;
      } else {
        date2 = new Date(prod.tmp_product.date_end).setHours(0, 0, 0, 0);
      }
      diffDays = 0;
      timeDiff = Math.abs(date2 - date1);
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      vm.diffDays = diffDays;
      vm.max_diffdays = diffDays;
      vm.diffDaysvalue = diffDays;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref = vm.countries;
        for (j = 0, len = ref.length; j < len; j++) {
          country_x = ref[j];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
        vm.currentCountryId = country_id;
      } else {
        country_id = country_id[0];
        vm.currentCountryId = country_id;
      }
      ref1 = prod.basefactors;
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        basefactor = ref1[l];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref2 = prod.factors;
      for (m = 0, len2 = ref2.length; m < len2; m++) {
        factor = ref2[m];
        if (factor.factor !== null) {
          ref3 = factor.factor;
          for (n = 0, len3 = ref3.length; n < len3; n++) {
            item_fact = ref3[n];
            if (item_fact.usage === 'sport' && factor.values.indexOf(vm.sport) > -1) {
              if (factor.coefficient_type === "Множитель") {
                theprice = theprice * factor.coefficient;
              }
              if (factor.coefficient_type === "Слагаемое") {
                fixedamounts = fixedamounts + factor.coefficient;
              }
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      console.log("theprice : " + theprice);
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    recalculateOnEvent = function() {
      var j, len, product, ref;
      ref = vm.productsList;
      for (j = 0, len = ref.length; j < len; j++) {
        product = ref[j];
        product.theprice = $filter('number')(computePrice(product), 2);
      }
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, item_y, j, len, ref, timeDiff;
      date1 = vm.period.date_start;
      date2 = vm.period.date_end;
      timeDiff = Math.abs(date2 - date1);
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (vm.color.name === 1) {
        if (diffDays >= 366) {
          toastr.warning('Период не должен превышать 365 дней');
          return;
        }
      }
      findMinInsurance();
      if (vm.color.name === 2 && vm.period.date_start) {
        vm.period.date_end = moment(vm.period.date_start).add(365, 'day').toDate();
      }
      ref = vm.productsList;
      for (j = 0, len = ref.length; j < len; j++) {
        item_y = ref[j];
        if (vm.product.country_id !== null || vm.product.country_id !== void 0 || vm.product.country_id.length !== 0) {
          item_y.tmp_product.country_id = vm.product.country_id;
        }
        if (vm.period.date_start !== null || vm.period.date_start !== void 0 || vm.period.date_start !== "") {
          item_y.tmp_product.date_start = vm.period.date_start;
        }
        if (vm.period.date_end !== null || vm.period.date_end !== void 0 || vm.period.date_end !== "") {
          item_y.tmp_product.date_end = vm.period.date_end;
        }
        item_y.theprice = $filter('number')(computePrice(item_y), 2);
      }
    };
    changeIcon = function(index) {
      if (vm['expandicon' + index] === 'fa fa-plus-square-o') {
        vm['expandicon' + index] = 'fa fa-minus-square-o';
      } else {
        vm['expandicon' + index] = 'fa fa-plus-square-o';
      }
    };
    getCurrencies = function() {
      RequestService.post('select.listing').then(function(result) {
        var factor, i, isIn, item, item_factor, item_y, item_z, itemd, j, l, len, len1, len2, len3, len4, len5, len6, len7, m, n, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, temparr, tmp_product, x, y;
        vm.currencies = result.currencies;
        vm.countries = result.countries;
        i = 0;
        while (i < result.product.length) {
          vm['expandicon' + i] = 'fa fa-plus-square-o';
          i++;
        }
        ref = result.product;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          temparr = [];
          if (item.factors !== null && item.factors !== void 0) {
            ref1 = item.factors;
            for (l = 0, len1 = ref1.length; l < len1; l++) {
              factor = ref1[l];
              if (factor !== null) {
                isIn = false;
                for (m = 0, len2 = temparr.length; m < len2; m++) {
                  x = temparr[m];
                  if (x.factor_id === factor.factor_id) {
                    x.values = x.values.concat(factor.values);
                    isIn = true;
                  }
                }
                if (isIn === false) {
                  if (factor.factor !== null) {
                    ref2 = factor.factor;
                    for (n = 0, len3 = ref2.length; n < len3; n++) {
                      item_factor = ref2[n];
                      y = {
                        factor_id: factor.factor_id,
                        name: item_factor.name,
                        usage: item_factor.usage,
                        values: factor.values,
                        description: item_factor.description
                      };
                    }
                    temparr.push(y);
                  }
                }
              }
            }
            item.factorListing = temparr;
          }
        }
        vm.productsList = result.product;
        if (vm.product === null || vm.product === void 0) {
          vm.product.factors = {};
          vm.product.country_id = [];
        } else {
          vm.product.factors = {};
        }
        ref3 = vm.productsList;
        for (o = 0, len4 = ref3.length; o < len4; o++) {
          item_y = ref3[o];
          ref4 = item_y.factorListing;
          for (p = 0, len5 = ref4.length; p < len5; p++) {
            item = ref4[p];
            if ("age" === item.usage) {
              vm.selectedAge.push(angular.copy(item));
              ref5 = vm.selectedAge.values;
              for (i = q = 0, len6 = ref5.length; q < len6; i = ++q) {
                itemd = ref5[i];
                vm.selectedAge.values[i] = parseFloat(vm.selectedAge.values[i]);
              }
            }
            if ("sport" === item.usage) {
              vm.selectedSport.push(angular.copy(item));
            }
            if ("group" === item.usage) {
              vm.selectedGroup.push(angular.copy(item));
            }
          }
          tmp_product = {};
          tmp_product = angular.copy(vm.product);
          ref6 = item_y.factors;
          for (r = 0, len7 = ref6.length; r < len7; r++) {
            item_z = ref6[r];
            if (item_z.is_default && item_z.factor !== null) {
              tmp_product.factors[item_z.factor[0].name] = item_z.values[0];
            }
          }
          item_y.tmp_product = tmp_product;
        }
        recalculateOnEventAll();
        return findMinInsurance();
      });
    };
    goToIssue = function(product) {
      var item, j, len, ref;
      vm.product = product;
      vm.product.trip = vm.color.name;
      vm.product.diffDays = vm.diffDays;
      vm.product.type_policy = vm.color.name;
      vm.product.insurance_amount = vm.insurance_amount;
      vm.product.currency_name = vm.currency_name;
      vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
      ref = vm.currenciesToday;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (item.currency === vm.currency_name) {
          vm.product.currencyRate1 = item.value;
        }
      }
      $state.go('app.policy_issue', {
        product: vm.product
      });
    };
    vm.arrow = 'fa fa-plus-square-o';
    changeArrow = function() {
      if (vm.arrow === 'fa fa-minus-square-o') {
        return vm.arrow = "fa fa-plus-square-o";
      } else {
        return vm.arrow = "fa fa-minus-square-o";
      }
    };
    vm.arrow2 = 'fa fa-minus-square-o';
    changeArrow2 = function() {
      if (vm.arrow2 === 'fa fa-minus-square-o') {
        return vm.arrow2 = "fa fa-plus-square-o";
      } else {
        return vm.arrow2 = "fa fa-minus-square-o";
      }
    };
    sorterFunc = function(data) {
      return parseInt(data.data.key);
    };
    vm.ifLessThanMin = ifLessThanMin;
    vm.changeIcon = changeIcon;
    vm.changeArrow2 = changeArrow2;
    vm.changeArrow = changeArrow;
    vm.goToIssue = goToIssue;
    vm.setProduct = setProduct;
    vm.computePrice = computePrice;
    vm.recalculateOnEvent = recalculateOnEvent;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.sorterFunc = sorterFunc;
    vm.changedRadio = changedRadio;
    getCurrencies();
  }).controller('PolicyIssueController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var addInsurant, changeIcon, computePrice, confirmAction, deleteInsurant, email, getCountries, j, l, len, len1, pdrobneeIconCnange, phone, reCompute, ref, ref1, savePolicy, vm;
    vm = this;
    vm.today = new Date();
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.product = $stateParams.product;
    vm.currency_name = '';
    vm.currencyRate = vm.product.currencyRate1;
    vm.iconsList = [];
    vm.pdrobneeIcon = 'fa fa-chevron-down';
    vm.minDay = moment().subtract(29200, 'days').format();
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.company = Session.getCompany();
    vm.buyer = {};
    if (vm.company.company_type = 'agent') {
      vm.buyer.surname = null;
      vm.buyer.name = null;
      if (vm.company.data.emails) {
        ref = vm.company.data.emails;
        for (j = 0, len = ref.length; j < len; j++) {
          email = ref[j];
          vm.buyer.email = email;
          break;
        }
      } else {
        vm.buyer.email = null;
      }
      if (vm.company.data.phones) {
        ref1 = vm.company.data.phones;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          phone = ref1[l];
          vm.buyer.phone = phone;
          break;
        }
      } else {
        vm.buyer.phone = null;
      }
    }
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('select.issue_listing', filter).then(function(result) {
        var item, itemx, len2, m, ref2, results;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        vm.min_insurance = 0;
        ref2 = result.countries;
        results = [];
        for (m = 0, len2 = ref2.length; m < len2; m++) {
          item = ref2[m];
          results.push((function() {
            var len3, n, ref3, results1;
            ref3 = vm.product.tmp_product.country_id;
            results1 = [];
            for (n = 0, len3 = ref3.length; n < len3; n++) {
              itemx = ref3[n];
              if (itemx === item._id) {
                vm.countriesView.push(item);
                if (item.min_insurance > vm.min_insurance) {
                  vm.min_insurance = item.min_insurance;
                  results1.push(vm.currentCountryId = itemx);
                } else {
                  results1.push(void 0);
                }
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          })());
        }
        return results;
      });
    };
    if (vm.product) {
      getCountries();
      vm.insurants = [
        {
          surname: '',
          name: '',
          passport_no: '',
          date_of_birth: '',
          factorListing: angular.copy(vm.product.factorListing),
          factors: angular.copy(vm.product.tmp_product.factors),
          theprice: angular.copy(vm.product.theprice),
          currency_value: vm.product.theprice * vm.currencyRate.toFixed(0)
        }
      ];
      vm.iconsList.push('fa fa-plus-square');
    } else {
      $state.go("app.policy_select");
    }
    addInsurant = function() {
      vm.insurants.push({
        surname: '',
        name: '',
        passport_no: '',
        date_of_birth: '',
        factorListing: angular.copy(vm.product.factorListing),
        factors: angular.copy(vm.product.tmp_product.factors),
        theprice: angular.copy(vm.product.theprice),
        currency_value: vm.product.theprice * vm.currencyRate.toFixed(0)
      });
      vm.iconsList.push('fa fa-plus-square');
    };
    deleteInsurant = function(index) {
      vm.insurants.splice(index, 1);
      vm.iconsList.splice(index, 1);
    };
    changeIcon = function(index) {
      if (vm.iconsList[index] === 'fa fa-plus-square') {
        return vm.iconsList[index] = 'fa fa-minus-square';
      } else {
        return vm.iconsList[index] = 'fa fa-plus-square';
      }
    };
    reCompute = function(insurant) {
      if (moment(insurant.date_of_birth).format() < vm.minDay) {
        toastr.warning('Дата рождение не больше 80 лет!');
        return;
      }
      if (insurant.date_of_birth && moment(insurant.date_of_birth).format() > vm.minDay) {
        insurant.factors['Возраст'] = moment().diff(insurant.date_of_birth, 'years');
        insurant.factors['Занятие спортом и активный отдых'] = insurant.factor_sport || "Не выбрано";
        insurant.theprice = computePrice(insurant).toFixed(2);
        insurant.currency_value = insurant.theprice * vm.currencyRate.toFixed(0);
      } else {
        insurant.theprice = computePrice(insurant).toFixed(2);
        insurant.currency_value = insurant.theprice * vm.currencyRate.toFixed(0);
      }
    };
    computePrice = function(insurant) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, len2, len3, len4, len5, m, n, o, obj_x, p, prod, ref2, ref3, ref4, ref5, theprice, timeDiff;
      prod = angular.copy(vm.product);
      prod.tmp_product.factors = insurant.factors;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref2 = vm.countries;
        for (m = 0, len2 = ref2.length; m < len2; m++) {
          country_x = ref2[m];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref3 = prod.basefactors;
      for (n = 0, len3 = ref3.length; n < len3; n++) {
        basefactor = ref3[n];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.product.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref4 = prod.factors;
      for (o = 0, len4 = ref4.length; o < len4; o++) {
        factor = ref4[o];
        if (factor.factor !== null) {
          ref5 = factor.factor;
          for (p = 0, len5 = ref5.length; p < len5; p++) {
            item_fact = ref5[p];
            if (item_fact.usage === 'age' && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
              if (factor.coefficient_type === "Множитель") {
                theprice = theprice * factor.coefficient;
              }
              if (factor.coefficient_type === "Слагаемое") {
                fixedamounts = fixedamounts + factor.coefficient;
              }
            }
            if (item_fact.usage === 'sport' && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
              if (factor.coefficient_type === "Множитель") {
                theprice = theprice * factor.coefficient;
              }
              if (factor.coefficient_type === "Слагаемое") {
                fixedamounts = fixedamounts + factor.coefficient;
              }
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    savePolicy = function() {
      var agent_id, branch_id, insurance_data, item, key, len2, len3, m, n, policy, policyList, policy_no, ref2, ref3, ref4, theUser, user, value;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
      }
      theUser = Session.getUser();
      if (vm.company) {
        ref2 = vm.company.staff;
        for (m = 0, len2 = ref2.length; m < len2; m++) {
          user = ref2[m];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      vm.product.data;
      insurance_data = angular.copy(vm.product.tmp_product);
      policyList = {
        items: []
      };
      ref3 = vm.insurants;
      for (n = 0, len3 = ref3.length; n < len3; n++) {
        item = ref3[n];
        if (item.theprice > 0) {
          insurance_data.factors = item.factors;
          insurance_data.factors_list = [];
          ref4 = item.factors;
          for (key in ref4) {
            value = ref4[key];
            value = value + "";
            insurance_data.factors_list.push({
              key: key,
              value: value
            });
          }
          policy_no = vm.product.code;
          if (vm.company.company_type === "agent") {
            agent_id = vm.company._id;
            policy_no = policy_no.slice(0, 3) + vm.company.code;
          }
          policy = {
            policy_no: policy_no,
            issue_date: new Date(),
            product_id: vm.product._id,
            company_id: vm.product.company_id,
            user_id: theUser.id,
            agent_id: agent_id,
            branch_id: branch_id,
            client: {
              surname: item.surname.toUpperCase(),
              name: item.name.toUpperCase(),
              passport_no: item.passport_no,
              date_of_birth: item.date_of_birth
            },
            insurance_amount: vm.product.insurance_amount,
            insurance_premium: item.theprice,
            insurance_data: angular.copy(insurance_data),
            payment_data: {},
            index: {},
            accumulation: {},
            data: {
              trip: vm.product.trip,
              buyer: vm.buyer,
              status: 'Оформлен',
              currency_name: vm.product.currency_name,
              insurance_premium_kgs: (item.theprice * vm.currencyRate).toFixed(0)
            }
          };
          policyList.items.push(policy);
        } else if (item.theprice === 0) {
          toastr.warning('Для ' + item.surname.toUpperCase() + ' ' + item.name.toUpperCase() + ' не создан полис');
        }
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        if (policyList.items.length === 1) {
          policy = angular.copy(policyList.items[0]);
          policy._id = result.resultList[0].id;
          policy._rev = result.resultList[0].rev;
          policy.policy_no = result.resultList[0].policy_no;
        }
        return $state.go('app.policy');
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var item, len2, m, ref2, temp, to_save;
        if (result) {
          to_save = [];
          ref2 = vm.insurants;
          for (m = 0, len2 = ref2.length; m < len2; m++) {
            item = ref2[m];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.changeIcon = changeIcon;
    vm.confirmAction = confirmAction;
    vm.addInsurant = addInsurant;
    vm.deleteInsurant = deleteInsurant;
    vm.reCompute = reCompute;
    vm.savePolicy = savePolicy;
  }).controller('PolicyViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, $uibModalInstance) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    findCurrencyName = function() {
      var country, currency, j, l, len, len1, ref, ref1;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        country = ref[j];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            currency = ref1[l];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var item, itemx, j, l, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        ref1 = vm.policy.insurance_data.country_id;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          itemx = ref1[l];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = $stateParams.product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, j, l, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (j = 0, len = ref.length; j < len; j++) {
        country_id = ref[j];
        ref1 = vm.countries;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          country = ref1[l];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, j, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code;
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
      $uibModalInstance.dismiss('cancel');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
  }).controller('PolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance, AppStorage) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issuePolicy, sendMail, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.now = moment().format('YYYY-MM-DD HH:mm');
    vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    findCurrencyName = function() {
      var country, currency, item, j, l, len, len1, len2, m, ref, ref1, ref2;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        country = ref[j];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            currency = ref1[l];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.currency_name) {
                ref2 = vm.currenciesToday;
                for (m = 0, len2 = ref2.length; m < len2; m++) {
                  item = ref2[m];
                  if (item.currency === vm.currency_name) {
                    vm.currencyRate1 = item.value;
                  }
                }
                vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate1).toFixed(0);
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var item, itemx, j, l, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        ref1 = vm.policy.insurance_data.country_id;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          itemx = ref1[l];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, j, l, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (j = 0, len = ref.length; j < len; j++) {
        country_id = ref[j];
        ref1 = vm.countries;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          country = ref1[l];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, j, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code;
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issuePolicy = function() {
      var item, j, len, ref;
      ref = vm.currenciesToday;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (item.currency === vm.currency_name) {
          vm.currencyRate = item.value;
        }
      }
      console.log("vm.currencyRate " + vm.currencyRate);
      FormPolicy();
    };
    spoilPolicy = function() {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termPolicy = function(moneyBack) {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
      $uibModalInstance.dismiss();
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  }).controller('PolicyFormController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var FormPolicy, SavePolicy, computePrice, confirmActionForm, confirmActionSave, findCurrencyName, findMinInsurance, getCountries, getProducts, ifLessThanMin, issuePolicy, reCompute, sendMail, vm;
    vm = this;
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    ifLessThanMin = function(item) {
      if (parseInt(item.data.key) >= vm.min_insurance) {
        return true;
      } else {
        return false;
      }
    };
    findCurrencyName = function() {
      var country, currency, j, l, len, len1, ref, ref1;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        country = ref[j];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            currency = ref1[l];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var item, itemx, j, l, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        ref1 = vm.policy.insurance_data.country_id;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          itemx = ref1[l];
          if (itemx === item._id) {
            vm.countriesView.push(item);
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('countries.listing', filter).then(function(result) {
        vm.countries = result.docs;
        findMinInsurance();
        RequestService.post('currencies.listing').then(function(result2) {
          vm.currencies = result2.docs;
          findCurrencyName();
        });
      });
    };
    getProducts = function(product_id) {
      var company, filter;
      filter = {
        with_related: true
      };
      company = Session.getCompany();
      if (company) {
        if (company.company_type === "insurance_company") {
          filter = {
            with_related: true,
            filter: {
              company_id: company._id,
              _id: product_id
            }
          };
        } else if (company.insurance_company) {
          filter = {
            with_related: true,
            filter: {
              company_id: company.insurance_company._id,
              _id: product_id
            }
          };
        } else {
          filter = {
            with_related: true,
            filter: {
              product_id: product_id
            }
          };
        }
      }
      RequestService.post('product.listing', filter).then(function(result) {
        var factor, isIn, item, item_y, j, l, len, len1, len2, len3, m, n, ref, ref1, ref2, temparr, x, y;
        ref = result.docs;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          temparr = [];
          if (item.factors !== null && item.factors !== void 0) {
            ref1 = item.factors;
            for (l = 0, len1 = ref1.length; l < len1; l++) {
              factor = ref1[l];
              isIn = false;
              for (m = 0, len2 = temparr.length; m < len2; m++) {
                x = temparr[m];
                if (x.factor_id === factor.factor_id) {
                  x.values = x.values.concat(factor.values);
                  isIn = true;
                }
              }
              if (isIn === false) {
                y = {
                  factor_id: factor.factor_id,
                  name: factor.factor.name,
                  usage: factor.factor.usage,
                  values: factor.values,
                  description: factor.factor.description
                };
                temparr.push(y);
              }
            }
            item.factorListing = temparr;
          }
        }
        vm.productsList = result.docs;
        ref2 = vm.productsList;
        for (n = 0, len3 = ref2.length; n < len3; n++) {
          item_y = ref2[n];
          item_y.tmp_product = vm.policy.insurance_data;
        }
        vm.product = vm.productsList[0];
        getCountries();
        return console.log(vm.product);
      });
    };
    vm.policy = $stateParams.policy;
    if (vm.policy) {
      getProducts(vm.policy.product_id);
    } else {
      console.log("Страница на получила данные");
      $state.go("app.policy");
    }
    vm.company = Session.getCompany();
    reCompute = function(arg) {
      findMinInsurance();
      vm.policy.insurance_data.factors['Возраст'] = moment().diff(vm.policy.client.date_of_birth, 'years') + "";
      vm.policy.insurance_premium = $filter('number')(computePrice(), 2);
    };
    computePrice = function() {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, j, l, len, len1, len2, m, obj_x, prod, ref, ref1, ref2, theprice, timeDiff;
      if (vm.policy.insurance_data.country_id.length === 0) {
        return 0;
      }
      prod = angular.copy(vm.product);
      prod.tmp_product = angular.copy(vm.policy.insurance_data);
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref = vm.countries;
        for (j = 0, len = ref.length; j < len; j++) {
          country_x = ref[j];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref1 = prod.basefactors;
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        basefactor = ref1[l];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.policy.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref2 = prod.factors;
      for (m = 0, len2 = ref2.length; m < len2; m++) {
        factor = ref2[m];
        if (prod.tmp_product.factors[factor.factor.name] !== null && prod.tmp_product.factors[factor.factor.name] !== void 0 && factor.values.indexOf(prod.tmp_product.factors[factor.factor.name].toString()) > -1) {
          if (factor.coefficient_type === "Множитель") {
            theprice = theprice * factor.coefficient;
          }
          if (factor.coefficient_type === "Слагаемое") {
            fixedamounts = fixedamounts + factor.coefficient;
          }
        }
      }
      theprice = theprice + fixedamounts;
      console.log("theprice : " + theprice);
      return theprice;
    };
    sendMail = function() {
      var countries, country, country_id, j, l, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (j = 0, len = ref.length; j < len; j++) {
        country_id = ref[j];
        ref1 = vm.countries;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          country = ref1[l];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, j, key, len, policyList, policy_no, ref, ref1, theUser, user, value;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code;
      }
      vm.policy.policy_no = policy_no;
      vm.policy.user_id = theUser.id;
      vm.policy.issue_date = new Date();
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = 'Оформлен';
      vm.policy.data.currency_name = vm.currency_name;
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      vm.policy.insurance_data.factors_list = [];
      vm.policy.client.name = vm.policy.client.name.toUpperCase();
      vm.policy.client.surname = vm.policy.client.surname.toUpperCase();
      ref1 = vm.policy.insurance_data.factors;
      for (key in ref1) {
        value = ref1[key];
        value = value + "";
        vm.policy.insurance_data.factors_list.push({
          key: key,
          value: value
        });
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        vm.policy.policy_no = result.resultList[0].policy_no;
        toastr.success('Полис оформлен успешно');
        sendMail();
        return $state.go('app.policy_show', {
          product: vm.policy
        });
      });
      return false;
    };
    issuePolicy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        FormPolicy();
      });
    };
    SavePolicy = function() {
      var branch_id, j, key, len, policyList, ref, ref1, theUser, user, value;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.currency_name = vm.currency_name;
      vm.policy.insurance_data.factors_list = [];
      ref1 = vm.policy.insurance_data.factors;
      for (key in ref1) {
        value = ref1[key];
        vm.policy.insurance_data.factors_list.push({
          key: key,
          value: value
        });
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис сохранен успешно');
        return $state.go('app.policy_show', {
          product: angular.copy(policyList.items[0])
        });
      });
      return false;
    };
    confirmActionSave = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var temp, to_save;
        if (result) {
          to_save = [];
          temp = {
            client_type: 'insured',
            name: vm.policy.client.name,
            surname: vm.policy.client.surname,
            passport: vm.policy.client.passport_no,
            date_of_birth: vm.policy.client.date_of_birth
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            SavePolicy();
          });
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var temp, to_save;
        if (result) {
          to_save = [];
          temp = {
            client_type: 'insured',
            name: vm.policy.client.name,
            surname: vm.policy.client.surname,
            passport: vm.policy.client.passport_no,
            date_of_birth: vm.policy.client.date_of_birth
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            issuePolicy();
          });
        }
      });
    };
    vm.ifLessThanMin = ifLessThanMin;
    vm.confirmActionForm = confirmActionForm;
    vm.confirmActionSave = confirmActionSave;
    vm.SavePolicy = SavePolicy;
    vm.findMinInsurance = findMinInsurance;
    vm.FormPolicy = FormPolicy;
    vm.getProducts = getProducts;
    vm.reCompute = reCompute;
  }).controller('PolicyDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TerminateDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    vm.moneyBack = 0;
    ok = function() {
      $uibModalInstance.close(vm.moneyBack);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).filter('filterCountries', function() {
    return function(input, search) {
      var item, j, len, res;
      res = [];
      if (input) {
        for (j = 0, len = input.length; j < len; j++) {
          item = input[j];
          if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.data.name_eng.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
            res.push(item);
          }
        }
      } else {
        return [];
      }
      return res;
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('PaymentController', function($scope, $state, RequestService, hotkeys, $uibModal) {
    'ngInject';
    var editPayment, getPayments, newPayment, viewPayment, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'branch.name',
          displayName: 'Филиал'
        }, {
          name: 'amount',
          displayName: 'Наименование'
        }, {
          name: 'currency.name',
          displayName: 'Валюта'
        }, {
          name: 'payment_direction_value.data.name',
          displayName: 'Направление платежа'
        }, {
          name: 'payment_type_value.data.name',
          displayName: 'Тип платежа'
        }, {
          name: 'payment_date',
          displayName: 'Дата редактирования',
          cellTemplate: '<div class="ui-grid-cell-contents" am-time-ago="grid.getCellValue(row,col)"></div>'
        }
      ],
      appScopeProvider: {
        onDoubleClick: function(row) {
          viewPayment(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getPayments = function() {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true
      };
      RequestService.post('payment.listing', filter).then(function(result) {
        delete vm.selected_payment;
        vm.gridOptions.data = result.payments;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newPayment = function() {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentEditController',
        controllerAs: 'edit',
        templateUrl: 'app/payment/edit.html',
        size: 'lg',
        resolve: {
          payment: void 0
        }
      });
      paymentModal.result.then(function(result) {
        getPayments();
      });
    };
    editPayment = function() {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentEditController',
        controllerAs: 'edit',
        templateUrl: 'app/payment/edit.html',
        size: 'lg',
        resolve: {
          payment: angular.copy(vm.selected_payment)
        }
      });
      paymentModal.result.then(function(result) {
        getPayments();
      });
    };
    viewPayment = function(payment) {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentViewController',
        controllerAs: 'view',
        templateUrl: 'app/payment/view.html',
        size: 'lg',
        resolve: {
          payment: payment
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_payment = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPayments();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить платеж',
      callback: newPayment
    }).add({
      combo: 'r',
      description: 'Обновить список платежей',
      callback: getPayments
    });
    vm.getPayments = getPayments;
    vm.newPayment = newPayment;
    vm.editPayment = editPayment;
    getPayments();
  }).controller('PaymentEditController', function($scope, $state, RequestService, payment, $uibModalInstance, toastr) {
    'ngInject';
    var savePayment, vm;
    vm = this;
    vm.payment = payment;
    savePayment = function() {
      if (vm.saving === true) {
        return;
      }
      if ((angular.isDefined(vm.payment.data.contractor_id)) && (angular.isDefined(vm.payment.data.employee_id)) && (angular.isDefined(vm.payment.data.branch_id))) {
        vm.contractor_error = angular.isDefined(vm.payment.data.contractor_id);
        vm.employee_error = angular.isDefined(vm.payment.data.employee_id);
        vm.brach_error = angular.isDefined(vm.payment.data.branch_id);
        toastr.warning('Укажите только одного');
        vm.saving = false;
        return;
      }
      if ((angular.isUndefined(vm.payment.data.contractor_id)) && (angular.isUndefined(vm.payment.data.employee_id)) && (angular.isUndefined(vm.payment.data.branch_id))) {
        vm.contractor_error = true;
        vm.employee_error = true;
        vm.brach_error = true;
        toastr.warning('Заполните одно из полей');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.branch_id)) {
        toastr.warning('Укажите филиал');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.currency_id)) {
        toastr.warning('Укажите валюту');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.payment_direction)) {
        toastr.warning('Укажите направление платежа');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.payment_type)) {
        toastr.warning('Укажите тип платежа');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.amount)) {
        toastr.warning('Укажите сумму');
        vm.saving = false;
        return;
      }
      vm.saving = true;
      RequestService.post('payment.put', vm.payment).then(function(result) {
        vm.saving = false;
        return $uibModalInstance.close(result);
      }, function(result) {
        vm.saving = false;
      });
    };
    vm.savePayment = savePayment;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PaymentViewController', function($scope, $state, RequestService, payment, $uibModalInstance) {
    'ngInject';
    var vm;
    vm = this;
    vm.payment = payment;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('PatientController', function() {
    var vm;
    vm = this;
  }).controller('PatientMainController', function($scope, RequestService, IntermediateDataService, $state, $uibModal, AppStorage) {
    var openAddForm, openEditForm, openImportModal, resetFilter, searchPatient, vm;
    vm = this;
    vm.filter = {};
    vm.dirRelativeDegrees = [];
    vm.patients = [];
    $("#exam_date").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    RequestService.post('dictionarya.listing', {
      type: 'DirRelativeDegree'
    }).then(function(response) {
      vm.dirRelativeDegrees = response.docs;
    }, function(response) {
      console.log(response);
    });
    openImportModal = function() {
      var modalInstance, onPressCancel, onPressOk;
      modalInstance = $uibModal.open({
        templateUrl: 'app/patient/import-modal.html',
        controller: 'ImportPatientController',
        size: 'lg'
      });
      onPressOk = function() {};
      onPressCancel = function() {};
      modalInstance.result.then(onPressOk, onPressCancel);
    };
    searchPatient = function() {
      RequestService.post('policiesa.get_patient_list', vm.filter).then(function(response) {
        vm.patientGridOptions.data = response.docs;
        AppStorage.setObject('patientFilterParams', vm.filter);
      }, function(response) {
        console.log(response);
      });
    };
    resetFilter = function() {
      vm.filter = {};
    };
    openAddForm = function() {
      IntermediateDataService.set({});
      $state.go('app.patient.edit');
    };
    openEditForm = function() {
      IntermediateDataService.set(vm.selectedRow.entity);
      $state.go('app.patient.edit');
    };
    vm.patientGridOptions = {
      noUnselect: false,
      multiSelect: false,
      enableRowSelection: false,
      enableFullRowSelection: true,
      enableSelectAll: false,
      showGridFooter: true,
      columnDefs: [
        {
          name: 'fullname',
          displayName: 'ФИО',
          width: '20%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'policy_no',
          displayName: 'Номер полиса',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'birthday',
          displayName: 'Дата рождения',
          width: '10%',
          cellFilter: 'date: "dd.MM.yyyy"',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'relative_degree',
          displayName: 'Степень родства',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }
      ],
      onRegisterApi: function(gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function(row) {
          vm.selectedRow = row;
        });
        vm.gridApi = gridApi;
      }
    };
    vm.openEditForm = openEditForm;
    vm.openAddForm = openAddForm;
    vm.searchPatient = searchPatient;
    vm.resetFilter = resetFilter;
    vm.openImportModal = openImportModal;
    vm.filter = AppStorage.getObject('patientFilterParams');
    if (vm.filter) {
      searchPatient();
    } else {
      vm.filter;
    }
  }).controller('PatientEditController', function($scope, RequestService, IntermediateDataService, $state) {
    var goBack, savePatient, searchPolicy, vm;
    vm = this;
    vm.patient = IntermediateDataService.get({});
    vm.dateOptions = {
      opened: false
    };
    vm.policies = [];
    vm.dirRelativeDegrees = [];
    RequestService.post('dictionarya.listing', {
      type: 'DirRelativeDegree'
    }).then(function(response) {
      vm.dirRelativeDegrees = response.docs;
    }, function(response) {
      console.log(response);
    });
    searchPolicy = function(policyno) {
      if (!policyno) {
        return;
      }
      RequestService.post('policiesa.find', {
        policy_no: policyno
      }).then(function(response) {
        vm.policies = response.docs;
      }, function(response) {
        console.log(response);
      });
    };
    savePatient = function() {
      RequestService.post('policiesa/put_patient', vm.patient).then(function(response) {
        console.log(response);
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    goBack = function() {
      $state.go('app.patient.main');
    };
    vm.searchPolicy = searchPolicy;
    vm.savePatient = savePatient;
    vm.goBack = goBack;
  }).controller('ImportPatientController', function($scope, $uibModalInstance, RequestService) {
    'ngInject';
    $scope.patients = [];
    $scope.disabled = false;
    $scope.patientGridOptions = {
      data: 'patients',
      noUnselect: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полиса',
          width: '15%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'status_code',
          displayName: 'Статус',
          width: '15%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'product_id',
          displayName: 'Продукт',
          width: '15%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'fullname',
          displayName: 'ФИО',
          width: '20%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'birthday',
          displayName: 'Дата рождения',
          cellFilter: 'date:"dd.MM.yyyy"',
          width: '15%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'relative_degree_id',
          displayName: 'Род. связь',
          width: '15%',
          maxWidth: 500,
          minWidth: 50
        }
      ]
    };
    $scope.readWorkbook = function(workbook) {
      if (workbook.SheetNames.length > 0) {
        $scope.patients = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
        $scope.patientGridOptions.data = $scope.patients;
      }
    };
    $scope.onWorkbookLoadError = function(e) {
      console.log(e);
    };
    $scope.cancel = function() {
      $uibModalInstance.dismiss('canceled');
    };
    return $scope.ok = function() {
      $scope.disabled = true;
      RequestService.post('policiesa.put_patient_list', {
        list: $scope.patients
      }).then(function(result) {
        $uibModalInstance.close();
      });
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('OperationsController', function(Session, AppStorage, $state, operation_types, operation_statuses, NgTableParams, $stateParams) {
    'ngInject';
    var initColumns, initOperations, vm;
    vm = this;
    vm.userAccount = Session.getUser() || void 0;
    vm.company = AppStorage.getObject('company') || void 0;
    if (vm.company === void 0) {
      $state.go('app.main.company');
      return;
    }
    vm.operation_types = operation_types;
    vm.operation_statuses = operation_statuses;
    initOperations = function() {
      if (vm.products && vm.units && vm.currencies && vm.contractors) {
        getOperations();
      }
    };
    initColumns = function() {
      if (vm.columns === void 0) {
        vm.columns = [];
      }
      vm.columns.splice(0, vm.columns.length);
      Array.prototype.push.apply(vm.columns, [
        {
          title: 'Продукт',
          valueExpr: 'product.name',
          show: true,
          filter: {
            'product.name': 'text'
          },
          sortable: 'product.name'
        }, {
          title: 'Тип оперции',
          valueExpr: 'type.value',
          show: true,
          filter: {
            'type.value': 'text'
          },
          sortable: 'type.value'
        }, {
          title: 'Статус',
          valueExpr: 'status.value',
          show: true,
          filter: {
            'status.value': 'text'
          },
          sortable: 'status.value'
        }, {
          title: 'Единица изм.',
          valueExpr: 'unit.data.short_name',
          show: false,
          filter: {
            'unit.name': 'text'
          },
          sortable: 'unit.data.short_name'
        }, {
          title: 'Количество',
          valueExpr: 'quantity',
          show: true,
          filter: {
            'quantity': 'number'
          },
          sortable: 'quantity'
        }, {
          title: 'Валюта',
          valueExpr: 'currency.name',
          show: true,
          filter: {
            'currency.name': 'text'
          },
          sortable: 'currency.name'
        }, {
          title: 'Контрагент',
          valueExpr: 'contractor.name',
          show: false,
          filter: {
            'contractor.name': 'text'
          },
          sortable: 'contractor.name'
        }, {
          title: 'Филиал',
          valueExpr: 'target_branch.name',
          show: false,
          filter: {
            'target_branch.name': 'text'
          },
          sortable: 'target_branch.name'
        }, {
          title: 'Утверждение',
          valueExpr: 'approval.status.value',
          show: false,
          filter: {
            'approval.status.value': 'text'
          },
          sortable: 'approval.status.value'
        }, {
          title: 'Проводка',
          valueExpr: 'book.status.value',
          show: false,
          filter: {
            'book.status.value': 'text'
          },
          sortable: 'book.status.value'
        }, {
          title: 'Назначение ЦЗ',
          valueExpr: 'purpose.name',
          show: false,
          filter: {
            'purpose.name': 'text'
          },
          sortable: 'purpose.name'
        }, {
          title: 'Цена ед.',
          valueExpr: 'quote_unit_price',
          show: false,
          filter: {
            'quote_unit_price': 'number'
          },
          sortable: 'quote_unit_price'
        }, {
          title: 'Итог стоимости',
          valueExpr: 'total_cost',
          show: true,
          filter: {
            'total_cost': 'number'
          },
          sortable: 'total_cost'
        }, {
          title: 'Дополнительная стоимость',
          valueExpr: 'additional_cost',
          show: true,
          filter: {
            'additional_cost': 'number'
          },
          sortable: 'additional_cost'
        }, {
          title: 'Стоимость ед.',
          valueExpr: 'cost_per_unit',
          show: false,
          filter: {
            'cost_per_unit': 'number'
          },
          sortable: 'cost_per_unit'
        }, {
          title: 'Стоимость в KGS',
          valueExpr: 'cost_kgs',
          show: false,
          filter: {
            'cost_kgs': 'number'
          },
          sortable: 'cost_kgs'
        }, {
          title: 'Баланс',
          valueExpr: 'balance',
          show: false,
          filter: {
            'balance': 'number'
          },
          sortable: 'balance'
        }, {
          title: 'Дата доставки',
          valueExpr: 'delivery_date',
          show: false,
          filter: {
            'delivery_date': 'text'
          },
          sortable: 'delivery_date'
        }, {
          title: 'В долг',
          valueExpr: 'is_due',
          show: false,
          filter: {
            'is_due': 'text'
          },
          sortable: 'is_due'
        }, {
          title: 'Долг закрыт',
          valueExpr: 'due_closed',
          show: false,
          filter: {
            'due_closed': 'text'
          },
          sortable: 'due_closed'
        }, {
          title: 'Срок выплаты',
          valueExpr: 'due_date',
          show: false,
          filter: {
            'due_date': 'text'
          },
          sortable: 'due_date'
        }, {
          title: 'Дополнительно',
          valueExpr: 'data',
          show: false,
          filter: {
            'data': 'text'
          },
          sortable: 'data'
        }, {
          title: 'Опции',
          dataType: 'action',
          show: true
        }
      ]);
    };
    vm.getOperations = getOperations;
    initColumns();
    getUnits();
  });

}).call(this);

(function() {
  angular.module('stock').controller('OperationViewController', function($state, Session, AppStorage, $stateParams, operation_types, operation_statuses, booking_statuses, booking_types, approve_statuses, approve_types, dt) {
    'ngInject';
    var initApproval, initBooking, initOperation, vm;
    vm = this;
    vm.userAccount = Session.getUser() || void 0;
    vm.company = AppStorage.getObject('company') || void 0;
    if (vm.company === void 0) {
      $state.go('app.main.company');
      return;
    }
    vm.dt = dt;
    vm.operation_statuses = operation_statuses;
    vm.operation_types = operation_types;
    vm.booking_statuses = booking_statuses;
    vm.booking_types = booking_types;
    vm.approval_statuses = approve_statuses;
    vm.approval_types = approve_types;
    initBooking = function() {
      if (vm.branches && vm.operation && vm.operation.book_id) {
        return getBooking();
      }
    };
    initApproval = function() {
      if (vm.branches && vm.roles && vm.operation && vm.operation.approval_id) {
        getApproval();
      }
    };
    initOperation = function() {
      if (vm.branches && vm.products && vm.units && vm.currencies && vm.contractors && vm.purposes) {
        getOperation();
      }
    };
    getUnits();
  });

}).call(this);

(function() {
  angular.module('stock').controller('OperationController', function(Session, AppStorage, $state, $stateParams, $rootScope, operation_types, operation_statuses, booking_statuses, booking_types, approve_statuses, approve_types, dt, AppToast, RequestService, user_company_accesses) {
    'ngInject';
    var addOperation, calcTotalCost, calcUnitPrice, cancelPutOperation, datePickerDeliveryDate, datePickerDueDate, editOperation, getEmployees, getFooter, goBack, i, initContent, len, productSelected, putOperation, putOperations, ref, type, vm;
    vm = this;
    vm.userAccount = Session.getUser() || void 0;
    vm.company = AppStorage.getObject('company') || void 0;
    if (vm.company === void 0) {
      $state.go('app.main.company');
      return;
    }
    vm.dt = dt;
    vm.operation_types = operation_types;
    vm.operation_type = vm.operation_types[0];
    ref = vm.operation_types;
    for (i = 0, len = ref.length; i < len; i++) {
      type = ref[i];
      if ($stateParams.type === type.key) {
        vm.operation_type = type;
      }
    }
    vm.operation_statuses = operation_statuses;
    vm.operation_status = vm.operation_statuses[0];
    vm.booking_statuses = booking_statuses;
    vm.booking_types = booking_types;
    vm.booking = {
      status: vm.booking_statuses[0],
      type: vm.operation_type.key === 'purchase' ? vm.booking_types[0] : vm.booking_types[1]
    };
    vm.approval_statuses = approve_statuses;
    vm.approval_types = approve_types;
    vm.approval = {
      status: vm.approval_statuses[0],
      type: vm.approval_types[0]
    };
    vm.operations = [];
    vm.new_operation = {};
    vm.popup_delivery_date = {
      opened: false
    };
    vm.popup_due_date = {
      opened: false
    };
    datePickerDeliveryDate = function() {
      vm.popup_delivery_date.opened = true;
    };
    datePickerDueDate = function() {
      vm.popup_due_date.opened = true;
    };
    initContent = function() {
      if (vm.roles && vm.branches && vm.products && vm.units && vm.contractors && vm.cost_center_purposes && vm.currencies && vm.rules) {
        if ($stateParams.action === 'edit') {
          initApproval();
          initBooking();
          initOperations();
        }
      }
    };
    getEmployees = function() {
      vm.employees = AppStorage.getObject('employees') || [];
      if (vm.employees.length > 0) {
        vm.executor = vm.employees[0];
      }
      initBooking();
      RequestService.post('company/employees', {
        company_id: vm.company.id
      }).then(function(data) {
        var employee, j, len1, ref1, user_company_access;
        vm.employees = data.bobject;
        ref1 = vm.employees;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          employee = ref1[j];
          employee.role = (function() {
            var k, len2, results;
            results = [];
            for (k = 0, len2 = user_company_accesses.length; k < len2; k++) {
              user_company_access = user_company_accesses[k];
              if (user_company_access.key === employee.access) {
                results.push(user_company_access);
              }
            }
            return results;
          })();
        }
        if (vm.employees.length > 0) {
          vm.executor = vm.employees[0];
        }
        return AppStorage.setObject('employees', vm.employees);
      });
    };
    addOperation = function() {
      cancelPutOperation();
      $('#addOperationModal').modal('show');
      return false;
    };
    putOperation = function() {
      if (vm.temp_positon === -1) {
        vm.operations.push(vm.new_operation);
      } else {
        vm.operations[vm.temp_positon] = angular.copy(vm.new_operation);
      }
      return cancelPutOperation();
    };
    cancelPutOperation = function() {
      $('#addOperationModal').modal('hide');
      vm.temp_positon = -1;
      vm.new_operation = {
        product: vm.products ? vm.products[0] : void 0,
        data: {
          pricing_rule_id: void 0
        }
      };
      productSelected();
      return false;
    };
    editOperation = function(operation, position) {
      vm.temp_positon = position;
      vm.new_operation = angular.copy(operation);
      getPricingRules();
      $('#addOperationModal').modal('show');
      return false;
    };
    putOperations = function() {
      var approval_data, booking_data, j, len1, operation, operation_data, operations_data, ref1, ref2, role;
      vm.disabled = true;
      if (vm.operations.length === 0) {
        vm.disabled = false;
        AppToast.pop('warning', 'Выберите продукты');
        return;
      }
      $('#progressModal').modal('show');
      operations_data = [];
      ref1 = vm.operations;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        operation = ref1[j];
        operation_data = {
          _id: operation._id,
          _rev: operation._rev,
          company_id: vm.company.id,
          branch_id: vm.branch._id,
          product_id: operation.product._id,
          unit_id: operation.unit._id,
          quantity: operation.quantity,
          quote_unit_price: operation.quote_unit_price,
          cost_per_unit: operation.cost_per_unit,
          additional_cost: operation.additional_cost,
          cost_kgs: operation.cost_kgs,
          balance: operation.balance,
          total_cost: operation.total_cost,
          data: operation.data
        };
        operation_data.operation_type = vm.operation_type.key;
        operation_data.contractor_id = operation_data.operation_type !== 'consumption' && operations_data.operation_type !== 'movement' ? vm.contractor._id : void 0;
        operation_data.target_branch_id = operation_data.operation_type === 'movement' ? vm.target_branch._id : void 0;
        operation_data.purpose_id = operation_data.operation_type === 'consumption' ? vm.purpose._id : void 0;
        operation_data.quote_currency_id = vm.currency._id;
        operation_data.delivery_date = vm.delivery_date;
        operation_data.operation_status = vm.operation_status.key;
        if (operation.rule && operation.rule._id !== void 0 && operation.rule._id !== 0) {
          operation_data.data.pricing_rule_id = operation.rule._id;
        }
        if (vm.as_due) {
          operation_data.is_due = vm.as_due;
          operation_data.due_closed = (ref2 = operation_data.due_closed) != null ? ref2 : false;
          operation_data.due_date = vm.due_date;
        }
        operation_data.book_id = vm.booking._id ? vm.booking._id : void 0;
        operation_data.approval_id = vm.approval._id ? vm.approval._id : vm.booking.approval_id ? vm.booking.approval_id : void 0;
        operations_data.push(operation_data);
      }
      booking_data = {
        _id: vm.booking._id,
        _rev: vm.booking._rev,
        company_id: vm.company.id,
        branch_id: vm.branch._id,
        booking_type: vm.booking.type.key,
        booking_status: vm.booking.status.key,
        data: vm.booking.data
      };
      if (vm.as_approval) {
        if (vm.outputRoles.length === 0) {
          AppToast.pop('warning', 'Укахите роли для одобрения');
          $('#progressModal').modal('hide');
          return;
        }
        approval_data = {
          _id: vm.approval._id,
          _rev: vm.approval._rev,
          company_id: vm.company.id,
          branch_id: vm.branch._id,
          approve_type: vm.approval.type.key,
          approve_status: vm.approval.status.key,
          roles_id: (function() {
            var k, len2, ref3, results;
            ref3 = vm.outputRoles;
            results = [];
            for (k = 0, len2 = ref3.length; k < len2; k++) {
              role = ref3[k];
              results.push(role._id);
            }
            return results;
          })(),
          users: [],
          data: vm.approval.data
        };
        addApproval(approval_data, operations_data, booking_data);
      } else {
        addBooking(booking_data, operations_data);
      }
    };
    calcTotalCost = function(operation) {
      var ac, q, qup, ref1, ref2, ref3;
      if (operation === void 0 || operation === null || operation.quantity === void 0 || operation.quote_unit_price === void 0) {
        return;
      }
      q = (ref1 = operation.quantity) != null ? ref1 : 0;
      qup = (ref2 = operation.quote_unit_price) != null ? ref2 : 0;
      ac = (ref3 = operation.additional_cost) != null ? ref3 : 0;
      operation.total_cost = q * qup;
      operation.cost_per_unit = (q * qup + ac) / q;
    };
    calcUnitPrice = function(operation) {
      var ac, q, qup, ref1, ref2, ref3, ref4, tc;
      if (operation === void 0 || operation === null || operation.quantity === void 0 || operation.total_cost === void 0) {
        return;
      }
      q = (ref1 = operation.quantity) != null ? ref1 : 0;
      tc = (ref2 = operation.total_cost) != null ? ref2 : 0;
      ac = (ref3 = operation.additional_cost) != null ? ref3 : 0;
      operation.quote_unit_price = tc / q;
      qup = (ref4 = operation.quote_unit_price) != null ? ref4 : 0;
      operation.cost_per_unit = (q * qup + ac) / q;
    };
    getFooter = function() {
      var footer, j, len1, operation, ref1, ref2;
      footer = {
        total_cost: 0
      };
      ref1 = vm.operations;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        operation = ref1[j];
        footer.total_cost += (ref2 = operation.total_cost) != null ? ref2 : 0;
      }
      return footer;
    };
    productSelected = function() {
      var j, len1, ref1, unit;
      if (vm.units) {
        ref1 = vm.units;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          unit = ref1[j];
          if (unit._id === vm.new_operation.product.data.unit_id) {
            vm.new_operation.unit = unit;
            break;
          }
        }
      } else {
        getUnits();
      }
      return getPricingRules();
    };
    goBack = function() {
      if ($stateParams.action === 'edit') {
        if ($stateParams.book_id !== void 0) {
          $state.go('app.main.booking_view', {
            id: $stateParams.book_id
          });
          return;
        } else if ($stateParams.approval_id !== void 0) {
          $state.go('app.main.approval_view', {
            id: $stateParams.approval_id
          });
          return;
        }
      } else if ($stateParams.action === 'new') {
        if (vm.as_approval === true) {
          $state.go('app.main.approval');
          return;
        }
      }
      $state.go('app.main.booking');
    };
    vm.addOperation = addOperation;
    vm.putOperations = putOperations;
    vm.cancelPutOperation = cancelPutOperation;
    vm.editOperation = editOperation;
    vm.putOperation = putOperation;
    vm.calcTotalCost = calcTotalCost;
    vm.calcUnitPrice = calcUnitPrice;
    vm.getFooter = getFooter;
    vm.productSelected = productSelected;
    vm.datePickerDeliveryDate = datePickerDeliveryDate;
    vm.datePickerDueDate = datePickerDueDate;
    vm.goBack = goBack;
    getUnits();
    getEmployees();
  });

}).call(this);

(function() {
  angular.module('stock').controller('OperationController', function($scope, $state, RequestService, hotkeys, $uibModal) {
    'ngInject';
    var getOperations, viewOperation, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'branch.name',
          displayName: 'Филиал'
        }, {
          name: 'product.name',
          displayName: 'Продукт'
        }, {
          name: 'quantity',
          displayName: 'Наименование'
        }, {
          name: 'currency.name',
          displayName: 'Валюта'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена'
        }, {
          name: 'total_cost',
          displayName: 'Сумма'
        }, {
          name: 'additional_cost',
          displayName: 'Доп. стоимость'
        }
      ],
      appScopeProvider: {
        onDoubleClick: function(row) {
          viewOperation(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getOperations = function() {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true
      };
      RequestService.post('operation.listing', filter).then(function(result) {
        delete vm.selected_operation;
        vm.gridOptions.data = result.operations;
        vm.gridOptions.totalItems = result.count;
      });
    };
    viewOperation = function(operation) {
      var operationModal;
      operationModal = $uibModal.open({
        controller: 'OperationViewController',
        controllerAs: 'view',
        templateUrl: 'app/operation/view.html',
        size: 'lg',
        resolve: {
          operation: operation
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_operation = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getOperations();
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить список операций',
      callback: getOperations
    });
    vm.getOperations = getOperations;
    getOperations();
  }).controller('OperationViewController', function($scope, $state, RequestService, operation, $uibModalInstance) {
    'ngInject';
    var vm;
    vm = this;
    vm.operation = operation;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('OpController', function() {
    var vm;
    return vm = this;
  }).controller('OpSaleController', function($scope, hotkeys, $uibModal, uiGridConstants, $timeout, OpService) {
    var getNext, getPrevious, gridOptions, invoices, purge, save, scanned, search, setData, startNew, total, vm;
    vm = this;
    invoices = [
      {
        products: []
      }
    ];
    gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          pinnedLeft: true,
          displayName: 'Наименование',
          enableCellEdit: false
        }, {
          name: 'count',
          pinnedLeft: true,
          displayName: 'Количество',
          type: 'number'
        }, {
          name: 'price',
          pinnedLeft: true,
          displayName: 'Цена',
          enableCellEdit: false
        }, {
          name: 'sum',
          pinnedLeft: true,
          displayName: 'Сумма',
          enableCellEdit: false,
          cellTemplate: '<div class="ui-grid-cell-contents" >{{row.entity.count*row.entity.price}}</div>'
        }
      ]
    };
    scanned = function(e) {
      vm.currentCode = e;
      $scope.$digest();
    };
    search = function(event, key) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: '/app/modals/search-product.html',
        controller: 'SearchProdController'
      });
      modalInstance.result.then(function(e) {
        var p;
        p = {
          id: e._id,
          count: 1,
          price: e.data.price,
          name: e.data.name
        };
        vm.currentInvoice.products.push(p);
        setData();
        $timeout(function() {
          return vm.gridOptions.gridApi.selection.selectRow(p);
        });
      });
      event.preventDefault;
    };
    setData = function() {
      vm.gridOptions.data = vm.currentInvoice.products;
      vm.gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      vm.currentItem = null;
    };
    getPrevious = function(event) {
      var i;
      i = invoices.indexOf(vm.currentInvoice);
      if (i > 0) {
        vm.currentInvoice = invoices[i - 1];
        setData();
      }
      event.preventDefault();
    };
    getNext = function(event) {
      var i;
      i = invoices.indexOf(vm.currentInvoice);
      if (i < invoices.length - 1) {
        vm.currentInvoice = invoices[i + 1];
        setData();
      }
      event.preventDefault();
    };
    startNew = function() {
      var item;
      if (vm.currentInvoice.products.length === 0) {
        return;
      }
      item = {
        products: []
      };
      invoices.push(item);
      vm.currentInvoice = item;
      setData();
    };
    total = function() {
      var sum;
      sum = 0;
      angular.forEach(vm.currentInvoice.products, function(p) {
        sum += p.count * p.price;
      });
      return sum;
    };
    save = function() {
      if (vm.currentInvoice.products.length > 0) {
        vm.currentInvoice.total = total();
        OpService.sale(vm.currentInvoice).then(function() {
          purge();
        });
      }
    };
    purge = function() {
      if (vm.currentInvoice) {
        invoices.splice(invoices.indexOf(vm.currentInvoice), 1);
        if (invoices.length > 0) {
          vm.currentInvoice = invoices[0];
          setData();
        } else {
          startNew();
        }
      }
    };
    hotkeys.bindTo($scope).add({
      combo: ['p', 'з'],
      description: 'Добавление товара вручную',
      callback: search
    }).add({
      combo: ['n', 'т'],
      description: "Начать новый инвойс",
      callback: startNew
    }).add({
      combo: "left",
      description: "Перемотка на предыдущий инвойс",
      callback: getPrevious
    }).add({
      combo: "right",
      description: "Перемотка на следующий инвойс",
      callback: getNext
    }).add({
      combo: ["z", 'я'],
      description: "Отменить текущий инвойс",
      callback: purge
    }).add({
      combo: ["s", "ы"],
      description: "Применить инвойс",
      callback: save
    });
    vm.save = save;
    vm.cancel = purge;
    vm.invoices = invoices;
    vm.currentInvoice = invoices[0];
    vm.handleScan = scanned;
    vm.total = total;
    vm.gridOptions = gridOptions;
    $scope.$on('data-selected', function(e, row) {
      return vm.currentItem = row.entity;
    });
    $scope.$watch(function() {
      return vm.currentCode;
    }, function() {
      var ean;
      if (vm.currentCode && vm.currentCode.length > 0) {
        ean = vm.currentCode;
        vm.currentCode = "".then(function(result) {
          var e, p;
          if (result.docs.length === 1) {
            e = result.docs[0];
            p = {
              id: e._id,
              count: 1,
              price: e.data.price,
              name: e.data.name
            };
            vm.currentInvoice.products.push(p);
            setData();
            $timeout(function() {
              return vm.gridOptions.gridApi.selection.selectRow(p);
            });
          }
        });
      }
    });
  }).controller('OpBuyController', function(hotkeys, $scope, $uibModal, uiGridConstants, $timeout) {
    var getNext, getPrevious, gridOptions, invoices, purge, save, scanned, search, setData, startNew, total, vm;
    vm = this;
    invoices = [
      {
        products: []
      }
    ];
    gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          pinnedLeft: true,
          displayName: 'Наименование',
          enableCellEdit: false
        }, {
          name: 'count',
          pinnedLeft: true,
          displayName: 'Количество',
          type: 'number'
        }, {
          name: 'price',
          pinnedLeft: true,
          displayName: 'Цена'
        }, {
          name: 'sum',
          pinnedLeft: true,
          displayName: 'Сумма',
          enableCellEdit: false,
          cellTemplate: '<div class="ui-grid-cell-contents" >{{row.entity.count*row.entity.price}}</div>'
        }
      ]
    };
    scanned = function(e) {
      vm.currentCode = e;
      console.log(e);
      $scope.$digest();
    };
    search = function(event, key) {
      var modalInstance;
      modalInstance = $uibModal.open({
        animation: false,
        templateUrl: '/app/modals/search-product.html',
        controller: 'SearchProdController'
      });
      modalInstance.result.then(function(e) {
        var p;
        p = {
          id: e._id,
          count: 1,
          price: e.data.price,
          name: e.data.name
        };
        vm.currentInvoice.products.push(p);
        setData();
        $timeout(function() {
          return vm.gridOptions.gridApi.selection.selectRow(p);
        });
      });
      event.preventDefault;
    };
    setData = function() {
      vm.gridOptions.data = vm.currentInvoice.products;
      vm.gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      vm.currentItem = null;
    };
    getPrevious = function(event) {
      var i;
      i = invoices.indexOf(vm.currentInvoice);
      if (i > 0) {
        vm.currentInvoice = invoices[i - 1];
        setData();
      }
      event.preventDefault();
    };
    getNext = function(event) {
      var i;
      i = invoices.indexOf(vm.currentInvoice);
      if (i < invoices.length - 1) {
        vm.currentInvoice = invoices[i + 1];
        setData();
      }
      event.preventDefault();
    };
    startNew = function() {
      var item;
      if (vm.currentInvoice.products.length === 0) {
        return;
      }
      item = {
        products: []
      };
      invoices.push(item);
      vm.currentInvoice = item;
      setData();
    };
    total = function() {
      var sum;
      sum = 0;
      angular.forEach(vm.currentInvoice.products, function(p) {
        sum += p.count * p.price;
      });
      return sum;
    };
    save = function() {
      if (vm.currentInvoice.products.length > 0) {
        vm.currentInvoice.total = total();
        OpService.purchase(vm.currentInvoice).then(function() {
          purge();
        });
      }
    };
    purge = function() {
      if (vm.currentInvoice) {
        invoices.splice(invoices.indexOf(vm.currentInvoice), 1);
        if (invoices.length > 0) {
          vm.currentInvoice = invoices[0];
          setData();
        } else {
          startNew();
        }
      }
    };
    hotkeys.bindTo($scope).add({
      combo: 'p',
      description: 'Добавление товара вручную',
      callback: search
    }).add({
      combo: 'n',
      description: "Начать новый инвойс",
      callback: startNew
    }).add({
      combo: "left",
      description: "Перемотка на предыдущий инвойс",
      callback: getPrevious
    }).add({
      combo: "right",
      description: "Перемотка на следующий инвойс",
      callback: getNext
    }).add({
      combo: "z",
      description: "Отменить текущий инвойс",
      callback: purge
    }).add({
      combo: "s",
      description: "Применить инвойс",
      callback: save
    });
    vm.save = save;
    vm.cancel = purge;
    vm.invoices = invoices;
    vm.currentInvoice = invoices[0];
    vm.handleScan = scanned;
    vm.total = total;
    vm.gridOptions = gridOptions;
    $scope.$on('data-selected', function(e, row) {
      return vm.currentItem = row.entity;
    });
    $scope.$watch(function() {
      return vm.currentCode;
    }, function() {
      var ean;
      if (vm.currentCode && vm.currentCode.length > 0) {
        ean = vm.currentCode;
        vm.currentCode = "".then(function(result) {
          var e, p;
          if (result.docs.length === 1) {
            e = result.docs[0];
            p = {
              id: e._id,
              count: 1,
              price: e.data.price,
              name: e.data.name
            };
            vm.currentInvoice.products.push(p);
            setData();
            $timeout(function() {
              return vm.gridOptions.gridApi.selection.selectRow(p);
            });
          }
        });
      }
    });
  }).controller('OpHistController', function(uiGridConstants) {
    var gridOptions, vm;
    vm = this;
    gridOptions = {
      columnDefs: [
        {
          name: 'date',
          pinnedLeft: true,
          displayName: 'Дата'
        }, {
          name: 'data.total',
          pinnedLeft: true,
          displayName: 'Сумма',
          type: 'number'
        }, {
          name: 'data.products',
          pinnedLeft: true,
          displayName: 'Детали',
          cellTemplate: '<div class="ui-grid-cell-contents" > <span ng-repeat="p in grid.getCellValue(row, col)">{{p.name}} x {{p.count}}, </span> </div>'
        }
      ]
    };
    vm.gridOptions = gridOptions;
    vm.page = 0;
    vm.page_size = 200;
  });

}).call(this);

(function() {
  angular.module('stock').controller('NewsController', function() {
    'ngInject';
    var vm;
    return vm = this;
  }).controller('NewsListController', function($rootScope, $scope, $state, RequestService, $http, IntermediateDataService) {
    'ngInject';
    var getNews, openCreateForm, openEditForm, openUploadImageForm, vm;
    vm = this;
    vm.searchValues = {};
    vm.selectedRow = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    vm.gridOptions = {
      data: [],
      noUnselect: false,
      multiSelect: false,
      enableRowSelection: false,
      enableFullRowSelection: true,
      enableSelectAll: false,
      showGridFooter: true,
      columnDefs: [
        {
          name: 'title',
          displayName: 'Название',
          width: '100%'
        }
      ],
      onRegisterApi: function(gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function(row) {
          vm.selectedRow = row;
        });
        vm.gridApi = gridApi;
      }
    };
    getNews = function() {
      var filters;
      filters = vm.searchValues;
      RequestService.post('news/listing', filters).then(function(response) {
        vm.gridOptions.data = response.list;
      }, function(response) {
        console.log(response);
      });
    };
    openCreateForm = function() {
      IntermediateDataService.clear();
      $state.go('app.news.form');
    };
    openEditForm = function() {
      IntermediateDataService.set(vm.selectedRow.entity);
      $state.go('app.news.form');
    };
    openUploadImageForm = function() {
      IntermediateDataService.set(vm.selectedRow.entity);
      $state.go('app.news.uploadimage');
    };
    vm.getNews = getNews;
    vm.openCreateForm = openCreateForm;
    vm.openEditForm = openEditForm;
    vm.openUploadImageForm = openUploadImageForm;
  }).controller('NewsFormController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, IntermediateDataService) {
    'ngInject';
    var goBack, saveNews, vm;
    vm = this;
    vm.newsItem = IntermediateDataService.get({
      is_active: true
    });
    saveNews = function() {
      RequestService.post('news/put', vm.newsItem).then(function(response) {
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    goBack = function() {
      $state.go('app.news.list');
    };
    vm.saveNews = saveNews;
    vm.goBack = goBack;
  }).controller('NewsUploadimageController', function($rootScope, $scope, $state, $http, IntermediateDataService, RequestService) {
    'ngInject';
    var goBack, saveImage, vm;
    vm = this;
    vm.newsItem = IntermediateDataService.get();
    vm.newsItem = vm.newsItem ? vm.newsItem : {};
    saveImage = function() {
      RequestService.post('upload/news/' + vm.newsItem.id, {
        file: vm.newsItem.image
      }).then(function(result) {
        console.log(result);
      });
    };
    goBack = function() {
      $state.go('app.news.list');
    };
    vm.saveImage = saveImage;
    vm.goBack = goBack;
  });

}).call(this);

(function() {
  angular.module('stock').controller('SearchProdController', function($scope, $uibModalInstance, uiGridConstants, $timeout) {
    $scope.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'data.name',
          pinnedLeft: true,
          displayName: 'Наименование'
        }, {
          name: 'data.price',
          pinnedLeft: true,
          displayName: 'Цена'
        }
      ]
    };
    $scope.ok = function() {
      return $uibModalInstance.close($scope.entity);
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss();
    };
    $scope.pressed = function(e) {
      if (e.keyCode === 13 && $scope.entity) {
        $scope.ok();
      }
    };
    $scope.$on('data-selected', function(e, row) {
      return $scope.entity = row.entity;
    });
  });

}).call(this);

(function() {
  angular.module('stock').controller('MenuController', function($scope, RequestService, Session, $state, AppStorage, hotkeys) {
    'ngInject';
    var filterOnlyParents, getMenus, vm;
    vm = this;
    if ($scope.app.ua.role < 10) {
      $state.go('app.company');
      return;
    }
    getMenus = function() {
      RequestService.post('menu.listing').then(function(result) {
        vm.menus = result.docs;
      });
    };
    filterOnlyParents = function(menu) {
      if ((angular.isUndefined(menu)) || (angular.isUndefined(menu.parent_id)) || menu.parent_id === null) {
        return true;
      }
      return false;
    };
    $scope.$on('refresh-menus', function() {
      return getMenus();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Новое меню',
      callback: function() {
        return $state.go('app.menu.item', {
          id: 'new'
        });
      }
    }).add({
      combo: 'r',
      description: 'Обновить сисок меню',
      callback: getMenus
    });
    vm.getMenus = getMenus;
    vm.filterOnlyParents = filterOnlyParents;
    getMenus();
  }).controller('MenuItemController', function($scope, RequestService, $stateParams, AppStorage, $state, $rootScope, $uibModal) {
    'ngInject';
    var confirmAction, initMenu, putMenu, refreshMenus, removeMenu, vm;
    vm = this;
    refreshMenus = function() {
      return $rootScope.$broadcast('refresh-menus');
    };
    putMenu = function() {
      var data;
      data = {
        _id: vm.menu._id,
        _rev: vm.menu._rev,
        name: vm.menu.name,
        parent_id: vm.menu.parent_id,
        data: {
          position: vm.menu.data.position,
          icon: vm.menu.data.icon,
          route: vm.menu.data.route
        }
      };
      RequestService.post('menu.save', data).then(function(result) {
        vm.menu._id = result.id;
        if ($stateParams.id === 'new') {
          $state.go('app.menu.item', {
            id: vm.menu._id
          });
        }
        refreshMenus();
        return;
      });
      return false;
    };
    removeMenu = function(item) {
      return RequestService.post('menu.remove', item).then(function(data) {
        refreshMenus();
      });
    };
    confirmAction = function(item) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", Вы уверены, что хотите продолжить?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeMenu(item);
        }
      });
    };
    initMenu = function() {
      vm.menu = {};
      if ($stateParams.id !== 'new') {
        return RequestService.post('menu.listing', {
          filter: {
            _id: $stateParams.id
          }
        }).then(function(result) {
          if (result.docs.length === 1) {
            return vm.menu = result.docs[0];
          }
        });
      }
    };
    $rootScope.$on('menus-updated', function() {
      return initMenu();
    });
    vm.putMenu = putMenu;
    vm.removeMenu = removeMenu;
    vm.confirmAction = confirmAction;
    initMenu();
  });

}).call(this);

(function() {
  angular.module('stock').controller('MedexpenseController', function() {
    var vm;
    vm = this;
  }).controller('MedexpenseMainController', function($scope, RequestService, IntermediateDataService, AppStorage) {
    var date, removeExpense, resetFilter, searchMedExpenses, vm;
    vm = this;
    date = new Date();
    vm.filter = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    searchMedExpenses = function() {
      RequestService.post('medexpenses.listing', vm.filter).then(function(response) {
        vm.medexpensesGridOptions.data = response.docs;
        AppStorage.setObject('medexpenseFilterParams', vm.filter);
      }, function(response) {
        console.log(response);
      });
    };
    removeExpense = function(expense) {
      if (!expense) {
        return;
      }
      RequestService.post('medexpenses.delete', expense).then(function(response) {
        searchMedExpenses();
        vm.selectedRow = null;
        console.log(response);
      }, function(response) {
        console.log(response);
      });
    };
    resetFilter = function() {
      vm.filter = {
        created_from: new Date(date.getFullYear(), date.getMonth(), 1),
        created_to: new Date()
      };
    };
    vm.medexpensesGridOptions = {
      noUnselect: false,
      multiSelect: false,
      enableRowSelection: false,
      enableFullRowSelection: true,
      enableSelectAll: false,
      showGridFooter: true,
      columnDefs: [
        {
          name: 'patient',
          displayName: 'Пациент',
          width: '20%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'policy_no',
          displayName: 'Номер полиса',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'exam_date',
          displayName: 'Дата осмотра',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'doctor',
          displayName: 'Врач',
          width: '20%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'diagnosises',
          displayName: 'Диагнозы',
          width: '20%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'services',
          displayName: 'Сервисы',
          width: '20%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'service_total',
          displayName: 'Всего за сервисы',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }, {
          name: 'created_datetime',
          displayName: 'Дата регистрации',
          width: '10%',
          maxWidth: 500,
          minWidth: 50
        }
      ],
      onRegisterApi: function(gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function(row) {
          vm.selectedRow = row;
        });
        vm.gridApi = gridApi;
      }
    };
    vm.searchMedExpenses = searchMedExpenses;
    vm.resetFilter = resetFilter;
    vm.removeExpense = removeExpense;
    vm.filter = AppStorage.getObject('medexpenseFilterParams');
    if (vm.filter) {
      searchMedExpenses();
    } else {
      resetFilter();
    }
  });

}).call(this);

(function() {
  angular.module('stock').controller('MainController', function($scope, AppStorage, $rootScope, RequestService, $state, Session, EVENTS, $window, toastr, $uibModal) {
    'ngInject';
    var closeCompany, getCurrency, getMenus, goBack, logOut, parentGroup, vm;
    vm = this;
    vm.today = new Date();
    $rootScope.$on(EVENTS.notAuthenticated, function() {
      Session.destroy();
      delete vm.ua;
      $state.go('login');
      return AppStorage.clear();
    });
    $rootScope.$on(EVENTS.businessError, function(e, message) {
      return toastr.warning(message);
    });
    $rootScope.$on(EVENTS.applicationError, function(e, message) {
      return toastr.error(message);
    });
    $rootScope.$on(EVENTS.connectionError, function() {
      return toastr.error('Проверьте соединение с сервером');
    });
    $rootScope.$on(EVENTS.successMessage, function(e, message) {
      return toastr.success(message);
    });
    $rootScope.$on(EVENTS.loginSuccess, function() {
      AppStorage.clear();
      $state.go('app.dashboard');
    });
    vm.signOut = function() {
      return vm.$emit(EVENTS.notAuthenticated);
    };
    $rootScope.company = {
      name: "APEX GROUP",
      id: 1
    };
    $rootScope.branch = {
      name: "Main Office",
      id: 5
    };
    $rootScope.user = {
      name: "User",
      id: 1
    };
    if (Session.getToken() === void 0) {
      $state.go('login');
      return;
    }
    vm.api = $rootScope.api;
    vm.ua = Session.getUser();
    vm.navigation = AppStorage.getObject('navigation') || [];
    logOut = function() {
      return $rootScope.$broadcast(EVENTS.notAuthenticated);
    };
    if (vm.ua === void 0) {
      logOut();
      return;
    }
    if (vm.ua.role >= 10) {
      vm.admin_menu = [
        {
          name: 'Админ',
          data: {
            icon: 'fa fa-cogs',
            position: 1
          },
          children: [
            {
              name: 'Компании',
              data: {
                route: 'app.company',
                position: 0
              }
            }, {
              name: 'Агенты',
              data: {
                route: 'app.agent',
                position: 1
              }
            }, {
              name: 'Меню',
              data: {
                route: 'app.menu',
                position: 2
              }
            }, {
              name: 'Роли',
              data: {
                route: 'app.role',
                position: 3
              }
            }, {
              name: 'Справочники',
              data: {
                route: 'app.dictionary',
                position: 4
              }
            }, {
              name: 'Пользователи',
              data: {
                route: 'app.users',
                position: 5
              }
            }, {
              name: 'Просмотр отчетов',
              data: {
                route: 'app.report_viewer',
                position: 6
              }
            }, {
              name: 'Дизайнер отчетов',
              data: {
                route: 'app.report_designer',
                position: 7
              }
            }, {
              name: 'Шаблоны отчетов',
              data: {
                route: 'app.report_template',
                position: 8
              }
            }, {
              name: 'Курсы валют',
              data: {
                route: 'app.currency',
                position: 9
              }
            }
          ]
        }
      ];
    }
    getMenus = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('menu.listing', filter).then(function(result) {
        var child, children, i, j, k, len, len1, len2, menu, parents, ref;
        parents = [];
        children = [];
        ref = result.docs;
        for (i = 0, len = ref.length; i < len; i++) {
          menu = ref[i];
          if (menu.parent_id === null || angular.isUndefined(menu.parent_id)) {
            parents.push(menu);
          } else {
            children.push(menu);
          }
        }
        for (j = 0, len1 = parents.length; j < len1; j++) {
          menu = parents[j];
          menu.children = [];
          for (k = 0, len2 = children.length; k < len2; k++) {
            child = children[k];
            if (menu._id === child.parent_id) {
              menu.children.push(child);
            }
          }
        }
        vm.navigation = parents;
        AppStorage.setObject('navigation', vm.navigation);
        AppStorage.setObject('menus', result.docs);
        return $rootScope.$broadcast('menus-updated');
      });
    };
    closeCompany = function() {
      RequestService.post('user.set_company', {
        company_id: null
      }).then(function(result) {
        $rootScope.$broadcast('close-active-company');
        $state.go('app.company');
        return getMenus();
      });
    };
    parentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    $rootScope.$on('refresh-menus', function() {
      getMenus();
    });
    goBack = function() {
      if ($window.history.length === 1) {
        if ($state.current.name.startsWith('app.docs')) {
          $state.go("app.docs.listing");
        } else {
          $state.go("app.company");
        }
        return;
      }
      $window.history.back();
    };
    getCurrency = function() {
      return RequestService.post('currencynbkr.get_nbkr_rate', {
        date: moment().format("YYYY-MM-DD 00:00:00")
      }).then(function(response) {
        return AppStorage.setObject('currenciesToday', response.results);
      });
    };
    vm.getCurrency = getCurrency;
    vm.parentGroup = parentGroup;
    vm.closeCompany = closeCompany;
    vm.logOut = logOut;
    $scope.goBack = goBack;
    getCurrency();
    getMenus();
  });

}).call(this);

(function() {
  angular.module('stock').controller('InsurantsaController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, getPolicies, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = {};
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.offset = 0;
    vm.limit = 10;
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client.surname',
          displayName: 'Фамилия клиента'
        }, {
          name: 'client.name',
          displayName: 'Имя клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Страховщик'
        }, {
          name: 'agent',
          displayName: 'Агент'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getPolicies = function() {
      var filter;
      filter = {};
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["policy_no DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
        console.log(data.docs);
      });
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    goToShow = function() {
      console.log(vm.policy_statuses);
      $state.go('app.policy_show', {
        product: vm.selected_policy
      });
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    goToNew = function() {
      if (!vm.company) {
        $state.go('app.policy_new');
      } else if (vm.company.company_type === "insurance_company") {
        $state.go('app.policy_select');
      } else {
        $state.go('app.policy_new');
      }
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.getPolicies = getPolicies;
    getPolicies();
  }).controller('InsurantsaNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToSelect = function(item) {
      $state.go('app.policy_select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ExpensesaController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, getPolicies, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = {};
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.offset = 0;
    vm.limit = 10;
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client.surname',
          displayName: 'Фамилия клиента'
        }, {
          name: 'client.name',
          displayName: 'Имя клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Страховщик'
        }, {
          name: 'agent',
          displayName: 'Агент'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getPolicies = function() {
      var filter;
      filter = {};
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["policy_no DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
        console.log(data.docs);
      });
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    goToShow = function() {
      console.log(vm.policy_statuses);
      $state.go('app.policy_show', {
        product: vm.selected_policy
      });
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    goToNew = function() {
      if (!vm.company) {
        $state.go('app.policy_new');
      } else if (vm.company.company_type === "insurance_company") {
        $state.go('app.policy_select');
      } else {
        $state.go('app.policy_new');
      }
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.getPolicies = getPolicies;
    getPolicies();
  }).controller('ExpensesaNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToSelect = function(item) {
      $state.go('app.policy_select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  });

}).call(this);

(function() {
  angular.module('stock').controller('EquipmentController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('EquipmentListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteequipment, downloadPDF, editBranch, fiterequipment, getAgents, getEquipments, goToIssue, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.equipments = null;
    vm.equipment_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/equipment/view.html',
        controller: 'EquipmentViewController',
        controllerAs: 'view',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_equipment
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_equipment = angular.copy(row.entity);
      goToShow();
    };
    vm.equipmentsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'status',
          displayName: 'Статус'
        }, {
          name: 'client',
          displayName: 'ФИО клиента'
        }, {
          name: 'model',
          displayName: 'Модель'
        }, {
          name: 'price',
          displayName: 'Стоимость'
        }, {
          name: 'sum',
          displayName: 'Страховая сумма'
        }, {
          name: 'premium',
          displayName: 'Страховая премия'
        }, {
          name: 'period.start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'period.end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.created',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'employee.name',
          displayName: 'Продавец'
        }, {
          name: 'company.name',
          displayName: 'Страховщик'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.equipment.create');
      return false;
    };
    goToIssue = function() {
      $state.go('app.equipment_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/equipment/edit.html',
        controller: 'EquipmentEditController',
        controllerAs: 'equipment',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_equipment
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getEquipments = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'insurance_company') {
        filter.with_related = true;
        filter.filter = {
          company_id: vm.company._id
        };
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "status") {
          if (v === "Все") {
            if (filter.filter) {
              delete filter.filter;
            }
            continue;
          } else {
            filter.filter = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "name") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      RequestService.post('tehpolicies.listing', filter).then(function(data) {
        delete vm.selected_equipment;
        vm.equipments = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.equipmentsGridOptions.data = angular.copy(data.docs);
        vm.equipmentsGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      ReportService.printReport('TP', {
        'policyNumber': vm.selected_equipment.policy_no
      });
    };
    deleteequipment = function() {
      return RequestService.post('tehequipments.delete', vm.selected_equipment).then(function(data) {
        getEquipments();
      });
    };
    resetFilter = function() {
      vm.equipment_filtered = [];
      vm.filter = {};
      vm.equipmentsGridOptions.data = angular.copy(vm.equipments);
    };
    fiterequipment = function() {
      var equipment, j, len, ref;
      vm.equipment_filtered = [];
      if (vm.equipments) {
        ref = vm.equipments;
        for (j = 0, len = ref.length; j < len; j++) {
          equipment = ref[j];
          if (vm.filter.policy_no) {
            if (equipment.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (equipment.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (equipment.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.equipment_status) {
            if (equipment.data.status !== vm.filter.equipment_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (equipment.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.equipment_filtered.push(equipment);
        }
        vm.equipmentsGridOptions.data = angular.copy(vm.equipment_filtered);
      } else {
        console.log("vm.equipments is falsy");
      }
      if (!vm.filter.equipment_status) {
        return vm.filter.equipment_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_equipment = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getEquipments
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'equipmentDialogController',
        controllerAs: 'equipment_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteequipment();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getEquipments();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deleteequipment = deleteequipment;
    vm.resetFilter = resetFilter;
    vm.fiterequipment = fiterequipment;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getEquipments = getEquipments;
    getAgents();
    getEquipments();
  }).controller('EquipmentCreateController', function($stateParams, RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var formatLabel, getEmployees, putPolicy, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.today = moment();
    vm.end_date = moment().add(183, 'days');
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    vm.policy = {
      sum: 0,
      period: {
        start: vm.today.format('DD.MM.YYYY'),
        end: vm.end_date.format('DD.MM.YYYY')
      },
      data: {
        created: vm.today.format('DD.MM.YYYY')
      }
    };
    vm.insure_sum = [
      {
        name: "3000",
        summ: 3000
      }, {
        name: "5000",
        summ: 5000
      }, {
        name: "8000",
        summ: 8000
      }, {
        name: "10000",
        summ: 10000
      }, {
        name: "14000",
        summ: 14000
      }, {
        name: "25000",
        summ: 25000
      }
    ];
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    $scope.$watch('create.policy.sum', function(search_name, oldVal) {
      if (vm.policy.price <= search_name) {
        toastr.warning('Данная страховая сумма недоступна для указанной стоимости');
        vm.policy.sum = 0;
        vm.policy.premium = 0;
      } else if (vm.policy.price <= 4999) {
        toastr.warning('Данная страховая сумма недоступна для указанной стоимости');
        vm.policy.sum = 0;
        vm.policy.premium = 0;
      } else if (search_name !== oldVal) {
        if (search_name === 3000) {
          vm.policy.premium = 250;
        } else if (search_name === 5000) {
          vm.policy.premium = 350;
        } else if (search_name === 8000) {
          vm.policy.premium = 500;
        } else if (search_name === 10000) {
          vm.policy.premium = 650;
        } else if (search_name === 14000) {
          vm.policy.premium = 800;
        } else if (search_name === 25000) {
          vm.policy.premium = 1100;
        } else if (search_name === 0 && (search_name = null)) {
          vm.policy.premium = 0;
        }
      }
    });
    $scope.$watch('create.policy.price', function(search_name, oldVal) {
      if (search_name !== oldVal) {
        if (search_name >= 0 && search_name <= 4999) {
          vm.policy.sum = 0;
        } else if (search_name >= 5000 && search_name <= 8000) {
          vm.policy.sum = 3000;
        } else if (search_name >= 8001 && search_name <= 10000) {
          vm.policy.sum = 5000;
        } else if (search_name >= 10001 && search_name <= 15000) {
          vm.policy.sum = 8000;
        } else if (search_name >= 15001 && search_name <= 20000) {
          vm.policy.sum = 10000;
        } else if (search_name >= 20001 && search_name <= 35000) {
          vm.policy.sum = 14000;
        } else if (search_name >= 35001) {
          vm.policy.sum = 25000;
        } else if (search_name === 0) {
          vm.policy.sum = 0;
        }
      }
    });
    formatLabel = function(model) {
      var i;
      i = 0;
      while (i < vm.insure_sum.length) {
        if (model === vm.insure_sum[i].name) {
          return vm.insure_sum[i].summ;
        }
        i++;
      }
    };
    putPolicy = function() {
      vm.policy.status = 'Оформлен';
      vm.policy.issue_date = new Date();
      RequestService.post('tehpolicies.save', vm.policy).then(function(result) {
        toastr.success('Полис сохранен успешно');
        vm.policy_id = result.tehpolicy.id;
        return $state.go('app.equipment.show', {
          id: vm.policy_id
        });
      });
      return false;
    };
    getEmployees = function() {
      RequestService.post('employee.listing', {
        company_id: vm.company._id
      }).then(function(data) {
        return vm.employees = data.docs;
      });
    };
    vm.putPolicy = putPolicy;
    vm.formatLabel = formatLabel;
    vm.getEmployees = getEmployees;
    getEmployees();
  }).controller('EquipmentViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, goToForm, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.policy = product;
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    downloadPDF = function() {
      ReportService.printReport('TP', {
        policyNumber: vm.policy.policy_no
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    spoilPolicy = function() {
      vm.policy.status = "Испорчен";
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис испорчен успешно');
      });
      return false;
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    termPolicy = function(moneyBack) {
      vm.policy.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис расторжен успешно');
      });
      return false;
    };
    goToForm = function() {
      $state.go('app.equipment.edit', {
        policy: vm.policy
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          FormPolicy();
        }
      });
    };
    FormPolicy = function() {
      vm.policy.status = 'Оформлен';
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        vm.policy.data.status = 'Оформлен';
        sendMail();
        $scope.list.getEquipments();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    vm.cancel = cancel;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.spoilPolicy = spoilPolicy;
    vm.confirmActionTerm = confirmActionTerm;
    vm.goToForm = goToForm;
    vm.confirmActionForm = confirmActionForm;
  }).controller('EquipmentDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('EquipmentShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, getPolicy, goToForm, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.policy = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getPolicy = function(policy_id) {
      var filter;
      filter = {
        with_related: true,
        filter: {
          _id: policy_id
        }
      };
      RequestService.post('equipment.listing', filter).then(function(result) {
        return vm.policy = result.docs[0];
      });
    };
    vm.policy_id = $stateParams.id;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.equipment.list");
    } else {
      getPolicy(vm.policy_id);
    }
    downloadPDF = function() {
      ReportService.printReport('TP', {
        policyNumber: vm.policy.policy_no
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    spoilPolicy = function() {
      vm.policy.status = "Испорчен";
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис испорчен успешно');
      });
      return false;
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    termPolicy = function(moneyBack) {
      vm.policy.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        $scope.list.getEquipments();
        return toastr.success('Полис расторжен успешно');
      });
      return false;
    };
    goToForm = function() {
      $state.go('app.equipment.edit', {
        policy: vm.policy
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          FormPolicy();
        }
      });
    };
    FormPolicy = function() {
      vm.policy.status = 'Оформлен';
      RequestService.post('tehpolicies.put', vm.policy).then(function(result) {
        vm.policy.data.status = 'Оформлен';
        sendMail();
        $scope.list.getEquipments();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.spoilPolicy = spoilPolicy;
    vm.confirmActionTerm = confirmActionTerm;
    vm.goToForm = goToForm;
    vm.confirmActionForm = confirmActionForm;
  });

}).call(this);

(function() {
  angular.module('stock').controller('EmployeeController', function(RequestService, product_types, $scope, $uibModal, toastr, Session) {
    'ngInject';
    var deleteEmployee, editEmployee, getEmployees, newEmployee, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.employeeGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'ФИО'
        }, {
          name: 'birthday',
          displayName: 'Дата рождения',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }
      ]
    };
    getEmployees = function() {
      RequestService.post('employee.listing', {
        company_id: vm.company._id
      }).then(function(data) {
        vm.employees = data.docs;
        vm.employeeGridOptions.data = vm.employees;
        vm.employeeGridOptions.totalItems = vm.employees.length;
      });
    };
    editEmployee = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/employee/edit.html',
        controller: 'EmployeeCreateController',
        controllerAs: 'employee',
        size: 'lg',
        resolve: {
          employee: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getEmployees();
      });
    };
    deleteEmployee = function(user) {
      RequestService.post('employee.delete', {
        _id: user._id,
        _rev: user._rev
      }).then(function(data) {
        toastr.success('Сотрудник удален');
        return getEmployees();
      });
    };
    newEmployee = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/employee/create.html',
        controller: 'EmployeeCreateController',
        controllerAs: 'employee',
        size: 'lg',
        resolve: {
          employee: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getEmployees();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    vm.newEmployee = newEmployee;
    vm.editEmployee = editEmployee;
    vm.getEmployees = getEmployees;
    vm.deleteEmployee = deleteEmployee;
    getEmployees();
  }).controller('EmployeeCreateController', function(RequestService, employee, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createEmployee, updateEmployee, vm;
    vm = this;
    if (employee === null || employee === void 0) {
      vm.employee = {};
    } else {
      vm.employee = employee;
    }
    createEmployee = function() {
      RequestService.post('employee.put', vm.employee).then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    updateEmployee = function() {
      RequestService.post('employee.put', vm.employee).then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateEmployee = updateEmployee;
    vm.createEmployee = createEmployee;
    vm.cancel = cancel;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DoctemplatesController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('DoctemplatesAddController', function($rootScope, $scope, RequestService, $state, $http, Session) {
    'ngInject';
    var goBack, saveDocTemp, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.flowConfig = {
      target: $rootScope.api + 'upload/' + vm.company.name + '/' + vm.company._id,
      singleFile: true
    };
    vm.docTemp = {};
    goBack = function() {
      $state.go('app.doctemplates.list');
    };
    saveDocTemp = function() {
      console.log(vm.docTemp);
      RequestService.post('doc_templates/put', vm.docTemp).then(function(response) {
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    vm.goBack = goBack;
    vm.saveDocTemp = saveDocTemp;
  }).controller('DoctemplatesListController', function($rootScope, $scope, AppStorage, RequestService, $http, $state, Session, $base64) {
    'ngInject';
    var deleteDoc, getDocTeplates, openAddForm, vm;
    vm = this;
    vm.docTemps = [];
    vm.api = $rootScope.api;
    getDocTeplates = function() {
      RequestService.post('doc_templates.listing', {}).then(function(response) {
        vm.docTemps = response.docs;
      }, function(response) {
        console.log(response);
      });
    };
    deleteDoc = function(docTemp) {
      if (!confirm('Вы действительно хотите удалить шаблон ?')) {
        return;
      }
      RequestService.post('doc_templates.delete', docTemp).then(function(response) {
        console.log(response);
        getDocTeplates();
      }, function(response) {
        console.log(response);
      });
    };
    openAddForm = function() {
      $state.go('app.doctemplates.add');
    };
    vm.getDocTeplates = getDocTeplates;
    vm.deleteDoc = deleteDoc;
    vm.openAddForm = openAddForm;
    getDocTeplates();
  });

}).call(this);

(function() {
  angular.module('stock').controller('DictionaryaController', function($scope, RequestService, $state, $stateParams, toastr, $uibModal) {
    'ngInject';
    var editDictionary, getDictionaries, listTables, newDictionary, roleFilter, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: []
    };
    listTables = function() {
      RequestService.post('dictionarya.tables_list').then(function(result) {
        vm.tables = result.tables;
        if ((angular.isUndefined(vm.active_table)) && vm.tables.length > 0) {
          vm.active_table = vm.tables[0];
        }
      });
    };
    getDictionaries = function() {
      var filter;
      if (angular.isUndefined(vm.active_table)) {
        listDictionaries();
        return;
      }
      filter = {
        type: vm.active_table.table,
        offset: vm.offset,
        limit: vm.limit,
        with_related: true
      };
      RequestService.post('dictionarya.listing', filter).then(function(result) {
        delete vm.selected_dictionary;
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionarya/modal.html',
        controller: 'DictionaryaEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: void 0
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    editDictionary = function() {
      var editModal;
      if (vm.active_table.table === "DrugsA") {
        vm.selected_dictionary.form_of_issue = angular.fromJson(vm.selected_dictionary.form_of_issue);
      }
      editModal = $uibModal.open({
        templateUrl: 'app/dictionarya/modal.html',
        controller: 'DictionaryaEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: angular.copy(vm.selected_dictionary)
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    roleFilter = function(table) {
      if (table.role_requires <= $scope.app.ua.role) {
        return true;
      }
      return false;
    };
    $scope.$watch('dictionarya.active_table', function() {
      var column;
      if (angular.isDefined(vm.active_table)) {
        vm.gridOptions.columnDefs = (function() {
          var i, len, ref, results;
          ref = vm.active_table.columns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            column = ref[i];
            results.push({
              name: column.name,
              displayName: column.displayName
            });
          }
          return results;
        })();
        vm.grid = '<paged-table options="dictionarya.gridOptions" disable-search="true"></paged-table>';
        getDictionaries();
      }
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_dictionary = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getDictionaries();
    });
    vm.roleFilter = roleFilter;
    vm.getDictionaries = getDictionaries;
    vm.newDictionary = newDictionary;
    vm.editDictionary = editDictionary;
    vm.grid = '';
    listTables();
  }).controller('DictionaryaEditController', function($scope, RequestService, table, dictionary, $uibModalInstance) {
    'ngInject';
    var saveDictionary, vm;
    vm = this;
    if (angular.isUndefined(table)) {
      $uibModalInstance.dismiss('cancel');
      return;
    }
    vm.template = 'app/dictionarya/' + (table.table.toLowerCase()) + '/edit.html';
    if (angular.isUndefined(dictionary)) {
      dictionary = {
        type: table.table
      };
    }
    vm.table = table;
    vm.dictionary = dictionary;
    saveDictionary = function() {
      if (vm.preSave() === false) {
        return;
      }
      vm.dictionary.type = vm.table.table;
      RequestService.post('dictionarya.save', vm.dictionary).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    vm.preSave = function() {};
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.saveDictionary = saveDictionary;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DictionaryController', function($scope, RequestService, $state, $stateParams, toastr, $uibModal) {
    'ngInject';
    var editDictionary, getDictionaries, listTables, newDictionary, removeConfirmAction, removeDictionary, roleFilter, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 25;
    vm.gridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [25, 50, 100, 500],
      paginationPageSize: 25,
      useExternalPagination: true,
      columnDefs: []
    };
    listTables = function() {
      RequestService.post('dictionary.tables_list').then(function(result) {
        vm.tables = result.tables;
        if ((angular.isUndefined(vm.active_table)) && vm.tables.length > 0) {
          vm.active_table = vm.tables[0];
        }
      });
    };
    getDictionaries = function() {
      var filter;
      if (angular.isUndefined(vm.active_table)) {
        listDictionaries();
        return;
      }
      filter = {
        type: vm.active_table.table,
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: {
          search_filter: vm.search_filter
        }
      };
      RequestService.post('dictionary.listing', filter).then(function(result) {
        delete vm.selected_dictionary;
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionary/modal.html',
        controller: 'DictionaryEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: void 0
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    editDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionary/modal.html',
        controller: 'DictionaryEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: angular.copy(vm.selected_dictionary)
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    roleFilter = function(table) {
      if (table.role_requires <= $scope.app.ua.role) {
        return true;
      }
      return false;
    };
    removeDictionary = function() {
      vm.selected_dictionary.type = vm.active_table.table;
      return RequestService.post('dictionary.remove', vm.selected_dictionary).then(function(data) {
        getDictionaries();
      });
    };
    removeConfirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить справочник"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeDictionary();
        }
      });
    };
    $scope.$watch('dictionary.active_table', function() {
      var column;
      if (angular.isDefined(vm.active_table)) {
        vm.gridOptions.columnDefs = (function() {
          var i, len, ref, results;
          ref = vm.active_table.columns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            column = ref[i];
            results.push({
              name: column.name,
              displayName: column.displayName
            });
          }
          return results;
        })();
        vm.grid = '<paged-table options="dictionary.gridOptions" disable-search="true"></paged-table>';
        getDictionaries();
      }
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_dictionary = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getDictionaries();
    });
    vm.roleFilter = roleFilter;
    vm.getDictionaries = getDictionaries;
    vm.newDictionary = newDictionary;
    vm.editDictionary = editDictionary;
    vm.removeDictionary = removeDictionary;
    vm.removeConfirmAction = removeConfirmAction;
    vm.grid = '';
    listTables();
  }).controller('DictionaryEditController', function($scope, RequestService, table, dictionary, $uibModalInstance) {
    'ngInject';
    var saveDictionary, vm;
    vm = this;
    if (angular.isUndefined(table)) {
      $uibModalInstance.dismiss('cancel');
      return;
    }
    vm.template = 'app/dictionary/' + (table.table.toLowerCase()) + '/edit.html';
    if (angular.isUndefined(dictionary)) {
      dictionary = {
        type: table.table
      };
    }
    vm.table = table;
    vm.dictionary = dictionary;
    saveDictionary = function() {
      if (vm.preSave() === false) {
        return;
      }
      vm.dictionary.type = vm.table.table;
      RequestService.post('dictionary.save', vm.dictionary).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    vm.preSave = function() {};
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.saveDictionary = saveDictionary;
  });

}).call(this);

(function() {
  angular.module('stock').controller('DefaultsController', function($scope, $state, $stateParams, toastr, hotkeys, RequestService, $uibModal) {
    'ngInject';
    var editDefault, getDefaults, vm;
    vm = this;
    vm.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Тип'
        }, {
          name: 'data.approval.required',
          displayName: 'Обьязательное одобрение'
        }, {
          name: 'data.data.executor.username',
          displayName: 'Исполнитель'
        }
      ]
    };
    getDefaults = function() {
      vm.doc_types = [];
      RequestService.post('doc/all').then(function(result) {
        var doc_type, filter;
        delete vm.selected_default;
        vm.doc_types = result.doc_types;
        vm.gridOptions.data = (function() {
          var i, len, ref, results;
          ref = vm.doc_types;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            doc_type = ref[i];
            results.push({
              document_type: doc_type.id,
              name: doc_type.name
            });
          }
          return results;
        })();
        filter = {
          with_related: true
        };
        return RequestService.post('defaults.listing', filter).then(function(result) {
          var doc_default, i, item, len, position, ref, ref1;
          ref = result.docs;
          for (i = 0, len = ref.length; i < len; i++) {
            doc_type = ref[i];
            position = -1;
            ref1 = vm.gridOptions.data;
            for (item in ref1) {
              doc_default = ref1[item];
              if (doc_default.document_type === doc_type.document_type) {
                doc_type.name = doc_default.name;
                position = item;
                break;
              }
            }
            if (position > -1) {
              vm.gridOptions.data.splice(position, 1, doc_type);
            }
          }
        });
      });
    };
    editDefault = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/defaults/edit.html',
        controller: 'DefaultsEditController',
        controllerAs: 'defaults',
        size: 'lg',
        resolve: {
          doc_types: function() {
            return angular.copy(vm.doc_types);
          },
          doc_default: angular.copy(vm.selected_default)
        }
      });
      editModal.result.then(function() {
        return getDefaults();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_default = row.entity;
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить',
      callback: function() {
        return getDefaults();
      }
    });
    vm.getDefaults = getDefaults;
    vm.editDefault = editDefault;
    getDefaults();
  }).controller('DefaultsEditController', function($scope, $state, $stateParams, toastr, RequestService, doc_types, doc_default, $uibModalInstance) {
    'ngInject';
    var addApprovalRole, delApprovalRole, putDefault, vm;
    vm = this;
    vm.doc_types = doc_types;
    vm.doc_default = doc_default;
    putDefault = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.doc_default.data.approval && vm.doc_default.data.approval.required === true) {
        if (vm.doc_default.data.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return;
        }
        if (angular.isUndefined(vm.doc_default.data.approval.approval_roles) || vm.doc_default.data.approval.approval_roles.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return;
        }
      } else {
        delete vm.doc_default.data.approval;
      }
      RequestService.post('defaults.save', vm.doc_default).then(function(result) {
        vm.saving = false;
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.doc_default.data.approval.roles_id ? vm.doc_default.data.approval.roles_id : vm.doc_default.data.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.doc_default.data.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.doc_default.data.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.doc_default.data.approval.roles_id.splice(index, 1);
      }
    };
    vm.putDefault = putDefault;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('DashboardController', function($scope) {
    'ngInject';
    var vm;
    return vm = this;
  });

}).call(this);

(function() {
  angular.module('stock').controller('CurrencyController', function(RequestService, ReportService, $scope, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteCurrency, editCurrency, getCurrency, newCurrency, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.currencyGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'currency_date',
          displayName: 'День',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'currency',
          displayName: 'Валюта'
        }, {
          name: 'rate',
          displayName: 'Ставка'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      }
    };
    getCurrency = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["currency_date DESC"];
      RequestService.post('currencyrate.listing', filter).then(function(result) {
        vm.currencyGridOptions.data = result.docs;
        vm.currencyGridOptions.totalItems = result.count;
      });
    };
    editCurrency = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/currency/create.html',
        controller: 'CurrencyCreateController',
        controllerAs: 'currency',
        size: 'lg',
        resolve: {
          currency: angular.copy(vm.selected_currency)
        }
      });
      employeeDialog.result.then(function() {
        return getCurrency();
      });
    };
    newCurrency = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/currency/create.html',
        controller: 'CurrencyCreateController',
        controllerAs: 'currency',
        size: 'lg',
        resolve: {
          currency: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getCurrency();
      });
    };
    deleteCurrency = function() {
      RequestService.post('currencyrate.delete', vm.selected_currency).then(function(data) {
        toastr.success('Операция выполнена успешно');
        getCurrency();
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот курс валют"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteCurrency();
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_currency = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getCurrency();
    });
    vm.getCurrency = getCurrency;
    vm.deleteCurrency = deleteCurrency;
    vm.confirmAction = confirmAction;
    vm.newCurrency = newCurrency;
    vm.editCurrency = editCurrency;
    getCurrency();
  }).controller('CurrencyCreateController', function($scope, RequestService, $uibModalInstance, currency, Session, toastr, email_mask) {
    'ngInject';
    var createCurrency, vm;
    vm = this;
    if (currency === null || currency === void 0) {
      vm.currency = {};
    } else {
      vm.currency = currency;
    }
    createCurrency = function() {
      vm.currency.currency_date = moment(vm.currency.currency_date).format("YYYY-MM-DD 00:00:00");
      RequestService.post('currencyrate.put', vm.currency).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.createCurrency = createCurrency;
  });

}).call(this);

(function() {
  angular.module('stock').directive('pagedTable', function($location, $rootScope, store) {
    var link;
    link = function(scope, el, attr) {
      var localStore;
      if (angular.isUndefined(scope.options)) {
        scope.options = {};
      }
      localStore = store.getNamespacedStore($location.path());
      scope.options.enableRowSelection = scope.options.enableRowSelection || true;
      scope.options.enableRowHeaderSelection = scope.options.enableRowHeaderSelection || false;
      scope.options.multiSelect = scope.options.multiSelect || false;
      scope.options.saveWidths = scope.options.saveWidths || true;
      scope.options.enableGridMenu = scope.options.enableGridMenu || true;
      scope.options.gridMenuCustomItems = scope.options.gridMenuCustomItems || [];
      scope.options.gridMenuCustomItems.push({
        title: 'Сохранить',
        action: function() {
          return localStore.set('state', scope.options.gridApi.saveState.save());
        },
        order: 210
      });
      scope.options.onRegisterApi = function(gridApi) {
        scope.options.gridApi = gridApi;
        gridApi.selection.on.rowSelectionChanged(scope, function(row) {
          return $rootScope.$broadcast('data-selected', row);
        });
        gridApi.cellNav.on.navigate(scope, function(newRowCol, oldRowCol) {
          return gridApi.selection.selectRow(newRowCol.row.entity);
        });
        if (gridApi.pagination) {
          gridApi.pagination.on.paginationChanged(scope, function(newPage, pageSize) {
            return $rootScope.$broadcast('get-page', {
              page: newPage - 1,
              size: pageSize
            });
          });
        }
      };
      scope.$watch('query', function() {
        return $rootScope.$broadcast('data-search', {
          query: scope.query
        });
      });
      scope.$on('ngGridEventData', function(id) {
        var state;
        state = localStore.get('state');
        if (state) {
          scope.options.gridApi.saveState.restore(scope, state);
          return;
        }
      });
    };
    return {
      restrict: 'E',
      link: link,
      transclude: true,
      scope: {
        options: '=',
        disablePaging: '@',
        disableSearch: '@',
        enableEdit: '@'
      },
      template: function(elem, attr) {
        var editing, html, pagination;
        editing = attr.enableEdit ? "ui-grid-edit" : "";
        pagination = attr.disablePaging ? "" : "ui-grid-pagination";
        html = "<input ng-hide=\"disableSearch\" class=\"form-control\" ng-model=\"query\" ng-model-options=\"{debounce:200}\" placeholder=\"Поиск\" autofocus> <div ui-grid=\"options\" class=\"grid\" ui-grid-selection ui-grid-resize-columns ui-grid-save-state ui-grid-cellNav " + editing + " " + pagination + "></div> </div>";
        return html;
      }
    };
  });

}).call(this);

(function() {
  angular.module('stock').service('ProductService', function(db) {
    var service;
    service = this;
    return service;
  });

}).call(this);

(function() {
  angular.module('stock').directive('productSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        productId: '=',
        asText: '=?',
        productUnitId: '=?',
        ngDisabled: '=?'
      },
      controller: function($scope, RequestService, $uibModal) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectProduct = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/product/select.html',
            controller: 'ProductSelectController',
            controllerAs: 'product',
            size: 'lg'
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchProduct = function(search_name) {
          return RequestService.post('product.listing', {
            limit: 10,
            filter: {
              name: search_name
            }
          }).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('productId', function() {
          if ((angular.isDefined($scope.productId)) && vm.watch_prevent !== true) {
            RequestService.post('product.listing', {
              filter: {
                _id: $scope.productId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
          vm.watch_prevent = false;
        });
        $scope.$watch('product.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.productId = vm.selected._id;
            $scope.productUnitId = (angular.isDefined(vm.selected)) && (angular.isObject(vm.selected)) && (angular.isDefined(vm.selected.data)) ? vm.selected.data.unit_id : void 0;
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'product',
      link: function(scope, element, attr) {},
      template: '<div><div ng-hide="asText===true" class="input-group"> <div class="input-group-addon" ng-show="loadingProducts"> <span class="glyphicon glyphicon-refresh"></span> </div> <div class="input-group-addon" ng-show="noProducts"> <span class="glyphicon glyphicon-remove text-danger"></span> </div> <input type="text" ng-model="product.selected" class="form-control" uib-typeahead="product as product.name for product in product.searchProduct($viewValue)" typeahead-loading="loadingProducts" typeahead-no-results="noProducts" ng-disabled="ngDisabled"> <div class="input-group-btn"> <button class="btn btn-primary" type="button" ng-click="product.openSelectProduct()" ng-disabled="ngDisabled"> <span class="glyphicon glyphicon-paperclip"></span> </button> </div> </div> <span ng-show="asText===true">{{ product.selected.name }}</span></div>'
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('panel', function() {
    var link;
    link = function(scope, el) {
      el.find('.collapse-link').on('click', function() {
        var $BOX_CONTENT, $BOX_PANEL, $ICON;
        $BOX_PANEL = $(this).closest('.box');
        $ICON = $(this).find('i');
        $BOX_CONTENT = $BOX_PANEL.find('.box-body');
        if ($BOX_PANEL.attr('style')) {
          $BOX_CONTENT.slideToggle(200, function() {
            return $BOX_PANEL.removeAttr('style');
          });
        } else {
          $BOX_CONTENT.slideToggle(200);
          $BOX_PANEL.css('height', 'auto');
        }
        return $ICON.toggleClass('fa-chevron-up fa-chevron-down');
      });
    };
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        title: '@'
      },
      link: link,
      template: '<div class="box box-danger" > <div class="box-header"> <h3 class="box-title">{{title}}</h3> </div> <div class="box-body pad table-responsive" ng-transclude> </div> </div>'
    };
  });

}).call(this);

(function() {
  angular.module('stock').service('OpService', function(db) {
    var service;
    service = this;
    service.sale = function(invoice) {
      var docs;
      docs = [
        {
          type: 'sale',
          data: invoice
        }
      ];
      angular.forEach(invoice.products, function(p) {
        return docs.push({
          type: 'stock_record',
          data: {
            product_id: p.id,
            count: -p.count
          }
        });
      });
      return db.insert(docs);
    };
    service.purchase = function() {
      var docs;
      docs = [
        {
          type: 'purchase',
          data: invoice
        }
      ];
      angular.forEach(invoice.products, function(p) {
        return docs.push({
          type: 'stock_record',
          data: {
            product_id: p.id,
            count: p.count
          }
        });
      });
      return db.insert(docs);
    };
    return service;
  });

}).call(this);

(function() {
  angular.module('stock').service('IntermediateDataService', function() {
    var clear, get, savedData, set;
    savedData = null;
    set = function(data) {
      return savedData = data;
    };
    get = function(_default) {
      return savedData || _default;
    };
    clear = function() {
      return savedData = null;
    };
    return {
      set: set,
      get: get,
      clear: clear
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('input', function() {
    var link;
    link = function(scope, element, attr, ngModel) {
      if (attr.type !== 'file' || !ngModel) {
        return;
      }
      element.on('change', function() {
        var file, reader;
        file = element[0].files[0];
        reader = new FileReader();
        reader.onload = function(e) {
          var data;
          data = e.target.result;
          return ngModel.$setViewValue(data);
        };
        reader.readAsBinaryString(file);
      });
    };
    return {
      restrict: 'E',
      link: link,
      require: '?ngModel'
    };
  });

}).call(this);

(function() {
  angular.module('stock').filter('fileSize', function() {
    var sizes;
    sizes = [[1, 'b'], [1024, 'Kb'], [1024 * 1024, 'Mb'], [1024 * 1024 * 1024, 'Gb']];
    return function(input) {
      var i, l_size, len, out, size;
      input = input || 0;
      out = '';
      for (i = 0, len = sizes.length; i < len; i++) {
        size = sizes[i];
        if (input < size[0] && l_size) {
          out = (input / l_size[0]).toFixed(2) + ' ' + l_size[1];
        } else {
          l_size = size;
        }
      }
      return out;
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('employeeSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        employeeId: '=',
        asText: '=',
        ngDisabled: '=?'
      },
      controller: function($scope, RequestService, $uibModal) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectEmployee = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/employee/select.html',
            controller: 'EmployeeSelectController',
            controllerAs: 'employee',
            size: 'lg'
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchEmployee = function(search_name) {
          return RequestService.post('employee.listing', {
            name: search_name,
            limit: 10,
            with_related: true
          }).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('employeeId', function() {
          if ((angular.isDefined($scope.employeeId)) && vm.watch_prevent !== true) {
            RequestService.post('employee.listing', {
              with_related: true,
              filter: {
                _id: $scope.employeeId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
          vm.watch_prevent = false;
        });
        $scope.$watch('employee.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.employeeId = vm.selected._id;
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'employee',
      link: function(scope, element, attr) {},
      template: '<div class="col-responsive"><div ng-hide="asText===true" class="form-group"> <div class="input-group-addon" ng-show="loadingEmployees"> <span class="glyphicon glyphicon-refresh"></span> </div> <div class="input-group-addon" ng-show="noEmployees"> <span class="glyphicon glyphicon-remove text-danger"></span> </div> <input type="text" ng-model="employee.selected" class="form-control" uib-typeahead="employee as employee.name for employee in employee.searchEmployee($viewValue)" typeahead-loading="loadingEmployees" typeahead-no-results="noEmployees" ng-disabled="ngDisabled"> </div> <span ng-show="asText===true">{{ employee.selected.name }}</span></div>'
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('dynamic', function($compile) {
    var link;
    link = function(scope, ele, attrs) {
      scope.$watch(attrs.dynamic, function(html) {
        ele.html(html);
        return $compile(ele.contents())(scope);
      });
    };
    return {
      restrict: 'A',
      replace: true,
      link: link
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('stockDict', function(BObjectService) {
    return {
      restrict: 'A',
      scope: {
        stockDict: '=',
        dictTable: '@',
        dictFilter: '=',
        dictFirstItem: '=',
        dictOptions: '='
      },
      link: function(scope, element, attr) {
        var getDict;
        getDict = function() {
          var filter;
          filter = {
            type: scope.dictTable,
            with_related: true,
            filter: scope.dictFilter
          };
          BObjectService.list(filter.type, filter).then(function(data) {
            var dict, dicts;
            if (angular.isDefined(scope.dictOptions)) {
              if (scope.dictOptions.onlyParents === true) {
                dicts = (function() {
                  var i, len, ref, results;
                  ref = data.docs;
                  results = [];
                  for (i = 0, len = ref.length; i < len; i++) {
                    dict = ref[i];
                    if (dict.parent_id === null || angular.isUndefined(dict.parent_id)) {
                      results.push(dict);
                    }
                  }
                  return results;
                })();
              } else if (scope.dictOptions.onlyChildren === true) {
                dicts = (function() {
                  var i, len, ref, results;
                  ref = data.docs;
                  results = [];
                  for (i = 0, len = ref.length; i < len; i++) {
                    dict = ref[i];
                    if (dict.parent_id !== null && angular.isDefined(dict.parent_id)) {
                      results.push(dict);
                    }
                  }
                  return results;
                })();
              }
              if (angular.isUndefined(dicts)) {
                dicts = angular.copy(data.docs);
              }
            } else {
              dicts = angular.copy(data.docs);
            }
            if (angular.isDefined(scope.dictFirstItem)) {
              dicts.unshift(scope.dictFirstItem);
            }
            scope.stockDict = dicts;
          });
        };
        scope.$watch('dictTable', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
        scope.$watch('dictFilter', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
        scope.$watch('dictFirstItem', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
        scope.$watch('dictOptions', function(oldVal, newVal) {
          if (newVal !== void 0) {
            getDict();
          }
        });
      }
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('documentComment', function() {
    return {
      scope: {
        documentId: '='
      },
      templateUrl: 'app/docs/comments.html',
      controller: 'CommentsController',
      controllerAs: 'comments'
    };
  });

}).call(this);

(function() {
  angular.module('stock').directive('colResponsive', function() {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template: '<div class="col col-xs-12 col-sm-6 col-md-4" ng-transclude></div>'
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('CompanyusersController', function(RequestService, product_types, $scope, $uibModal) {
    'ngInject';
    var Removeuser, editUser, getUsers, newUser, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 20;
    vm.usersGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'username',
          displayName: 'Имя'
        }, {
          name: 'email',
          displayName: 'Емайл'
        }, {
          name: 'role',
          displayName: 'Важность'
        }, {
          name: 'rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "username") {
          filter.filter.username = v;
        }
        if (k === "email") {
          filter.filter.email = v;
        }
        if (k === "surname") {
          filter.filter.data.surname = v;
        }
        if (k === "name") {
          filter.filter.data.name = v;
        }
        if (k === "patronymic") {
          filter.filter.data.patronymic = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      RequestService.post('company.list', filter).then(function(result) {
        vm.usersGridOptions.data = result.users;
        vm.usersGridOptions.totalItems = result.count;
      });
    };
    Removeuser = function(user) {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.user_id = user.id;
      RequestService.post('company.removeuser', filter).then(function(result) {
        getUsers();
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/companyusers/edit.html',
        controller: 'CompanyusersEditController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/companyusers/create.html',
        controller: 'CompanyusersEditController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getUsers();
    });
    vm.editUser = editUser;
    vm.newUser = newUser;
    vm.getUsers = getUsers;
    vm.Removeuser = Removeuser;
    getUsers();
  }).controller('CompanyusersEditController', function(RequestService, user, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createUser, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user;
    }
    updateUser = function() {
      RequestService.post('company.putuser', vm.user).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    createUser = function() {
      RequestService.post('company.adduser', vm.user).then(function(result) {
        console.log(result);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
  });

}).call(this);

(function() {
  angular.module('stock').controller('CompanyController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editCompany, getCompanies, newCompany, removeCompany, setActiveCompany, vm;
    vm = this;
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'insurance_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/company/edit.html',
        controller: 'CompanyEditController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/company/edit.html',
        controller: 'CompanyEditController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    removeCompany = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление компании</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите удалить?</h5></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('company.remove', vm.selected_company).then(function(result) {
          getCompanies();
        });
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newCompany = newCompany;
    vm.editCompany = editCompany;
    vm.removeCompany = removeCompany;
    getCompanies();
  }).controller('CompanyEditController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, checkAgents, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getUsers, handleFileSelect, logging, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    checkAgents = function() {
      var flag, i, id, j, len, len1, percent, ref, ref1, res;
      if (!vm.company.data.agent_percentage) {
        vm.company.data.agent_percentage = [];
      }
      res = [];
      ref = vm.company.agents_id;
      for (i = 0, len = ref.length; i < len; i++) {
        id = ref[i];
        flag = false;
        ref1 = vm.company.data.agent_percentage;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          percent = ref1[j];
          if (percent.id === id) {
            flag = true;
            res.push(angular.copy(percent));
            break;
          }
        }
        if (!flag) {
          res.push(angular.copy({
            "id": id,
            "percent": 0
          }));
        }
      }
      return vm.company.data.agent_percentage = res;
    };
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "insurance_company"
      };
    } else {
      vm.company = company;
      checkAgents();
    }
    logging = function(arg) {
      console.log(arg);
    };
    vm.logging = logging;
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      console.log(vm.company);
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
        console.log(vm.users);
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            console.log("Этот user уже в списке");
            return;
          }
        }
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    getUsers();
    vm.checkAgents = checkAgents;
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
  });

}).call(this);

(function() {
  angular.module('stock').controller('BranchController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, date, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, m, onDblClick, resetFilter, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.date_start.setHours(vm.date_start.getHours() + 6);
    vm.date_end.setHours(vm.date_end.getHours() + 6);
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/branch/show.html',
        controller: 'BranchShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client.surname',
          displayName: 'Фамилия клиента'
        }, {
          name: 'client.name',
          displayName: 'Имя клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Страховщик'
        }, {
          name: 'agent',
          displayName: 'Агент'
        }, {
          name: 'branch',
          displayName: 'Филиал'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      if (!vm.company) {
        $state.go('app.apolicy.new');
      } else if (vm.company.company_type === "insurance_company") {
        $state.go('app.apolicy.select');
      } else if (vm.company.company_type === "agent") {
        $state.go('app.apolicy.select');
      } else {
        $state.go('app.apolicy.new');
      }
      return false;
    };
    goToIssue = function() {
      $state.go('app.apolicy.issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/edit.html',
        controller: 'ApolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      }
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "name") {
          filter.filter.client.name = v;
        }
        if (k === "surname") {
          filter.filter.client.surname = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      filter.filter.date_end = vm.date_end;
      filter.filter.date_start = vm.date_start;
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      RequestService.post('branch.branchlisting', {
        company_id: vm.company._id
      }).then(function(data) {
        return vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        'policyNumber': vm.selected_policy.policy_no
      });
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    getAgents();
    getPolicies();
  }).controller('BranchShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
      console.log(vm.policy);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);

(function() {
  angular.module('stock').controller('AuthController', function(RequestService, $rootScope, toastr, EVENTS, Session, browser, email_mask, AppStorage, $http, $state, $scope) {
    'ngInject';
    var checkPolicy, login, ref, register, toast, vm;
    vm = this;
    vm.policyShow = null;
    vm.os = (ref = browser()) != null ? ref : 'unknown';
    register = function() {
      if (!vm.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      if (vm.auth_loading === true) {
        return;
      }
      vm.auth_loading = true;
      RequestService.post('user/register', vm).then(function(data) {
        Session.create(data.token, data.user);
        $state.go('app.profile.preregistration');
        vm.auth_loading = false;
      }, function(result) {
        vm.auth_loading = false;
        toast(result);
      });
      return false;
    };
    login = function() {
      if (vm.auth_loading === true) {
        return;
      }
      vm.auth_loading = true;
      RequestService.post('user/auth', vm).then(function(data) {
        Session.create(data.token, data.user, data.company);
        $scope.$emit(EVENTS.loginSuccess);
        vm.auth_loading = false;
      }, function(result) {
        vm.auth_loading = false;
        toast(result ? result : {
          result: -1,
          message: 'Ошибка сети'
        });
      });
      return false;
    };
    checkPolicy = function() {
      vm.policyShow = null;
      vm.textError = null;
      $http.post($rootScope.api + 'get_policy/' + vm.policy_no).then(function(data) {
        vm.policy = data.data;
        if (!vm.policy.message) {
          if (vm.policy.data.status === 'Оформлен') {
            vm.color = '#32CD32';
          } else if (vm.policy.data.status === 'Истек') {
            vm.color = '#FFD700';
          }
          return vm.policyShow = {};
        } else {
          return vm.textError = {};
        }
      });
    };
    toast = function(result) {
      if (result.result > 0) {
        return toastr.warning(result.message);
      } else if (result.result < 0) {
        return toastr.error(result.message);
      }
    };
    $scope.$on(EVENTS.loginSuccess, function() {
      AppStorage.clear();
      vm.company = Session.getCompany();
      $state.go('app.dashboard');
    });
    vm.register = register;
    vm.checkPolicy = checkPolicy;
    vm.login = login;
  }).controller('AuthInfoController', function(RequestService, $rootScope, EVENTS, Session, browser, email_mask, AppStorage, $http, $state, $scope) {
    'ngInject';
    var checkPolicy, vm;
    vm = this;
    vm.policyNumber = $state.params.id;
    checkPolicy = function() {
      vm.policyShow = null;
      vm.textError = null;
      $http.post($rootScope.api + 'get_policy/' + vm.policyNumber).then(function(data) {
        vm.policy = data.data;
        if (!vm.policy.message) {
          if (vm.policy.data.status === 'Оформлен') {
            vm.color = '#32CD32';
          } else if (vm.policy.data.status === 'Истек') {
            vm.color = '#FFD700';
          }
          return vm.policyShow = {};
        } else {
          return vm.textError = {};
        }
      });
    };
    vm.checkPolicy = checkPolicy;
    checkPolicy();
  });

}).call(this);

(function() {
  angular.module('stock').controller('AssistanceAuthController', function(RequestService, $rootScope, toastr, EVENTS, Session, browser, email_mask, AppStorage, $http, $state) {
    var checkPolicy, login, vm;
    vm = this;
    vm.authCredentials = {};
    vm.policyCredentials = {};
    vm.policies = null;
    vm.companies = [
      {
        name: 'Аман Ассистанс',
        companyId: '240da0d6-81a2-406d-b31f-e689d680f147'
      }
    ];
    login = function() {
      RequestService.post('user/auth', vm.authCredentials).then(function(data) {
        Session.create(data.token, data.user, data.company);
        AppStorage.clear();
        $state.go('app.dashboard');
      });
      return false;
    };
    checkPolicy = function() {
      RequestService.post('policiesa/check_balance', vm.policyCredentials).then(function(response) {
        vm.policies = response.docs;
      }, function(response) {
        vm.policies = [];
        console.log(response);
      });
    };
    vm.login = login;
    vm.checkPolicy = checkPolicy;
  });

}).call(this);

(function() {
  angular.module('stock').controller('ApolicyController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ApolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, downloadPDF3, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/show.html',
        controller: 'ApolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client.surname',
          displayName: 'Фамилия клиента'
        }, {
          name: 'client.name',
          displayName: 'Имя клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_amount',
          displayName: 'Страховая сумма'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Страховщик',
          visible: false
        }, {
          name: 'agent',
          displayName: 'Агент'
        }, {
          name: 'employee.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.employee.surname}} {{row.entity.employee.name}}</span>',
          width: 150
        }, {
          name: 'branch',
          displayName: 'Филиал',
          visible: false
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      if (!vm.company) {
        $state.go('app.apolicy.new');
      } else if (vm.company.company_type === "insurance_company") {
        $state.go('app.apolicy.select');
      } else if (vm.company.company_type === "agent") {
        $state.go('app.apolicy.select');
      } else {
        $state.go('app.apolicy.new');
      }
      return false;
    };
    goToIssue = function() {
      $state.go('app.apolicy.issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/edit.html',
        controller: 'ApolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'insurance_company') {
        filter.with_related = true;
        filter.filter = {
          company_id: vm.company._id
        };
      }
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.insurance_data.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.insurance_data.date_start = v;
        }
        if (k === "name") {
          filter.filter.client.name = v;
        }
        if (k === "surname") {
          filter.filter.client.surname = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.issue_date > '2019-07-22 00:00:00+06') {
        ReportService.printReport('IIP', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        ReportService.printReport('IIP2', {
          'policyNumber': vm.selected_policy.policy_no
        });
      }
    };
    downloadPDF3 = function() {
      if (vm.selected_policy.issue_date > '2019-07-22 00:00:00+06') {
        ReportService.printReport('IIP3', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        ReportService.printReport('IIP2', {
          'policyNumber': vm.selected_policy.policy_no
        });
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, issue_d, j, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (j = 0, len = ref.length; j < len; j++) {
          policy = ref[j];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.downloadPDF3 = downloadPDF3;
    getAgents();
    getPolicies();
  }).controller('ApolicyEditController', function($scope, hotkeys, $state, RequestService, Session, $uibModalInstance, branch, toastr) {
    'ngInject';
    var putBranch, vm;
    vm = this;
    vm.branch = branch || {
      type: 'Branches'
    };
    putBranch = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.branch.name === void 0 || vm.branch.name.trim().length === 0) {
        toastr.warning('Укажите имя филиала');
        vm.saving = false;
        return false;
      }
      if (angular.isUndefined(vm.branch.branch_type)) {
        toastr.warning('Выберите тип');
        vm.saving = false;
        return false;
      }
      RequestService.post('branch.save', vm.branch).then(function(result) {
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
      return false;
    };
    vm.putBranch = putBranch;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('ApolicyNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToSelect = function(item) {
      $state.go('app.apolicy.select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  }).controller('ApolicySelectController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, AppStorage) {
    'ngInject';
    var changeArrow, changeArrow2, changeIcon, changedRadio, computePrice, findMinInsurance, getCurrencies, goToIssue, ifLessThanMin, recalculateOnEvent, recalculateOnEventAll, setProduct, sorterFunc, vm;
    vm = this;
    vm.today = new Date();
    vm.diffDays = 0;
    vm.diffDaysvalue = 0;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.maxdate = moment().add(364, 'day').toDate();
    vm.period = {
      date_start: new Date(),
      date_end: moment().add(1, 'day').toDate()
    };
    vm.selectedProduct = {};
    vm.selectedAge = [];
    vm.age = null;
    vm.selectedSport = [];
    vm.selectedGroup = [];
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
    vm.color = {
      name: 1
    };
    changedRadio = function(value) {
      vm.color = {
        name: value
      };
      if (value === 1) {
        vm.selectedtab = 'raw';
        vm.period.date_end = moment(vm.period.date_start).add(6, 'day').toDate();
        recalculateOnEventAll();
      }
      if (value === 2) {
        vm.selectedtab = 'summary';
        vm.period.date_end = moment(vm.period.date_start).add(365, 'day').toDate();
        return recalculateOnEventAll();
      }
    };
    ifLessThanMin = function(item) {
      if (parseInt(item.data.key) >= vm.min_insurance_amount) {
        return true;
      } else {
        return false;
      }
    };
    findMinInsurance = function() {
      var country, country_id, currency, currency_id, item, j, l, len, len1, len2, len3, local_min, m, n, ref, ref1, ref2, ref3;
      if (vm.product.country_id) {
        local_min = 0;
        currency_id = 0;
        ref = vm.countries;
        for (j = 0, len = ref.length; j < len; j++) {
          country = ref[j];
          ref1 = vm.product.country_id;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            country_id = ref1[l];
            if (country_id === country._id) {
              if (parseInt(country.min_insurance) > local_min) {
                local_min = parseInt(country.min_insurance);
                currency_id = country.currency_id;
              }
            }
          }
        }
        vm.min_insurance_amount = local_min;
        vm.insurance_amount = local_min;
        if (vm.currencies) {
          ref2 = vm.currencies;
          for (m = 0, len2 = ref2.length; m < len2; m++) {
            currency = ref2[m];
            if (currency._id === currency_id) {
              vm.currency_name = currency.data.name;
            }
          }
          ref3 = vm.currenciesToday;
          for (n = 0, len3 = ref3.length; n < len3; n++) {
            item = ref3[n];
            if (item.currency === vm.currency_name) {
              vm.currencyRate1 = item.value;
            }
          }
        }
      }
    };
    setProduct = function(item) {
      var itemx, j, len, ref;
      ref = vm.productsList;
      for (j = 0, len = ref.length; j < len; j++) {
        itemx = ref[j];
        if (itemx._id === vm.selectedProduct._id) {
          itemx.tmp_product = vm.product;
        }
      }
      if (item.tmp_product === null || item.tmp_product === void 0) {
        item.tmp_product = {};
        vm.product = {};
        vm.product.factors = {};
      } else {
        vm.product = item.tmp_product;
      }
      vm.selectedProduct = item;
    };
    computePrice = function(prod) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, j, l, len, len1, len2, len3, m, n, obj_x, ref, ref1, ref2, ref3, theprice, timeDiff;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = moment().toDate();
        date1 = prod.tmp_product.date_start;
      } else {
        date1 = new Date(prod.tmp_product.date_start).setHours(0, 0, 0, 0);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = moment(prod.tmp_product.date_start).add(1, 'day').toDate();
        date2 = prod.tmp_product.date_start;
      } else {
        date2 = new Date(prod.tmp_product.date_end).setHours(0, 0, 0, 0);
      }
      diffDays = 0;
      timeDiff = Math.abs(date2 - date1);
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      vm.diffDays = diffDays;
      vm.max_diffdays = diffDays;
      vm.diffDaysvalue = diffDays;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref = vm.countries;
        for (j = 0, len = ref.length; j < len; j++) {
          country_x = ref[j];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
        vm.currentCountryId = country_id;
      } else {
        country_id = country_id[0];
        vm.currentCountryId = country_id;
      }
      ref1 = prod.basefactors;
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        basefactor = ref1[l];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref2 = prod.factors;
      for (m = 0, len2 = ref2.length; m < len2; m++) {
        factor = ref2[m];
        if (factor.factor !== null) {
          ref3 = factor.factor;
          for (n = 0, len3 = ref3.length; n < len3; n++) {
            item_fact = ref3[n];
            if (item_fact.usage === 'sport' && factor.values.indexOf(vm.sport) > -1) {
              if (factor.coefficient_type === "Множитель") {
                theprice = theprice * factor.coefficient;
              }
              if (factor.coefficient_type === "Слагаемое") {
                fixedamounts = fixedamounts + factor.coefficient;
              }
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      console.log("theprice : " + theprice);
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    recalculateOnEvent = function() {
      var j, len, product, ref;
      ref = vm.productsList;
      for (j = 0, len = ref.length; j < len; j++) {
        product = ref[j];
        product.theprice = $filter('number')(computePrice(product), 2);
      }
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, item_y, j, len, ref, timeDiff;
      date1 = vm.period.date_start;
      date2 = vm.period.date_end;
      timeDiff = Math.abs(date2 - date1);
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (vm.color.name === 1) {
        if (diffDays >= 366) {
          toastr.warning('Период не должен превышать 365 дней');
          return;
        }
      }
      findMinInsurance();
      if (vm.color.name === 2 && vm.period.date_start) {
        vm.period.date_end = moment(vm.period.date_start).add(365, 'day').toDate();
      }
      ref = vm.productsList;
      for (j = 0, len = ref.length; j < len; j++) {
        item_y = ref[j];
        if (vm.product.country_id !== null || vm.product.country_id !== void 0 || vm.product.country_id.length !== 0) {
          item_y.tmp_product.country_id = vm.product.country_id;
        }
        if (vm.period.date_start !== null || vm.period.date_start !== void 0 || vm.period.date_start !== "") {
          item_y.tmp_product.date_start = vm.period.date_start;
        }
        if (vm.period.date_end !== null || vm.period.date_end !== void 0 || vm.period.date_end !== "") {
          item_y.tmp_product.date_end = vm.period.date_end;
        }
        item_y.theprice = $filter('number')(computePrice(item_y), 2);
      }
    };
    changeIcon = function(index) {
      if (vm['expandicon' + index] === 'fa fa-plus-square-o') {
        vm['expandicon' + index] = 'fa fa-minus-square-o';
      } else {
        vm['expandicon' + index] = 'fa fa-plus-square-o';
      }
    };
    getCurrencies = function() {
      RequestService.post('select.listing').then(function(result) {
        var factor, i, isIn, item, item_factor, item_y, item_z, itemd, j, l, len, len1, len2, len3, len4, len5, len6, len7, m, n, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, temparr, tmp_product, x, y;
        vm.currencies = result.currencies;
        vm.countries = result.countries;
        i = 0;
        while (i < result.product.length) {
          vm['expandicon' + i] = 'fa fa-plus-square-o';
          i++;
        }
        ref = result.product;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          temparr = [];
          if (item.factors !== null && item.factors !== void 0) {
            ref1 = item.factors;
            for (l = 0, len1 = ref1.length; l < len1; l++) {
              factor = ref1[l];
              if (factor !== null) {
                isIn = false;
                for (m = 0, len2 = temparr.length; m < len2; m++) {
                  x = temparr[m];
                  if (x.factor_id === factor.factor_id) {
                    x.values = x.values.concat(factor.values);
                    isIn = true;
                  }
                }
                if (isIn === false) {
                  if (factor.factor !== null) {
                    ref2 = factor.factor;
                    for (n = 0, len3 = ref2.length; n < len3; n++) {
                      item_factor = ref2[n];
                      y = {
                        factor_id: factor.factor_id,
                        name: item_factor.name,
                        usage: item_factor.usage,
                        values: factor.values,
                        description: item_factor.description
                      };
                    }
                    temparr.push(y);
                  }
                }
              }
            }
            item.factorListing = temparr;
          }
        }
        vm.productsList = result.product;
        if (vm.product === null || vm.product === void 0) {
          vm.product.factors = {};
          vm.product.country_id = [];
        } else {
          vm.product.factors = {};
        }
        ref3 = vm.productsList;
        for (o = 0, len4 = ref3.length; o < len4; o++) {
          item_y = ref3[o];
          ref4 = item_y.factorListing;
          for (p = 0, len5 = ref4.length; p < len5; p++) {
            item = ref4[p];
            if ("age" === item.usage) {
              vm.selectedAge.push(angular.copy(item));
              ref5 = vm.selectedAge.values;
              for (i = q = 0, len6 = ref5.length; q < len6; i = ++q) {
                itemd = ref5[i];
                vm.selectedAge.values[i] = parseFloat(vm.selectedAge.values[i]);
              }
            }
            if ("sport" === item.usage) {
              vm.selectedSport.push(angular.copy(item));
            }
            if ("group" === item.usage) {
              vm.selectedGroup.push(angular.copy(item));
            }
          }
          tmp_product = {};
          tmp_product = angular.copy(vm.product);
          ref6 = item_y.factors;
          for (r = 0, len7 = ref6.length; r < len7; r++) {
            item_z = ref6[r];
            if (item_z.is_default && item_z.factor !== null) {
              tmp_product.factors[item_z.factor[0].name] = item_z.values[0];
            }
          }
          item_y.tmp_product = tmp_product;
        }
        recalculateOnEventAll();
        return findMinInsurance();
      });
    };
    goToIssue = function(product) {
      var item, j, len, ref;
      vm.product = product;
      vm.product.trip = vm.color.name;
      vm.product.diffDays = vm.diffDays;
      vm.product.type_policy = vm.color.name;
      vm.product.insurance_amount = vm.insurance_amount;
      vm.product.currency_name = vm.currency_name;
      vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
      ref = vm.currenciesToday;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (item.currency === vm.currency_name) {
          vm.product.currencyRate1 = item.value;
        }
      }
      $state.go('app.policy_issue', {
        product: vm.product
      });
    };
    vm.arrow = 'fa fa-plus-square-o';
    changeArrow = function() {
      if (vm.arrow === 'fa fa-minus-square-o') {
        return vm.arrow = "fa fa-plus-square-o";
      } else {
        return vm.arrow = "fa fa-minus-square-o";
      }
    };
    vm.arrow2 = 'fa fa-minus-square-o';
    changeArrow2 = function() {
      if (vm.arrow2 === 'fa fa-minus-square-o') {
        return vm.arrow2 = "fa fa-plus-square-o";
      } else {
        return vm.arrow2 = "fa fa-minus-square-o";
      }
    };
    sorterFunc = function(data) {
      return parseInt(data.data.key);
    };
    vm.ifLessThanMin = ifLessThanMin;
    vm.changeIcon = changeIcon;
    vm.changeArrow2 = changeArrow2;
    vm.changeArrow = changeArrow;
    vm.goToIssue = goToIssue;
    vm.setProduct = setProduct;
    vm.computePrice = computePrice;
    vm.recalculateOnEvent = recalculateOnEvent;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.sorterFunc = sorterFunc;
    vm.changedRadio = changedRadio;
    getCurrencies();
  }).controller('ApolicyIssueController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var addInsurant, changeIcon, computePrice, confirmAction, deleteInsurant, email, getCountries, j, l, len, len1, pdrobneeIconCnange, phone, reCompute, ref, ref1, savePolicy, vm;
    vm = this;
    vm.today = new Date();
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.product = $stateParams.product;
    vm.currency_name = '';
    vm.currencyRate = vm.product.currencyRate1;
    vm.iconsList = [];
    vm.pdrobneeIcon = 'fa fa-chevron-down';
    vm.minDay = moment().subtract(29200, 'days').format();
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.company = Session.getCompany();
    vm.buyer = {};
    if (vm.company.company_type = 'agent') {
      vm.buyer.surname = null;
      vm.buyer.name = null;
      if (vm.company.data.emails) {
        ref = vm.company.data.emails;
        for (j = 0, len = ref.length; j < len; j++) {
          email = ref[j];
          vm.buyer.email = email;
          break;
        }
      } else {
        vm.buyer.email = null;
      }
      if (vm.company.data.phones) {
        ref1 = vm.company.data.phones;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          phone = ref1[l];
          vm.buyer.phone = phone;
          break;
        }
      } else {
        vm.buyer.phone = null;
      }
    }
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('select.issue_listing', filter).then(function(result) {
        var item, itemx, len2, m, ref2, results;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        vm.min_insurance = 0;
        ref2 = result.countries;
        results = [];
        for (m = 0, len2 = ref2.length; m < len2; m++) {
          item = ref2[m];
          results.push((function() {
            var len3, n, ref3, results1;
            ref3 = vm.product.tmp_product.country_id;
            results1 = [];
            for (n = 0, len3 = ref3.length; n < len3; n++) {
              itemx = ref3[n];
              if (itemx === item._id) {
                vm.countriesView.push(item);
                if (item.min_insurance > vm.min_insurance) {
                  vm.min_insurance = item.min_insurance;
                  results1.push(vm.currentCountryId = itemx);
                } else {
                  results1.push(void 0);
                }
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          })());
        }
        return results;
      });
    };
    if (vm.product) {
      getCountries();
      vm.insurants = [
        {
          surname: '',
          name: '',
          passport_no: '',
          date_of_birth: '',
          factorListing: angular.copy(vm.product.factorListing),
          factors: angular.copy(vm.product.tmp_product.factors),
          theprice: angular.copy(vm.product.theprice),
          currency_value: vm.product.theprice * vm.currencyRate.toFixed(0)
        }
      ];
      vm.iconsList.push('fa fa-plus-square');
    } else {
      $state.go("app.policy_select");
    }
    addInsurant = function() {
      vm.insurants.push({
        surname: '',
        name: '',
        passport_no: '',
        date_of_birth: '',
        factorListing: angular.copy(vm.product.factorListing),
        factors: angular.copy(vm.product.tmp_product.factors),
        theprice: angular.copy(vm.product.theprice),
        currency_value: vm.product.theprice * vm.currencyRate.toFixed(0)
      });
      vm.iconsList.push('fa fa-plus-square');
    };
    deleteInsurant = function(index) {
      vm.insurants.splice(index, 1);
      vm.iconsList.splice(index, 1);
    };
    changeIcon = function(index) {
      if (vm.iconsList[index] === 'fa fa-plus-square') {
        return vm.iconsList[index] = 'fa fa-minus-square';
      } else {
        return vm.iconsList[index] = 'fa fa-plus-square';
      }
    };
    reCompute = function(insurant) {
      if (moment(insurant.date_of_birth).format() < vm.minDay) {
        toastr.warning('Дата рождение не больше 80 лет!');
        return;
      }
      if (insurant.date_of_birth && moment(insurant.date_of_birth).format() > vm.minDay) {
        insurant.factors['Возраст'] = moment().diff(insurant.date_of_birth, 'years');
        insurant.factors['Занятие спортом и активный отдых'] = insurant.factor_sport || "Не выбрано";
        insurant.theprice = computePrice(insurant).toFixed(2);
        insurant.currency_value = insurant.theprice * vm.currencyRate.toFixed(0);
      } else {
        insurant.theprice = computePrice(insurant).toFixed(2);
        insurant.currency_value = insurant.theprice * vm.currencyRate.toFixed(0);
      }
    };
    computePrice = function(insurant) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, len2, len3, len4, len5, m, n, o, obj_x, p, prod, ref2, ref3, ref4, ref5, theprice, timeDiff;
      prod = angular.copy(vm.product);
      prod.tmp_product.factors = insurant.factors;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref2 = vm.countries;
        for (m = 0, len2 = ref2.length; m < len2; m++) {
          country_x = ref2[m];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref3 = prod.basefactors;
      for (n = 0, len3 = ref3.length; n < len3; n++) {
        basefactor = ref3[n];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.product.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref4 = prod.factors;
      for (o = 0, len4 = ref4.length; o < len4; o++) {
        factor = ref4[o];
        if (factor.factor !== null) {
          ref5 = factor.factor;
          for (p = 0, len5 = ref5.length; p < len5; p++) {
            item_fact = ref5[p];
            if (item_fact.usage === 'age' && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
              if (factor.coefficient_type === "Множитель") {
                theprice = theprice * factor.coefficient;
              }
              if (factor.coefficient_type === "Слагаемое") {
                fixedamounts = fixedamounts + factor.coefficient;
              }
            }
            if (item_fact.usage === 'sport' && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
              if (factor.coefficient_type === "Множитель") {
                theprice = theprice * factor.coefficient;
              }
              if (factor.coefficient_type === "Слагаемое") {
                fixedamounts = fixedamounts + factor.coefficient;
              }
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    savePolicy = function() {
      var agent_id, branch_id, insurance_data, item, key, len2, len3, m, n, policy, policyList, policy_no, ref2, ref3, ref4, theUser, user, value;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
      }
      theUser = Session.getUser();
      if (vm.company) {
        ref2 = vm.company.staff;
        for (m = 0, len2 = ref2.length; m < len2; m++) {
          user = ref2[m];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      vm.product.data;
      insurance_data = angular.copy(vm.product.tmp_product);
      policyList = {
        items: []
      };
      ref3 = vm.insurants;
      for (n = 0, len3 = ref3.length; n < len3; n++) {
        item = ref3[n];
        if (item.theprice > 0) {
          insurance_data.factors = item.factors;
          insurance_data.factors_list = [];
          ref4 = item.factors;
          for (key in ref4) {
            value = ref4[key];
            value = value + "";
            insurance_data.factors_list.push({
              key: key,
              value: value
            });
          }
          policy_no = vm.product.code;
          if (vm.company.company_type === "agent") {
            agent_id = vm.company._id;
            policy_no = policy_no.slice(0, 3) + vm.company.code;
          }
          policy = {
            policy_no: policy_no,
            issue_date: new Date(),
            product_id: vm.product._id,
            company_id: vm.product.company_id,
            user_id: theUser.id,
            agent_id: agent_id,
            branch_id: branch_id,
            client: {
              surname: item.surname.toUpperCase(),
              name: item.name.toUpperCase(),
              passport_no: item.passport_no,
              date_of_birth: item.date_of_birth
            },
            insurance_amount: vm.product.insurance_amount,
            insurance_premium: item.theprice,
            insurance_data: angular.copy(insurance_data),
            payment_data: {},
            index: {},
            accumulation: {},
            data: {
              trip: vm.product.trip,
              buyer: vm.buyer,
              status: 'Оформлен',
              currency_name: vm.product.currency_name,
              insurance_premium_kgs: (item.theprice * vm.currencyRate).toFixed(0)
            }
          };
          policyList.items.push(policy);
        } else if (item.theprice === 0) {
          toastr.warning('Для ' + item.surname.toUpperCase() + ' ' + item.name.toUpperCase() + ' не создан полис');
        }
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        if (policyList.items.length === 1) {
          policy = angular.copy(policyList.items[0]);
          policy._id = result.resultList[0].id;
          policy._rev = result.resultList[0].rev;
          policy.policy_no = result.resultList[0].policy_no;
        }
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var item, len2, m, ref2, temp, to_save;
        if (result) {
          to_save = [];
          ref2 = vm.insurants;
          for (m = 0, len2 = ref2.length; m < len2; m++) {
            item = ref2[m];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.changeIcon = changeIcon;
    vm.confirmAction = confirmAction;
    vm.addInsurant = addInsurant;
    vm.deleteInsurant = deleteInsurant;
    vm.reCompute = reCompute;
    vm.savePolicy = savePolicy;
  }).controller('ApolicyViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    findCurrencyName = function() {
      var country, currency, j, l, len, len1, ref, ref1;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        country = ref[j];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            currency = ref1[l];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var item, itemx, j, l, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        ref1 = vm.policy.insurance_data.country_id;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          itemx = ref1[l];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = $stateParams.product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, j, l, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (j = 0, len = ref.length; j < len; j++) {
        country_id = ref[j];
        ref1 = vm.countries;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          country = ref1[l];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, j, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code;
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        'policyNumber': vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
  }).controller('ApolicyShowController', function($scope, AppStorage, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.now = moment().format('YYYY-MM-DD HH:mm');
    vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    findCurrencyName = function() {
      var country, currency, item, j, l, len, len1, len2, m, ref, ref1, ref2;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        country = ref[j];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            currency = ref1[l];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.currency_name) {
                ref2 = vm.currenciesToday;
                for (m = 0, len2 = ref2.length; m < len2; m++) {
                  item = ref2[m];
                  if (item.currency === vm.currency_name) {
                    vm.currencyRate1 = item.value;
                  }
                }
                vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate1).toFixed(0);
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var item, itemx, j, l, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        ref1 = vm.policy.insurance_data.country_id;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          itemx = ref1[l];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
      console.log(vm.policy);
    }
    sendMail = function() {
      var countries, country, country_id, j, l, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (j = 0, len = ref.length; j < len; j++) {
        country_id = ref[j];
        ref1 = vm.countries;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          country = ref1[l];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, j, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code;
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      var item, j, len, ref;
      ref = vm.currenciesToday;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (item.currency === vm.currency_name) {
          vm.currencyRate = item.value;
        }
      }
      console.log("vm.currencyRate " + vm.currencyRate);
      FormPolicy();
    };
    spoilPolicy = function() {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.now > (moment(vm.policy.issue_date).add(24, 'hours').format("YYYY-MM-DD HH:mm"))) {
        toastr.error('Полис портить можно в течении 24 часов');
        return;
      }
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, j, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  }).controller('ApolicyFormController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var FormPolicy, computePrice, confirmActionForm, confirmActionSave, findCurrencyName, findMinInsurance, getCountries, getProducts, ifLessThanMin, issueAgent_policy, reCompute, savePolicy, sendMail, vm;
    vm = this;
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    ifLessThanMin = function(item) {
      if (parseInt(item.data.key) >= vm.min_insurance) {
        return true;
      } else {
        return false;
      }
    };
    findCurrencyName = function() {
      var country, currency, j, l, len, len1, ref, ref1;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        country = ref[j];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            currency = ref1[l];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var item, itemx, j, l, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        ref1 = vm.policy.insurance_data.country_id;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          itemx = ref1[l];
          if (itemx === item._id) {
            vm.countriesView.push(item);
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('countries.listing', filter).then(function(result) {
        vm.countries = result.docs;
        findMinInsurance();
        RequestService.post('currencies.listing').then(function(result2) {
          vm.currencies = result2.docs;
          findCurrencyName();
        });
      });
    };
    getProducts = function(product_id) {
      var company, filter;
      filter = {
        with_related: true
      };
      company = Session.getCompany();
      if (company) {
        if (company.company_type === "insurance_company") {
          filter = {
            with_related: true,
            filter: {
              company_id: company._id,
              _id: product_id
            }
          };
        } else if (company.insurance_company) {
          filter = {
            with_related: true,
            filter: {
              company_id: company.insurance_company._id,
              _id: product_id
            }
          };
        } else {
          filter = {
            with_related: true,
            filter: {
              product_id: product_id
            }
          };
        }
      }
      RequestService.post('product.listing', filter).then(function(result) {
        var factor, isIn, item, item_y, j, l, len, len1, len2, len3, m, n, ref, ref1, ref2, temparr, x, y;
        ref = result.docs;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          temparr = [];
          if (item.factors !== null && item.factors !== void 0) {
            ref1 = item.factors;
            for (l = 0, len1 = ref1.length; l < len1; l++) {
              factor = ref1[l];
              isIn = false;
              for (m = 0, len2 = temparr.length; m < len2; m++) {
                x = temparr[m];
                if (x.factor_id === factor.factor_id) {
                  x.values = x.values.concat(factor.values);
                  isIn = true;
                }
              }
              if (isIn === false) {
                y = {
                  factor_id: factor.factor_id,
                  name: factor.factor.name,
                  usage: factor.factor.usage,
                  values: factor.values,
                  description: factor.factor.description
                };
                temparr.push(y);
              }
            }
            item.factorListing = temparr;
          }
        }
        vm.productsList = result.docs;
        ref2 = vm.productsList;
        for (n = 0, len3 = ref2.length; n < len3; n++) {
          item_y = ref2[n];
          item_y.tmp_product = vm.policy.insurance_data;
        }
        vm.product = vm.productsList[0];
        getCountries();
        return console.log(vm.product);
      });
    };
    vm.policy = $stateParams.policy;
    if (vm.policy) {
      getProducts(vm.policy.product_id);
    } else {
      console.log("Страница на получила данные");
      $state.go("app.apolicy.list");
    }
    vm.company = Session.getCompany();
    reCompute = function(arg) {
      findMinInsurance();
      vm.policy.insurance_data.factors['Возраст'] = moment().diff(vm.policy.client.date_of_birth, 'years') + "";
      vm.policy.insurance_premium = $filter('number')(computePrice(), 2);
    };
    computePrice = function() {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, j, l, len, len1, len2, m, obj_x, prod, ref, ref1, ref2, theprice, timeDiff;
      if (vm.policy.insurance_data.country_id.length === 0) {
        return 0;
      }
      prod = angular.copy(vm.product);
      prod.tmp_product = angular.copy(vm.policy.insurance_data);
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref = vm.countries;
        for (j = 0, len = ref.length; j < len; j++) {
          country_x = ref[j];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref1 = prod.basefactors;
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        basefactor = ref1[l];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.policy.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref2 = prod.factors;
      for (m = 0, len2 = ref2.length; m < len2; m++) {
        factor = ref2[m];
        if (prod.tmp_product.factors[factor.factor.name] !== null && prod.tmp_product.factors[factor.factor.name] !== void 0 && factor.values.indexOf(prod.tmp_product.factors[factor.factor.name].toString()) > -1) {
          if (factor.coefficient_type === "Множитель") {
            theprice = theprice * factor.coefficient;
          }
          if (factor.coefficient_type === "Слагаемое") {
            fixedamounts = fixedamounts + factor.coefficient;
          }
        }
      }
      theprice = theprice + fixedamounts;
      console.log("theprice : " + theprice);
      return theprice;
    };
    sendMail = function() {
      var countries, country, country_id, j, l, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (j = 0, len = ref.length; j < len; j++) {
        country_id = ref[j];
        ref1 = vm.countries;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          country = ref1[l];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, j, key, len, policyList, policy_no, ref, ref1, theUser, user, value;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code;
      }
      vm.policy.policy_no = policy_no;
      vm.policy.user_id = theUser.id;
      vm.policy.issue_date = new Date();
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = 'Оформлен';
      vm.policy.data.currency_name = vm.currency_name;
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      vm.policy.insurance_data.factors_list = [];
      vm.policy.client.name = vm.policy.client.name.toUpperCase();
      vm.policy.client.surname = vm.policy.client.surname.toUpperCase();
      ref1 = vm.policy.insurance_data.factors;
      for (key in ref1) {
        value = ref1[key];
        value = value + "";
        vm.policy.insurance_data.factors_list.push({
          key: key,
          value: value
        });
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        vm.policy.policy_no = result.resultList[0].policy_no;
        toastr.success('Полис оформлен успешно');
        sendMail();
        return $state.go('app.apolicy.show', {
          product: vm.policy
        });
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        FormPolicy();
      });
    };
    savePolicy = function() {
      var branch_id, j, key, len, policyList, ref, ref1, theUser, user, value;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.currency_name = vm.currency_name;
      vm.policy.insurance_data.factors_list = [];
      ref1 = vm.policy.insurance_data.factors;
      for (key in ref1) {
        value = ref1[key];
        vm.policy.insurance_data.factors_list.push({
          key: key,
          value: value
        });
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис сохранен успешно');
        return $state.go('app.apolicy.show', {
          product: angular.copy(policyList.items[0])
        });
      });
      return false;
    };
    confirmActionSave = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var temp, to_save;
        if (result) {
          to_save = [];
          temp = {
            client_type: 'insured',
            name: vm.policy.client.name,
            surname: vm.policy.client.surname,
            passport: vm.policy.client.passport_no,
            date_of_birth: vm.policy.client.date_of_birth
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var temp, to_save;
        if (result) {
          to_save = [];
          temp = {
            client_type: 'insured',
            name: vm.policy.client.name,
            surname: vm.policy.client.surname,
            passport: vm.policy.client.passport_no,
            date_of_birth: vm.policy.client.date_of_birth
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            issueAgent_policy();
          });
        }
      });
    };
    vm.ifLessThanMin = ifLessThanMin;
    vm.confirmActionForm = confirmActionForm;
    vm.confirmActionSave = confirmActionSave;
    vm.savePolicy = savePolicy;
    vm.findMinInsurance = findMinInsurance;
    vm.FormPolicy = FormPolicy;
    vm.getProducts = getProducts;
    vm.reCompute = reCompute;
  }).controller('ApolicyDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TerminateDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    vm.moneyBack = 0;
    ok = function() {
      $uibModalInstance.close(vm.moneyBack);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).filter('filterCountries', function() {
    return function(input, search) {
      var item, j, len, res;
      res = [];
      if (input) {
        for (j = 0, len = input.length; j < len; j++) {
          item = input[j];
          if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.data.name_eng.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
            res.push(item);
          }
        }
      } else {
        return [];
      }
      return res;
    };
  });

}).call(this);

(function() {
  angular.module('stock').controller('AgentemployeeController', function(RequestService, Session, email_mask, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var editUser, getUsers, newUser, removeUser, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.users = {};
    vm.agentemployeeGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'User.username',
          displayName: 'Имя'
        }, {
          name: 'branch',
          displayName: 'Филиал'
        }, {
          name: 'User.email',
          displayName: 'Емайл'
        }, {
          name: 'User.rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: vm.company._id
      };
      RequestService.post('agentemployee.listing', filter).then(function(result) {
        delete vm.selected_agent;
        vm.agentemployeeGridOptions.data = result.users;
        return vm.agentemployeeGridOptions.totalItems = result.count;
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agentemployee/create.html',
        controller: 'AgentemployeeCreateController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agentemployee/edit.html',
        controller: 'AgentemployeeCreateController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    removeUser = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление пользователя</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите удалить?</h5></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('agentemployee.remove', {
          id: vm.selected_user.User.id
        }).then(function(result) {
          getUsers();
        });
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    vm.getUsers = getUsers;
    vm.newUser = newUser;
    vm.editUser = editUser;
    vm.removeUser = removeUser;
    getUsers();
  }).controller('AgentemployeeCreateController', function(RequestService, product_types, user, $scope, $uibModalInstance, Session) {
    'ngInject';
    var cancel, createUser, getBranches, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user.User;
    }
    getBranches = function() {
      var company, filter;
      company = Session.getCompany();
      if (company) {
        filter = {
          with_related: true,
          filter: {
            company_id: company._id
          }
        };
      } else {
        filter = {
          with_related: true
        };
      }
      RequestService.post('branch.listing', filter).then(function(data) {
        delete vm.selected_branch;
        vm.branches = data.docs;
      });
    };
    createUser = function() {
      RequestService.post('agentemployee.register', vm.user).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    updateUser = function() {
      RequestService.post('user.put', vm.user).then(function(result) {
        console.log("updateUser ->result.user = ");
        console.log(result.user);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
    vm.getBranches = getBranches;
    getBranches();
  });

}).call(this);

(function() {
  angular.module('stock').controller('AgentbranchController', function(RequestService, Session, email_mask, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteBranch, editBranch, getBranches, newBranch, vm;
    vm = this;
    vm.branchesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Официальное имя'
        }, {
          name: 'data.name_short',
          displayName: 'Краткое имя'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.websites[0]',
          displayName: 'Сайт'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company.name',
          displayName: 'Компания'
        }, {
          name: 'branch_type',
          displayName: 'Тип'
        }, {
          name: 'branch_status',
          displayName: 'Статус',
          visible: false
        }, {
          name: 'data.description',
          displayName: 'Описание',
          visible: false
        }, {
          name: 'data.owner_name',
          displayName: 'Владелец',
          visible: false
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.owner_type',
          displayName: 'Тип владельца',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Пользователь',
          visible: false
        }
      ]
    };
    newBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agentbranch/edit.html',
        controller: 'AgentbranchEditController',
        controllerAs: 'agentBranch',
        size: 'lg',
        resolve: {
          branch: void 0
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agentbranch/edit.html',
        controller: 'AgentbranchEditController',
        controllerAs: 'agentBranch',
        size: 'lg',
        resolve: {
          branch: vm.selected_branch
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getBranches = function() {
      var company, filter;
      company = Session.getCompany();
      if (company) {
        filter = {
          with_related: true,
          filter: {
            company_id: company._id
          }
        };
      } else {
        filter = {
          with_related: true
        };
      }
      RequestService.post('branch.listing', filter).then(function(data) {
        delete vm.selected_branch;
        vm.branchesGridOptions.data = data.docs;
      });
    };
    deleteBranch = function() {
      return RequestService.post('branch.delete', vm.selected_branch).then(function(data) {
        getBranches();
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот филиал"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteBranch();
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_branch = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: newBranch
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getBranches
    });
    vm.confirmAction = confirmAction;
    vm.deleteBranch = deleteBranch;
    vm.newBranch = newBranch;
    vm.editBranch = editBranch;
    vm.getBranches = getBranches;
    getBranches();
  }).controller('AgentbranchEditController', function($scope, RequestService, Session, $uibModalInstance, branch, toastr, $uibModal) {
    'ngInject';
    var addAddress, addEmail, addPhone, addWebsite, confirmAction, deleteAddress, deleteEmail, deletePhone, deleteWebsite, getCompanies, saveBranch, vm;
    vm = this;
    vm.user = Session.getUser();
    vm.company = Session.getCompany();
    if (branch) {
      vm.agentBranch = branch;
    } else {
      vm.agentBranch = {
        type: 'Branches',
        data: {}
      };
      if (vm.company) {
        vm.agentBranch.company_id = vm.company._id;
      }
    }
    if (vm.company !== null && vm.company !== void 0) {
      vm.agentBranch.company_id = vm.company._id;
    }
    getCompanies = function() {
      RequestService.post('company.listing').then(function(data) {
        vm.companies = data.docs;
      });
    };
    saveBranch = function() {
      RequestService.post('branch.save', vm.agentBranch).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.address = '';
    addAddress = function() {
      if (vm.agentBranch.data.addresses === null || vm.agentBranch.data.addresses === void 0) {
        vm.agentBranch.data.addresses = [];
      } else {
        if (vm.agentBranch.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agentBranch.data.addresses.push(vm.address);
      vm.address = '';
    };
    deleteAddress = function(index) {
      vm.agentBranch.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.agentBranch.data.emails === null || vm.agentBranch.data.emails === void 0) {
        vm.agentBranch.data.emails = [];
      } else {
        if (vm.agentBranch.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agentBranch.data.emails.push(vm.email);
      vm.email = '';
    };
    deleteEmail = function(index) {
      vm.agentBranch.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.agentBranch.data.websites === null || vm.agentBranch.data.websites === void 0) {
        vm.agentBranch.data.websites = [];
      } else {
        if (vm.agentBranch.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agentBranch.data.websites.push(vm.website);
      vm.website = '';
    };
    deleteWebsite = function(index) {
      vm.agentBranch.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.agentBranch.data.phones === null || vm.agentBranch.data.phones === void 0) {
        vm.agentBranch.data.phones = [];
      } else {
        if (vm.agentBranch.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agentBranch.data.phones.push(vm.phone);
      vm.phone = '';
    };
    deletePhone = function(index) {
      vm.agentBranch.data.phones.splice(index, 1);
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот филиал"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveBranch();
        }
      });
    };
    getCompanies();
    vm.confirmAction = confirmAction;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.saveBranch = saveBranch;
  });

}).call(this);

(function() {
  angular.module('stock').controller('AgentController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys) {
    'ngInject';
    var confirmAction, deleteAgent, editAgent, getAgents, newAgent, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 50;
    vm.employeesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [50, 100, 500],
      paginationPageSize: 50,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    editAgent = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agent/create.html',
        controller: 'AgentCreateController',
        controllerAs: 'agent',
        size: 'lg',
        resolve: {
          agent: angular.copy(vm.selected_agent)
        }
      });
      employeeDialog.result.then(function() {
        return getAgents();
      });
    };
    newAgent = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agent/create.html',
        controller: 'AgentCreateController',
        controllerAs: 'agent',
        size: 'lg',
        resolve: {
          agent: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getAgents();
      });
    };
    getAgents = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        order_by: ['_created DESC'],
        filter: {
          company_type: 'agent'
        }
      };
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "name") {
          filter.filter.name = v;
        }
      }
      RequestService.post('company.listing', filter).then(function(result) {
        delete vm.selected_agent;
        vm.employeesGridOptions.data = result.docs;
        return vm.employeesGridOptions.totalItems = result.count;
      });
    };
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить сотрудника',
      callback: newAgent
    }).add({
      combo: 'r',
      description: 'Обновить список сотрудников',
      callback: getAgents
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_agent = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getAgents();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить агента"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteAgent();
        }
      });
    };
    deleteAgent = function() {
      RequestService.post('company.remove', vm.selected_agent).then(function(result) {
        getAgents();
      });
    };
    vm.newAgent = newAgent;
    vm.editAgent = editAgent;
    vm.confirmAction = confirmAction;
    vm.deleteAgent = deleteAgent;
    vm.getAgents = getAgents;
    getAgents();
  }).controller('AgentEditController', function($scope, RequestService, agent, $uibModalInstance) {
    'ngInject';
    var addAddress, addEmail, addPhone, addWebsite, cancel, deleteAddress, deleteEmail, deletePhone, deleteWebsite, saveAgent, vm;
    vm = this;
    vm.agent = agent;
    saveAgent = function() {
      RequestService.post('agent.save', vm.agent).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.address = '';
    addAddress = function() {
      if (vm.agent.addresses === null || vm.agent.addresses === void 0) {
        vm.agent.addresses = {};
        vm.agent.addresses.items = [];
      } else {
        if (vm.agent.addresses.items.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.addresses.items.push(vm.address);
      vm.address = '';
    };
    deleteAddress = function(index) {
      vm.agent.addresses.items.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.agent.contacts === null || vm.agent.contacts === void 0) {
        vm.agent.contacts = {};
        vm.agent.contacts.email = [];
        vm.agent.contacts.website = [];
        vm.agent.contacts.phone = [];
      } else {
        if (vm.agent.contacts.email.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.contacts.email.push(vm.email);
      vm.email = '';
    };
    deleteEmail = function(index) {
      vm.agent.contacts.email.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.agent.contacts === null || vm.agent.contacts === void 0) {
        vm.agent.contacts = {};
        vm.agent.contacts.email = [];
        vm.agent.contacts.website = [];
        vm.agent.contacts.phone = [];
      } else {
        if (vm.agent.contacts.website.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.contacts.website.push(vm.website);
      vm.website = '';
    };
    deleteWebsite = function(index) {
      vm.agent.contacts.website.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.agent.contacts === null || vm.agent.contacts === void 0) {
        vm.agent.contacts = {};
        vm.agent.contacts.email = [];
        vm.agent.contacts.website = [];
        vm.agent.contacts.phone = [];
      } else {
        if (vm.agent.contacts.phone.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.contacts.phone.push(vm.phone);
      vm.phone = '';
    };
    deletePhone = function(index) {
      vm.agent.contacts.phone.splice(index, 1);
    };
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.saveAgent = saveAgent;
    vm.cancel = cancel;
  }).controller('AgentCreateController', function($scope, RequestService, $uibModalInstance, agent, Session, toastr, email_mask) {
    'ngInject';
    var addAddress, addEmail, addPhone, addStaff, addWebsite, createAgent, deleteAddress, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getBranches, getCompanies, getUsers, vm;
    vm = this;
    if (agent === null || agent === void 0) {
      vm.agent = {
        data: {},
        company_type: "insurance_company",
        staff: [],
        insurance_check: false
      };
    } else {
      vm.agent = agent;
      if (vm.agent.staff === null || vm.agent.staff === void 0) {
        vm.agent.staff = [];
      }
    }
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.agent.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            console.log("Этот user уже в списке");
            return;
          }
        }
        vm.agent.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.agent.staff.splice(index, 1);
    };
    getBranches = function() {
      var filter;
      filter = {
        company_id: vm.agent._id
      };
      RequestService.post('branch.branchlisting', filter).then(function(data) {
        vm.branchestype = data.docs;
      });
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
        console.log(vm.users);
      });
    };
    getCompanies = function() {
      vm.user_companies = {};
      RequestService.post('company.listing', {
        with_related: true
      }).then(function(data) {
        console.log(data);
      });
    };
    getCompanies();
    createAgent = function() {
      vm.agent.company_type = 'agent';
      vm.agent.user_id = 1;
      if (vm.agent.agents_id === null || vm.agent.agents_id === void 0) {
        vm.agent.agents_id = [];
      }
      if (vm.agent.staff === null || vm.agent.staff === void 0) {
        vm.agent.staff = [];
      }
      RequestService.post('company.put', vm.agent).then(function(result) {
        return $uibModalInstance.close(result);
      });
      return false;
    };
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.address = '';
    addAddress = function() {
      if (vm.agent.data.addresses === null || vm.agent.data.addresses === void 0) {
        vm.agent.data.addresses = [];
      } else {
        if (vm.agent.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.data.addresses.push(vm.address);
      vm.address = '';
    };
    deleteAddress = function(index) {
      vm.agent.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.agent.data.emails === null || vm.agent.data.emails === void 0) {
        vm.agent.data.emails = [];
      } else {
        if (vm.agent.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.data.emails.push(vm.email);
      vm.email = '';
    };
    deleteEmail = function(index) {
      vm.agent.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.agent.data.websites === null || vm.agent.data.websites === void 0) {
        vm.agent.data.websites = [];
      } else {
        if (vm.agent.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.data.websites.push(vm.website);
      vm.website = '';
    };
    deleteWebsite = function(index) {
      vm.agent.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.agent.data.phones === null || vm.agent.data.phones === void 0) {
        vm.agent.data.phones = [];
      } else {
        if (vm.agent.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      vm.agent.data.phones.push(vm.phone);
      vm.phone = '';
    };
    deletePhone = function(index) {
      vm.agent.data.phones.splice(index, 1);
    };
    vm.addStaff = addStaff;
    vm.deleteStaff = deleteStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.createAgent = createAgent;
    vm.getBranches = getBranches;
    getUsers();
    getBranches();
  });

}).call(this);

(function() {
  angular.module('stock').service('BObjectService', function($rootScope, RequestService, $cacheFactory, $q) {
    var bObject, dictionaryCache;
    bObject = {};
    dictionaryCache = $cacheFactory('dictionaries');
    bObject.list = function(type, filter, nocache) {
      var data, defer;
      if (angular.isUndefined(filter)) {
        filter = {};
      }
      filter.type = type;
      defer = $q.defer();
      data = null;
      if (angular.isUndefined(nocache) || nocache === false) {
        data = dictionaryCache.get(type + JSON.stringify(filter));
      }
      if (data) {
        defer.resolve(data);
      } else {
        RequestService.post('dictionary/listing', filter).then(function(data) {
          dictionaryCache.put(type + JSON.stringify(filter), data);
          return defer.resolve(data);
        }, function(data) {
          return defer.reject(data);
        });
      }
      return defer.promise;
    };
    bObject.clear = function() {
      return dictionaryCache.removeAll();
    };
    return bObject;
  }).service('RequestService', function($http, $rootScope, $q) {
    return {
      post: function(methodName, data, silent, timeOutSec) {
        var result, timedOut, timedOutFunc, timeout;
        timeOutSec = timeOutSec || 60;
        timeout = $q.defer();
        result = $q.defer();
        timedOut = false;
        timedOutFunc = function() {
          timedOut = true;
          timeout.resolve();
        };
        setTimeout(timedOutFunc, 100000 * timeOutSec);
        if (silent) {
          silent;
        }
        data = data || {};
        $rootScope.httPromise = $http({
          method: 'post',
          url: $rootScope.api + methodName,
          data: data,
          cache: false,
          timeout: timeout.promise
        }).success(function(data, status, headers, config) {
          if (!silent) {
            !silent;
          }
          if (data.result === 0) {
            return result.resolve(data);
          } else {
            return result.reject(data);
          }
        }).error(function(data, status, headers, config) {
          if (timedOut) {
            if (!silent) {
              !silent;
            }
            result.reject({
              error: 'timeout',
              message: 'Request took longer than ' + timeOutSec + ' seconds.'
            });
          } else {

          }
          if (!silent) {
            !silent;
          }
          return result.reject(data);
        });
        return result.promise;
      }
    };
  }).service('browser', function($window) {
    var userAgent;
    userAgent = $window.navigator.userAgent;
    return function() {
      return userAgent;
    };
  }).service('Session', function($localStorage) {
    return {
      create: function(token, user, user_company) {
        $localStorage.token = token;
        $localStorage.user = user;
        $localStorage.user_company = user_company;
      },
      setUser: function(user) {
        $localStorage.user = user;
      },
      destroy: function() {
        delete $localStorage.token;
        delete $localStorage.user;
        delete $localStorage.user_company;
      },
      getToken: function() {
        return $localStorage.token;
      },
      getUser: function() {
        return $localStorage.user;
      },
      getCompany: function() {
        return $localStorage.user_company;
      }
    };
  }).service('AppToast', function(toastr) {
    return {
      pop: function(type, message) {
        toastr.clear();
        if (toastr.hasOwnProperty(type)) {
          toastr[type](message);
        }
      }
    };
  }).service('AppStorage', function($window) {
    return {
      set: function(key, value) {
        $window.localStorage[key] = value;
      },
      get: function(key) {
        return $window.localStorage[key] || null;
      },
      setObject: function(key, value) {
        $window.localStorage[key] = JSON.stringify(value);
      },
      getObject: function(key) {
        return JSON.parse($window.localStorage[key] || null);
      },
      remove: function(key) {
        var err;
        try {
          $window.localStorage.removeItem(key);
        } catch (error) {
          err = error;
        }
      },
      clear: function() {
        var err;
        try {
          $window.localStorage.clear();
        } catch (error) {
          err = error;
        }
      }
    };
  }).service('passData', function() {
    var getData, passData, setData;
    passData = {};
    setData = function(key, data) {
      return passData[key] = data;
    };
    getData = function(key) {
      return passData[key];
    };
    return {
      setData: setData,
      getData: getData
    };
  }).service('ReportService', function($http, RequestService) {
    var service;
    service = {};
    service.printReport = function(code, params) {
      RequestService.post('reporta.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            report.print();
          });
        }
      });
    };
    service.saveReportPdf = function(code, params) {
      RequestService.post('reporta.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            var fileName, settings, stream;
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            settings = new Stimulsoft.Report.Export.StiPdfExportSettings;
            service = new Stimulsoft.Report.Export.StiPdfExportService;
            stream = new Stimulsoft.System.IO.MemoryStream();
            service.exportTo(report, stream, settings);
            data = stream.toArray();
            fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
            Object.saveAs(data, fileName + '.pdf', 'application/pdf');
          });
        }
      });
    };
    service.saveReportExcel = function(code, params) {
      RequestService.post('report.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            var fileName, settings, stream;
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            settings = new Stimulsoft.Report.Export.StiExcelExportSettings();
            service = new Stimulsoft.Report.Export.StiExcel2007ExportService();
            stream = new Stimulsoft.System.IO.MemoryStream();
            service.exportTo(report, stream, settings);
            data = stream.toArray();
            fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
            Object.saveAs(data, fileName + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          });
        }
      });
    };
    return service;
  }).factory('authInterceptor', function($rootScope, $q, $location, $log, Session, EVENTS, $base64) {
    return {
      request: function(config) {
        config.headers = config.headers || {};
        if (Session.getToken()) {
          config.headers.Authorization = 'Basic ' + $base64.encode('web' + ':' + Session.getToken());
        }
        $rootScope.$broadcast(EVENTS.requestStart);
        return config;
      },
      requestError: function(rejection) {
        $rootScope.$broadcast(EVENTS.connectionError);
        return $q.reject(rejection);
      },
      responseError: function(rejection) {
        $rootScope.$broadcast(EVENTS.connectionError);
        return $q.reject(rejection);
      },
      response: function(response) {
        $rootScope.$broadcast(EVENTS.requestEnd);
        if (response.data.result === 107) {
          $rootScope.$broadcast(EVENTS.notAuthenticated);
        }
        if (response.data.result > 0) {
          $rootScope.$broadcast(EVENTS.businessError, response.data.message);
        }
        if (response.data.result < 0) {
          $rootScope.$broadcast(EVENTS.applicationError, response.data.message);
        }
        return response || $q.when(response);
      }
    };
  });

}).call(this);

(function() {
  angular.module('stock').run(function($log, $rootScope, amMoment) {
    'ngInject';
    $log.debug('runBlock end');
    $rootScope.api = 'https://kamkor.agi.kg/';
    amMoment.changeLocale('ru');
  });

}).call(this);

(function() {
  angular.module('stock').config(function($stateProvider, $urlRouterProvider) {
    'ngInject';
    var args, c, i, j, len, path, r, template, url;
    $stateProvider.state('app', {
      abstract: true,
      url: '/app',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'app'
    }).state('login', {
      url: '/login',
      templateUrl: 'app/auth/login.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('assistance-login', {
      url: '/a-login',
      templateUrl: 'app/assistance-auth/assistance-login.html',
      controller: 'AssistanceAuthController',
      controllerAs: 'auth2'
    }).state('register', {
      url: '/register',
      templateUrl: 'app/auth/register.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('checkPolicy', {
      url: '/checkPolicy',
      templateUrl: 'app/auth/checkPolicy.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('info', {
      url: '/info?id',
      templateUrl: 'app/auth/info.html',
      controller: 'AuthInfoController',
      controllerAs: 'info'
    }).state('recover', {
      url: '/recover',
      templateUrl: 'app/auth/recover.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('app.policy_new', {
      url: '/policy/new',
      templateUrl: 'app/policy/new.html',
      controller: 'PolicyNewController',
      controllerAs: 'policies'
    }).state('app.policy_show', {
      url: '/policy/show',
      templateUrl: 'app/policy/show.html',
      controller: 'PolicyShowController',
      controllerAs: 'show',
      params: {
        product: null
      }
    }).state('app.policy_form', {
      url: '/policy/form',
      templateUrl: 'app/policy/form.html',
      controller: 'PolicyFormController',
      controllerAs: 'forming',
      params: {
        policy: null
      }
    }).state('app.policy_select', {
      url: '/policy/select',
      templateUrl: 'app/policy/select.html',
      controller: 'PolicySelectController',
      controllerAs: 'select',
      params: {
        product: null
      }
    }).state('app.policy_issue', {
      url: '/policy/issue',
      templateUrl: 'app/policy/issue.html',
      controller: 'PolicyIssueController',
      controllerAs: 'issue',
      params: {
        product: null,
        policy: null
      }
    }).state('app.policy_view', {
      url: '/policy/view',
      templateUrl: 'app/policy/view.html',
      controller: 'PolicyViewController',
      controllerAs: 'view',
      params: {
        product: null,
        policy: null
      }
    }).state('app.productm', {
      abstract: false,
      url: '/productm',
      templateUrl: 'app/productm/product.html',
      controller: 'ProductmController',
      controllerAs: 'productm'
    }).state('app.productm_new', {
      url: '/productm/new',
      templateUrl: 'app/productm/new.html',
      controller: 'ProductmNewController',
      controllerAs: 'new_productm',
      params: {
        product: null
      }
    }).state('app.product', {
      abstract: false,
      url: '/product',
      templateUrl: 'app/product/product.html',
      controller: 'ProductController',
      controllerAs: 'product'
    }).state('app.product_new', {
      url: '/product/new',
      templateUrl: 'app/product/new.html',
      controller: 'ProductNewController',
      controllerAs: 'new_product',
      params: {
        product: null
      }
    }).state('app.product_main', {
      url: '/main',
      parent: 'app.product_new',
      templateUrl: 'app/product/main.html',
      controller: 'ProductMainController',
      controllerAs: 'main',
      params: {
        product: null
      }
    }).state('app.product_service', {
      url: '/service',
      parent: 'app.product_new',
      templateUrl: 'app/product/service.html',
      controller: 'ProductServiceController',
      controllerAs: 'service'
    }).state('app.product_base', {
      url: '/base',
      parent: 'app.product_new',
      templateUrl: 'app/product/base.html',
      controller: 'ProductBaseController',
      controllerAs: 'base'
    }).state('app.product_additionally', {
      url: '/additionally',
      parent: 'app.product_new',
      templateUrl: 'app/product/additionally.html',
      controller: 'ProductAdditionallyController',
      controllerAs: 'additionally'
    }).state('app.product_view', {
      url: '/product/view',
      templateUrl: 'app/product/view.html',
      controller: 'ProductViewController',
      controllerAs: 'view_product',
      params: {
        product: null
      }
    }).state('app.report_viewer', {
      url: '/report_viewer',
      templateUrl: 'app/report/reporta.html',
      controller: 'ReportaController',
      controllerAs: 'reporta',
      params: {
        reportMode: 'viewer'
      }
    }).state('app.report_designer', {
      url: '/report_designer',
      templateUrl: 'app/report/reporta.html',
      controller: 'ReportaController',
      controllerAs: 'reporta',
      params: {
        reportMode: 'designer'
      }
    }).state('app.policya.main-limited', {
      url: '/policya-main-limited',
      templateUrl: 'app/policya/main-limited.html',
      controller: 'PolicyaMainController',
      controllerAs: 'main'
    });
    i = [
      {
        'n': 'app.dashboard'
      }, {
        'n': 'app.prod',
        'a': true,
        'e': true
      }, {
        'n': 'app.prod.entry',
        'u': '.entry/{id}'
      }, {
        'n': 'app.prod.list'
      }, {
        'n': 'app.prod.import'
      }, {
        'n': 'app.prod.stock'
      }, {
        'n': 'app.op',
        'a': true,
        'e': true
      }, {
        'n': 'app.op.sale'
      }, {
        'n': 'app.op.buy'
      }, {
        'n': 'app.op.hist'
      }, {
        'n': 'app.company'
      }, {
        'n': 'app.agentbranch'
      }, {
        'n': 'app.policy'
      }, {
        'n': 'app.apolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.apolicy.list'
      }, {
        'n': 'app.apolicy.new'
      }, {
        'n': 'app.apolicy.select'
      }, {
        'n': 'app.apolicy.form'
      }, {
        'n': 'app.apolicy.issue',
        p: {
          product: null
        }
      }, {
        'n': 'app.apolicy.show'
      }, {
        'n': 'app.apolicy.view',
        p: {
          product: null
        }
      }, {
        'n': 'app.policya',
        'a': true,
        'e': true
      }, {
        'n': 'app.policya.new'
      }, {
        'n': 'app.policya.main'
      }, {
        'n': 'app.policya.expense'
      }, {
        'n': 'app.patient',
        'a': true,
        'e': true
      }, {
        'n': 'app.patient.main'
      }, {
        'n': 'app.patient.edit'
      }, {
        'n': 'app.medexpense',
        'a': true,
        'e': true
      }, {
        'n': 'app.medexpense.main'
      }, {
        'n': 'app.expensesa'
      }, {
        'n': 'app.insurantsa'
      }, {
        'n': 'app.clients'
      }, {
        'n': 'app.agent'
      }, {
        'n': 'app.agent.accesses',
        'u': '.accesses/{id}'
      }, {
        'n': 'app.menu'
      }, {
        'n': 'app.menu.item',
        'u': '.item/{id}'
      }, {
        'n': 'app.udf',
        'u': '.udf/{is_admin:bool}'
      }, {
        'n': 'app.role'
      }, {
        'n': 'app.currency'
      }, {
        'n': 'app.category'
      }, {
        'n': 'app.industry'
      }, {
        'n': 'app.unit'
      }, {
        'n': 'app.purpose'
      }, {
        'n': 'app.rule'
      }, {
        'n': 'app.docs',
        'a': true,
        e: true
      }, {
        'n': 'app.docs.list'
      }, {
        'n': 'app.docs.entry',
        u: '.entry/{id}'
      }, {
        'n': 'app.docs.view',
        u: '.view/{id}'
      }, {
        'n': 'app.defaults'
      }, {
        'n': 'app.dictionary'
      }, {
        'n': 'app.dictionarya'
      }, {
        'n': 'app.profile',
        'a': true
      }, {
        'n': 'app.profile.view'
      }, {
        'n': 'app.profile.edit'
      }, {
        'n': 'app.approval.view',
        u: '.view/{id}'
      }, {
        'n': 'app.payment'
      }, {
        'n': 'app.operation'
      }, {
        'n': 'app.users'
      }, {
        'n': 'app.report'
      }, {
        'n': 'app.reportperiod'
      }, {
        'n': 'app.reporttehnika'
      }, {
        'n': 'app.report_template'
      }, {
        'n': 'app.news',
        'a': true,
        'e': true
      }, {
        'n': 'app.news.list'
      }, {
        'n': 'app.news.form'
      }, {
        'n': 'app.news.uploadimage'
      }, {
        'n': 'app.doctemplates',
        'a': true,
        'e': true
      }, {
        'n': 'app.doctemplates.list'
      }, {
        'n': 'app.doctemplates.add'
      }, {
        'n': 'app.equipment',
        'a': true,
        e: true
      }, {
        'n': 'app.equipment.list'
      }, {
        'n': 'app.equipment.create'
      }, {
        'n': 'app.equipment.show',
        u: '.show/{id}'
      }, {
        'n': 'app.employee'
      }, {
        'n': 'app.branch'
      }, {
        'n': 'app.agentemployee'
      }, {
        'n': 'app.tehnika',
        'a': true,
        e: true
      }, {
        'n': 'app.tehnika.list'
      }, {
        'n': 'app.tehnika.prev'
      }, {
        'n': 'app.tehnika.create'
      }, {
        'n': 'app.tehnika.show',
        u: '.show/{id}'
      }, {
        'n': 'app.companyusers'
      }, {
        'n': 'app.trip',
        'a': true,
        e: true
      }, {
        'n': 'app.trip.list'
      }
    ];
    for (j = 0, len = i.length; j < len; j++) {
      r = i[j];
      url = r.n.substring(r.n.lastIndexOf('.') + 1);
      path = r.n.split('.');
      template = [path[0], path[1], (path.length > 2 ? path[2] : path[1]) + '.html'].join('/');
      path[1] = path[1].toUpperCase().charAt(0) + path[1].substring(1);
      if (path.length > 2) {
        path[2] = path[2].toUpperCase().charAt(0) + path[2].substring(1);
      }
      c = path.length > 2 ? path[1] + path[2] : path[1];
      args = {
        url: '.' + url,
        controller: c + 'Controller',
        controllerAs: url,
        abstract: angular.isDefined(r.a && r.a)
      };
      if (angular.isDefined(r.u)) {
        args.url = r.u;
      }
      if (angular.isDefined(r.p)) {
        args.params = r.p;
      }
      if (angular.isDefined(r.t)) {
        args.template = r.t;
      } else if (r.e) {
        args.template = '<ui-view></ui-view>';
      } else {
        args.templateUrl = template;
      }
      console.log('Generated ' + r.n + ' as ' + angular.toJson(args));
      $stateProvider.state(r.n, args);
    }
    return $urlRouterProvider.otherwise('/login');
  });

}).call(this);

(function() {
  angular.module('stock').constant('malarkey', malarkey).constant('moment', moment).constant('EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
    connectionError: 'http-connection-error',
    businessError: 'business-error',
    applicationError: 'application-error',
    requestStart: 'http-request-start',
    requestEnd: 'http-request-end',
    successMessage: 'business-success',
    errorMessage: 'business-error'
  }).constant('email_mask', /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i).constant('user_company_accesses', [
    {
      key: 'company',
      value: 'Компания'
    }, {
      key: 'branch',
      value: 'Филиал'
    }
  ]).constant('branch_types', [
    {
      key: 'store',
      value: 'Магазин'
    }, {
      key: 'cost_center',
      value: 'Центр затрат'
    }, {
      key: 'stock',
      value: 'Склад'
    }
  ]).constant('product_types', [
    {
      key: 'raw',
      value: 'Сырье'
    }, {
      key: 'goods',
      value: 'Товар'
    }, {
      key: 'inventory',
      value: 'Инвентарий'
    }, {
      key: 'work',
      value: 'Работа'
    }, {
      key: 'service',
      value: 'Услуга'
    }
  ]).constant('contractor_types', [
    {
      key: 'supplier',
      value: 'Поставщик'
    }, {
      key: 'buyer',
      value: 'Покупатель'
    }, {
      key: 'employee',
      value: 'Сотрудник'
    }
  ]).constant('operation_types', [
    {
      key: 'purchase',
      value: 'Покупка'
    }, {
      key: 'sales',
      value: 'Продажа'
    }, {
      key: 'movement',
      value: 'Перевод'
    }, {
      key: 'consumption',
      value: 'Потребление'
    }, {
      key: 'return',
      value: 'Возврат'
    }
  ]).constant('operation_statuses', [
    {
      key: 'new',
      value: 'Новый'
    }, {
      key: 'active',
      value: 'Активый'
    }, {
      key: 'closed',
      value: 'Закрыт'
    }, {
      key: 'canceled',
      value: 'Отменен'
    }
  ]).constant('booking_statuses', [
    {
      key: 'new',
      value: 'Новый'
    }, {
      key: 'active',
      value: 'Активый'
    }, {
      key: 'closed',
      value: 'Закрыт'
    }, {
      key: 'canceled',
      value: 'Отменен'
    }
  ]).constant('booking_types', [
    {
      key: 'order',
      value: 'Заказ на покупку'
    }, {
      key: 'quote',
      value: 'Заказ на продажу'
    }
  ]).constant('document_statuses', [
    {
      key: 'draft',
      value: 'Черновик'
    }, {
      key: 'approval',
      value: 'На одобрении'
    }, {
      key: 'approved',
      value: 'Одобрен'
    }, {
      key: 'committed',
      value: 'Принят'
    }
  ]).constant('approve_types', [
    {
      key: 'all',
      value: 'Все'
    }, {
      key: 'one',
      value: 'Один'
    }
  ]).constant('udf_purposes', [
    {
      key: 'company',
      value: 'Компания'
    }, {
      key: 'operation',
      value: 'Операция'
    }, {
      key: 'contractor',
      value: 'Контрагент'
    }, {
      key: 'user',
      value: 'Пользователь'
    }, {
      key: 'branch',
      value: 'Филиал'
    }, {
      key: 'approval',
      value: 'Одобрение'
    }, {
      key: 'booking',
      value: 'Заказ'
    }
  ]).constant('udf_fields', [
    {
      key: 'text',
      value: 'Текст'
    }, {
      key: 'textarea',
      value: 'Текстовое поле'
    }, {
      key: 'number',
      value: 'Число'
    }, {
      key: 'date',
      value: 'Дата'
    }, {
      key: 'time',
      value: 'Время'
    }, {
      key: 'checkbox',
      value: 'Флажок'
    }, {
      key: 'radio',
      value: 'Радио кнопка'
    }, {
      key: 'select',
      value: 'Раскрывающийся список'
    }, {
      key: 'multiSelect',
      value: 'Список со мн. выбором'
    }
  ]);

}).call(this);

(function() {
  angular.module('stock').config(function($logProvider, toastrConfig, hotkeysProvider, $httpProvider) {
    'ngInject';
    $logProvider.debugEnabled(true);
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    hotkeysProvider.cheatSheetHotkey = ["h", "р"];
    hotkeysProvider.cheatSheetDescription = "Информация о быстрых кнопках открыть/закрыть";
    return $httpProvider.interceptors.push('authInterceptor');
  });

}).call(this);

(function () {
    'use strict';

    angular.module('stock')
        .directive('sideNav', function () {
            return {
                restrict: 'AC',
                link: function (scope, el) {
                    var $BODY = $('body'),
                        $MENU_TOGGLE = $('#menu_toggle'),
                        $SIDEBAR_MENU = $('#sidebar-menu'),
                        $SIDEBAR_FOOTER = $('.sidebar-footer'),
                        $LEFT_COL = $('.left_col'),
                        $RIGHT_COL = $('.right_col'),
                        $NAV_MENU = $('.nav_menu'),
                        $FOOTER = $('footer');

                    var setContentHeight = function () {
                        // reset height
                        $RIGHT_COL.css('min-height', $(window).height());

                        var bodyHeight = $BODY.outerHeight(),
                            footerHeight = $BODY.hasClass('footer_fixed') ? 0 : $FOOTER.height(),
                            leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
                            contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

                        // normalize content
                        contentHeight -= $NAV_MENU.height() + footerHeight;

                        $RIGHT_COL.css('min-height', contentHeight);
                    };

                    var setCurrentPage = function (url) {
                        var CURRENT_URL = url || window.location.href.split('?')[0];

                        $SIDEBAR_MENU.find('li.current-page').removeClass('current-page');

                        $SIDEBAR_MENU.find('a').filter(function () {
                            return this.href == CURRENT_URL;
                        }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
                            setContentHeight();
                        }).parent().addClass('active');
                    };

                    function initSideMenu (class_name) {
                        $SIDEBAR_MENU.find('a' + class_name).on('click', function (ev) {
                            if (ev.target.href) {
                                setCurrentPage(ev.target.href);
                            } else {
                                var $li = $(this).parent();

                                if ($li.is('.active')) {
                                    $li.removeClass('active active-sm');
                                    $('ul:first', $li).slideUp(function () {
                                        setContentHeight();
                                    });
                                } else {
                                    // prevent closing menu if we are on child menu
                                    if (!$li.parent().is('.child_menu')) {
                                        $SIDEBAR_MENU.find('li').removeClass('active active-sm');
                                        $SIDEBAR_MENU.find('li ul').slideUp();
                                    }

                                    $li.addClass('active');

                                    $('ul:first', $li).slideDown(function () {
                                        setContentHeight();
                                    });
                                }
                            }
                        });
                    }

                    initSideMenu();

                    scope.$watch('app.navigation', function () {
                        initSideMenu('.dynamic_menu');
                    });

                    scope.$watch('app.admin_menu', function () {
                        initSideMenu('.admin_menu');
                    });

                    // toggle small or large menu
                    $MENU_TOGGLE.on('click', function () {
                        if ($BODY.hasClass('nav-md')) {
                            $SIDEBAR_MENU.find('li.active ul').hide();
                            $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
                        } else {
                            $SIDEBAR_MENU.find('li.active-sm ul').show();
                            $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
                        }

                        $BODY.toggleClass('nav-md nav-sm');

                        setContentHeight();
                    });

                    setCurrentPage();

                    // recompute content when resizing
                    $(window).smartresize(function () {
                        setContentHeight();
                    });

                    setContentHeight();

                    // fixed sidebar
                    if ($.fn.mCustomScrollbar) {
                        $('.menu_fixed').mCustomScrollbar({
                            autoHideScrollbar: true,
                            theme: 'minimal',
                            mouseWheel: {preventDefault: true}
                        });
                    }
                }
            };
        });
})();

/**
 * Created by jaynakus on 2/11/16.
 */
angular.module('stock')
    .directive('autofocus', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $element[0].focus();
            }
        }
    });

angular.module("stock").run(["$templateCache", function($templateCache) {$templateCache.put("app/agent/agent.html","<div class=content><div class=row><div class=col-md-12><panel title=Агенты><form ng-submit=agent.getAgents()><div class=row><col-responsive><div class=form-group><label>Агент:</label><input type=text ng-model=agent.filter.name placeholder=\"Введите имя агента\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"agent.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button ng-click=agent.newAgent() class=\"btn btn-primary btn-sm\">Добавить агента</button> <button ng-click=agent.editAgent() ng-disabled=\"agent.selected_agent==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Редактировать</span></button> <button ng-click=agent.confirmAction() ng-disabled=\"agent.selected_agent == null\" class=\"btn btn-danger btn-sm\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button><div class=margin></div><paged-table options=agent.employeesGridOptions disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/agent/create.html","<!--\nCreated by Aibek on 25/08/16.\n\n--><form ng-submit=agent.createAgent() class=from-horizontal><div class=modal-header><h3>Новый агент</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><li><a data-toggle=tab data-target=#menu2>Контакты</a></li><li><a data-toggle=tab data-target=#menu3>Пользователи</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Официальное имя</label><input type=text ng-model=agent.agent.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Краткое имя</label><input type=text ng-model=agent.agent.short_name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Код Агента</label><input type=text ng-model=agent.agent.code ng-trim=true maxlength=2 class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Менеджер</label><input type=text ng-model=agent.agent.data.manager ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Логотип</label><input type=text ng-model=agent.agent.data.logo ng-trim=true class=form-control></div></div><div stock-dict=agent.tmp_industries dict-table=Industries class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отрасль</label><ui-select ng-model=agent.agent.data.industry ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет типа страхования</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in agent.tmp_industries track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div><div stock-dict=agent.tmp_statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;} class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Статус</label><ui-select ng-model=agent.agent.company_status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in agent.tmp_statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>не показывать страх. премию</label><input type=checkbox ng-model=agent.agent.data.insurance_check></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Описание</label><textarea ng-model=agent.agent.data.description rows=3 ng-trim=true class=form-control></textarea></div></div></div></div><div id=menu2 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=agent.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agent.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agent.agent.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=agent.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=text ng-model=agent.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agent.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agent.agent.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=agent.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=agent.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agent.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agent.agent.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=agent.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=text ng-model=agent.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agent.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agent.agent.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=agent.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div></div><div id=menu3 class=\"tab-pane fade\"><div class=row><div class=row><!--.col.col-xs-12.col-sm-6.col-md-6(stock-dict=\'agent.users\' dict-table=\'User\')--><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ползователи</label><ui-select ng-model=agent.currStaff.user_id ng-required=true class=form-control><ui-select-match>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in agent.users\">{{type.username}}</ui-select-choices></ui-select></div></div><div stock-dict=agent.branches dict-table=Branches dict-filter={company_id:agent.agent._id} class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=agent.currStaff.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in agent.branchestype\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12\"><button type=button ng-click=agent.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></div></div><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in agent.agent.staff\"><td><span ng-repeat=\"user in agent.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in agent.branchestype | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=agent.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=agent.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentbranch/agentbranch.html","<div class=content><div class=row><div class=col-md-12><panel title=Филиалы><button type=button ng-click=agentbranch.newBranch() class=\"btn btn-primary btn-xs\">Создать</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!branch.selected_branch\' ng-click=\'branch.editBranch()\')--> <button ng-click=agentbranch.editBranch() ng-disabled=!agentbranch.selected_branch class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=agentbranch.confirmAction() ng-disabled=!agentbranch.selected_branch class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=agentbranch.getBranches() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=agentbranch.branchesGridOptions disable-search=true disable-paging=true></paged-table></panel></div></div></div>");
$templateCache.put("app/agentbranch/edit.html","<!--\nCreated by Aibek on 26/08/16.\n\n--><form ng-submit=agentBranch.confirmAction() class=form-row><div class=modal-header><h3>Филиал</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=agentBranch.agentBranch.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=agentBranch.agentBranch.data.name_short ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=agentBranch.agentBranch.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=agentBranch.branch_types dict-table=Enums dict-filter={name:&quot;branch_type&quot;}><div class=form-group><label>Тип</label><ui-select ng-model=agentBranch.agentBranch.branch_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in agentBranch.branch_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=agentBranch.owner_types dict-table=Enums dict-filter={name:&quot;owner_type&quot;}><div class=form-group><label>Вид владельца</label><ui-select ng-model=agentBranch.agentBranch.data.owner_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in agentBranch.owner_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=agentBranch.tmp_statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=agentBranch.agentBranch.branch_status class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in agentBranch.tmp_statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>E-mail</label><div class=input-group><input type=text ng-model=agentBranch.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agentBranch.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agentBranch.agentBranch.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=agentBranch.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></col-responsive><col-responsive><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=agentBranch.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agentBranch.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agentBranch.agentBranch.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=agentBranch.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><div class=input-group><input type=text ng-model=agentBranch.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agentBranch.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agentBranch.agentBranch.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=agentBranch.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=agentBranch.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=agentBranch.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in agentBranch.agentBranch.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=agentBranch.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></col-responsive><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=agentBranch.agentBranch.data.description rows=5 class=form-control></textarea></div></col-responsive><col-responsive stock-dict=agentBranch.tmp_agents dict-table=Agents><div class=form-group><label>Компания</label><ui-select ng-model=agentBranch.agentBranch.company_id ng-disabled=\"agentBranch.user.role != 10\" class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in agentBranch.companies\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive></div></div><div class=modal-body><button ng-disabled=\"agentbranch.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"agentbranch.saving===true\" type=button ng-click=agentBranch.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentemployee/agentemployee.html","<div class=content><div class=row><div class=col-md-12><panel title=Сотрудники><div class=margin></div><button type=button ng-click=agentemployee.newUser() class=\"btn btn-primary btn-xs\">Создать</button> <button ng-click=agentemployee.editUser() ng-disabled=!agentemployee.selected_user class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=agentemployee.removeUser() ng-disabled=!agentemployee.selected_user class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=agentemployee.getUsers() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=agentemployee.agentemployeeGridOptions disable-search=true disable-paging=true></paged-table></panel></div></div></div>");
$templateCache.put("app/agentemployee/create.html","<form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=user.user.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentemployee/edit.html","<form ng-submit=user.updateUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=user.user.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/apolicy/form.html","<!--\nCreated by troy on 24.11.2016.\n\n--><div class=container><!--pre {{forming.policy.insurance_data|json}}--><div class=row><div class=col-md-12><button type=button ui-sref=app.policy class=\"btn btn-warning\">Выход</button> <button type=button ng-click=forming.confirmActionSave() class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-floppy-o\"></i> Сохранить</button> <button type=button ng-click=forming.confirmActionForm() ng-disabled=\"!forming.policy.insurance_premium || forming.policy.insurance_premium &lt;= 0\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div><div class=row><div class=col-md-6><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Основные данные</h4></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><td>Номер полиса</td><td>{{forming.policy.policy_no}}</td></tr><tr><td>Продукт</td><td>{{forming.policy.product}}</td></tr><tr><td>Компания</td><!--td(ng-if=\"forming.policy.product && forming.policy.product.company\") {{forming.policy.product.company.name}}--><td ng-if=forming.policy.company>{{forming.policy.company}}</td></tr><tr><td>Страны</td><td><ui-select ng-model=forming.policy.insurance_data.country_id on-select=forming.reCompute() on-remove=forming.reCompute() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in forming.countries | filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></td></tr><tr><td>Начало</td><td><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=forming.reCompute() ng-model=forming.policy.insurance_data.date_start is-open=forming.isOpen1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.isOpen1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><td>Конец</td><td><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=forming.reCompute() ng-model=forming.policy.insurance_data.date_end is-open=forming.isOpen2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.isOpen2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr stock-dict=forming.currencies dict-table=Currencies><td>Сумма страховки</td><!--td {{forming.policy.insurance_amount}}--><!--  span--><!--    |   {{forming.currency_name}}--><td><div class=row><div stock-dict=forming.insurance_amounts dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=col-md-10><div class=form-group><label ng-repeat=\"IM in forming.insurance_amounts\" ng-if=forming.ifLessThanMin(IM) class=radio-inline><input type=radio ng-model=forming.policy.insurance_amount ng-value=IM.data.key name=IMradio ng-change=forming.reCompute()>{{IM.data.name}} {{forming.currency_name}}</label></div></div></div></td></tr><tr><td>Премия страховки</td><td>{{forming.policy.insurance_premium}} {{forming.currency_name}} / {{forming.policy.data.insurance_premium_kgs}} KGS</td></tr></tbody></table></div></div></div><div stock-dict=forming.services dict-table=Services class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Сервисы</h4></div><div class=panel-body><ul class=list-group><li ng-repeat=\"service_id in forming.policy.product.services_id\" class=list-group-item><span ng-repeat=\"service in forming.services | filter:{_id:service_id}\">{{service.name}}</span></li></ul></div></div></div></div></div><div class=col-md-6><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Данные клиента</h4></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><td>Имя</td><td><input type=text ng-model=forming.policy.client.name ng-required=true ng-trim=true class=form-control></td></tr><tr><td>Фамилия</td><td><input type=text ng-model=forming.policy.client.surname ng-required=true ng-trim=true class=form-control></td></tr><tr><td>Дата рождения</td><td><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=forming.reCompute() ng-model=forming.policy.client.date_of_birth is-open=forming.isOpen3 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.isOpen3 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><td>Номер паспорта</td><td><input type=text ng-model=forming.policy.client.passport_no ng-required=true ng-trim=true class=form-control></td></tr></tbody></table></div></div></div><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Факторы</h4></div><div class=panel-body><ul class=list-group><li ng-repeat=\"factor in forming.product.factorListing\" class=list-group-item><h5>{{factor.name}}</h5><div class=container><div class=form-group><ui-select ng-model=forming.policy.insurance_data.factors[factor.name] on-select=forming.reCompute(factor.name) ng-required=true ng-disabled=\"factor.name == \'Возраст\'\" class=form-control><ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices></ui-select></div></div></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/apolicy/issue.html","<!--\nCreated by ilias on 07.10.2016.\n\n--><div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=\"box-body pad table-responsive\"><form ng-submit=issue.confirmAction() class=from-horizontal><div class=row><div class=col-md-12><button type=button ui-sref=app.apolicy.select class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Изменить полис</button><div class=\"panel panel-default\"><div class=panel-heading><h2 style=display:inline>Ваш страховой полис</h2></div><!--.panel-body(stock-dict=\'issue.currencies\' dict-table=\'Currencies\')--><div class=panel-body><table class=\"table table-striped\"><thead></thead><tbody><tr><td>Страховщик</td><td>{{issue.product.company[0].name}}</td></tr><tr ng-if=\"issue.company.company_type == \'agent\'\"><td>Агент страховой компании</td><td>{{issue.company.name}} Телефон {{issue.company.data.phones[0]}}</td></tr><tr><td>Период действия страхового полиса</td><td>с {{issue.product.tmp_product.date_start | date:\'dd-MM-yyyy\'}} по {{issue.product.tmp_product.date_end | date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Продукт</td><td>{{issue.product.name}}</td></tr><tr><td>Страна поездки</td><td><span ng-repeat=\"x in issue.countriesView\">{{x.name}} <mark>({{x.data.name_eng}})</mark></span></td></tr><tr><td>Страховая сумма</td><td><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><label ng-if=\"issue.min_insurance!=null\">{{issue.product.insurance_amount}}<span> {{issue.currency_name}}</span></label><label ng-if=\"issue.min_insurance==null\">0</label><a data-toggle=collapse data-target=#collapse1 ng-click=issue.pdrobneeIconCnange() style=cursor:pointer class=pull-right><i ng-class=issue.pdrobneeIcon aria-hidden=true></i> Сервисы</a></h4></div><div id=collapse1 class=\"panel-collapse collapse\"><div class=panel-body><ul><li ng-repeat=\"service in issue.product.services | filter:{ insurance_sum: issue.product.insurance_amount }\">{{service.service_name}} - {{service.data.limit}}</li></ul></div></div></div></td></tr><tr ng-repeat=\"x in issue.insurants\"><td>Стоимость страхового полиса ({{$index+1}}-го)</td><td><h4 ng-if=\"x.theprice!=null\">{{x.theprice}} {{issue.currency_name}} / {{x.currency_value.toFixed(0)}} KGS</h4><span class=small>(курс валют: 1 {{issue.currency_name}}: {{(issue.currencyRate)}} KGS)</span><h4 ng-if=\"x.theprice==null\">0</h4></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h2>Путешественники (застрахованные)</h2></div><div class=panel-body><div ng-repeat=\"x in issue.insurants\" class=row><div class=col-md-4><div class=row><div class=col-md-6><div class=form-group><label>Фамилия<br><em>Латиницей</em></label><input type=text ng-model=x.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-6><div class=form-group><label>Имя<br><em>Латиницей</em></label><input type=text ng-model=x.name ng-required=true ng-trim=true class=form-control></div></div></div></div><div class=col-md-2><div class=form-group><label><br>Дата рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=issue.reCompute(x) max-date=issue.today min-date=issue.minDay uib-datepicker-popup=dd.MM.yyyy ng-model=x.date_of_birth is-open=x.isOpen close-text=Закрыть current-text=Сегодня clear-text=Очистить ng-required=true class=form-control><span class=input-group-btn><button type=button ng-click=\"x.isOpen = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-2><div class=form-group><label><br>Паспорт №</label><input type=text ng-model=x.passport_no ng-trim=true class=form-control></div></div><div stock-dict=issue.sports dict-table=Factors dict-filter={usage:&quot;sport&quot;} class=col-md-2><div class=form-group><label><br>Индивидуальные условия</label><ui-select ng-model=x.factor_sport on-select=issue.reCompute(x) ng-required=true class=form-control><ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in issue.sports[0].values | filter: $select.search | orderBy:&quot;type&quot;\">{{type}}</ui-select-choices></ui-select></div></div><div class=col-md-1><div class=form-group><label><br>Закрыть</label><div class=\"input-group no-margin\"><span class=input-group-btn><button style=\"margin-left: 20px\" ng-click=issue.deleteInsurant($index) type=button class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span></div></div></div></div><div class=row><div class=col-md-2><button type=button ng-click=issue.addInsurant() class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить путешественника</button></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h2>Покупатель (страхователь)</h2></div><div class=panel-body><div class=row><div class=col-md-2><div class=form-group><label>Фамилия<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-2><div class=form-group><label>Имя<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.name ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-3><div class=form-group><label><br>Телефон</label><input type=text ui-mask=0(999)999-999 ng-model=issue.buyer.phone ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-2><div class=form-group><button type=submit class=\"btn btn-primary\">Оформить полис</button></div></div></div></div></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/apolicy/list.html","<div class=content><div class=row><div class=col-md-12><panel title=Полисы><form ng-submit=list.getPolicies()><div class=row><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"list.company.company_type !=\'agent\'\"><div class=form-group><label>Агенты:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in list.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Имя застрахованного:</label><input type=text ng-model=list.filter.name placeholder=\" Введите имя\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Фамилия застрахованного:</label><input type=text ng-model=list.filter.surname placeholder=\"Введите фамилию\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button type=button ng-click=list.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!list.selected_policy\' ng-click=\'list.editBranch()\')--> <button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'list.delete()\' ng-disabled=\"!list.selected_policy\")--> <button ng-click=list.confirmAction() ng-disabled=\"!list.selected_policy || list.selected_list.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Полис с печатью</button> <button type=button ng-click=list.downloadPDF3() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Полис без печати</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=list.policiesGridOptions disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/apolicy/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/apolicy/select.html","<!--Created by troy on 07.10.2016.\n--><div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=box-body><div class=row><div class=\"col col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div ng-repeat=\"x in select.productsList | orderBy:\'data.order\'\" ng-if=\"x.theprice!=null\" class=\"panel panel-default\"><div class=panel-body><div class=\"row text-center\"><div class=\"col col-md-12 col-lg-12 col-xs-12\"><h4 class=text-center>{{x.name}}</h4></div></div><div class=\"row text-center\"><div class=\"col col-md-3 col-lg-3 col-xs-12\"><div style=\"width: 100%;height:100px;max-width: 180px;display: inline-block\"><img ng-src=/assets/images/small_logo.png style=max-width:100% class=media-object></div></div><div class=\"col col-md-3 col-lg-3 col-xs-12\"><a data-toggle=collapse data-target=#demo{{$index}} ng-click=select.changeIcon($index) class=\"btn btn-link\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i> Подробнее</a></div><div class=\"col col-md-3 col-lg-3 col-xs-12\"><h4><span style=\"background-color: #80e5ff; color:#000000\" class=badge>{{x.name == \'BUSINESS\' ? 5 : x.name == \'PREMIUM\' ? 10 : x.name == \'VIP\' ? 13 : 0}}</span> опций</h4></div><div class=\"col col-md-3 col-lg-3 col-xs-12\"><h3><span ng-if=\"x.theprice!=null\">{{x.theprice}} {{select.currency_name}}</span><span class=small> {{(x.theprice * (select.currencyRate1)).toFixed(0)}} KGS</span><span ng-if=\"x.theprice==null\">0</span></h3><button type=button ng-click=select.goToIssue(x) ng-disabled=\"x.theprice==null\" class=\"btn btn-info\">Оформить</button></div></div><div class=row><div class=\"col col-md-12 col-lg-12\"><div id=demo{{$index}} class=collapse><div class=row><div class=col-xs-3><!-- required for floating--><!-- Nav tabs--><ul class=\"nav nav-pills nav-stacked\"><li><a data-toggle=tab data-target=#menu1{{$index}}>Ассистанс</a></li><li ng-hide=true><a data-toggle=tab data-target=#menu3{{$index}}>Франшиза</a></li><li><a data-toggle=tab data-target=#menu4{{$index}}>Правила страхования</a></li><li><a data-toggle=tab data-target=#menu5{{$index}}>Объем покрытия</a></li></ul></div><div class=col-xs-9><!-- Tab panes--><div class=tab-content><div id=menu1{{$index}} class=tab-pane><p><a target=_blank href=https://savitar-gr.com/ >ООО «Савитар Групп»</a></p></div><div id=menu3{{$index}} class=tab-pane><p>{{x.company.data.franchise}}</p></div><div id=menu4{{$index}} class=tab-pane><p><a ng-href=assets/documents/new.pdf target=_blank>Правила страхования ВЗР от 12.04.2022г</a></p></div><div id=menu5{{$index}} class=tab-pane><p ng-repeat=\"service in x.services | filter:{ insurance_sum: select.insurance_amount }\">{{service.service_name}} - {{service.data.limit}}</p></div></div></div><div class=clearfix></div></div></div></div></div></div></div></div><!--    Right side bar--><div class=\"col col-xs-12 col-sm-12 col-md-5 col-lg-5\"><div class=row><div class=col-md-10><div class=form-group><label>Укажите страну поездки</label><ui-select ng-model=select.product.country_id on-remove=select.recalculateOnEventAll() on-select=select.recalculateOnEventAll() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in select.countries| filterCountries:$select.search | orderBy:&quot;name&quot; \">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Выберите тип полиса и укажите даты поездки</label></div></div></div><div class=row><div class=col-md-10><div class=form-group><div role=group class=btn-group><button type=button ng-click=select.changedRadio(1) ng-class=\"{\'active\':select.selectedtab === \'raw\'}\" class=\"btn btn-primary\">Однократный <button type=button ng-click=select.changedRadio(2) ng-class=\"{\'active\':select.selectedtab === \'summary\'}\" class=\"btn btn-primary\">Многократный</button></button></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.period.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-4><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=\"select.color.name == 2\" uib-datepicker-popup=dd.MM.yyyy min-date=select.period.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.period.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=\"select.color.name == 2\" ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-4><div class=form-group><label>Кол-во дней:</label><p>{{select.diffDays}}</p></div></div></div><div class=row><div stock-dict=select.insurance_amounts dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=col-md-10><div class=form-group><label>Страховая сумма: {{select.insurance_amount}}</label><br><label ng-repeat=\"IM in select.insurance_amounts | orderBy : select.sorterFunc\" ng-if=select.ifLessThanMin(IM) class=radio-inline><input type=radio ng-model=select.insurance_amount ng-value=IM.data.key name=IMradio ng-change=select.recalculateOnEvent()>{{IM.data.name}} {{select.currency_name}}</label></div></div></div><div class=row><div stock-dict=select.sports dict-table=Factors dict-filter={usage:&quot;sport&quot;} class=col-md-10><div class=form-group><label>Индивидуальные условия</label><ui-select ng-model=select.sport on-select=select.recalculateOnEvent() ng-required=true class=form-control><ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in select.sports[0].values | filter: $select.search | orderBy:&quot;type&quot;\">{{type}}</ui-select-choices></ui-select></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/apolicy/show.html","<!--Created by troy on 07.10.2016.\n--><div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'show.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount}} {{show.currency_name}}<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium}} {{show.policy.data.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in show.policy.insurance_data.country_id\"><span ng-repeat=\"country in show.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{show.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{show.policy.product}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{show.policy.client.surname}} {{show.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{show.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{show.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=show.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in show.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in show.product.services_id\" class=list-group-item><span ng-repeat=\"service in show.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"show.confirmActionTerm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\")--><!--  i.fa.fa-thumbs-o-down(aria-hidden=\'true\')--><!--  |   Расторгнуть--> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/apolicy/view.html","<!--\nCreated by ilias on 17.05.2017.\n\n--><!--Created by troy on 07.10.2016.\n--><div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{view.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{view.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{view.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'view.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{view.policy.insurance_amount}} {{view.currency_name}}<!--span( ng-repeat=\"country in view.countries| filter: {_id: view.currentCountryId}\" ng-if=\"view.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in view.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{view.policy.insurance_premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in view.countries| filter: {_id: view.currentCountryId}\" ng-if=\"view.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in view.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in view.policy.insurance_data.country_id\"><span ng-repeat=\"country in view.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{view.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{view.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{view.policy.client.surname}} {{view.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{view.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{view.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=view.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in view.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in view.product.services_id\" class=list-group-item><span ng-repeat=\"service in view.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ui-sref=app.apolicy.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\' || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/assistance-auth/assistance-login.html","<!--\nCreated by jaynakus on 5/26/16.\n\n--><div class=\"container body footer-fixed\"><div class=main_container><!-- page content--><div role=main class=right_col><div class=\"login desktop\"><div layout=row class=flex><div layout=column class=\"login-left flex\"><div class=stok-logo><img ng-src=/assets/images/assistance.png></div><div layout=column class=\"stok-description flex\"><form ng-submit=auth2.checkPolicy() class=login-left><h2>Здесь Вы можете проверить ваш страховой полис</h2><div><div class=row><div class=\"col-sm-12 col-xs-12 col-md-12\"><div class=form-group><input placeholder=\"Введите номер полиса\" ng-required=true ng-model=auth2.policyCredentials.policy_no class=form-control></div></div></div><div class=row><div class=\"col-sm-12 col-xs-12 col-md-12\"><div class=form-group><input placeholder=\"Введите ФИО\" ng-required=true ng-model=auth2.policyCredentials.fullname class=form-control></div></div></div><div class=row><div class=\"col-sm-12 col-xs-12 col-md-12\"><div class=form-group><select ng-model=auth2.policyCredentials.company_id ng-required=true ng-options=\"company.companyId as company.name for company in auth2.companies\" class=form-control></select></div></div></div><div class=row><div class=\"col-xs-4 col-sm-4 col-md-3\"><div class=form-group><button type=submit class=\"btn btn-login\">Проверить</button></div></div></div></div><div ng-show=\"auth2.policies.length == 0\"><h2>К сожалению, Полис с таким номером отсутствует в базе</h2></div><div class=table-responsive><table ng-show=\"auth2.policies.length &gt; 0\" class=\"table table-bordered\"><thead><tr><th>Номер полиса</th><th>ФИО клиента</th><th>Статус</th><th>Продукт</th><th>Начало</th><th>Конец</th><!--th Лимит--><th>Остаток</th></tr></thead><tbody><tr ng-repeat=\"policy in auth2.policies\"><td>{{policy.policy_no}}</td><td>{{policy.fullname}}</td><td ng-style=\"{\'background-color\': policy.status_color}\">{{policy.status}}</td><td>{{policy.product}}</td><td>{{policy.valid_from}}</td><td>{{policy.valid_to}}</td><!--td {{policy.amount}}--><td>{{policy.amount - policy.service_total_amount}}</td></tr></tbody></table></div></form></div><div class=stok-footer><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 text-center\">© 2016-2017 Miller & Weismann</div><div class=\"col-xs-12 col-sm-12 col-md-6 text-center\"><a href=http://erp.kg target=_blank>О компании</a></div></div></div></div><form layout=column ng-submit=auth2.login() class=\"login-right flex\"><h2>Авторизация</h2><div class=form-group><input placeholder=Пользователь ng-required=true ng-model=auth2.authCredentials.username class=form-control></div><div class=form-group><input type=password placeholder=Пароль ng-required=true ng-model=auth2.authCredentials.password class=form-control></div><div class=form-group><button type=submit class=\"btn btn-login\">Войти</button></div></form></div></div><div class=\"login mobile\"><div layout=column class=\"login-left flex\"><div class=stok-logo><img ng-src=/assets/images/assistance.png></div><div class=stok-description><form ng-submit=auth2.checkPolicy() class=login-left><h2>Здесь Вы можете проверить ваш страховой полис</h2><div><div class=row><div class=\"col-sm-12 col-xs-12 col-md-12\"><div class=form-group><input placeholder=\"Введите номер полиса\" ng-required=true ng-model=auth2.policyCredentials.policy_no class=form-control></div></div></div><div class=row><div class=\"col-sm-12 col-xs-12 col-md-12\"><div class=form-group><input placeholder=\"Введите ФИО\" ng-required=true ng-model=auth2.policyCredentials.fullname class=form-control></div></div></div><div class=row><div class=\"col-sm-12 col-xs-12 col-md-12\"><div class=form-group><select ng-model=auth2.policyCredentials.company_id ng-required=true ng-options=\"company.companyId as company.name for company in auth2.companies\" class=form-control></select></div></div></div><div class=row><div class=\"col-xs-4 col-sm-4 col-md-3\"><div class=form-group><button type=submit class=\"btn btn-login\">Проверить</button></div></div></div></div><div ng-show=\"auth2.policies.length == 0\"><h2>К сожалению, Полис с таким номером отсутствует в базе</h2></div><div class=table-responsive><table ng-show=\"auth2.policies.length &gt; 0\" class=\"table table-bordered\"><thead><tr><th>Номер полиса</th><th>ФИО клиента</th><th>Статус</th><th>Продукт</th><th>Начало</th><th>Конец</th><!--th Лимит--><th>Остаток</th></tr></thead><tbody><tr ng-repeat=\"policy in auth2.policies\"><td>{{policy.policy_no}}</td><td>{{policy.fullname}}</td><td ng-style=\"{\'background-color\': policy.status_color}\">{{policy.status}}</td><td>{{policy.product}}</td><td>{{policy.valid_from}}</td><td>{{policy.valid_to}}</td><!--td {{policy.amount}}--><td>{{policy.amount - policy.service_total_amount}}</td></tr></tbody></table></div></form><form ng-submit=auth2.login() class=login-right><h2>Авторизация</h2><div class=form-group><input placeholder=Пользователь ng-required=true ng-model=auth2.authCredentials.username class=form-control></div><div class=form-group><input type=password placeholder=Пароль ng-required=true ng-model=auth2.authCredentials.password class=form-control></div><div class=form-group><button type=submit class=\"btn btn-login\">Войти</button></div></form></div><div class=stok-footer><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 text-center\">© 2016-2017 Miller & Weismann</div><div class=\"col-xs-12 col-sm-12 col-md-6 text-center\"><a href=http://erp.kg target=_blank>О компании</a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/auth/checkPolicy.html","<div class=content><div class=row><div class=col-xs-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Здесь Вы можете проверить ваш страховой полис</h3></div><div class=box-body><form layout=column ng-submit=auth.checkPolicy()><div class=row><div class=\"col-xs-12 col-sm-8 col-md-6\"><div class=form-group><input placeholder=\"Введите номер Полиса\" ng-required=true ng-model=auth.policy_no class=form-control></div></div><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=form-group><button type=submit class=\"btn btn-login\">Проверить</button> <button ui-sref=login class=\"btn btn-primary\">Назад</button></div></div></div></form><div ng-show=auth.textError class=row><div class=col-xs-12><div><h2>К сожалению, Полис с таким номером отсутствует в базе</h2></div></div></div><div ng-show=auth.policyShow><table class=\"table table-hover\"><tbody><tr><th>Номер полиса</th><th ng-style=\"{\'background-color\':auth.color}\">Статус</th><th>ФИО клиента</th><th>Страна пребывания</th><th>Страховая сумма</th><th>Начало</th><th>Конец</th></tr><tr><td>{{auth.policy.policy_no}}</td><td ng-style=\"{\'background-color\':auth.color}\">{{auth.policy.data.status}}</td><td>{{auth.policy.client.surname}} {{auth.policy.client.name}}</td><td>{{auth.policy.data.country_name}}</td><td>{{auth.policy.insurance_amount}}</td><td>{{auth.policy.insurance_data.date_start | date:\'dd.MM.yyyy\'}}</td><td>{{auth.policy.insurance_data.date_end | date:\'dd.MM.yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/auth/info.html","<div class=content><div class=row><div class=col-xs-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Здесь Вы можете проверить ваш страховой полис</h3></div><div class=box-body><div class=row><form layout=column ng-submit=info.checkPolicy()><div class=row><div class=\"col-xs-12 col-sm-8 col-md-6\"><div class=form-group><input placeholder=\"Введите номер Полиса\" ng-required=true ng-model=info.policy_no class=form-control></div></div><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=form-group><button type=submit class=\"btn btn-login\">Проверить</button> <button ui-sref=login class=\"btn btn-primary\">Назад</button></div></div></div></form><div ng-show=info.textError class=row><div class=col-xs-12><div><h2>К сожалению, Полис с таким номером отсутствует в базе</h2></div></div></div><div ng-show=info.policyShow><table class=\"table table-hover\"><tbody><tr><th>Номер полиса</th><th ng-style=\"{\'background-color\':info.color}\">Статус</th><th>ФИО клиента</th><th>Страна пребывания</th><th>Страховая сумма</th><th>Начало</th><th>Конец</th></tr><tr><td>{{info.policy.policy_no}}</td><td ng-style=\"{\'background-color\':info.color}\">{{info.policy.data.status}}</td><td>{{info.policy.client.surname}} {{info.policy.client.name}}</td><td>{{info.policy.data.country_name}}</td><td>{{info.policy.insurance_amount}}</td><td>{{info.policy.insurance_data.date_start | date:\'dd.MM.yyyy\'}}</td><td>{{info.policy.insurance_data.date_end | date:\'dd.MM.yyyy\'}}</td></tr></tbody></table></div></div><div class=row><div class=col-md-8><p>Для получения срочной медицинской помощи или иных услуг по настоящему Полису, Вам или Вашему представителю необходимо обязательно установить контакт с круглосуточным КОНТАКТ-ЦЕНТРом «САВИТАР ГРУПП» по указанным в полисе телефонам и следовать инструкциям сотрудников данного центра.</p><br><p>КОНТАКТ-ЦЕНТР вправе рекомендовать Застрахованному (его представителю) самостоятельно и за свой счет обратиться за получением необходимой медицинской помощи, в том числе с привлечением местных служб скорой помощи, и (или) организацией иных услуг, предусмотренных Полисом.</p><br><p>При невозможности связаться с представителем Страховщика или КОНТАКТ-ЦЕНТРа, Застрахованный может самостоятельно обратиться в ближайшее медицинское учреждение. При этом застрахованное лицо (его представитель) до самостоятельного обращения в медицинское учреждение обязаны написать на WhatsApp/Telegram/Viber причины обращения. Невыполнение данного условия застрахованным лицом (его представителем) является основанием Страховщику в отказе в выплате страхового возмещения.</p><br><p>В случае если Застрахованный самостоятельно понес расходы, связанные со страховым случаем, он должен при возвращении из Поездки в течение 15 (пятнадцати) рабочих дней в письменной форме заявить Страховщику о случившемся и предоставить затребованные Страховщиком документы. Несвоевременное обращение застрахованного лица Страховщику (его представителя) служит основанием в отказе в выплате страхового возмещения.</p></div></div><div class=row><div class=col-md-12><table width=1256><tbody><tr><td width=671><h3><strong>СТРАХОВОЕ ПОКРЫТИЕ (покрывается <u>в пределах лимита Полиса</u>)</strong></h3></td><td width=586><h3><strong>INSURANCE COVERS ( <u>covered within Policy limit</u>)</strong></h3></td></tr><tr><td width=671><p>Амбулаторное или стационарное лечение неожиданных заболеваний (в том числе COVID-19) или травм;</p><p>Оказание экстренной стоматологической помощи (исключая лечение заболеваний пародонта, замену старых пломб, зубопротезирование, включая подготовку к нему, восстановление (реконструкцию) коронковой части зуба, имплантацию зубов, ортодонтию);</p><p>Лечение обострений хронических заболеваний</p><p>Эвакуацию с места происшествия в ближайшее медицинское учреждение или к врачу, а также транспортировку из одной клиники в другую;</p><p>Медицинскую и посмертную репатриацию.</p><p></p></td><td width=586><p>Outpatient or inpatient treatment for unexpected illness (including COVID-19) or injury;</p><p>Provision of emergency dental care (excluding treatment of periodontal diseases, replacement of old fillings, dental prosthetics, including preparation for it, restoration (reconstruction) of the crown part of the tooth, implantation of teeth, orthodontics);</p><p></p><p>Treatment of exacerbations of chronic diseases;</p><p>Evacuation from the scene to the nearest medical facility or doctor, as well as transportation from one clinic to another;</p><p></p><p>Medical and posthumous repatriation.</p></td></tr><tr><td width=671><p><strong>Потеря багажа</strong></p><p>Компания возместит непредвиденные расходы Застрахованного лица, в пределах предусмотренного лимита по договору, понесенных в результате полной гибели, полной или частичной потери багажа по вине перевозчика. Действие страховой защиты начинает действие после того, как вы сдали багаж перевозчику и получили багажные бирки. Данное условие касается и дня отъезда.</p><p>Лимит ответственности в зависимости от выбранной опции устанавливается от 300 до 1000 евро/долларов. В пределах установленных лимитов будет выплачена компенсация при страховом случае, но не более 50 евро/долларов за 1 кг багажа. Страховое покрытие уменьшаются на сумму компенсаций, полученных от третьих лиц (перевозчика).</p><p>При частичном повреждении багажа компенсируются затраты на ремонт, но не более предусмотренного лимита ответственности, за вычетом сумм возмещения, выплаченных Вам третьими лицами (перевозчиком).</p><p></p></td><td width=586><p><strong>Luggage loss</strong></p><p>The Company will reimburse the unforeseen expenses of the Insured person, within the stipulated limit under the contract, incurred as a result of total destruction, total or partial loss of luggage due to the fault of the carrier. The validity of the insurance cover begins after you have checked in your baggage to the carrier and received the baggage tags. This condition also applies to the departure day.</p><p>The liability limit, depending on the option chosen, is set from 300 to 1000 EUR/USD. Within the established limits, indemnity will be paid in case of an insurance case, but not more than 50 EUR/USD per 1 kg of baggage. Insurance coverage is reduced by the amount of compensation received from third parties (carrier).</p><p></p><p>In case of partial damage to baggage, the repair costs are compensated, but not more than the stipulated liability limit, minus the amounts of compensation paid to you by third parties (carrier).</p><h3><strong></strong></h3></td></tr><tr><td width=671><p><strong>Задержки</strong><strong> рейса;</strong></p><p>Компания возместит непредвиденные расходы Застрахованного лица, в пределах предусмотренного лимита по договору, на питание и на размещение в гостинице, в связи с наступлением следующих событий:</p><p>-       Задержка отправки и/или отмена регулярного авиарейса.</p><p>Под задержкой и/или отменой регулярного авиарейса понимается задержка рейса более чем на 4 (четыре) часа относительно времени вылета согласно расписанию или отмена рейса, в связи с которой Застрахованному лицу не было предложено альтернативное средство перевозки в течение 4 (четырех) часов с момента вылета согласно расписанию.</p><p>-       Непреднамеренный отказ в посадке на регулярный авиарейс.</p><p>Под непреднамеренным отказом в посадке на регулярный авиарейс понимается, что Застрахованное лицо зарегистрировалось или попыталось зарегистрироваться в течение объявленного времени регистрации, но ему было непреднамеренно отказано в посадке в результате переполненности рейса.</p><p>-       Пропущенная пересадка с одного регулярного рейса на другой.</p><p>Под пропущенной пересадкой (или стыковкой) регулярного авиарейса понимается, что Застрахованное лицо опоздало на следующий подтвержденный регулярный авиарейс в пункте пересадки в связи с поздним прибытием предыдущего (задержанного) регулярного авиарейса, и в течение 4 (четырех) часов после фактического времени прибытия предыдущего авиарейса, Застрахованному лицу не предоставлено альтернативное средство дальнейшей перевозки.</p><p></p></td><td width=586><p><strong>Flight</strong><strong> delay;</strong></p><p>The Company will indemnify the unforeseen expenses of the Insured person, within the limit stipulated by the contract, for food and hotel accommodation, in connection with the occurrence of the following events:</p><p>-       Departure delay and/or cancellation of a scheduled flight.</p><p>Delay and/or cancellation of a scheduled flight means a flight delay of more than 4 (four) hours relative to the scheduled departure time or flight cancellation due to which the Insured person was not offered an alternative means of transportation within 4 (four) hours from the moment of departure according to the timetable.</p><p></p><p>-       Unintentional denial of boarding on a scheduled flight.</p><p>Unintentional denial of boarding on a scheduled flight means that the Insured person checked in or attempted to check in during the announced check in time, but was unintentionally denied in boarding as a result of overcrowding on the flight.</p><p></p><p></p><p>-       Missed transfer from one scheduled flight to another.</p><p>The missed transfer (or connection) of a scheduled flight means that the Insured person was late for the next confirmed scheduled flight at the transfer point due to the late arrival of the previous (delayed) regular flight, and within 4 (four) hours after the actual arrival time of the previous flight, the insured person was not provided with an alternative means of further transportation.</p><p></p><h3><strong></strong></h3></td></tr><tr><td width=671><p><strong>Отмена</strong><strong> поездки</strong></p><p>Компания возместит непредвиденные расходы Застрахованного лица, в пределах предусмотренного лимита по договору, возникшие вследствие:</p><p>-       смерти Застрахованного лица или его Близкого родственника, возникшая до начала Застрахованной поездки вследствие Несчастного случая или Внезапного заболевания;</p><p>-       Внезапного заболевания Застрахованного лица, возникшее до начала Застрахованной поездки и препятствующее совершению предполагаемой поездки в связи с экстренной госпитализацией Застрахованного лица;</p><p>-       Травмы любой сложности, возникшие у Застрахованного лица в результате Несчастного случая не ранее чем за 21 (Двадцать один) день до начала Застрахованной поездки, но только в том случае если есть медицинские противопоказания для осуществления Застрахованной поездки, подтвержденные Врачом-экспертом Страховщика;</p><p>-       Инфекционного заболевание, в том числе коронавирусная инфекция (COVID-19), кроме ОРВИ и/или Гриппа, препятствующее совершению поездки, возникшее у Застрахованного лица не ранее чем за 15 (Пятнадцать) дней до начала Застрахованной поездки, что должно быть подтверждено результатами лабораторного теста;</p><p>-       неполучение визы (отказ в визе) при своевременной подаче всех необходимых документов на оформление в соответствии с требованиями консульства страны назначения;</p><p>-       получения Застрахованным лицом после заключения Договора страхования не ранее чем за 15 (Пятнадцать) дней до начала Застрахованной поездки повестки о явке в следственные органы или судебное заседание в рамках возбужденного уголовного производства или судебного разбирательства, в котором Застрахованное лицо участвует в качестве свидетеля или обязан принять участие в судебном заседании в качестве присяжного заседателя в период действия Договора страхования.</p><p>-       призыва Застрахованного лица на срочную военную службу или на военные сборы после заключения Договора страхования, но не ранее чем за 15 (Пятнадцать) дней до начала Застрахованной поездки.</p><p><strong></strong></p></td><td width=586><p><strong>Trip</strong><strong> сancellation</strong></p><p>The company will reimburse the unforeseen expenses of the Insured person, within the limit stipulated by the contract, arising as a result:</p><p>-       death of the Insured person or his сlose кelative, which occurred before the start of the Insured trip due to an Accident or Sudden illness;</p><p></p><p>-       Sudden illness of the Insured person that occurred prior to the start of the Insured trip and prevented the intended trip due to the emergency hospitalization of the Insured person;</p><p></p><p>-       Injuries of any complexity that occurred to the Insured person as a result of an Accident not earlier than 21 (twenty-one) days before the start of the Insured trip, but only if there are medical contraindications for the Insured trip, confirmed by the Insurer\'s medical expert;</p><p>-       Infectious disease, including coronavirus infection (COVID-19), except for ARI and/or Flu, preventing the trip, which the Insured person has experienced not earlier than 15 (fifteen) days before the start of the Insured trip, which must be confirmed by the results of a laboratory test;</p><p></p><p>-       non-receipt of a visa (denial of a visa) with the timely submission of all necessary documents for registration in accordance with the requirements of the consulate of the destination country;</p><p>-       receipt by the Insured Person after the conclusion of the Insurance Contract not earlier than 15 (Fifteen) days before the start of the Insured Trip of a subpoena to appear at the investigating authorities or a court session in the framework of initiated criminal proceedings or court proceedings in which the Insured Person participates as a witness or is obliged to accept participation in a court session as a juror during the validity period of the Insurance Contract.</p><p></p><p></p><p>-       conscription of the Insured Person to fixed-term military service or military training after the conclusion of the Insurance contract, but not earlier than 15 (fifteen) days before the start of the Insured trip.</p></td></tr><tr><td width=671><p><strong>Оказание</strong><strong> юридической помощи</strong></p><p>Компания возместит непредвиденные расходы Застрахованного лица, в пределах предусмотренного лимита по договору, понесенных в связи с получением юридической консультации, в случае если его преследуют в судебном порядке в соответствии с гражданским законодательством Страны временного пребывания в результате неумышленного причинения Застрахованным лицом ущерба третьей стороне, ненамеренного нарушения нормативных актов Страны временного пребывания или нарушения правил дорожного движения.</p><h3><strong></strong></h3></td><td width=586><p><strong>Provision</strong><strong> of legal assistance</strong></p><p>The company will reimburse the unforeseen expenses of the Insured person, within the stipulated limit under the contract, incurred in connection with obtaining legal advice, if he is prosecuted in accordance with the civil legislation of the Country of temporary residence as a result of unintentional damage caused by the Insured person to a third party, unintentional violation normative acts of the country of temporary residence or violation of traffic rules.</p><h3><strong></strong></h3></td></tr><tr><td width=671><p><strong>Оказание</strong><strong> помощи при потере документов</strong></p><p>Компания возместит непредвиденные расходы Застрахованного лица, в пределах предусмотренного лимита по договору, понесенных в связи с поиском и оформлением необходимых для передвижения и/или выезда из Страны временного пребывания утерянных документов (паспорта с визой, проездных транспортных документов).</p><h3><strong></strong></h3></td><td width=586><p><strong>Assistance</strong><strong> in case of loss of documents</strong></p><p>The Company will reimburse the unforeseen expenses of the Insured person, within the stipulated limit under the contract, incurred in connection with the search and execution of the lost documents necessary for movement and/or departure from the Country of temporary residence (passport with visa, travel transport documents).</p><h3><strong></strong></h3></td></tr><tr><td width=671><p><strong>Досрочного</strong><strong> возвращения застрахованного лица на место постоянного проживания</strong></p><p>Компания возместит непредвиденные расходы Застрахованного лица, в пределах предусмотренного лимита по договору, на приобретение/переоформление проездных билетов (экономического класса), а также подтвержденная организатором поездки и/или туристической компанией стоимость проживания в гостинице за неиспользованную часть срока Застрахованной поездки по договору о реализации туристских услуг, в связи с досрочным возвращением в Страну (Регион) постоянного проживания в случае:</p><p>-       внезапной или непредвиденной смерти его Близкого родственника или внезапной и непредвиденной госпитализации Близкого родственника Застрахованного лица в связи с Несчастным случаем или Внезапным заболеванием;</p><p>-       если правоохранительные органы требуют присутствия Застрахованного лица в Стране постоянного проживания в связи с кражей, затоплением, пожаром или порчей имущества Застрахованного лица на сумму превышающую эквивалент в кыргызских сомах 2 500 (Две тысячи пятьсот) долларов США.</p><p><strong></strong></p></td><td width=586><p><strong>Early</strong><strong> return of the insured person to the place of permanent residence</strong></p><p>The Company will reimburse the unforeseen expenses of the Insured person, within the stipulated limit under the contract, for the purchase/reissuance of travel tickets (economy class), as well as the cost of hotel accommodation confirmed by the trip organizer and/or travel company for the unused part of the term of the Insured trip under the contract for the sale of tourist services, in connection with the early return to the Country (Region) of permanent residence in the event:</p><p>-       sudden or unforeseen death of his Close Relative or sudden and unforeseen hospitalization of the Close Relative of the Insured person due to an Accident or Sudden Illness;</p><p></p><p></p><p>-       in case if law enforcement agencies require the presence of the Insured person in the Country of permanent residence in connection with theft, flooding, fire or damage to the property of the Insured person for an amount exceeding the equivalent in Kyrgyz soms of 2,500 (Two thousand five hundred) US dollars.</p></td></tr><tr><td width=671><p><strong>Возвращение</strong><strong> несовершеннолетних детей, оставшихся без присмотра.</strong></p><p>Компания возместит непредвиденные расходы, в пределах предусмотренного лимита по договору, по проезду в один конец экономическим классом несовершеннолетних детей, находящихся с Застрахованным лицом до Страны постоянного проживания в случае, если дети остались без присмотра в результате произошедшего с Застрахованным лицом:</p><p>-       Несчастного случая;</p><p>-       Внезапного заболевания;</p><p>-       Смерти Застрахованного лица.</p></td><td width=586><p><strong>Return</strong><strong> of minor children, who left unattended</strong></p><p>The Company will compensate for unforeseen expenses, within the stipulated limit under the contract, for one-way economy class travel of minor children who are with the Insured person to the Country of permanent residence if the children were left unattended as a result of what happened with the Insured person:</p><p>-       Accident;</p><p>-       Sudden illness;</p><p>-       Death of the Insured person.</p><h3><strong></strong></h3></td></tr></tbody></table></div></div><div class=row><div class=col-md-12><table width=1256><tbody><tr><td><h3><strong>ИСКЛЮЧЕНИЯ ИЗ СТРАХОВАНИЯ.</strong></h3><h3><strong>РАСХОДЫ, НЕ ВОЗМЕЩАЕМЫЕ СТРАХОВЩИКОМ</strong></h3><h3></h3></td><td><h3><strong>EXCEPTIONS TO INSURANCE.</strong></h3><h3><strong>COSTS NOT REIMBURSABLE BY THE INSURER</strong></h3><h3></h3></td></tr><tr><td><p><strong>По риску <u>«страхование медицинских и медико-транспортных расходов»</u> не являются страховыми случаями и не подлежат возмещению Страховщиком расходы:</strong></p></td><td><p><strong>For risk, \"insurance of medical and medical transportation expenses\" are not insured events and are not subject to reimbursement by the Insurer:</strong></p></td></tr><tr><td><p>·      в связи с обострением или осложнением заболеваний, известных Застрахованному лицу к моменту заключения Договора страхования, а также с Несчастными случаями, произошедшими с Застрахованным лицом до начала Застрахованной поездки. При обострении хронических заболеваний Страховщик возмещает только расходы на оказание неотложной медицинской помощи, необходимой для купирования острого состояния, а также расходы на посмертную репатриацию тела Застрахованного лица в случае его смерти. В любом случае расходы страховщика по неотложной медицинской помощи при обострении хронического заболевания не должны превышать 1 000 (одна тысяча) условных единиц – валюта полиса.</p></td><td><p>·    due to exacerbation or complication of diseases known to the Insured Person at the time of the Insurance Contract, as well as Accidents that occurred with the Insured Person before the Insured Trip. In the event of exacerbation of chronic diseases, the Insurer shall reimburse only the costs of providing emergency medical care necessary to relieve the acute condition, as well as the costs of posthumously repatriating the body of the Insured in the event of his death. In any case, the insurer\'s emergency medical expenses for exacerbation of a chronic disease should not exceed 1,000 (one thousand) conditional currency arrange in the policy.</p><h3></h3></td></tr><tr><td><p>·      возникшие в связи с обострением или осложнением таких заболеваний как туберкулез, саркоидоз, муковисцидоз, хроническая почечная и печеночная недостаточность, хронический гепатит, цирроз печени, сахарный диабет и другие эндокринные заболевания, системные заболевания соединительной ткани, болезнь Бехтерева, заболевания крови, герпес, кожных заболеваний (псориаза, нейродермита, экземы), микоз, паразитарные заболевания с момента постановки соответствующего диагноза;</p></td><td><p>·    due to exacerbation or complication of diseases such as tuberculosis, sarcoidosis, cystic fibrosis, chronic renal and liver failure, chronic hepatitis, cirrhosis of the liver, diabetes mellitus and other endocrine diseases, systemic connective tissue diseases, Bechterev\'s disease, blood diseases, herpes, skin diseases (psoriasis, neurodermatitis, eczema), mycosis, parasitic diseases from the moment of staging appropriate diagnosis;</p></td></tr><tr><td><p>·      понесенные в связи с ухудшением состояния здоровья или смертью Застрахованного лица при совершении Застрахованной поездки, несмотря на наличие прямых медицинских противопоказаний;</p></td><td><p>·    incurred in connection with the deterioration of the state of health or death of the Insured Person during the Insured trip, despite the presence of direct medical contraindications;</p></td></tr><tr><td><p>·      на оплату курса лечения, начатого до начала Срока страхования и продолжающегося в Застрахованной поездке, а также расходы на оплату лечения, которое может быть, с медицинской точки зрения, осуществлено после возвращения Застрахованного лица в Страну постоянного проживания;</p></td><td><p>·    to pay for the course of treatment started before the start of the Insurance Term and continuing on the Insured Trip, as well as the cost of payment for treatment, which may, from a medical point of view, be carried out after the Insured Person returns to the Country of Permanent Residence;</p></td></tr><tr><td><p>·      при возникновении, обострении или осложнении психических заболеваний, судорожных состояний, неврозов (панические атаки, депрессия, истерические синдромы, стресс), демиелинизирующих заболеваний нервной системы, а также расходы на купирование и лечение их осложнений и любых других последствий (травмы, заболевания или смерть), вызванных этими состояниями;</p></td><td><p>·    in the occurrence, exacerbation or complication of mental illness, convulsive conditions, neuroses (panic attacks, depression, hysterical syndromes, stress), demyelinating diseases of the nervous system, as well as the cost of stopping and treating their complications and any other consequences (injury, disease or death) caused by these conditions;</p></td></tr><tr><td><p>·      связанные с оказанием медицинской и медико-транспортной помощи при заболевании эпилепсией, а также расходы на лечение осложнений и любых других последствий (травмы, заболевания или смерть), вызванных этим состоянием, за исключением купирования эпилептического припадка;</p></td><td><p>·    related to the provision of medical and medical and transport assistance for epilepsy disease, as well as the cost of treating complications and any other consequences (injury, disease or death) caused by this condition, with the exception of relief of an epileptic seizure;</p></td></tr><tr><td><p>·      связанные с заболеваниями нервной системы (рассеянный склероз, нарушения речи и другое), опорно-двигательного аппарата, органов зрения и чувств нетравматического генеза, требующих сложного и/или реконструктивного оперативного лечения;</p></td><td><p>·    associated with diseases of the nervous system (multiple sclerosis, speech disorders, etc.), musculoskeletal system, organs of vision and feelings of non-traumatic genesis, requiring complex and/or reconstructive surgical treatment;</p></td></tr><tr><td><p>·      связанные с онкологическими заболеваниями, в том числе злокачественными и доброкачественными новообразованиями, в том числе гемобластозами, и их осложнениями, и последствиями, с момента установления диагноза. Расходы в отношение любой эвакуации и/или репатриации, связанные с последствиями онкологических заболеваний, не возмещаются;</p></td><td><p>·    associated with oncological diseases, including malignant and benign neoplasms, including hemoblastosis, and their complications, and consequences, from the moment of diagnosis. Expenses in relation to any evacuation and/or repatriation related to the consequences of cancer are not reimbursed;</p></td></tr><tr><td><p>·      возникшие вследствие обострения или осложнения заболеваний системы кровообращения, требующих кардиохирургического или нейрохирургического оперативного лечения (коронарография, ангиография, баллонная ангиопластика коронарных артерий, аортокоронарное шунтирование, установка коронарного стента, имплантация электрокардиостимулятора и другое);</p></td><td><p>·    diseases of the circulatory system resulting from exacerbation or complication requiring cardiac surgery or neurosurgical surgical treatment (coronary angiography, angiography, balloon angioplasty of the coronary arteries, coronary bypass surgery, installation of a coronary stent, implantation of an electrocardio stimulator, etc.);</p></td></tr><tr><td><p>·      связанные с оказанием медицинской и медико-транспортной помощи в связи с любыми проявлениями, осложнениями или обострениями системных заболеваний (согласно перечню, установленному МКБ-10), диагностированных у Застрахованного лица;</p></td><td><p>·    related to the provision of medical and medical and transport assistance in connection with any manifestations, complications or exacerbations of systemic diseases (according to the list established by ICD-10) diagnosed in the Insured Person;</p></td></tr><tr><td><p>·      возникшие вследствие обострения или осложнения наследственных и/или врожденных заболеваний, аномалий и пороков развития органов и их осложнений;</p></td><td><p>·    caused by exacerbation or complication of hereditary and/or congenital diseases, anomalies and malformations of organs and their complications;</p></td></tr><tr><td><p>·      при возникновении, обострении или осложнении заболеваний органов и тканей, требующие их трансплантации и/или протезирования;</p></td><td><p>·    in case of occurrence, exacerbation or complication of diseases of organs and tissues requiring their transplantation and/or prosthetics;</p></td></tr><tr><td><p>·      возникшие при умышленном причинении Застрахованным лицом себе Телесных повреждений, суицидальными попытками, самоубийстве или покушении на самоубийство и возникшими в связи с этим осложнениями в состоянии здоровья;</p></td><td><p>·    Personal Injuries, suicidal attempts, suicide or attempted suicide and related health complications caused by the Insured Person;</p></td></tr><tr><td><p>·      связанные с контрацепцией, стерилизацией (или обратной процедурой), лечением бесплодия, оплодотворением или другими формами искусственной репродукции, вазэктомией, изменением пола или другими состояниями полового характера;</p></td><td><p>·    related to contraception, sterilization (or reverse procedure), fertility treatment, fertilization or other forms of artificial reproduction, vasectomy, sex change or other sexual conditions;</p></td></tr><tr><td><p>·      возникшие вследствие:</p><p>–   консультаций, обследований, связанных с беременностью или лечением осложнений независимо от срока беременности, а также дородового наблюдения, родов (в том числе преждевременных или по проведению кесарева сечения);</p><p>–   проведения абортов, кроме случаев, когда операция выполнена с целью спасения жизни Застрахованного лица в результате внезапных осложнений протекания беременности, включая прерывание беременности при внематочной беременности или смерти плода, проведенное по медицинским показаниям или вследствие документально подтвержденного Несчастного случая.</p></td><td><p>·    Including costs associated the above conditions</p><p>–   consultations, examinations related to pregnancy or treatment of complications regardless   of the term of pregnancy, as well as antenatal supervision, childbirth (including premature or caesarean section);</p><p>–   performing abortions unless the operation is performed to save the life of the Insured Person as a result of sudden complications of pregnancy, including termination of pregnancy in ectopic pregnancy or fetal death, performed for medical reasons or as a result of a documented Accident.</p></td></tr><tr><td><p>·      В любом случае  Страховщик не несет никакой ответственности по отношению к новорожденному ребенку и все расходы, связанные с его лечением, нахождением под медицинским наблюдением и передвижением (включая эвакуацию и/или репатриацию) осуществляются за счет Застрахованного лица, кроме случаев, когда данное условие отдельно предусмотрено Договором страхования;</p></td><td><p>·    In any case, the Insurer will not be responsible in relation to the newborn child and all expenses related to its treatment, medical supervision and movement (including evacuation and/or repatriation) must be at the expense of the Insured Person, except where this condition is separately provided for by the Insurance Contract;</p></td></tr><tr><td><p>·      при венерических заболеваниях и заболеваниях, передающихся половым или преимущественно половым путем, а также заболеваниях, являющихся их следствием;</p></td><td><p>·    sexually transmitted and sexually transmitted diseases, as well as diseases resulting from them;</p></td></tr><tr><td><p>·      на диагностику и лечение ВИЧ-инфекции и заболеваний, являющихся ее следствием или осложнением, а также любых форм гепатита;</p></td><td><p>·    diagnosis and treatment of HIV infection and diseases resulting from it or complication, as well as any forms of hepatitis;</p></td></tr><tr><td><p>·      являющиеся следствием профессиональных заболеваний, вызванных вредным воздействием химических, физических производственных факторов, лазерного излучения, Внезапных заболеваний и Несчастных случаев, произошедших во время занятия профессиональной деятельностью или Опасной работой;</p></td><td><p>·    resulting from occupational diseases caused by harmful effects of chemical, physical production factors, laser radiation, Sudden diseases and Accidents that occurred during the occupation of professional activities or Hazardous work, unless otherwise provided by the Contract,</p></td></tr><tr><td><p>·      связанные с лечением травм, заболеваний, вызванных прямым или косвенным воздействием излучения любого рода, в том числе солнечного воздействия (воздействия ультрафиолетового излучения, приведшего к ожогам, фотодерматитам и иным подобным повреждениям кожного покрова и др.), за исключением случаев угрозы жизни Застрахованного лица;</p></td><td><p>·    related to the treatment of injuries, diseases caused by direct or indirect exposure to radiation of any kind, including solar exposure (exposure to ultraviolet radiation, leading to burns, photodermatitis and other similar damage to the skin, etc.), except in cases of threat to the life of the Insured Person;</p></td></tr><tr><td><p>·      при любой эвакуации и/или репатриации, не организованной Страховщиком или Сервисной компанией, а также расходы, возникшие в результате добровольного отказа Застрахованного лица от эвакуации в Страну или Регион постоянного проживания;</p></td><td><p>·    any evacuation and/or repatriation not arranged by the Insurer or the Service Company, and any costs resulting from the Insured\'s voluntary refusal to evacuate to the Country or Region of Permanent Residence;</p></td></tr><tr><td><p>·      понесенные в том случае, если поездка была предпринята Застрахованным лицом с намерением получить лечение или связанные с обращением в Медицинское учреждение с умыслом болезни, включая расходы на эвакуацию или репатриацию;</p></td><td><p>·    incurred if the trip was undertaken by the Insured Person with the intention of receiving treatment or related to going to the Medical Institution with intent of illness, including the cost of evacuation or repatriation;</p></td></tr><tr><td><p>·      связанные с лечением заболеваний, сопровождающихся хронической почечной или печеночной недостаточностью и требующие проведения гемодиализа, плазмофореза, УФО крови, за исключением расходов на проведение гемодиализа в случае острых отравлений, сопровождающихся острой почечной или печеночной недостаточностью;</p></td><td><p>·    Treatment-related diseases associated with chronic renal or hepatic impairment requiring hemodialysis, plasmapheresis, and blood UV, except for the costs of hemodialysis in the event of acute poisoning accompanied by acute renal or hepatic impairment;</p></td></tr><tr><td><p>·      на компьютерную томографию, магнитно-резонансную томографию, не согласованные с Сервисной компанией и/или Страховщиком, за исключением случаев, когда данные исследования необходимы по экстренным медицинским показаниям и проводятся для диагностики степени тяжести травм и заболеваний, либо в связи с оперативным вмешательством;</p></td><td><p>·    for computed tomography, magnetic resonance imaging not agreed with the Service Company and/or the Insurer, unless the study data is necessary for emergency medical reasons and is performed to diagnose the severity of injuries and diseases, or in connection with operational intervention;</p></td></tr><tr><td><p>·      на устранение косметических дефектов лица (в том числе стоматологических), тела независимо от времени их возникновения;</p></td><td><p>·    to eliminate cosmetic defects of the face (including dental), body regardless of the time of their occurrence;</p></td></tr><tr><td><p>·      на косметическую, пластическую и восстановительную хирургию и всякого рода протезирование, включая зубное и глазное протезирование</p></td><td><p>·    cosmetic, plastic and restorative surgery and all kinds of prosthetics, including dental and eye prosthetics;</p></td></tr><tr><td><p>·      на иммунокоррекцию, расширенное иммунологическое исследование;</p></td><td><p>·    for immuno correction, extended immunological study;</p></td></tr><tr><td><p>·      на стоматологические услуги, (кроме расходов на осмотр, лечение и медикаменты при острой зубной боли, а также при травме зуба в результате Несчастного случая), лечение заболеваний пародонта, замену старых пломб, зубопротезирование, включая подготовку к нему, восстановление (реконструкцию) коронковой части зуба, имплантацию зубов, ортодонтию;</p></td><td><p>·    for dental services (except for the costs of examination, treatment and medicines for acute toothache, as well as for tooth injury as a result of an Accident), treatment of periodontal diseases, replacement of old fillings, dental prosthetics, including preparation for it, restoration (reconstruction) of the crown part of the tooth, implantation of teeth, orthodontics;</p></td></tr><tr><td><p>·      возникшие в результате отказа Застрахованного лица от выполнения предписаний лечащего врача или Врача-эксперта Страховщика, полученные им в связи с обращением по поводу страхового случая, а также на нетрадиционные методы лечения;</p></td><td><p>·    arising as a result of the Insured Person\'s refusal to comply with the instructions of the treating physician or the Expert Physician of the Insurer, received by him in connection with the appeal for an insured event, as well as for non-traditional methods of treatment;</p></td></tr><tr><td><p>·      по лечению Застрахованного лица и уходу за ним, осуществляемым его родственниками, независимо от того, являются ли они профессиональными медицинскими работниками или нет;</p></td><td><p>·    for the treatment and care of the Insured Person carried out by his relatives, whether or not they are professional medical professionals;</p></td></tr><tr><td><p>·      связанные с оказанием услуг Медицинским учреждением, не имеющим права на оказание соответствующих услуг (лицензии), либо лицом, не имеющим права на осуществление медицинской деятельности;</p></td><td><p>·    related to the provision of services by a Medical Institution not entitled to provide the relevant services (licenses) or a person not entitled to carry out medical activities;</p></td></tr><tr><td><p>·      на оздоровительное и реабилитационное лечение в условиях Стационарных учреждений, диспансеров, санаториев, пансионатах, домах отдыха, восстановительных центров и других специализированных Медицинских учреждений;</p></td><td><p>·    for health and rehabilitation treatment in the conditions of inpatient institutions, dispensaries, sanatoriums, boarding houses, rest homes, recovery centers and other specialized medical institutions;</p></td></tr><tr><td><p>·      на физиотерапию, массаж, мануальную терапию, занятия на тренажерах, ЛФК, бассейн, водолечение, гелиотерапия, солярий, лазеротерапию, рефлексотерапию (акупунктуру и иглорефлексотерапию), гирудотерапию, хиропрактику, гомеопатию, фито- и натуротерапию, и так далее;</p></td><td><p>·    physical therapy, massage, manual therapy, exercise exercises, exercise therapy, swimming pool, hydrotherapy, heliotherapy, solarium, laser therapy, reflexology (acupuncture and acupuncture), hirudotherapy, chiropractic, homeopathy, phyto- and nature therapy, and so on;</p></td></tr><tr><td><p>·      на общие медицинские осмотры, обследования с профилактическими целями, не связанные с необходимостью диагностики острого заболевания или травмы в результате Несчастного случая, на проведение вакцинации (за исключением экстренной вакцинации в связи с укусом насекомого, животного или Телесного повреждения), дезинфекции;</p></td><td><p>·    general medical examinations, examinations for preventive purposes not related to the need to diagnose an acute illness or injury as a result of an Accident, vaccination (except for emergency vaccination in connection with an insect, animal or Bodily injury bite), disinfection;</p></td></tr><tr><td><p>·      на услуги Врача и лабораторные исследования, не связанные с Несчастным случаем или Внезапным заболеванием;</p></td><td><p>·    for the services of the Physician and laboratory tests not related to an Accident or Sudden Illness;</p></td></tr><tr><td><p>·      произведенные Застрахованным лицом на приобретение медицинского оборудования, очков, контактных линз, слуховых аппаратов, а также других корригирующих медицинских устройств и приспособлений, и расходы на их подгонку;</p></td><td><p>·    Medical equipment, glasses, contact lenses, hearing aids, as well as other corrective medical devices and devices produced by the Insured Person for the purchase of medical equipment, glasses, contact lenses, hearing aids, as well as costs for their adjustment;</p></td></tr><tr><td><p>·      на приобретение препаратов, которые не причисляются к лекарственным препаратам, несертифицированные лекарства, лекарства, состав которых скрывается составителем, а также пищевые продукты, укрепляющие средства, средства для похудения и слабительные, выдаваемые по Рецепту, косметические средства, минеральная вода и так далее;</p></td><td><p>·    for the purchase of drugs that are not classified as drugs, uncertified drugs, medicines whose composition is hidden by the compiler, as well as food products, strengthening agents, weight loss products and laxatives, prescription drugs, cosmetics, mineral water, and so on;</p></td></tr><tr><td><p>·      на услуги, связанные с предоставлением дополнительного комфорта, а именно: одноместных палат и палат типа «люкс», телевизора, телефона, кондиционера, увлажнителя, услуг парикмахера, массажиста, косметолога, переводчика и так далее;</p></td><td><p>·    services related to the provision of additional comfort, namely: single chambers and chambers of the \"luxury\" type, TV, telephone, air conditioner, humidifier, services of a hairdresser, massage therapist, cosmetologist, translator, and so on;</p></td></tr><tr><td><p>·      на ритуальные услуги (погребение) на территории Страны постоянного проживания Застрахованного лица;</p></td><td><p>·    for ritual services (burial) in the territory of the Country of permanent residence of the Insured Person;</p></td></tr><tr><td><p>·      возникшие после окончания срока действия Договора страхования;</p></td><td><p>·    arising after the expiration of the Insurance Contract;</p></td></tr><tr><td><p>·      на лечение в Стационарном учреждении (на которое не было получено согласие Сервисной компании перед тем, как оно было начато, кроме предоставления медицинской помощи направленной на спасение жизни Застрахованного лица, с последующим согласованием этих расходов со Страховщиком и/или Сервисной компанией), а также на хирургическое вмешательство или лечение, которое может быть отложено до возвращения Застрахованного лица в Страну постоянного проживания;</p></td><td><p>·    treatment at the Inpatient Facility (which was not agreed to by the Service Company before it was started, other than the provision of life-saving medical care to the Insured Person, with subsequent agreement of these costs with the Insurer and/or the Service Company), and surgical intervention or treatment that may be delayed until the Insured Person returns to the Country of Permanent Residence;</p></td></tr><tr><td><p>·      имевшие место после возвращения в Страну постоянного проживания, если иное не предусмотрено Договором страхования;</p></td><td><p>·    those that occurred after returning to the Country of permanent residence, unless otherwise provided by the Insurance Contract;</p></td></tr><tr><td><p>·      на лечение от алкоголизма, наркомании и прочих злоупотреблений/зависимостей или другого состояния, связанного с привыканием, вызванных приемом наркотических, токсических веществ, алкогольных напитков, а также на лечение травм и заболеваний находящихся в прямой причинно-следственной связи с употреблением вышеуказанных веществ (кроме случаев лечения травм, полученных в момент, когда количество спирта в крови не превышало 0,7 (ноль целых семь десятых) промилле), включая расходы на эвакуацию или репатриацию останков, за исключением противоправных действий третьих лиц в отношение Застрахованного лица, что должно быть подтверждено компетентными государственными органами;</p></td><td><p>·    for treatment of alcoholism, drug addiction and other abuse/addictions or other addictive condition caused by the use of narcotic, toxic substances, alcoholic beverages, as well as for the treatment of injuries and diseases in direct causal relationship with the use of the above substances (except in cases of treatment of injuries sustained at the moment when the amount of alcohol in the blood did not exceed 0.7 (zero point seven) ppm), including expenses for the evacuation or repatriation of the remains, except for the unlawful actions of third parties against the Insured Person, which must be confirmed by the competent state authorities;</p></td></tr><tr><td><p>·      при автотранспортной аварии, если Застрахованное лицо управляло средством транспорта, не имея водительских прав или в состоянии алкогольного (в соответствии с законодательством Страны (Региона) временного пребывания), наркологического или токсического опьянения, или передало управление лицу, не имеющему водительских прав и доверенности на право управления автомобилем, или находящемуся в состоянии алкогольного (в соответствии с законодательством Страны (Региона) временного пребывания), наркологического или токсического опьянения, а также если Застрахованное лицо пренебрегло и не воспользовалось средствами безопасности (защиты) как вместе, так и по отдельности, такими, как: ремень безопасности, шлем, каска, спасательный жилет, а также иные средства безопасности, предусмотренные правилами эксплуатации транспортного средства, при возможности использования вышеуказанных средств безопасности в транспортном средстве;</p></td><td><p>·    • in a motor vehicle accident, if the Insured Person was driving a vehicle without a driver\'s license or in a state of alcohol (in accordance with the laws of the Country (Region) of temporary stay), narcological or toxic intoxication, or transferred control to a person who does not have a driver\'s license and power of attorney for the right to drive a car, or who is in a state of alcohol (in accordance with the laws of the Country (Region) of temporary stay), narcological or toxic intoxication, as well as if the Insured Person neglected and did not use the means of safety (protection) both together and separately, such as: safety belt, helmet, helmet, life jacket, as well as other safety means provided for by the rules of operation of the vehicle, if the above safety means can be used in the vehicle;</p></td></tr><tr><td><p>·      понесенные в связи с вредом здоровью Застрахованного лица вследствие принятия им лекарственных средств без назначения Врача;</p></td><td><p>·    incurred in connection with harm to the health of the Insured Person due to the adoption of medicines by him without the prescription of the Doctor;</p></td></tr><tr><td><p>·      понесенные в связи с вредом здоровью Застрахованного лица при совершении им преступных действий, а также во время его участия в политических демонстрациях, забастовках или в результате его службы в любых вооруженных силах или формированиях;</p></td><td><p>·    incurred in connection with the damage to the health of the Insured Person in the course of his criminal acts, as well as during his participation in political demonstrations, strikes or as a result of his service in any armed forces or formations;</p></td></tr><tr><td><p>·      явившиеся следствием занятия Застрахованным лицом следующими видами спорта: авто- или мотоспортом, альпинизмом, скалолазанием, боевыми видами спорта, спелеологией (кроме спуска в пещеры с экскурсией), спортивным туризмом, маунтинбайком, подводным плаванием на глубину более 12 метров, катанием на горных лыжах или сноуборде вне маркированных трасс с или без инструктора, санным спортом, хоккеем, скачками, прыжками в воду и с трамплина, прыжками с эластичным канатом, паркуром, и/или занятий любым Профессиональным спортом, Любительским спортом и/или Активным отдыхом, если иное не предусмотрено договором страхования;</p></td><td><p>·    resulting from the Insured Person\'s occupation of the following sports: auto or motor sports, mountaineering, climbing, combat sports, caving (except for descending into caves with excursion), sports tourism, mountain bike, scuba diving to a depth of more than 12 meters, skiing or snowboarding off marked tracks with or without an instructor, luge, hockey, horse racing, diving and ski jumping, jumping with elastic rope, parkour, and/or playing any Professional Sport, Amateur sports and/or Active recreation, unless otherwise stipulated by the insurance contract;</p></td></tr><tr><td><p>·      наступившие в связи с:</p><p>–   полетом Застрахованного лица на летательном аппарате, управляемом им, кроме случаев полета в качестве пассажира, оплатившего проезд регулярным авиарейсом или лицензированным чартерным перелетом по установленному маршруту, на самолете гражданской авиации, управляемом профессиональным пилотом;</p><p>–   полетом Застрахованного лица на безмоторных летательных аппаратах, моторных планерах, суперлегких летательных аппаратах,</p><p>–   прыжками Застрахованного лица с парашютом;</p></td><td><p>·    occurring in connection with:</p><p>–   the flight of the Insured Person on an aircraft controlled by him, except for the cases of a flight as a passenger who paid for travel by a regular flight or a licensed charter flight along the established route, on a civil aviation aircraft controlled by a professional pilot;</p><p>–   flight of the Insured Person on non-motorized aircraft, motor gliders, super-light aircraft</p><p>–   parachute jumps of the Insured Person;</p></td></tr><tr><td><p>·      связанные с нарушением Застрахованным лицом правил профилактики заболеваний, эндемичных для Страны временного пребывания, которые включены в условия выдачи разрешения на въезд в данную страну, а также медицинские и медико-транспортные расходы в связи с особо опасными инфекциями (натуральная оспа, чума, сибирская язва, холера, оспа, желтая лихорадка, геморрагическая лихорадка, сыпной тиф, туберкулёз и т.п. заболевания, отнесенные к особо опасным инфекционным заболеваниям, согласно Международным Медико-санитарным правилам Всемирной организации здравоохранения) при нарушении требований введённых карантинных мероприятий, а также связанных с эпидемиями, загрязнением окружающей среды и стихийными бедствиями на Территории страхования, известными до начала Застрахованной поездки кроме случаев, когда данное условие отдельно предусмотрено Договором страхования. Исключением является лечение коронавирусной инфекции SARS-CoV-2 (COVID-19), входящей в страховое покрытие по условиям настоящих Правил и в пределах лимитов, установленных договором страхования</p></td><td><p>·           related to the violation by the Insured Person of the rules for the prevention of diseases endemic to the Country of temporary residence, which are included in the conditions for issuing a permit to enter this country, as well as medical and medical transport costs in connection with especially dangerous infections (smallpox, plague, anthrax, cholera, smallpox, yellow fever, hemorrhagic fever, typhus, tuberculosis, etc., diseases classified as particularly dangerous infectious diseases, according to the International Health Rules of the World Health Organization) in case of violation of the requirements of the introduced quarantine measures, as well as related to epidemics, environmental pollution and natural disasters in the Insurance Territory known before the start of the Insured Trip, unless this condition is separately provided for by the Insurance Contract. An exception is the treatment of coronavirus infection SARS-CoV-2 (COVID-19), which is covered under the terms of these Rules and within the limits established by the insurance contract.</p></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/auth/login.html","<div class=login-box><div class=login-logo><img src=assets/images/logo.png></div><div class=login-box-body><form layout=column ng-submit=auth.login()><div class=\"form-group has-feedback\"><input placeholder=Логин ng-required=true ng-model=auth.username class=form-control><span class=\"glyphicon glyphicon-user form-control-feedback\"></span></div><div class=\"form-group has-feedback\"><input type=password placeholder=Пароль ng-required=true ng-model=auth.password class=form-control><span class=\"glyphicon glyphicon-lock form-control-feedback\"></span></div><div class=row><div class=col-xs-4><button type=submit ng-disabled=auth.auth_loading class=\"btn btn-danger btn-block btn-flat\">Войти</button></div><div class=col-xs-8><button ui-sref=checkPolicy class=\"btn btn-default btn-block btn-flat\">Проверить полис</button></div><!-- /.col--></div></form></div></div><div class=footer><div class=text-center><div class=hidden-xs><b>Version</b> 3.1.0</div><strong>Copyright © 2019-2022<a href=http://agi.kg target=_blank> СК АЮ Гарант</a>.</strong> All rights reserved.</div></div>");
$templateCache.put("app/auth/register.html","<!--Created by jaynakus on 5/26/16.\n--><div class=\"container body footer-fixed\"><div class=main_container><!-- page content--><div role=main class=right_col><div class=login><div class=login_wrapper><div class=\"form login_form\"><div class=login_content><form ng-submit=auth.register()><h1>Зарегистрироваться</h1><div><input placeholder=Пользователь required ng-model=auth.username class=form-control></div><div><input type=email placeholder=Email required ng-model=auth.email class=form-control></div><div><input type=password placeholder=Пароль required ng-model=auth.password class=form-control></div><div><button type=submit class=\"btn btn-default submit\">Зарегистрироваться</button></div><div class=clearfix></div><div class=separator><p class=change_link>Уже регистрировались?<a ui-sref=login class=to_register>Войти</a></p><div class=clearfix></div><br><div><h1><img src=assets/images/stok.png style=\"border: none; background-color: transparent\" width=150 height=150 class=img-thumbnail><!--span   kamkor IPS--></h1><p>© 2016-2017 Miller & Weismann</p></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/branch/branch.html","<div class=content><div class=row><div class=col-md-12><panel title=\"По филиалам\"><form ng-submit=branch.getPolicies()><div class=row><col-responsive stock-dict=branch.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=branch.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in branch.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Филиалы:</label><ui-select ng-model=branch.filter.branch_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in branch.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=branch.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=branch.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=branch.date_start ng-click=\"branch.search.popup_to_date.opened=true\" is-open=branch.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"branch.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=branch.date_start ng-model=branch.date_end ng-click=\"branch.search.popup_from_date.opened=true\" is-open=branch.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"branch.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"branch.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button ng-click=branch.goToShow() ng-disabled=!branch.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=branch.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=branch.policiesGridOptions disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/branch/show.html","<!--Created by ilias on 15.09.2017.\n--><div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'show.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount}} {{show.currency_name}}<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium}} {{show.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in show.policy.insurance_data.country_id\"><span ng-repeat=\"country in show.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{show.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{show.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{show.policy.client.surname}} {{show.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{show.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{show.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=show.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in show.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in show.product.services_id\" class=list-group-item><span ng-repeat=\"service in show.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button></div></div></div>");
$templateCache.put("app/company/company.html","<!--Created by Aibek on 06/06/16.\n--><div class=content><div class=row><div class=col-md-12><panel title=Компании><button type=button ng-click=company.newCompany() class=\"btn btn-primary btn-sm\">Создать</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!branch.selected_branch\' ng-click=\'branch.editBranch()\')--> <button ng-click=company.editCompany() ng-disabled=\"company.selected_company==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=company.removeCompany() ng-disabled=!company.selected_company class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button><div class=margin></div><paged-table options=company.companiesGridOptions disable-search=true disable-paging=true></paged-table></panel></div></div></div>");
$templateCache.put("app/company/edit.html","<!--\nCreated by Aibek on 26/08/16.\n\n--><form ng-submit=company.putCompany() class=from-horizontal><div class=modal-header><h3>Компания</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><li><a data-toggle=tab data-target=#menu1>Ассистанс</a></li><li><a data-toggle=tab data-target=#menu2>Контакты</a></li><li><a data-toggle=tab data-target=#menu3>Пользователи</a></li><li><a data-toggle=tab data-target=#menu4>Агенты</a></li><li><a data-toggle=tab data-target=#menu5>Логотип</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=company.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=company.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=company.company.code ng-required=false ng-trim=true maxlength=2 class=form-control></div></col-responsive><col-responsive stock-dict=company.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=company.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=company.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"company.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=company.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=company.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=company.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=company.insurancetypes dict-table=InsuranceTypes><div class=form-group><label>Тип страхования</label><ui-select ng-model=company.company.data.insurancetypes_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in company.insurancetypes\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=company.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><!--col-responsive(stock-dict=\'company.insurer_types\' dict-table=\'Enums\' dict-filter=\'{name:\"insurer_type\"}\')--><!--  .form-group--><!--    label Тип--><!--    ui-select.form-control(ng-model=\'company.company.data.insurer_type\' ng-required=\'true\')--><!--      ui-select-match {{$select.selected.data.name}}--><!--      ui-select-choices(repeat=\'type.data.key as type in company.insurer_types track by type.data.key\') {{type.data.name}}--><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=company.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=company.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=company.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=company.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=company.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=company.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div stock-dict=company.assistanceList dict-table=Assistance class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ассистанс</label><div class=input-group><ui-select ng-model=company.assistance ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in company.assistanceList\">{{type.name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=company.addAssistance() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><h2>Список ассистанс</h2><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"item in company.company.data.assistants\" class=list-group-item><label>{{item.name}}</label><a ng-click=company.deleteAssistance($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><span ng-init=company.initMS2() style=display:none></span></div><div id=menu2 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=number ng-model=company.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=company.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=company.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=email ng-model=company.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=company.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div></div><div id=menu3 class=\"tab-pane fade\"><div class=row><div class=row><!--.col.col-xs-12.col-sm-6.col-md-6(stock-dict=\'company.users\' dict-table=\'User\')--><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ползователи</label><ui-select ng-model=company.currStaff.user_id ng-required=true class=form-control><ui-select-match>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in company.users\">{{type.username}}</ui-select-choices></ui-select></div></div><div stock-dict=company.branches dict-table=Branches dict-filter={company_id:company.company._id} class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=company.currStaff.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in company.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12\"><button type=button ng-click=company.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></div></div><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in company.company.staff\"><td><span ng-repeat=\"user in company.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in company.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=company.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div><div id=menu4 class=\"tab-pane fade\"><div class=row><div stock-dict=company.agentList dict-table=Companies dict-filter={company_type:&quot;agent&quot;} class=\"col col-xs-12\"><div class=form-group><label><h5>Список агентов компании</h5></label><div class=input-group><ui-select ng-model=company.company.agents_id on-select=company.checkAgents() on-remove=company.checkAgents() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in company.agentList | filter:{name:$select.search}\">{{type.name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" style=visibility:hidden ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col col-xs-12\"><h5>Доля агентов с продаж</h5><table class=\"table-bordered countries_list\"><thead><tr class=row><th class=\"col-md-1 text-center\">№</th><th class=\"col-md-8 text-center\">Название агентской компании:</th><th class=\"col-md-3 text-center\">Процент с продаж:</th></tr></thead><tbody><tr ng-repeat=\"percent_agent in company.company.data.agent_percentage\" class=row><td class=\"col-md-1 text-center\">{{$index+1}}</td><td ng-repeat=\"agent in company.agentList|filter:{_id:percent_agent.id}\" class=\"col-md-8 text-center\">{{agent.name}}</td><td class=col-md-3><input type=number step=1 ng-model=percent_agent.percent ng-trim=true class=\"text-center form-control\"></td></tr></tbody></table></div></div></div><div id=menu5 class=\"tab-pane fade\"><div class=row><div flow-init={singleFile:true} class=\"col col-xs-12 col-md-8 col-lg-8\"><span flow-btn flow-file-added=\"company.handleFileSelect($event, $flow, $file)\" class=\"btn btn-default margin-right-8\">Выбрать файл...</span><span>{{$flow.files[0].name}}</span></div></div><div class=row><div class=\"col col-xs-12 col-md-8 col-lg-8\"><div class=cropArea><img-crop image=company.image result-image=company.result_image area-type=square result-image-size=100></img-crop></div><div>Итоговое изибражение:<div><img ng-src={{company.result_image}}></div><a data-target=# ng-click=company.upload() class=\"btn btn-primary\">Заменить существующий</a></div></div><div class=\"col col-xs-12 col-md-4 col-lg-4\"><div class=\"clearfix pull-left\"><h3>Логотип компании</h3><img ng-src={{app.api}}{{company.company.data.image}} class=profile-image-lg></div></div></div></div></div></div><div class=modal-body><!--button.btn.btn-primary.btn-sm.pull-right(type=\'submit\', ng-if=\'company.company.user_id==company.ua.id\') Сохранить--> <button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=company.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/companyusers/companyusers.html","<!--\nCreated by Aibek on 13/06/16.\n\n--><div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-box><h3 class=box-title>Пользователи</h3></div><div class=\"box-body pad table-responsive\"><form ng-submit=companyusers.getUsers()><div class=row><col-responsive><div class=form-group><label>Логин:</label><input type=text ng-model=companyusers.filter.username placeholder=\" Введите логин\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Email:</label><input type=text ng-model=companyusers.filter.email placeholder=\"Введите email\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Фамилия:</label><input type=text ng-model=companyusers.filter.data.surname placeholder=\"Введите фамилию\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Имя:</label><input type=text ng-model=companyusers.filter.data.name placeholder=\"Введите имя\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Отчество:</label><input type=text ng-model=companyusers.filter.data.patronymic placeholder=\"Введите отчество\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"companyusers.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button ng-click=companyusers.newUser() class=\"btn btn-primary btn-sm\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!product.selected_product\' ng-click=\'product.editProduct()\')--> <button ng-click=companyusers.editUser() ng-disabled=\"companyusers.selected_user == null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=companyusers.Removeuser(companyusers.selected_user) ng-disabled=\"companyusers.selected_user == null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Убрать</span></button> <button ng-click=product.getUsers() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><div class=margin></div><paged-table options=companyusers.usersGridOptions disable-search=true></paged-table></form></div></div></div></div></div>");
$templateCache.put("app/companyusers/create.html","<form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div stock-dict=user.roles dict-table=Roles dict-filter={role_type:&quot;tehnika&quot;} class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Роли</label><ui-select ng-model=user.user.roles_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.roles\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/companyusers/edit.html","<form ng-submit=user.updateUser()><div class=modal-header><h3>Редактирование пользователя</h3></div><div class=modal-body><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div stock-dict=user.roles dict-table=Roles dict-filter={role_type:&quot;tehnika&quot;} class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Роли</label><ui-select ng-model=user.user.roles_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.roles\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/currency/create.html","<!--\nCreated by Aibek on 25/08/16.\n\n--><form ng-submit=currency.createCurrency() class=from-horizontal><div class=modal-header><h3>Новый агент</h3></div><div class=modal-body><div class=tab-content><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>День</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"currency.popup_delivery_date.opened=true\" ng-model=currency.currency.currency_date is-open=currency.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"currency.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Валюта</label><input type=text ng-model=currency.currency.currency ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Ставка</label><input type=number step=0.01 ng-model=currency.currency.rate ng-trim=true class=form-control></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=currency.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/currency/currency.html","<!--\nCreated by Ilias on 13/06/16.\n\n--><div class=container><panel title=\"Курс валют\"><button ng-click=currency.newCurrency() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=currency.editCurrency() ng-disabled=\"currency.selected_currency==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Редактировать</span></button> <button ng-click=currency.confirmAction() ng-disabled=\"currency.selected_currency == null\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=currency.getCurrency() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=currency.currencyGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-box><h3 class=box-title>Добро пожаловать</h3></div><div class=\"box-body pad table-responsive\"><div class=wrapper-left><h4>История, миссия и задача</h4><p></p><ul class=bullet><li><span style=font-size:14px>​История </span></li></ul><p><span style=font-size:14px><strong></strong></span><span style=font-size:14px><strong>ОАО Страховая компания «АЮ Гарант»</strong>является одной из составляющей многофункциональной холдинговой компании<a href=http://ayuholding.kg/ >«АЮ Холдинг»</a>.<br>Свою деятельность компания начала с<strong>27 декабря 2012 года</strong>, позиционируя себя как широкопрофильная компания.</span></p><p><span style=font-size:14px><br>«АЮ Гарант» занял позицию лидера по размеру уставного капитала на страховом рынке Кыргызской Республики.</span></p><p><span style=font-size:14px><br>Страховая компания оказывает широкий спектр услуг по страхованию и перестрахованию. По добровольным видам страхования имеется 19 лицензий и по обязательному виду страхования 5 лицензии.</span></p><p><span style=font-size:14px><br>Работа настроена как на частных клиентов, так и на корпоративных клиентов. Преимуществом компании является индивидуальный подход к каждому клиенту.<br><strong>Головной офис</strong> находится по адресу: город <strong>Бишкек</strong>, ул. Токтогула, 126 (пересекая ул.Панфилова).<br>В сентябре 2016 года был<strong>открыт филиал компании в г. Ош</strong>, где жители и гости южной столицы могут получить полную информацию о всех видах страхования. Адрес: г. Ош, ул. Ленина, 272/1, тел.: 0772 51 90 09.</span></p><p><span style=font-size:14px>Согласно свидетельству о государственной перерегистрации юридического лица серия ГПЮ № 0038421 от<strong>22.07.2019</strong>года произошло изменение организационно-правовой формы компании.<br><br>А именно из Акционерного Общество Открытого типа (ОАО) организационно правовая форма Страховой Компании «АЮ Гарант» была изменена на<strong>Акционерное Общество Закрытого типа (ЗАО).</strong></span><br></p><ul class=bullet><li><span style=font-size:14px>Миссия</span></li></ul><p><span style=font-size:14px>Миссия нашей компании заключается в том, чтобы улучшить жизнь граждан<strong>Кыргызстана</strong>, предоставляя им качественную и доступную страховую защиту, которая даст уверенность в завтрашнем дне, чувство стабильности и спокойствия. Способствовать развитию и совершенствованию страхового сектора в экономике во благо страны.</span><br></p><ul class=bullet><li><span style=font-size:14px>Задача</span></li></ul><p><span style=font-size:14px>Разработка пакетных и индивидуальных программ, отвечающих реальным потребностям клиентов и обеспечивающих защиту их благосостояния.</span></p></div></div></div></div></div></div>");
$templateCache.put("app/defaults/defaults.html","<!--\nCreated by Aibek on 17/08/16.\n\n--><panel title=Документы><button ng-disabled=!defaults.selected_default ng-click=defaults.editDefault() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=defaults.getDefaults() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=defaults.gridOptions disable-paging=true disable-search=true></paged-table></panel>");
$templateCache.put("app/defaults/edit.html","<!--\nCreated by Aibek on 29/08/16.\n\n--><form ng-submit=defaults.putDefault() class=modal-content><div class=modal-header><h3>Параметры документа</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Тип</label><input ng-disabled=true ng-repeat=\"doc_type in defaults.doc_types | filter: {id:defaults.doc_default.document_type} | limitTo: 1 track by doc_type.id\" ng-model=doc_type.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Одобрение</label><label class=form-control><input type=checkbox ng-model=defaults.doc_default.data.approval.required><span ng-hide=defaults.doc_default.data.approval.required>&nbsp;Не обьязательно</span><span ng-show=defaults.doc_default.data.approval.required>&nbsp;Обьязательное одобрение</span></label></div></col-responsive><col-responsive ng-if=\"defaults.doc_default.data.approval.required===true\"><div stock-dict=defaults.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-group><label>Должны одобрить</label><div class=form-control><label ng-repeat=\"type in defaults.approval_types track by type.data.key\" ng-class={&quot;margin-right-8&quot;:!$last}><input type=radio ng-model=defaults.doc_default.data.approval.approval_type ng-value=type.data.key name=approve_type><span>&nbsp;{{type.data.name}}</span></label></div></div></col-responsive><col-responsive ng-if=\"defaults.doc_default.data.approval.required===true\"><div class=form-group><label uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\">Добавить роль для одобрения</label><div stock-dict=defaults.roles dict-table=Roles class=input-group><ui-select ng-model=defaults.approval_role_id class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (defaults.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=!defaults.approval_role_id ng-click=defaults.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div ng-show=\"defaults.doc_default.data.approval.roles_id.length &gt; 0 &amp;&amp; defaults.doc_default.data.approval.required===true\" class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div ng-show=\"defaults.doc_default.data.approval.roles_id.length &gt; 0 &amp;&amp; defaults.doc_default.data.approval.required===true\" class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in defaults.doc_default.data.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (defaults.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=defaults.delApprovalRole(role_id) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=defaults.doc_default.data.data.executor_id></employee-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=\"defaults.saving==true\" type=button ng-click=defaults.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=\"defaults.saving==true\" class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/dictionary/dictionary.html","<div class=content><div class=row><div class=\"col col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Справочники</h3></div><div class=\"box-body pad table-responsive\"><div class=row><div class=\"col col-xs-12 col-md-3\"><div class=list-group><a ng-class=\"{active:dictionary.active_table.table==table.table}\" ng-click=\"dictionary.active_table=table\" ng-repeat=\"table in dictionary.tables | filter: dictionary.roleFilter track by table.table\" class=list-group-item>{{table.name}}</a></div></div><div class=\"col col-xs-12 col-md-9\"><div class=form-group><button ng-click=dictionary.newDictionary() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!dictionary.selected_dictionary ng-click=dictionary.editDictionary() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-disabled=!dictionary.selected_dictionary ng-click=dictionary.removeConfirmAction() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-trash margin-right-8\"></span><span>Удалить</span></button></div><!--form.row(ng-submit=\'dictionary.getDictionaries()\')--><!--  .col.col-xs-12.col-sm-6(ng-show=\'app.ua.role>=10\')--><!--    .form-group--><!--      textarea.form-control(ng-model=\'dictionary.search_filter\' placeholder=\'Найти по фильтру\')--><!--    .from-group--><!--      button.btn.btn-default Найти--><!--        span.fa.fa-search.margin-left-8--><div dynamic=dictionary.grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/dictionary/modal.html","<!--Created by Aibek on 24/08/16.\n--><form ng-submit=edit.saveDictionary()><div class=modal-header><h3>{{edit.table.name}}</h3></div><div class=modal-body><ng-include src=edit.template></ng-include></div><div class=modal-footer><button type=button ng-click=edit.cancel() class=\"btn btn-default\">Отмена</button> <button type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/dictionarya/dictionarya.html","<!--\nCreated by Aibek on 24/08/16.\n\n--><div class=row><div class=\"col col-xs-12 col-md-3\"><div class=list-group><a ng-class=\"{active:dictionarya.active_table.table==table.table}\" ng-click=\"dictionarya.active_table=table\" ng-repeat=\"table in dictionarya.tables | filter: dictionarya.roleFilter track by table.table\" class=list-group-item>{{table.name}}</a></div></div><div class=\"col col-xs-12 col-md-9\"><button ng-click=dictionarya.newDictionary() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!dictionarya.selected_dictionary ng-click=dictionarya.editDictionary() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button><div dynamic=dictionarya.grid></div></div></div>");
$templateCache.put("app/dictionarya/modal.html","<!--Created by Aibek on 24/08/16.\n--><form ng-submit=edit.saveDictionary()><div class=modal-header><h3>{{edit.table.name}}</h3></div><div class=modal-body><ng-include src=edit.template></ng-include></div><div class=modal-footer><button type=button ng-click=edit.cancel() class=\"btn btn-default\">Отмена</button> <button type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/doctemplates/add.html","<div flow-init=add.flowConfig class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=x_panel><div class=x_title><h2>Добавить документ</h2><div class=clearfix></div></div><div class=x_content><form id=doctemp-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=title name=title required ng-model=add.docTemp.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите файл<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--input(type=\"file\", flow-btn)--><file-load file-src=add.docTemp.url type=exp_fk allow=ods,odt,xls,xlsx></file-load><!--label.btn.btn-default.btn-file--><!--  input(type=\"file\", id=\"file\", name=\"file\", ng-model=\"add.docTemp.file\", hidden)--></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=add.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=add.saveDocTemp() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/doctemplates/list.html","<div class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=x_panel><div class=x_title><h2>Шаблоны документов</h2><div class=clearfix></div></div><div class=x_content><table class=table><thead><tr><th>#</th><th>Название</th><th><button type=button ng-click=list.openAddForm() class=\"btn btn-default btn-xs\">Добавить</button> <button type=button ng-click=list.getDocTeplates() class=\"btn btn-default btn-xs\">Обновить</button></th></tr></thead><tbody><tr ng-repeat=\"doc in list.docTemps\" ng-if=\"list.docTemps.length &gt; 0\"><td>{{ ($index + 1) }}</td><td padding-top>{{ doc.name }}</td><td><a target=_blank href=\"{{ list.api + \'download/\' + doc.url }}\" class=\"btn btn-primary btn-xs\">Скачать</a> <button type=button ng-click=list.deleteDoc(doc) class=\"btn btn-danger btn-xs\">Удалить</button></td></tr><tr ng-if=\"list.docTemps.length == 0\"><td></td><td>Нет шаблонов</td><td></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/employee/create.html","<!--\nCreated by ilias on 20.08.2017.\n\n--><form ng-submit=employee.createEmployee()><div class=modal-header><h3>Новый сотрудник</h3></div><div class=modal-body><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>ФИО</label><input type=text ng-model=employee.employee.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"employee.popup_delivery_date.opened=true\" ng-model=employee.employee.birthday is-open=employee.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"employee.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=employee.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/employee/edit.html","<!--\nCreated by ilias on 20.08.2017.\n\n--><form ng-submit=employee.updateEmployee()><div class=modal-header><h3>Сотрудник<div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>ФИО</label><input type=text ng-model=employee.employee.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"employee.popup_delivery_date.opened=true\" ng-model=employee.employee.birthday is-open=employee.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"employee.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></h3></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=employee.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/employee/employee.html","<div class=content><div class=row><div class=col-md-12><panel title=Сотрудники><button ng-click=employee.newEmployee() class=\"btn btn-primary btn-sm\">Добавить<!--button.btn.btn-default.btn-sm(ng-click=\"employee.editEmployee()\" ng-disabled=\"users.selected_user == null\")--> <button ng-click=employee.editEmployee() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=employee.deleteEmployee(employee.selected_user) class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=employee.getEmployees() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></button><div class=margin></div><paged-table options=employee.employeeGridOptions disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/equipment/create.html","<!--Created by ilias on 14.04.17.\n--><div class=content><div class=row><div class=col-md-12><panel title=\"Создание полиса\"><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input ng-model=create.policy.client ng-trim=true type=text class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Модель, Марка</label><input ng-model=create.policy.model ng-trim=true type=text class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Идентификационный номер</label><input ng-model=create.policy.data.id_number ng-trim=true type=text class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Стоимость</label><input ng-model=create.policy.price ng-trim=true type=number allow-clear=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><ui-select ng-model=create.policy.sum><ui-select-match allow-clear=true><span ng-bind=$select.selected.summ></span></ui-select-match><ui-select-choices repeat=\"currency.summ as currency in create.insure_sum | filter:{name:$select.search}\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input ng-model=create.policy.premium ng-trim=true type=number ng-disabled=true class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label for=middle-name class=control-label>Начало</label><div class=\"input-group no-margin\"><input id=middle-name type=text ng-disabled=true min-date=create.today max-date=create.policy.period.end uib-datepicker-popup=dd-MM-yyyy ng-click=\"create.popup_delivery_date.opened=true\" ng-model=create.policy.period.start is-open=create.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"create.popup_delivery_date.opened=true\" ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label for=middle-name2 class=control-label>Конец</label><div class=\"input-group no-margin\"><input id=middle-name2 ng-disabled=true type=text uib-datepicker-popup=dd-MM-yyyy min-date=create.policy.period.start ng-click=\"create.popup_delivery_date.opened1=true\" ng-model=create.policy.period.end is-open=create.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"create.popup_delivery_date.opened1=true\" ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Дата выписки</label><div class=input-group><input type=text ng-model=create.policy.data.created uib-datepicker-popup=dd-MM-yyyy is-open=create.datepicker.start ng-disabled=true class=form-control><div class=input-group-btn><button type=button ng-click=\"create.datepicker.start=true\" ng-disabled=true class=\"btn btn-default\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>ФИО продавца</label><ui-select ng-model=create.policy.employee_id><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"empl._id as empl in create.employees | filter:{name:$select.search}\"><span ng-bind=empl.name></span></ui-select-choices></ui-select></div></col-responsive></div><div class=ln_solid></div><div class=row><button ng-disabled=create.saving type=button ui-sref=app.equipment.list class=\"btn btn-warning btn-sm pull-right\">Отмена</button> <button ng-disabled=create.saving type=button ng-click=create.putPolicy() class=\"btn btn-primary btn-sm pull-right\">Сохранить</button></div></panel></div></div></div>");
$templateCache.put("app/equipment/edit.html","<!--Created by ilias on 14.04.17.\n-->");
$templateCache.put("app/equipment/list.html","<!--\nCreated by ilias on 14.04.17.\n\n--><div class=content><div class=row><div class=col-md-12><panel title=Техника><form ng-submit=list.getEquipments()><div uib-collapse=!list.filter class=row><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.status ng-required=true class=form-control><ui-select-match allow-clear=true placeholder=\"Все статусы\">{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses | filter:{name:$select.search}\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"list.company.company_type !=\'agent\'\"><div class=form-group><label>Агенты:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true placeholder=\"Все агенты\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in list.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.list_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.name placeholder=\" Введите ФИО\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter=list.filter ? null : {}\" class=\"btn btn-default\">{{list.filter ? \'Скрыть\':\'Показать\'}} фильтры</button> <button type=button ng-show=list.filter ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button type=button ng-click=list.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!list.selected_list\' ng-click=\'list.editBranch()\')--> <button ng-click=list.goToShow() ng-disabled=!list.selected_equipment class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'list.delete()\' ng-disabled=\"!list.selected_list\")--> <button ng-click=list.confirmAction() ng-disabled=\"!list.selected_equipment || list.selected_equipment.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_equipment || list.selected_equipment.list_no == \'00000\' || (list.selected_equipment.status != \'Оформлен\' &amp;&amp; list.selected_equipment.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getEquipments() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=list.equipmentsGridOptions disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/equipment/show.html","<!--\nCreated by ilias on 06.06.2017.\n\n--><div class=container><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=row><div class=col-md-12><div class=form-group><h4 style=display:inline-block><span>Номер полиса:<span>{{show.policy.policy_no}}</span></span></h4></div></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{show.policy.client}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-4><div class=form-group><h5>Продукт:<span class=text-info> {{show.policy.model}}</span></h5></div></div><div class=col-md-4><div class=form-group><h5>Идентификационный номер:<span class=text-info> {{show.policy.data.id_number}}</span></h5></div></div><div class=col-md-4><div class=form-group><h5>Начало :<span class=text-info> {{show.policy.period.start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=form-group><h5>Конец :<span class=text-info> {{show.policy.period.end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=col-md-4></div></div><div class=row><div class=col-md-4><div class=form-group><h5>Стоимость:<span class=text-info> {{show.policy.price}}</span></h5></div></div><div class=col-md-4><div class=form-group><h5>Страховая сумма :<span class=text-info> {{show.policy.sum}} {{show.currency_name}}</span></h5></div></div><div class=col-md-4><div class=form-group><h5>Страховая премия :<span class=text-info> {{show.policy.premium}} {{show.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS</span></h5></div></div></div><div class=row><div class=col-md-4><div class=form-group><h5>ФИО Продавца:<span class=text-info> {{show.policy.employee.name}}</span></h5></div></div><div class=col-md-4><div class=form-group><h5>Агент:<span class=text-info> {{show.policy.company.name}}</span></h5></div></div></div><div class=ln_solid></div><div class=row><div class=col-md-12><button type=button ui-sref=app.equipment.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.status &amp;&amp; show.policy.status == \'Оформлен\'\" ng-disabled=\"!show.policy.status || show.policy.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.confirmActionTerm() ng-if=\"show.policy.status &amp;&amp; show.policy.status == \'Оформлен\'\" ng-disabled=\"!show.policy.status || show.policy.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.status != \'Истек\' &amp;&amp; show.policy.status != \'Оформлен\' &amp;&amp; show.policy.status != \'Испорчен\' &amp;&amp; show.policy.status != \'Расторгнут\'\" ng-disabled=\"show.policy.status == \'Оформлен\' || show.policy.status == \'Испорчен\'|| show.policy.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.status != \'Истек\' &amp;&amp; show.policy.status != \'Оформлен\' &amp;&amp; show.policy.status != \'Испорчен\' &amp;&amp; show.policy.status != \'Расторгнут\'\" ng-disabled=\"show.policy.status == \'Оформлен\' || show.policy.status == \'Испорчен\'|| show.policy.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div></div></div>");
$templateCache.put("app/equipment/view.html","<!--\nCreated by ilias on 14.04.17.\n\n--><div class=content><div class=row><div class=col-md-12><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=row><col-responsive><div class=form-group><h4 style=display:inline-block><span>Номер полиса:<span>{{view.policy.policy_no}}</span></span></h4></div></col-responsive></div><div class=ln_solid></div><div class=row><col-responsive><h5>ФИО Клиента:<span class=text-info> {{view.policy.client}}</span></h5></col-responsive><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><h5>Продукт:<span class=text-info> {{view.policy.model}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Начало :<span class=text-info> {{view.policy.period.start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=form-group><h5>Конец :<span class=text-info> {{view.policy.period.end|date:\'dd-MM-yyyy\'}}</span></h5></div></col-responsive><col-responsive></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>Идентификационный номер:<span class=text-info> {{view.policy.data.id_number}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Стоимость:<span class=text-info> {{view.policy.price}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая сумма :<span class=text-info> {{view.policy.sum}} {{view.currency_name}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая премия :<span class=text-info> {{view.policy.premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>ФИО Продавца:<span class=text-info> {{view.policy.employee.name}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Агент:<span class=text-info> {{view.policy.company.name}}</span></h5></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=col-md-12><button type=button ng-click=view.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.status &amp;&amp; view.policy.status == \'Оформлен\'\" ng-disabled=\"!view.policy.status || view.policy.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.status &amp;&amp; view.policy.status == \'Оформлен\'\" ng-disabled=\"!view.policy.status || view.policy.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.status != \'Истек\' &amp;&amp; view.policy.status != \'Оформлен\' &amp;&amp; view.policy.status != \'Испорчен\' &amp;&amp; view.policy.status != \'Расторгнут\'\" ng-disabled=\"view.policy.status == \'Оформлен\' || view.policy.status == \'Испорчен\'|| view.policy.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.status != \'Истек\' &amp;&amp; view.policy.status != \'Оформлен\' &amp;&amp; view.policy.status != \'Испорчен\' &amp;&amp; view.policy.status != \'Расторгнут\'\" ng-disabled=\"view.policy.status == \'Оформлен\' || view.policy.status == \'Испорчен\'|| view.policy.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div></div></div></div></div>");
$templateCache.put("app/expensesa/expensesa.html","<!--\nCreated by Aibek on 15/06/16.\n\n--><!--ui-sref=\'app.policy_new\',--><div class=container><panel title=\"Фильтр расходов\"><!--pre {{policy.filter|json}}--><form><div class=row><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ui-mask=AAA**99999 ng-model=expensesa.filter.policy_no ui-mask-placeholder ui-mask-placeholder-char=_ placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата расхода:</label><div class=\"input-group no-margin\"><input type=text name=datemask max-date=expensesa.filter.date_end uib-datepicker-popup=dd.MM.yyyy ng-model=expensesa.filter.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><div class=\"col-sm-12 col-md-8\"><div class=form-group><label>ФИО застрахованного:</label><input type=text ng-model=expensesa.filter.full_name placeholder=\" Введите имя\" class=form-control></div></div></div><div class=row><div class=\"col-sm-12 col-md-8\"><button type=button ng-click=expensesa.resetFilter() class=\"btn btn-primary btn-sm pull-right\">Сбросить фильтр</button> <button type=button ng-click=expensesa.getPolicies() class=\"btn btn-primary btn-sm pull-right\"><i aria-hidden=true class=\"fa fa-search\"></i> Искать</button></div></div></form></panel><panel title=\"Список расходов\"><button type=button ng-click=expensesa.goToNew() class=\"btn btn-primary btn-xs\">Информация о расходе</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!expensesa.selected_policy\' ng-click=\'expensesa.editBranch()\')--> <button ng-click=expensesa.goToShow() ng-disabled=!expensesa.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span>Изменить расход</span></button> <button ng-click=expensesa.confirmAction() ng-disabled=\"!expensesa.selected_policy || expensesa.selected_policy.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=expensesa.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=expensesa.policiesGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/expensesa/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/insurantsa/insurantsa.html","<!--\nCreated by Aibek on 15/06/16.\n\n--><!--ui-sref=\'app.policy_new\',--><div class=container><panel title=\"Фильтр застрахованных\"><!--pre {{policy.filter|json}}--><form><div class=row><col-responsive><div class=form-group><label>Мед. карта:</label><input type=text ui-mask=AAA**99999 ng-model=insurantsa.filter.policy_no ui-mask-placeholder ui-mask-placeholder-char=_ placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive></div><div class=row><div class=\"col-sm-12 col-md-8\"><div class=form-group><label>ФИО застрахованного:</label><input type=text ng-model=insurantsa.filter.full_name placeholder=\" Введите имя\" class=form-control></div></div></div><div class=row><div class=\"col-sm-12 col-md-8\"><button type=button ng-click=insurantsa.resetFilter() class=\"btn btn-primary btn-sm pull-right\">Сбросить фильтр</button> <button type=button ng-click=insurantsa.getPolicies() class=\"btn btn-primary btn-sm pull-right\"><i aria-hidden=true class=\"fa fa-search\"></i> Искать</button></div></div></form></panel><panel title=\"Список застрахованных\"><button type=button ng-click=insurantsa.goToNew() class=\"btn btn-primary btn-xs\">Информация</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!insurantsa.selected_policy\' ng-click=\'insurantsa.editBranch()\')--> <button ng-click=insurantsa.goToShow() ng-disabled=!insurantsa.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span>Изменить</span></button> <button ng-click=insurantsa.confirmAction() ng-disabled=\"!insurantsa.selected_policy || insurantsa.selected_policy.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=insurantsa.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=insurantsa.policiesGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/insurantsa/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=wrapper><header class=main-header><!-- Logo--><a ui-sref=app.dashboard class=logo><!-- mini logo for sidebar mini 50x50 pixels--><span class=logo-mini><b>АЮ</b></span> <!-- logo for regular state and mobile devices--><span class=logo-lg><b>АЮ</b>Гарант</span></a><!-- Header Navbar: style can be found in header.less--><nav class=\"navbar navbar-static-top\"><!-- Sidebar toggle button--><a data-toggle=push-menu role=button class=sidebar-toggle><span class=sr-only>Toggle navigation</span><span class=icon-bar><i class=\"fa fa-bars\"></i></span><span class=icon-bar><i class=\"fa fa-bars\"></i></span><span class=icon-bar><i class=\"fa fa-bars\"></i></span></a><div class=navbar-custom-menu><ul class=\"nav navbar-nav\"><li class=\"dropdown user user-menu\"><a data-toggle=dropdown class=dropdown-toggle><img src=assets/img/ayu-logo.svg alt=\"User Image\" class=user-image><span class=hidden-xs>{{app.ua.data.surname}} {{app.ua.data.name}}</span></a><ul class=dropdown-menu><!-- User image--><li class=user-header><img src=assets/img/ayu-logo.svg alt=\"User Image\" class=img-circle><p>{{app.ua.data.surname}} {{app.ua.data.name}}<small>@{{app.ua.username}} &bull; {{app.ua.rec_date | amDateFormat:\'MMMM DD, YYYY, HH:mm:ss\'}}</small></p></li><!-- Menu Body--><li class=user-body></li><li class=user-footer><div class=pull-left><a ui-sref=app.profile.view class=\"btn btn-default btn-flat\">Профиль</a></div><div class=pull-right><a ng-click=app.logOut() class=\"btn btn-default btn-flat\">Выход</a></div></li></ul></li></ul></div></nav></header><aside class=main-sidebar><div class=sidebar><div class=user-panel><div class=\"pull-left image\"><img src=assets/img/ayu-logo.svg alt=\"User Image\" class=img-circle></div><div class=\"pull-left info\"><p>{{app.ua.username}}</p></div></div><div id=sidebar-menu side-nav class=\"main_menu_side hidden-print main_menu\"><ul class=\"nav side-menu sidebar-menu\"><li ng-repeat=\"menu in app.navigation | orderBy : &quot;data.position&quot;\"><a class=dynamic_menu><i ng-class=menu.data.icon></i><span>{{menu.name}} <span class=\"fa fa-angle-left pull-right\"></span></span></a><ul style=display:block class=\"nav child_menu treeview-menu\"><li ng-repeat=\"child in menu.children | orderBy : &quot;data.position&quot;\"><a ui-sref={{child.data.route}} class=dynamic_menu>{{child.name}}</a></li></ul></li><li ng-repeat=\"menu in app.admin_menu | orderBy : &quot;data.position&quot;\"><a class=admin_menu><i ng-class=menu.data.icon></i><span>{{menu.name}} <span class=\"fa fa-angle-left pull-right\"></span></span></a><ul class=\"nav child_menu treeview-menu\"><!--li--><!--  a(ui-sref=\'app.company\')--><!--    i.fa.fa-home--><!--    span Компании--><li ng-repeat=\"child in menu.children | orderBy : &quot;data.position&quot;\"><a ui-sref={{child.data.route}} class=admin_menu>{{child.name}}</a></li></ul></li></ul></div></div></aside><div role=main class=content-wrapper><ui-view><div style=height:100px class=row></div></ui-view></div><div class=fixed-bottom><div class=pull-right><b>Version</b> 2.3.0</div><strong>Copyright © 2018-2019<a href=http://agi.kg target=_blank> СК АЮ Гарант</a>.</strong> All rights reserved.</div></div>");
$templateCache.put("app/medexpense/main.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Фильтры</h2><div class=clearfix></div></div><div class=x_content><form id=patient-filters name=patient-filters ng-submit=main.searchMedExpenses()><div class=row><div class=col-md-4><div class=form-group><label class=control-label>ФИО:</label><input type=text ng-model=main.filter.fullname class=form-control></div></div><div class=col-md-4><div class=form-group><label class=control-label>Номер полиса:</label><input type=text ng-model=main.filter.policy_no class=form-control></div></div></div><div class=row><div class=col-md-4><div class=form-group><label for=createdFrom class=control-label>Дата создания от:</label><div class=\"input-group no-margin\"><input type=text id=createdFrom name=createdFrom is-open=main.dateOptions.opened1 uib-datepicker-popup=dd.MM.yyyy ng-model=main.filter.created_from close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"main.dateOptions.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-4><div class=form-group><label for=createdTo class=control-label>Дата создания до:</label><div class=\"input-group no-margin\"><input type=text id=createdTo name=createdTo is-open=main.dateOptions.opened2 uib-datepicker-popup=dd.MM.yyyy ng-model=main.filter.created_to close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"main.dateOptions.opened2=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=ln_solid></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><button type=submit class=\"btn btn-primary btn-sm\">Поиск</button> <button type=button ng-click=main.resetFilter() class=\"btn btn-primary btn-sm\">Сбросить фильтры</button></div></div></form></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_content><div class=row><div class=col-md-12><button type=button ng-click=main.searchMedExpenses() class=\"btn btn-default btn-xs\">Обновить</button><!--button.btn.btn-primary.btn-xs(type=\'button\' ng-click=\"\") Добавить--><!--button.btn.btn-primary.btn-xs(type=\'button\' ng-click=\"\" ng-disabled=\"!main.selectedRow.isSelected\") Редактировать--> <button type=button ng-click=main.removeExpense(main.selectedRow.entity) ng-disabled=!main.selectedRow.isSelected class=\"btn btn-danger btn-xs\">Удалить</button></div></div><div class=row><div class=col-md-12><div ui-grid=main.medexpensesGridOptions ui-grid-selection ui-grid-resize-columns ui-grid-move-columns ui-grid-auto-resize class=grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/menu/item.html","<div class=content><div class=row><div class=\"col-lg-12 col-md-12 col-xs-12\"><panel title=\"{{item.menu._id ? &quot;Изменть&quot;:&quot;Добавить&quot;}}\"><form ng-submit=item.putMenu() class=form-horizontal><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Родитель</label></div><div class=\"col col-md-10\"><ui-select ng-model=item.menu.parent_id ng-disabled=item.children.length&gt;0 theme=bootstrap remove-selected=false><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"menu._id as menu in (menu.menus | filter:{name:$select.search} | filter: menu.filterOnlyParents | orderBy:&quot;data.position&quot;) track by menu._id\" ui-disable-choice=\"menu._id==item.menu._id\">{{menu.name}}</ui-select-choices></ui-select></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Наименование</label></div><div class=\"col col-md-10\"><input type=text ng-model=item.menu.name ng-required=true ng-trim=true class=form-control></div></div></div><div ng-hide=item.disabled class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Путь</label></div><div class=\"col col-md-10\"><input type=text ng-model=item.menu.data.route class=form-control></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Позиция</label></div><div class=\"col col-md-10\"><input type=number ng-model=item.menu.data.position ng-required=true class=form-control></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Иконка</label></div><div class=\"col col-md-10\"><div ng-class=\"{&quot;input-group&quot;: item.menu.data.icon}\"><div class=input-group-btn><button ng-if=item.menu.data.icon class=\"btn btn-default\"><i ng-class=item.menu.data.icon></i></button></div><input type=text ng-model=item.menu.data.icon class=form-control></div></div></div></div><button ng-if=item.menu._id class=\"btn btn-primary btm-sm\">Сохранить</button> <button ng-if=!item.menu._id class=\"btn btn-primary btm-sm\">Добавить</button> <button ng-if=item.menu._id ng-click=item.confirmAction(item.menu) class=\"btn btn-danger btm-sm\">Удалить</button></form></panel></div></div></div>");
$templateCache.put("app/menu/menu.html","<div class=content><div class=row><div class=\"col col-lg-3 col-md-3 col-sm-3\"><div class=row><div class=\"col col-md-12\"><button ui-sref=app.menu.item({id:&quot;new&quot;}) class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=menu.getMenus() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><div ng-repeat=\"menu_item in menu.menus | filter: menu.filterOnlyParents | orderBy : &quot;data.position&quot;\" class=list-group><a ui-sref=app.menu.item({id:menu_item._id}) class=list-group-item>{{menu_item.data.position}}) {{menu_item.name}}</a><a ui-sref=app.menu.item({id:child._id}) ng-repeat=\"child in menu.menus | filter:{parent_id:menu_item._id} | orderBy : &quot;data.position&quot;\" class=list-group-item>&#9;{{child.data.position}}. {{child.name}}</a></div></div></div></div><div class=\"col col-lg-9 col-md-9 col-sm-9\"><ui-view></ui-view></div></div></div>");
$templateCache.put("app/modals/confirmation-dialog.html","<div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-default\"><div class=box-header><h3 class=box-title>Окно подтверждения!</h3></div><div class=\"box-body pad table-responsive\">Вы уверены {{policy_dialog.text.text}}</div><div class=box-footer><button id=delete type=button ng-click=policy_dialog.ok() class=\"btn btn-success\">ДА</button> <button type=button ng-click=policy_dialog.cancel() class=\"btn btn-primary\">НЕТ</button></div></div></div></div></div>");
$templateCache.put("app/modals/dialog_parameter.html","<!--Created by troy on 15.12.2016.\n--><div class=container><form ng-submit=term_dialog.ok() class=from-horizontal><div class=\"panel panel-default\"><div class=panel-heading>Окно подтверждения!</div><div class=panel-body><h5>Вы уверены {{term_dialog.text.text}}</h5><div class=form-group><label for=money>Возвращаемая сумма:</label><input id=money type=number ng-model=term_dialog.moneyBack min=0 step=0.01 ng-required=true class=form-control></div></div><div class=panel-footer><button id=delete type=submit class=\"btn btn-success\">Расторгнуть</button> <button type=button ng-click=term_dialog.cancel() class=\"btn btn-primary\">Нет</button></div></div></form></div>");
$templateCache.put("app/modals/search-product.html","<!--Created by jaynakus on 7/18/16.\n--><div class=modal-header><h3>Поиск</h3></div><div class=modal-body><input ng-keyup=pressed($event) ng-model=query ng-model-options={debounce:200} placeholder=Поиск autofocus class=form-control><paged-table id=search options=gridOptions disable-search=true></paged-table><div class=clearfix></div></div><div class=modal-footer><button ng-click=cancel() class=\"btn btn-primary\">Отмена</button> <button ng-click=ok() class=\"btn btn-success\">OK</button></div>");
$templateCache.put("app/news/form.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Создать новость</h2><div class=clearfix></div></div><div class=x_content><form id=news-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=title name=title required ng-model=form.newsItem.title class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><textarea id=description name=description cols=10 rows=5 required ng-model=form.newsItem.description class=\"form-control col-md-7 col-xs-12\"></textarea></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Ссылка<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><textarea id=link name=link width=100 height=80 required ng-model=form.newsItem.link class=\"form-control col-md-7 col-xs-12\"></textarea></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Активный<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=checkbox><label><input type=checkbox checked ng-model=form.newsItem.is_active class=flat></label></div></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Картинка<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--input(type=\"file\", flow-btn)--><file-load file-src=form.newsItem.image type=exp_fk allow=jpg,png></file-load></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=form.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=form.saveNews() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/news/list.html","<div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Новости</h3></div><div class=\"box-body pad table-responsive\"><div class=row><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Название</label><input type=text ng-model=list.searchValues.title class=form-control></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Дата создания от</label><div class=\"input-group no-margin\"><input type=text name=valid_from ng-model=list.searchValues.created_from uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Дата создания до</label><div class=\"input-group no-margin\"><input type=text name=valid_to ng-model=list.searchValues.created_to uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Активный</label><select ng-model=list.searchValues.is_active class=form-control><option value=all>Все</option><option value=yes>Активный</option><option value=no>Неактивный</option></select></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><button type=button ng-click=list.getNews() class=\"btn btn-primary\">Поиск</button> <button type=button ng-click=list.openCreateForm() class=\"btn btn-primary\">Добавить</button> <button type=button ng-click=list.openEditForm() ng-disabled=!list.selectedRow.isSelected class=\"btn btn-primary\">Изменить</button> <button type=button ng-click=list.getNews() class=\"btn btn-default\">Обновить</button><!--button.btn.btn-primary(type=\"button\", ng-click=\"list.openUploadImageForm()\", ng-disabled=\"!list.selectedRow.isSelected\") Загрузать картинку--><div class=margin></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div ui-grid=list.gridOptions ui-grid-selection class=grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/news/uploadimage.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Загрузить картинку</h2><div class=clearfix></div></div><div class=x_content><form id=image-upload-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите картинку<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><label class=\"btn btn-default btn-file\"><input type=file id=file name=file ng-model=uploadimage.newsItem.image hidden></label></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=uploadimage.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=uploadimage.saveImage() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/op/buy.html","<!--Created by jaynakus on 7/18/16.\n--><barcode-listener on-scan=buy.handleScan scan-duration=500 prefix=~></barcode-listener><panel title=Помощь><div class=row><div class=col-xs-12><h2>Для получения информации о быстрых кнопках нажмите на <code>h</code></h2></div></div></panel><panel title=Закуп><section class=\"content invoice\"><div class=row><div class=\"col-xs-12 invoice-header\"><h1 style=\"min-height: 150px\">{{buy.currentItem.data.name}}</h1></div></div><div class=row><div class=\"col-xs-12 table\"><paged-table options=buy.gridOptions disable-paging=true disable-search=true enable-edit=true></paged-table></div></div><div class=row><div class=col-xs-6><h1>{{buy.currentCode}}</h1></div><div class=col-xs-6><h1>Итого: {{buy.total()}}</h1></div></div><div class=ln_solid></div><div class=col-xs-12><div class=\"form-group pull-right\"><button ng-click=buy.cancel() class=\"btn btn-danger\">Отменть</button> <button ng-click=buy.save() class=\"btn btn-success\">Применить</button></div></div></section></panel>");
$templateCache.put("app/op/hist.html","<!--Created by jaynakus on 7/20/16.\n--><panel title=Поиск><form name=searchForm class=\"form-horizontal form-label-left\"><div class=row><div class=col-sm-4><div class=form-group><label for=type class=\"control-label col-md-4\">Тип</label><div class=col-md-8><select id=type ng-model=hist.query.type required class=\"form-control col-md-8\"><option value=sale selected>Продажи</option><option value=purchase selected>Покупки</option></select></div></div></div></div><div class=ln_solid></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button ng-click=hist.find() ng-disabled=searchForm.$invalid class=\"btn btn-success\">Найти</button></div></div></form></panel><panel title=\"История операций\"><paged-table options=hist.gridOptions disable-search=true page=hist.page page-count=hist.page_count></paged-table></panel>");
$templateCache.put("app/op/sale.html","<!--Created by jaynakus on 7/18/16.\n--><barcode-listener on-scan=sale.handleScan scan-duration=500 prefix=~></barcode-listener><panel title=Помощь><div class=row><div class=col-xs-12><h2>Для получения информации о быстрых кнопках нажмите на <code>h</code></h2></div></div></panel><panel title=Продажа><section class=\"content invoice\"><div class=row><div class=\"col-xs-12 invoice-header\"><h1 style=\"min-height: 150px\">{{sale.currentItem.data.name}}</h1></div></div><div class=row><div class=\"col-xs-12 table\"><paged-table options=sale.gridOptions disable-paging=true disable-search=true enable-edit=true></paged-table></div></div><div class=row><div class=col-xs-6><h1>{{sale.currentCode}}</h1></div><div class=col-xs-6><h1>Итого: {{sale.total()}}</h1></div></div><div class=ln_solid></div><div class=col-xs-12><div class=\"form-group pull-right\"><button ng-click=sale.cancel() class=\"btn btn-danger\">Отменть</button> <button ng-click=sale.save() class=\"btn btn-success\">Применить</button></div></div></section></panel>");
$templateCache.put("app/operation/operation.html","<!--\nCreated by Aibek on 26/07/16.\n\n--><panel title=Операции><button ng-click=operation.getOperations() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=operation.gridOptions disable-search=true></paged-table></panel>");
$templateCache.put("app/operation/view.html","<!--Created by Aibek on 25/08/16.\n--><div class=modal-header><h3>Операция</h3></div><div class=modal-body><div class=row-striped><div class=row><div class=\"col col-xs-12 col-md-4\">Филал</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.branch.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доукмент</div><div class=\"col col-xs-12 col-md-8\"><a ui-sref=app.docs.view({id:view.operation.document_id})>{{view.operation.document.title}}</a><p class=small>{{view.operation.document.short_desc}}</p></div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Продукт</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.product.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Единица измерения</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.unit.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Количество</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.quantity | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Валюта</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.currency.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Стоимость</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.quote_unit_price | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Сумма</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.total_cost | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доп. стоимотсь</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.additional_cost | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Статус операции</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.operation_status_value.data.name}}</div></div><div ng-if=view.operation.branch2 class=row><div class=\"col col-xs-12 col-md-4\">Филал назначения</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.branch2.name}}</div></div><div ng-if=view.operation.contractor class=row><div class=\"col col-xs-12 col-md-4\">Контрагент</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.contractor.name}}</div></div><div ng-if=view.operation.is_due class=row><div class=\"col col-xs-12 col-md-4\">В долг</div><div class=\"col col-xs-12 col-md-8\"><input type=checkbox ng-model=view.operation.is_due></div></div><div ng-if=view.operation.is_due class=row><div class=\"col col-xs-12 col-md-4\">Дата выплаты</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.due_date | amDateFormat:\"Do MMMM YYYY\"}}</div></div><div ng-if=view.operation.is_advance class=row><div class=\"col col-xs-12 col-md-4\">Аванс</div><div class=\"col col-xs-12 col-md-8\"><input type=checkbox ng-model=view.operation.is_advance></div></div><div ng-if=view.operation.employee class=row><div class=\"col col-xs-12 col-md-4\">Сотрудник</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.employee.user.username}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Комметарий</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.comment}}</div></div></div></div><div class=modal-footer><button ng-click=view.cancel() class=\"btn btn-default btn-sm\">Закрыть</button></div>");
$templateCache.put("app/operations/operation.html","<!--\nCreated by Aibek on 24/06/16.\n\n--><div class=container><div class=panel><div class=panel-heading><h4>Операция <button ng-click=operation.putOperations() ng-disabled=\"operation.operations.length == 0\" class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-click=operation.goBack() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></h4></div></div><div class=row><div class=\"col col-md-2 col-sm-4\"><div class=list-group><a ng-repeat=\"type in operation.operation_types track by type.key\" ng-class=\"{active:type.key==operation.operation_type.key}\" ui-sref=\"app.main.operation({action:&quot;new&quot;, type:type.key})\" class=list-group-item>{{type.value}}</a></div></div><div class=\"col col-md-10 col-sm-8\"><div class=panel><div class=panel-body><div class=row><div class=\"col col-md-3\"><div class=form-group><label><input type=checkbox ng-model=operation.as_approval><span>&nbsp;Отправить на одобрение</span></label></div></div><div ng-show=operation.as_approval class=\"co col-md-3\"><isteven-multi-select ng-model=operation.approve.roles input-model=operation.roles output-model=operation.outputRoles button-label=name item-label=name tick-property=ticked></isteven-multi-select></div><div ng-show=operation.as_approval class=\"col col-md-3\"><div class=form-group><label>Необходимо одобрение</label><div class=row><div ng-repeat=\"type in operation.approval_types track by type.key\" class=\"col col-md-4 col-sm-6\"><label><input type=radio ng-model=operation.approval.type ng-value=type name=approve_type><span>&nbsp;{{type.value}}</span></label></div></div></div></div></div></div></div><div class=panel><div class=panel-body><div class=row><div class=\"col col-md-4\"><div class=form-group><label>Филиал</label><ui-select ng-model=operation.branch theme=bootstrap remove-selected=false on-select=operation.getCostCenterPurposes()><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"branch in (operation.branches | filter:{name:$select.search} | orderBy:&quot;branch.name&quot;) track by branch._id\"><span ng-bind=branch.name></span></ui-select-choices></ui-select></div></div><div ng-if=\"operation.operation_type.key == &quot;movement&quot;\" class=\"col col-md-4\"><div class=form-group><label>В какой филиал</label><ui-select ng-model=operation.target_branch theme=bootstrap remove-selected=false><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"branch in (operation.branches | filter:{name:$select.search} | orderBy:&quot;branch.name&quot;) track by branch._id\" ui-disable-choice=\"operation.branch._id == branch._id\"><span ng-bind=branch.name></span></ui-select-choices></ui-select></div></div><div ng-if=\"operation.operation_type.key!=&quot;consumption&quot; &amp;&amp; operation.operation_type.key!=&quot;movement&quot;\" class=\"col col-md-4\"><div class=form-group><label>Контрагент</label><ui-select ng-model=operation.contractor theme=bootstrap remove-selected=false><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"contractor in (operation.contractors | filter:{name:$select.search} | orderBy:&quot;contractor.name&quot;) track by contractor._id\"><span ng-bind=contractor.name></span></ui-select-choices></ui-select></div></div><div ng-if=\"operation.operation_type.key==&quot;consumption&quot;\" class=\"col col-md-4\"><div class=form-group><label>Назначение ЦЗ</label><ui-select ng-model=operation.purpose theme=bootstrap remove-selected=false><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"cost_center_purpose in (operation.cost_center_purposes | filter:{name:$select.search} | orderBy:&quot;cost_center_purpose.name&quot;) track by cost_center_purpose._id\"><span ng-bind=cost_center_purpose.name></span></ui-select-choices></ui-select></div></div><div class=\"col col-md-4\"><div class=form-group><label>Исполнитель</label><ui-select ng-model=operation.executor theme=bootstrap remove-selected=false><ui-select-match><span ng-bind=$select.selected.user.username></span></ui-select-match><ui-select-choices repeat=\"agent in (operation.employees | filter:{user:{username:$select.search}} | orderBy:&quot;agent.user.username&quot;) track by agent._id\"><span ng-bind=employee.user.username></span></ui-select-choices></ui-select></div></div><div class=\"col col-md-4\"><div class=form-group><label>Валюта</label><ui-select ng-model=operation.currency theme=bootstrap remove-selected=false><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"currency in (operation.currencies | filter:{name:$select.search} | orderBy:&quot;currency.name&quot;) track by currency._id\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></div><div ng-if=\"operation.operation_type.key!=&quot;consumption&quot;\" class=\"col col-md-4\"><div class=form-group><label>Дата доставки</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy ng-model=operation.delivery_date is-open=operation.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=operation.datePickerDeliveryDate() class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col col-md-4\"><div class=form-group><label>&nbsp;</label><label class=form-control><input type=checkbox ng-model=operation.as_due><span>&nbsp;В долг</span></label></div></div><div ng-if=operation.as_due class=\"col col-md-4\"><div class=form-group><label>Дата выплаты</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy ng-model=operation.due_date is-open=operation.popup_due_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=operation.datePickerDueDate() class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col col-md-4\"><div class=form-group><label>Комментарий</label><textarea ng-model=operation.booking.data.comment class=form-control></textarea></div></div></div></div></div><div class=panel><div class=panel-heading><h4>Продукты <button ng-click=operation.addOperation() class=\"btn btn-primary btn-sm pull-right\"><span class=\"glyphicon glyphicon-plus\"></span><span>Добавить</span></button></h4></div><div class=panel-body><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th>Продукт</th><th>Единица измерения</th><th>Количество</th><th>Цена за единицу</th><th>Дополнительная стоимость</th><th>Общая стоимость</th><th></th></tr></thead><tbody><tr ng-repeat=\"operation_item in operation.operations\"><td>{{operation_item.product.name}}</td><td>{{operation_item.unit.name}}</td><td>{{operation_item.quantity}}</td><td>{{operation_item.quote_unit_price}}</td><td>{{operation_item.additional_cost}}</td><td>{{operation_item.total_cost | number:2}}</td><td><button ng-click=\"operation.editOperation(operation_item, $index)\" class=\"glyphicon glyphicon-pencil\">Изменить</button></td></tr></tbody><tfoot ng-if=\"operation.operations.length &gt; 0\"><tr><th></th><th></th><th></th><th></th><th></th><th></th><th>{{operation.getFooter().total_cost | number:2}}</th><th></th><th></th></tr></tfoot></table></div></div></div></div></div><div id=addOperationModal role=dialog class=\"modal fade\"><div class=\"modal-dialog modal-lg\"><div class=modal-content><div class=modal-body><form ng-submit=operation.putOperation()><div class=row><div class=\"col col-md-4\"><div class=form-group><label>Продукт</label><ui-select ng-model=operation.new_operation.product theme=bootstrap remove-selected=false required on-select=operation.productSelected()><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"product in (operation.products | filter:{name:$select.search} | orderBy:&quot;product.name&quot;) track by product._id\"><span ng-bind=product.name></span></ui-select-choices></ui-select></div></div><div class=\"col col-md-4\"><div class=form-group><label>Единица измерения</label><ui-select ng-model=operation.new_operation.unit theme=bootstrap remove-selected=false required ng-disabled=true><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"unit in (operation.units | filter:{name:$select.search} | orderBy:&quot;unit.name&quot;) track by unit._id\"><span ng-bind=unit.name></span></ui-select-choices></ui-select></div></div><div class=\"col col-md-4\"><div class=form-group><label>Цена/Скидка</label><ui-select ng-model=operation.new_operation.rule theme=bootstrap remove-selected=false><ui-select-match><span ng-if=\"$select.selected._id != 0\"><span ng-if=$select.selected.price>Цена: {{$select.selected.price}}</span><span ng-if=\"$select.selected.price &amp;&amp; $select.selected.discount\">&nbsp;/&nbsp;</span><span ng-if=$select.selected.discount>Скидка: {{$select.selected.discount}}%</span></span><span ng-if=\"$select.selected._id == 0\">Без скидки</span></ui-select-match><ui-select-choices repeat=\"rule in (operation.rules | filter:$select.search | orderBy:&quot;rule.priority&quot;) track by rule._id\"><div ng-if=\"rule._id != 0\" class=row><div class=\"col col-sm-6\"><span>Цена: {{rule.price}}</span></div><div class=\"col col-sm-6\"><span>Приоритет: {{rule.priority}}</span></div><div class=\"col col-sm-6\"><span>Скидка: {{rule.discount}}%</span></div><div class=\"col col-sm-6\"><span>Мин. кол.: {{rule.min_quantity}}</span></div><div class=\"col col-sm-12\"><div class=small>{{operation.dt.toStringDate(rule.valid_from)}} - {{operation.dt.toStringDate(rule.valid_up_to)}}</div></div></div><div ng-if=\"rule._id == 0\" class=row><div class=\"col col-sm-12\">Без скидки</div></div></ui-select-choices></ui-select></div></div><div class=\"col col-md-4\"><div class=form-group><label>Количество</label><input type=number min={{operation.new_operation.unit.data.round}} step={{operation.new_operation.unit.data.round}} ng-model=operation.new_operation.quantity ng-change=operation.calcTotalCost(operation.new_operation);operation.calcUnitPrice(operation.new_operation) required class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Цена за единицу</label><input type=number step=0.01 ng-model=operation.new_operation.quote_unit_price ng-change=operation.calcTotalCost(operation.new_operation) class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Дополнительная стоимость</label><input type=number step=0.01 ng-model=operation.new_operation.additional_cost class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Общая стоимость</label><input type=number ng-model=operation.new_operation.total_cost ng-change=operation.calcUnitPrice(operation.new_operation) class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Комментарий</label><textarea ng-model=operation.new_operation.data.comment class=form-control></textarea></div></div></div><button class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=operation.cancelPutOperation() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></form></div></div></div></div><div id=progressModal role=dialog class=\"modal fade\"><div class=\"modal-dialog modal-lg\"><div class=modal-content><div class=modal-body><div class=panel><div class=panel-body><div class=progress><div role=progressbar aria-valuenow={{operation.progress.value}} aria-valuemin=0 aria-valuemax=100 class=\"progress-bar progress-bar-info progress-bar-striped\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/operations/operation_view.html","<!--\nCreated by Aibek on 06/07/16.\n\n--><div class=container><div class=panel><div class=panel-heading><h4>Операция &bull; {{operation.operation.type.value}}<!--button.btn.btn-primary.btn-sm.pull-right(ng-disabled=\'!operation.canManage\', ng-click=\'operation.completeOperation()\') Принять--><!--button.btn.btn-danger.btn-sm.pull-right(ng-disabled=\'!operation.canManage\', ng-click=\'operation.cancelOperation()\') Отменить--><!--button.btn.btn-default.btn-sm.pull-right(ng-disabled=\'!operation.canManage || !operation.canEdit\', ui-sref=\'app.main.operation_id({id:operation.operation._id, type:operation.type.key, action:\"edit\"})\') Изменить--></h4></div><div class=panel-body><div class=row><div class=\"col col-lg-4 col-md-6 col-sm-8 col-xs-12\"><h5>Операция</h5><table class=\"table table-bordered\"><thead><tr><th class=\"col col-xs-6\">Параметр</th><th>Значение</th></tr></thead><tbody><tr><td>Филиал</td><td>{{operation.operation.branch.name}}</td></tr><tr><td>Продукт</td><td>{{operation.operation.product.name}}</td></tr><tr><td>Единица измерения</td><td>{{operation.operation.unit.name}}</td></tr><tr><td>Количество</td><td>{{operation.operation.quantity | number}}</td></tr><tr><td>Цена за единицу</td><td>{{operation.operation.quote_unit_price | number}}</td></tr><tr><td>Дополнительная стоимость</td><td>{{operation.operation.additional_cost | number}}</td></tr><tr><td>Цена в KGS</td><td>{{operation.operation.cost_kgs | number}}</td></tr><tr><td>Общая стоимость</td><td>{{operation.operation.total_cost | number:2}}</td></tr><tr><td>Валюта</td><td>{{operation.operation.currency.name}}</td></tr><tr><td>Статус</td><td>{{operation.operation.status.value}}</td></tr><tr><td>Тип</td><td>{{operation.operation.type.value}}</td></tr><tr ng-if=operation.operation.contractor><td>Контрагент</td><td>{{operation.operation.contractor.name}}</td></tr><tr ng-if=operation.operation.target_branch><td>В филивл</td><td>{{operation.operation.target_branch.name}}</td></tr><tr ng-if=operation.operation.purpose><td>Назначение в центре затрат</td><td>{{operation.operation.purpose}}</td></tr><tr ng-if=operation.operation.delivery_date><td>Дата доставки</td><td>{{operation.dt.toStringDate(operation.operation.delivery_date)}}</td></tr></tbody></table></div><!--.row.children-border-left--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Филиал--><!--    label {{operation.operation.branch.name}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Продукт--><!--    label {{operation.operation.product.name}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Единица измерения--><!--    label {{operation.operation.unit.name}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Количество--><!--    label {{operation.operation.quantity}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Цена за единицу--><!--    label {{operation.operation.quote_unit_price}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Дополнительная стоимость--><!--    label {{operation.operation.additional_cost}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Цена в KGS--><!--    label {{operation.operation.cost_kgs}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Общая стоимость--><!--    label {{operation.operation.total_cost | number:2}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Валюта--><!--    label {{operation.operation.currency.name}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Статус--><!--    label--><!--      span.fa.fa-circle(ng-class=\'operation.operation.status.key\')--><!--      span &nbsp;{{operation.operation.status.value}}--><!--  .col.col-lg-2.col-md-3.col-sm-6(ng-if=\'operation.operation.contractor\')--><!--    .text-muted Контрагент--><!--    label {{operation.operation.contractor.name}}--><!--  .col.col-lg-2.col-md-3.col-sm-6(ng-if=\'operation.operation.target_branch\')--><!--    .text-muted В филивл--><!--    label {{operation.operation.target_branch.name}}--><!--  .col.col-lg-2.col-md-3.col-sm-6(ng-if=\'operation.operation.purpose\')--><!--    .text-muted Назначение в центре затрат--><!--    label {{operation.operation.purpose}}--><!--  .col.col-lg-2.col-md-3.col-sm-6(ng-if=\'operation.operation.delivery_date\')--><!--    .text-muted Дата доставки--><!--    label {{operation.operation.delivery_date}}--><div ng-if=operation.approval class=\"col col-lg-4 col-md-6 col-sm-8 col-xs-12\"><h5>Одобрение<a ui-sref=app.main.approval_view({id:operation.approval._id}) class=\"pull-right small\">Показать</a></h5><table class=\"table table-bordered\"><thead><tr><th class=\"col col-xs-6\">Параметр</th><th>Значение</th></tr></thead><tbody><tr><td>Статус одобрения</td><td>{{operation.approval.status.value}}</td></tr><tr><td>Необходмио одобрение</td><td>{{operation.approval.type.value}}</td></tr><tr><td>Роли</td><td><span ng-repeat=\"role in operation.approval.roles\">{{!$first ? \', \':\'\'}}{{role.data.approval_name}}</span></td></tr></tbody></table></div><!--.row.children-border-left--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Опции--><!--    label--><!--      a(ui-sref=\'app.main.approval_view({id:operation.approval._id})\') Показать--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Статус одобрения--><!--    label--><!--      span.fa.fa-circle(ng-class=\'operation.approval.approve_status\')--><!--      span &nbsp;{{operation.approval.status.value}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Необходмио одобрение--><!--    label {{operation.approval.type.value}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Роли--><!--    label(ng-repeat=\'role in operation.approval.roles\') {{!$first ? \', \':\'\'}}{{role.data.approval_name}}--><div ng-if=operation.booking class=\"col col-lg-4 col-md-6 col-sm-8 col-xs-12\"><h5>Booking<a ui-sref=app.main.booking_view({id:operation.booking._id}) class=\"pull-right small\">Показать</a></h5><table class=\"table table-bordered\"><thead><tr><th class=\"col col-xs-6\">Параметр</th><th>Значение</th></tr></thead><tbody><tr><td>Booking статус</td><td>{{operation.booking.status.value}}</td></tr><tr><td>Booking тип</td><td>{{operation.booking.type.value}}</td></tr></tbody></table></div><!--.row.children-border-left--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Опции--><!--    label--><!--      a(ui-sref=\'app.main.booking_view({id:operation.booking._id})\') Показать--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Booking статус--><!--    label--><!--      span.fa.fa-circle(ng-class=\'operation.booking.status.key\')--><!--      span &nbsp;{{operation.booking.status.value}}--><!--  .col.col-lg-2.col-md-3.col-sm-6--><!--    .text-muted Booking тип--><!--    label {{operation.booking.type.value}}--></div></div></div></div>");
$templateCache.put("app/operations/operations.html","<!--\nCreated by Aibek on 24/06/16.\n\n--><div class=container><div class=panel><div class=panel-heading><h4>Операции <button ng-click=operations.getOperations() class=\"btn btn-default btn-sm pull-right\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button ng-click=operations.getOperations() class=\"btn btn-primary btn-sm pull-right\"><span class=\"glyphicon glyphicon-filter\"></span></button></h4></div></div><div class=row><div class=\"col col-md-2 col-sm-4\"><div class=list-group><a ng-repeat=\"type in operations.operation_types\" ui-sref=\"app.main.operation({action:&quot;new&quot;, type:type.key})\" class=list-group-item>{{type.value}}</a></div></div><div class=\"col col-md-10 col-sm-8\"><div class=panel><div class=panel-body><div class=table-responsive><table ng-table-dynamic=\"operations.tableParams with operations.columns\" class=\"table table-bordered table-striped table-hover\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><span ng-if=\"col.dataType!=&quot;action&quot;\"><span ng-class=row.status.key ng-if=\"col.valueExpr==&quot;status.value&quot;\" class=\"fa fa-circle\"></span><span ng-if=\"col.valueExpr==&quot;status.value&quot;\">&nbsp;</span><span>{{$eval(col.valueExpr, row)}}</span></span><span ng-if=\"col.dataType==&quot;action&quot;\"><a ui-sref=app.main.operation_view({id:row._id})>Просмотр</a></span></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/patient/edit.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Пациент</h2><div class=clearfix></div></div><div class=x_content><form id=patient-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">ФИО:<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text ng-model=edit.patient.fullname class=form-control></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Дата рождения:</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input type=text id=exam_date name=datemask ng-model=edit.patient.birthday ng-required=false uib-datepicker-popup=dd.MM.yyyy is-open=edit.dateOptions.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.dateOptions.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Степень родства:<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><select ng-model=edit.patient.relative_degree_id ng-required=true ng-options=\"relDegree._id as relDegree.name for relDegree in edit.dirRelativeDegrees\" class=form-control></select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Номер полиса:<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><ui-select id=policy_id name=policy_id ng-model=edit.patient.policy_id ng-required=true class=\"form-control col-md-7 col-xs-12\"><ui-select-match>{{$select.selected.policy_no}} (продукт: {{ $select.selected.product }}; лимит: {{ $select.selected.amount }})</ui-select-match><ui-select-choices refresh=edit.searchPolicy($select.search) ng-init=edit.searchPolicy(edit.patient.policy_no) repeat=\"policy._id as policy in edit.policies | filter: {policy_no: $select.search}\"><div ng-bind-html=\"policy.policy_no | highlight: $select.search\"></div><div>продукт: {{ policy.product }}; лимит: {{ policy.amount }}</div></ui-select-choices></ui-select></div></div><div class=ln_solid></div><div class=form-group><div class=\"col-md-9 col-sm-9 col-xs-12 col-md-offset-3\"><button ng-click=edit.goBack() class=\"btn btn-default\">Отмена</button> <button ng-click=edit.savePatient() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/patient/import-modal.html","<div class=modal-header><div class=modal-title><h3>Импорт пациентов</h3></div></div><div class=modal-body><div class=container><div class=row><div class=\"col-sm-12 pull-left\">Выберите файл (только форматы: .xls, xlsx)</div></div><div class=row><div class=\"col-sm-12 pull-left\"><js-xls onread=readWorkbook onerror=onWorkbookLoadError></js-xls><br></div></div><div class=row><div class=col-sm-12><div ui-grid=patientGridOptions ui-grid-resize-columns ui-grid-auto-resize ui-grid-move-columns class=grid></div></div></div></div></div><div class=modal-footer><button type=button ng-click=cancel() ng-disabled=disabled class=\"btn btn-default\">Отмена</button> <button type=button ng-click=ok() ng-disabled=disabled class=\"btn btn-primary\">Принять</button></div>");
$templateCache.put("app/patient/main.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Фильтры</h2><div class=clearfix></div></div><div class=x_content><form id=patient-filters name=patient-filters ng-submit=main.searchPatient()><div class=row><div class=col-md-4><div class=form-group><label class=control-label>ФИО:</label><input type=text ng-model=main.filter.fullname class=form-control></div></div><div class=col-md-4><div class=form-group><label class=control-label>Номер полиса:</label><input type=text ng-model=main.filter.policy_no class=form-control></div></div><div class=col-md-4><div class=form-group><label class=control-label>Род. связь:</label><select ng-model=main.filter.relative_degree_id ng-options=\"relDegree._id as relDegree.name for relDegree in main.dirRelativeDegrees\" class=form-control></select></div></div></div><div class=ln_solid></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><button type=submit class=\"btn btn-primary btn-sm\">Поиск</button> <button type=button ng-click=main.resetFilter() class=\"btn btn-primary btn-sm\">Сбросить фильтры</button></div></div></form></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_content><div class=row><div class=col-md-12><button type=button ng-click=main.searchPatient() class=\"btn btn-default btn-xs\">Обновить</button> <button type=button ng-click=main.openAddForm() class=\"btn btn-primary btn-xs\">Добавить</button> <button type=button ng-click=main.openEditForm() ng-disabled=!main.selectedRow.isSelected class=\"btn btn-primary btn-xs\">Редактировать</button> <button type=button ng-click=main.openImportModal() class=\"btn btn-primary btn-xs\">Импортировать</button></div></div><div class=row><div class=col-md-12><div ui-grid=main.patientGridOptions ui-grid-selection ui-grid-resize-columns ui-grid-move-columns ui-grid-auto-resize class=grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/payment/edit.html","<!--Created by Aibek on 25/08/16.\n--><form ng-submit=edit.savePayment()><div class=modal-header><h3>Платеж</h3></div><div class=modal-body><div class=form-horizontal><div class=row><col-responsive><div stock-dict=edit.branches dict-table=Branches class=form-group><label>Филиал</label><ui-select ng-model=edit.payment.branch_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"branch._id as branch in edit.branches track by branch._id\">{{branch.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=edit.payment.currency_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"currency._id as currency in edit.currencies track by currency._id\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.payment_directions dict-table=Enums dict-filter={name:&quot;payment_direction&quot;} class=form-group><label>Направление платежа</label><ui-select ng-model=edit.payment.payment_direction ng-required=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_direction.data.key as payment_direction in edit.payment_directions track by payment_direction.data.key\">{{payment_direction.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.payment_types dict-table=Enums dict-filter={name:&quot;payment_type&quot;} class=form-group><label>Тип платежа</label><ui-select ng-model=edit.payment.payment_type ng-required=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_type.data.key as payment_type in edit.payment_types track by payment_type.data.key\">{{payment_type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number step=0.01 min=0 ng-model=edit.payment.amount ng-required=true class=form-control></div></col-responsive><col-responsive><div ng-class={&quot;has-error&quot;:payment.contractor_error} class=form-group><label>Контрагент</label><contractor-select contractor-id=edit.payment.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div ng-class={&quot;has-error&quot;:payment.employee_error} class=form-group><label>Сотрудник</label><employee-select employee-id=edit.payment.data.employee_id></employee-select></div></col-responsive><col-responsive><div stock-dict=edit.branches dict-table=Branches ng-class={&quot;has-error&quot;:payment.branch_error} class=form-group><label>Филиал назначения</label><ui-select ng-model=edit.payment.data.branch_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"branch._id as branch in edit.branches track by branch._id\">{{branch.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=edit.payment.data.comment ng-trim=true class=form-control></textarea></div></col-responsive></div></div></div><div class=modal-footer><button ng-disabled=\"edit.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"edit.saving===true\" type=button ng-click=edit.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/payment/payment.html","<!--\nCreated by Aibek on 26/07/16.\n\n--><panel title=Платежи><button ng-click=payment.newPayment() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!payment.selected_payment ng-click=payment.editPayment() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=payment.getPayments() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=payment.gridOptions disable-search=true></paged-table></panel>");
$templateCache.put("app/payment/view.html","<!--Created by Aibek on 25/08/16.\n--><div class=modal-header><h3>Платеж</h3></div><div class=modal-body><div class=row-striped><div class=row><div class=\"col col-xs-12 col-md-4\">Филал</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.branch.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доукмент</div><div class=\"col col-xs-12 col-md-8\"><a ui-sref=app.docs.view({id:view.payment.document_id})>{{view.payment.document.title}}</a><p class=small>{{view.payment.document.short_desc}}</p></div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Валюта</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.currency.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Сумма</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.amount | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Дата платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_date | amDateFormat: \'Do MMMM YYYY\'}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Направление платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_direction_value.data.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Тип платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_type_value.data.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Статус платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_status_value.data.name}}</div></div><div ng-if=view.payment.branch2 class=row><div class=\"col col-xs-12 col-md-4\">Филал назначения</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.branch2.name}}</div></div><div ng-if=view.payment.contractor class=row><div class=\"col col-xs-12 col-md-4\">Контрагент</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.contractor.name}}</div></div><div ng-if=view.payment.employee class=row><div class=\"col col-xs-12 col-md-4\">Сотрудник</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.employee.user.username}}</div></div></div></div><div class=modal-footer><button ng-click=view.cancel() class=\"btn btn-default btn-sm\">Закрыть</button></div>");
$templateCache.put("app/policy/form.html","<!--\nCreated by troy on 24.11.2016.\n\n--><div class=container><!--pre {{forming.policy.insurance_data|json}}--><div class=row><div class=col-md-12><button type=button ui-sref=app.policy class=\"btn btn-warning\">Выход</button> <button type=button ng-click=forming.confirmActionSave() class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-floppy-o\"></i> Сохранить</button> <button type=button ng-click=forming.confirmActionForm() ng-disabled=\"!forming.policy.insurance_premium || forming.policy.insurance_premium &lt;= 0\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div><div class=row><div class=col-md-6><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Основные данные</h4></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><td>Номер полиса</td><td>{{forming.policy.policy_no}}</td></tr><tr><td>Продукт</td><td>{{forming.policy.product}}</td></tr><tr><td>Компания</td><!--td(ng-if=\"forming.policy.product && forming.policy.product.company\") {{forming.policy.product.company.name}}--><td ng-if=forming.policy.company>{{forming.policy.company}}</td></tr><tr><td>Страны</td><td><ui-select ng-model=forming.policy.insurance_data.country_id on-select=forming.reCompute() on-remove=forming.reCompute() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in forming.countries | filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></td></tr><tr><td>Начало</td><td><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=forming.reCompute() ng-model=forming.policy.insurance_data.date_start is-open=forming.isOpen1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.isOpen1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><td>Конец</td><td><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=forming.reCompute() ng-model=forming.policy.insurance_data.date_end is-open=forming.isOpen2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.isOpen2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr stock-dict=forming.currencies dict-table=Currencies><td>Сумма страховки</td><!--td {{forming.policy.insurance_amount}}--><!--  span--><!--    |   {{forming.currency_name}}--><td><div class=row><div stock-dict=forming.insurance_amounts dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=col-md-10><div class=form-group><label ng-repeat=\"IM in forming.insurance_amounts\" ng-if=forming.ifLessThanMin(IM) class=radio-inline><input type=radio ng-model=forming.policy.insurance_amount ng-value=IM.data.key name=IMradio ng-change=forming.reCompute()>{{IM.data.name}} {{forming.currency_name}}</label></div></div></div></td></tr><tr><td>Премия страховки</td><td>{{forming.policy.insurance_premium}} {{forming.currency_name}} / {{forming.policy.data.insurance_premium_kgs}} KGS</td></tr></tbody></table></div></div></div><div stock-dict=forming.services dict-table=Services class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Сервисы</h4></div><div class=panel-body><ul class=list-group><li ng-repeat=\"service_id in forming.policy.product.services_id\" class=list-group-item><span ng-repeat=\"service in forming.services | filter:{_id:service_id}\">{{service.name}}</span></li></ul></div></div></div></div></div><div class=col-md-6><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Данные клиента</h4></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><td>Имя</td><td><input type=text ng-model=forming.policy.client.name ng-required=true ng-trim=true class=form-control></td></tr><tr><td>Фамилия</td><td><input type=text ng-model=forming.policy.client.surname ng-required=true ng-trim=true class=form-control></td></tr><tr><td>Дата рождения</td><td><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy ng-change=forming.reCompute() ng-model=forming.policy.client.date_of_birth is-open=forming.isOpen3 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.isOpen3 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><td>Номер паспорта</td><td><input type=text ng-model=forming.policy.client.passport_no ng-required=true ng-trim=true class=form-control></td></tr></tbody></table></div></div></div><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4>Факторы</h4></div><div class=panel-body><ul class=list-group><li ng-repeat=\"factor in forming.product.factorListing\" class=list-group-item><h5>{{factor.name}}</h5><div class=container><div class=form-group><ui-select ng-model=forming.policy.insurance_data.factors[factor.name] on-select=forming.reCompute(factor.name) ng-required=true ng-disabled=\"factor.name == \'Возраст\'\" class=form-control><ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices></ui-select></div></div></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/policy/issue.html","<!--\nCreated by ilias on 07.10.2016.\n\n--><div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=\"box-body pad table-responsive\"><form ng-submit=issue.confirmAction() class=from-horizontal><div class=row><div class=col-md-12><button type=button ui-sref=app.policy_select class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Изменить полис</button><div class=\"panel panel-default\"><div class=panel-heading><h2 style=display:inline>Ваш страховой полис</h2></div><!--.panel-body(stock-dict=\'issue.currencies\' dict-table=\'Currencies\')--><div class=panel-body><table class=\"table table-striped\"><thead></thead><tbody><tr><td>Страховщик</td><td>{{issue.product.company[0].name}}</td></tr><tr ng-if=\"issue.company.company_type == \'agent\'\"><td>Агент страховой компании</td><td>{{issue.company.name}} Телефон {{issue.company.data.phones[0]}}</td></tr><tr><td>Период действия страхового полиса</td><td>с {{issue.product.tmp_product.date_start | date:\'dd-MM-yyyy\'}} по {{issue.product.tmp_product.date_end | date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Продукт</td><td>{{issue.product.name}}</td></tr><tr><td>Страна поездки</td><td><span ng-repeat=\"x in issue.countriesView\">{{x.name}} <mark>({{x.data.name_eng}})</mark></span></td></tr><tr><td>Страховая сумма</td><td><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><label ng-if=\"issue.min_insurance!=null\">{{issue.product.insurance_amount}}<span> {{issue.currency_name}}</span></label><label ng-if=\"issue.min_insurance==null\">0</label><a data-toggle=collapse data-target=#collapse1 ng-click=issue.pdrobneeIconCnange() style=cursor:pointer class=pull-right><i ng-class=issue.pdrobneeIcon aria-hidden=true></i> Сервисы</a></h4></div><div id=collapse1 class=\"panel-collapse collapse\"><div class=panel-body><ul><li ng-repeat=\"service in issue.product.services | filter:{ insurance_sum: issue.product.insurance_amount }\">{{service.service_name}} - {{service.data.limit}}</li></ul></div></div></div></td></tr><tr ng-repeat=\"x in issue.insurants\"><td>Стоимость страхового полиса ({{$index+1}}-го)</td><td><h4 ng-if=\"x.theprice!=null\">{{x.theprice}} {{issue.currency_name}} / {{x.currency_value.toFixed(0)}} KGS</h4><span class=small>(курс валют: 1 {{issue.currency_name}}: {{(issue.currencyRate)}} KGS)</span><h4 ng-if=\"x.theprice==null\">0</h4></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h2>Путешественники (застрахованные)</h2></div><div class=panel-body><div ng-repeat=\"x in issue.insurants\" class=row><div class=col-md-4><div class=row><div class=col-md-6><div class=form-group><label>Фамилия<br><em>Латиницей</em></label><input type=text ng-model=x.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-6><div class=form-group><label>Имя<br><em>Латиницей</em></label><input type=text ng-model=x.name ng-required=true ng-trim=true class=form-control></div></div></div></div><div class=col-md-2><div class=form-group><label><br>Дата рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=issue.reCompute(x) max-date=issue.today min-date=issue.minDay uib-datepicker-popup=dd.MM.yyyy ng-model=x.date_of_birth is-open=x.isOpen close-text=Закрыть current-text=Сегодня clear-text=Очистить ng-required=true class=form-control><span class=input-group-btn><button type=button ng-click=\"x.isOpen = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-2><div class=form-group><label><br>Паспорт №</label><input type=text ng-model=x.passport_no ng-trim=true class=form-control></div></div><div stock-dict=issue.sports dict-table=Factors dict-filter={usage:&quot;sport&quot;} class=col-md-2><div class=form-group><label><br>Индивидуальные условия</label><ui-select ng-model=x.factor_sport on-select=issue.reCompute(x) ng-required=true class=form-control><ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in issue.sports[0].values | filter: $select.search | orderBy:&quot;type&quot;\">{{type}}</ui-select-choices></ui-select></div></div><div class=col-md-1><div class=form-group><label><br>Закрыть</label><div class=\"input-group no-margin\"><span class=input-group-btn><button style=\"margin-left: 20px\" ng-click=issue.deleteInsurant($index) type=button class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span></div></div></div></div><div class=row><div class=col-md-2><button type=button ng-click=issue.addInsurant() class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить путешественника</button></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h2>Покупатель (страхователь)</h2></div><div class=panel-body><div class=row><div class=col-md-2><div class=form-group><label>Фамилия<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-2><div class=form-group><label>Имя<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.name ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-3><div class=form-group><label><br>Телефон</label><input type=text ui-mask=0(999)999-999 ng-model=issue.buyer.phone ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-2><div class=form-group><button type=submit class=\"btn btn-primary\">Оформить полис</button></div></div></div></div></div></div></div></form></div></div></div></div></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"width: 450px;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"factor in x.factorListing\" ng-if=\"factor.name != \'Возраст\'\" class=\"list-group-item\"><a ng-if=\"factor.description != null &amp;&amp; service.data.description != \'\'\"><i uib-tooltip=\"{{factor.description}}\" class=\"fa fa-info-circle\"></i></a><a id=\"headingOne{{$index}}\" role=\"tab\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#collapseOnefer{{$index}}\" aria-expanded=\"false\" aria-controls=\"collapseOne\" style=\"cursor:pointer;\" class=\"panel-heading collapsed\"><i aria-hidden=\"true\" style=\"color: #2f3233; font-size: 130%;\" class=\"fa fa-chevron-down\"></i> {{factor.name}}\n          <mark><span style=\"text-decoration-color: red; text-decoration-line: underline; text-decoration-style: dotted;\">: {{x.factors[factor.name]}}</span></mark></a>\n        <div id=\"collapseOnefer{{$index}}\" role=\"tabpanel\" aria-labelledby=\"headingOne\" aria-expanded=\"false\" style=\"height: 0px;\" class=\"panel-collapse collapse\">\n          <div class=\"panel-body\">\n              <div class=\"form-group\">\n                <ui-select ng-model=\"x.factors[factor.name]\" on-select=\"issue.reCompute(x)\" ng-required=\"true\" class=\"form-control\">\n                  <ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match>\n                  <ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices>\n                </ui-select>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/policy/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/policy/policy.html","<div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Полисы</h3></div><div class=\"box-body pad table-responsive\"><form ng-submit=policy.getPolicies()><div class=row><col-responsive stock-dict=policy.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=policy.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in policy.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"policy.company.company_type !=\'agent\'\"><div class=form-group><label>Агенты:</label><ui-select ng-model=policy.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in policy.agents |filter:{name:$select.search}\">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=policy.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Имя застрахованного:</label><input type=text ng-model=policy.filter.name placeholder=\" Введите имя\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Фамилия застрахованного:</label><input type=text ng-model=policy.filter.surname placeholder=\"Введите фамилию\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата выдачи:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy ng-model=policy.filter.issue_date ng-click=\"policy.filter.popup_to_date.opened=true\" is-open=policy.filter.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policy.filter.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"policy.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button type=button ng-click=policy.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!policy.selected_policy\' ng-click=\'policy.editBranch()\')--> <button ng-click=policy.goToShow() ng-disabled=!policy.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'policy.delete()\' ng-disabled=\"!policy.selected_policy\")--> <button ng-click=policy.confirmAction() ng-disabled=\"!policy.selected_policy || app.ua.role == 10\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=policy.downloadPDF() ng-disabled=\"!policy.selected_policy || policy.selected_policy.policy_no == \'00000\' || (policy.selected_policy.data.status != \'Оформлен\' &amp;&amp; policy.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Полис с печатью</button> <button type=button ng-click=policy.downloadPDF3() ng-disabled=\"!policy.selected_policy || policy.selected_policy.policy_no == \'00000\' || (policy.selected_policy.data.status != \'Оформлен\' &amp;&amp; policy.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Полис без печати</button> <button type=button ng-click=policy.savePDF() ng-disabled=!policy.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Скачать pdf</button> <button type=button ng-click=policy.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=policy.policiesGridOptions disable-search=true height=700></paged-table></div></div></div></div></div>");
$templateCache.put("app/policy/select.html","<!--Created by troy on 07.10.2016.\n--><div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=box-body><div class=row><div class=\"col col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div ng-repeat=\"x in select.productsList | orderBy:\'data.order\'\" ng-if=\"x.theprice!=null\" class=\"panel panel-default\"><div class=panel-body><div class=\"row text-center\"><div class=\"col col-md-12 col-lg-12 col-xs-12\"><h4 class=text-center>{{x.name}}</h4></div></div><div class=\"row text-center\"><div class=\"col col-md-3 col-lg-3 col-xs-12\"><div style=\"width: 100%;height:100px;max-width: 180px;display: inline-block\"><img ng-src=/assets/images/small_logo.png style=max-width:100% class=media-object></div></div><div class=\"col col-md-3 col-lg-3 col-xs-12\"><a data-toggle=collapse data-target=#demo{{$index}} ng-click=select.changeIcon($index) class=\"btn btn-link\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i> Подробнее</a></div><div class=\"col col-md-3 col-lg-3 col-xs-12\"><h4><span style=\"background-color: #80e5ff; color:#000000\" class=badge>{{x.name == \'BUSINESS\' ? 5 : x.name == \'PREMIUM\' ? 10 : x.name == \'VIP\' ? 13 : 0}}</span> опций</h4></div><div class=\"col col-md-3 col-lg-3 col-xs-12\"><h3><span ng-if=\"x.theprice!=null\">{{x.theprice}} {{select.currency_name}}</span><span class=small> {{(x.theprice * (select.currencyRate1)).toFixed(0)}} KGS</span><span ng-if=\"x.theprice==null\">0</span></h3><button type=button ng-click=select.goToIssue(x) ng-disabled=\"x.theprice==null\" class=\"btn btn-info\">Оформить</button></div></div><div class=row><div class=\"col col-md-12 col-lg-12\"><div id=demo{{$index}} class=collapse><div class=row><div class=col-xs-3><!-- required for floating--><!-- Nav tabs--><ul class=\"nav nav-pills nav-stacked\"><li><a data-toggle=tab data-target=#menu1{{$index}}>Ассистанс</a></li><li ng-hide=true><a data-toggle=tab data-target=#menu3{{$index}}>Франшиза</a></li><li><a data-toggle=tab data-target=#menu4{{$index}}>Правила страхования</a></li><li><a data-toggle=tab data-target=#menu5{{$index}}>Объем покрытия</a></li></ul></div><div class=col-xs-9><!-- Tab panes--><div class=tab-content><div id=menu1{{$index}} class=tab-pane><p><a target=_blank href=https://savitar-gr.com/ >ООО «Савитар Групп»</a></p></div><div id=menu3{{$index}} class=tab-pane><p>{{x.company.data.franchise}}</p></div><div id=menu4{{$index}} class=tab-pane><p><a ng-href=assets/documents/new.pdf target=_blank>Правила страхования ВЗР от 12.04.2022г</a></p></div><div id=menu5{{$index}} class=tab-pane><p ng-repeat=\"service in x.services | filter:{ insurance_sum: select.insurance_amount }\">{{service.service_name}} - {{service.data.limit}}</p></div></div></div><div class=clearfix></div></div></div></div></div></div></div></div><!--    Right side bar--><div class=\"col col-xs-12 col-sm-12 col-md-5 col-lg-5\"><div class=row><div class=col-md-10><div class=form-group><label>Укажите страну поездки</label><ui-select ng-model=select.product.country_id on-remove=select.recalculateOnEventAll() on-select=select.recalculateOnEventAll() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in select.countries| filterCountries:$select.search | orderBy:&quot;name&quot; \">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Выберите тип полиса и укажите даты поездки</label></div></div></div><div class=row><div class=col-md-10><div class=form-group><div role=group class=btn-group><button type=button ng-click=select.changedRadio(1) ng-class=\"{\'active\':select.selectedtab === \'raw\'}\" class=\"btn btn-primary\">Однократный</button> <button type=button ng-click=select.changedRadio(2) ng-class=\"{\'active\':select.selectedtab === \'summary\'}\" class=\"btn btn-primary\">Многократный</button></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.period.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-4><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=\"select.color.name == 2\" uib-datepicker-popup=dd.MM.yyyy min-date=select.period.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.period.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=\"select.color.name == 2\" ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-4><div class=form-group><label>Кол-во дней:</label><p>{{select.diffDays}}</p></div></div></div><div class=row><div stock-dict=select.insurance_amounts dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=col-md-10><div class=form-group><label>Страховая сумма: {{select.insurance_amount}}</label><br><label ng-repeat=\"IM in select.insurance_amounts | orderBy : select.sorterFunc\" ng-if=select.ifLessThanMin(IM) class=radio-inline><input type=radio ng-model=select.insurance_amount ng-value=IM.data.key name=IMradio ng-change=select.recalculateOnEvent()>{{IM.data.name}} {{select.currency_name}}</label></div></div></div><div class=row><div stock-dict=select.sports dict-table=Factors dict-filter={usage:&quot;sport&quot;} class=col-md-10><div class=form-group><label>Индивидуальные условия</label><ui-select ng-model=select.sport on-select=select.recalculateOnEvent() ng-required=true class=form-control><ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in select.sports[0].values | filter: $select.search | orderBy:&quot;type&quot;\">{{type}}</ui-select-choices></ui-select></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/policy/show.html","<div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=box-body><div class=col-md-12><div class=\"box box-default\"><div class=box-header><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=box-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'show.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount}} {{show.currency_name}}<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium}} {{show.policy.data.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in show.policy.insurance_data.country_id\"><span ng-repeat=\"country in show.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{show.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{show.policy.product}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{show.policy.client.surname}} {{show.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{show.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{show.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=show.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in show.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in show.product.services_id\" class=list-group-item><span ng-repeat=\"service in show.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=box-footer><button type=button ng-click=show.goToPolicy() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\'\" ng-disabled=\"show.policy.policy_no == \'00000\' || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"show.confirmActionTerm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\")--><!--  i.fa.fa-thumbs-o-down(aria-hidden=\'true\')--><!--  |   Расторгнуть--> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div></div></div>");
$templateCache.put("app/policy/view.html","<div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=box-body><div class=col-md-12><div class=\"box box-default\"><div class=box-header><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{view.policy.policy_no}}</span></h4></div><div class=box-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{view.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{view.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'view.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{view.policy.insurance_amount}} {{view.currency_name}}<!--span( ng-repeat=\"country in view.countries| filter: {_id: view.currentCountryId}\" ng-if=\"view.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in view.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{view.policy.insurance_premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in view.countries| filter: {_id: view.currentCountryId}\" ng-if=\"view.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in view.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in view.policy.insurance_data.country_id\"><span ng-repeat=\"country in view.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{view.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{show.policy.product}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{view.policy.client.surname}} {{view.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{view.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{view.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=view.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in view.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in view.product.services_id\" class=list-group-item><span ng-repeat=\"service in view.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=box-footer><button type=button ng-click=view.goToPolicy() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\' || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div></div></div>");
$templateCache.put("app/policya/expense.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Расход</h2><div class=clearfix></div></div><div class=x_content><!--form.form-horizontal.form-label-left(id=\"expense-form\")--><div id=expense-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Пациент:<span class=required>*</span></label><div class=\"col-md-4 col-sm-6 col-xs-12\"><ui-select id=patient_id name=patient_id ng-model=expense.buffer.patient_id ng-required=true class=\"form-control col-md-7 col-xs-12\"><ui-select-match>{{$select.selected.fullname}} ({{ $select.selected.relative_degree }})</ui-select-match><ui-select-choices ng-init=expense.searchPatient(expense.selectedPolicy._id) repeat=\"patient._id as patient in expense.patients | filter: {fullname: $select.search}\"><div ng-bind-html=\"patient.fullname | highlight: $select.search\"></div><div>{{ patient.relative_degree }}</div></ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Дата осмотра:<span class=required>*</span></label><div class=\"col-md-4 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input type=text id=exam_date name=datemask ng-model=expense.buffer.exam_date ng-required=true uib-datepicker-popup=dd.MM.yyyy is-open=expense.dateOptions.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"expense.dateOptions.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Услуги:<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--ui-select.form-control.col-md-7.col-xs-12(id=\"service_category\", name=\"service_category\"--><!--search-enabled=\"true\" ng-model=\'expense.buffer.category_id\' ng-required=\'true\' on-select=\"expense.getServiceList(expense.buffer.category_id)\")--><!--  ui-select-match(placeholder=\"Выберите категорию из списка...\") {{$select.selected.name}}--><!--  ui-select-choices(repeat=\'categ._id as categ in expense.dirServiceCategories | filter: {name: $select.search}\')--><!--    div(ng-bind-html=\"categ.name | highlight: $select.search\")--><table class=\"table table-striped\"><thead><tr><th style=width:20%>Категория</th><th style=width:20%>Услуга</th><th style=width:15%>Стоимость</th><!--th(style=\"width:15%\") Кол-во--><th style=width:30%>Редактировать</th></tr></thead><tbody><tr ng-repeat=\"service in expense.buffer.services\"><td><span e-form=rowform editable-select=category e-name=category e-class=form-control e-ng-required=true e-ng-options=\"categ as categ.name for categ in expense.dirServiceCategories\" e-ng-change=expense.getServiceList($data._id)>{{ category.name }}</span></td><td><!--span(e-form=\"rowform\" editable-select=\"service.service\" e-name=\"servce\" e-class=\"form-control\" e-ng-options=\"serv as serv.name for serv in expense.dirServices\" e-required)--><!--  | {{ service.service.name }}--><div editable-ui-select=service.service name=servce data-e-form=rowform data-e-name=servce data-e-search-enabled=true>{{ service.service.name }}<editable-ui-select-match placeholder=Сервис>{{$select.selected.name}}</editable-ui-select-match><editable-ui-select-choices repeat=\"serv in expense.dirServices | filter:{name: $select.search}\"><div ng-bind-html=\"serv.name | highlight: $select.search\"></div></editable-ui-select-choices></div></td><td><span e-form=rowform editable-number=service.cost e-name=cost e-class=form-control e-min=0 e-required>{{ service.cost }}</span></td><!--td--><!--  span(e-form=\"rowform\" editable-number=\"service.quantity\" e-name=\"quantity\" e-class=\"form-control\" e-min=\"0\" e-step=\"1\" e-required)--><!--    | {{ service.quantity }}--><td><form editable-form id=rowform name=rowform ng-show=rowform.$visible novalidate class=\"form-buttons form-inline\"><button type=submit ng-disabled=\"rowform.$waiting || rowform.$invalid\" class=\"btn btn-primary btn-xs\">Сохранить</button> <button type=button ng-disabled=rowform.$waiting ng-click=rowform.$cancel() class=\"btn btn-default btn-xs\">Отмена</button></form><div ng-show=!rowform.$visible class=buttons><button type=button ng-click=rowform.$show() ng-init=rowform.$show() class=\"btn btn-primary btn-xs\">Изменить</button> <button type=button ng-click=expense.removeService($index) class=\"btn btn-danger btn-xs\">Удалить</button></div></td></tr></tbody></table><button type=button ng-click=expense.addService() class=\"btn btn-default\">Добавить</button></div></div><!--.form-group--><!--  //label.control-label.col-md-3.col-sm-3.col-xs-12 Услуги:--><!--    span.required *--><!--  .col-md-4.col-sm-6.col-xs-12.col-md-offset-3.col-sm-offset-3--><!--    ui-select.form-control.col-md-7.col-xs-12(id=\"services\", name=\"services\"--><!--    multiple search-enabled=\"true\" ng-model=\'expense.buffer.services\' ng-required=\'true\')--><!--      ui-select-match {{$item.name}}--><!--      ui-select-choices(repeat=\'service in expense.dirServices | filter: {name: $select.search}\')--><!--        div(ng-bind-html=\"service.name | highlight: $select.search\")--><!--        small(ng-bind-html=\"service.cost | highlight: $select.search\")--><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Направить в:<span class=required>*</span></label><div class=\"col-md-4 col-sm-6 col-xs-12\"><ui-select id=organization_id name=organization_id ng-model=expense.buffer.organization_id ng-required=true class=\"form-control col-md-7 col-xs-12\"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"organization._id as organization in expense.dirOrganizations | filter: {name: $select.search}\"><div ng-bind-html=\"organization.name | highlight: $select.search\"></div><small ng-bind-html=\"organization.address | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Диагноз<span class=required>*</span></label><div class=\"col-md-4 col-sm-6 col-xs-12\"><ui-select id=diagnosis_id name=diagnosis_id multiple ng-model=expense.buffer.diagnosises ng-required=true class=\"form-control col-md-7 col-xs-12\"><ui-select-match>{{$item.name}} ({{$item.code}})</ui-select-match><ui-select-choices repeat=\"diagnosis._id as diagnosis in expense.dirDiagnosises | filter: {name: $select.search}\" refresh=expense.refreshDiagnosisList($select.search)><div ng-bind-html=\"diagnosis.name | highlight: $select.search\"></div><small ng-bind-html=\"diagnosis.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Врач<!--span.required *--></label><div class=\"col-md-4 col-sm-6 col-xs-12\"><ui-select id=doctor_id name=doctor_id ng-model=expense.buffer.doctor_id ng-required=true search-enabled=true reset-search-input=true class=\"form-control col-md-4 col-xs-12\"><ui-select-match>{{$select.selected.fullname}}</ui-select-match><ui-select-choices repeat=\"doctor._id as doctor in expense.dirDoctors | filter:{fullname: $select.search}\"><div ng-bind-html=\"doctor.fullname | highlight: $select.search\"></div><small ng-bind-html=\"doctor.speciality | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Замечания:</label><div class=\"col-md-4 col-sm-6 col-xs-12\"><textarea rows=5 ng-model=expense.buffer.description class=\"form-control col-md-7 col-xs-12\"></textarea></div></div><div class=ln_solid></div><div class=form-group><div class=\"col-md-4 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=expense.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=expense.saveExpense() class=\"btn btn-primary\">Сохранить</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/policya/expenses-history-modal.html","<div class=modal-header><div class=modal-title><h3>Номер полиса: {{ policy.policy_no }}</h3></div></div><div class=modal-body><div class=container><div class=table-responsive><table class=\"table table-bordered\"><thead><tr><th>Дата</th><th>Диагнозы</th><th>Дата осмотра</th><th>Врач</th><th>Сервисы</th><th>Сумма</th><th>Направлен в</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"expense in expenses\" ng-if=\"expenses.length &gt; 0\"><td>{{ expense.created_datetime }}</td><td>{{ expense.diagnosises }}</td><td>{{ expense.exam_date }}</td><td>{{ expense.doctor }}</td><td><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"serv in expense.services\"><td>{{ serv.service.name }}</td><td><strong>{{ serv.cost }}</strong></td></tr></tbody></table></td><td>{{ expense.service_total }}</td><td>{{ expense.organization }}</td><td>{{ expense.description }}</td></tr><tr ng-if=\"expenses.length &lt;= 0\"><td colspan=8>Нет данных</td></tr></tbody></table></div></div></div><div class=modal-footer><button type=button ng-click=ok() class=\"btn btn-default\">Закрыть</button></div>");
$templateCache.put("app/policya/import-modal.html","<div class=modal-header><div class=modal-title><h3>Импортировать полисы</h3></div></div><div class=modal-body><div class=container><div class=row><div class=\"col-sm-12 pull-left\">Выберите файл (только форматы: .xls, xlsx)</div></div><div class=row><div class=\"col-sm-12 pull-left\"><js-xls onread=readWorkbook onerror=onWorkbookLoadError></js-xls><br></div></div><div class=row><div class=col-sm-12><div ui-grid=policiesGridOptions ui-grid-resize-columns ui-grid-auto-resize ui-grid-move-columns class=grid></div></div></div></div></div><div class=modal-footer><button type=button ng-click=cancel() ng-disabled=disabled class=\"btn btn-default\">Отмена</button> <button type=button ng-click=ok() ng-disabled=disabled class=\"btn btn-primary\">Принять</button></div>");
$templateCache.put("app/policya/main-limited.html","<div ng-controller=\"PolicyaMainController as main\" class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Фильтры</h2><div class=clearfix></div></div><div class=x_content><form id=policya-filters name=policya-filters ng-submit=main.getPolicies()><div class=row><div class=col-md-4><div class=form-group><label class=control-label>ФИО застрахованного:</label><input type=text ng-model=main.filter.fullname placeholder=\" Введите имя\" class=form-control></div></div><div class=col-md-4><div class=form-group><label for=policyNo class=control-label>Номер полиса:</label><input type=text id=policyNo ng-model=main.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></div><!--.col-md-4--><!--  .form-group--><!--    label.control-label Продукт:--><!--    select.form-control(ng-options=\"prod._id as prod.name for prod in main.dirProducts\" ng-model=\"main.filter.product_id\")--></div><!--.row--><!--  .col-md-4--><!--    .form-group--><!--      label.control-label(for=\"validFrom\") Начало страховки:--><!--      .input-group.no-margin--><!--        input.form-control.datemask(type=\"text\" id=\"validFrom\" name=\'validFrom\' is-open=\"main.dateOptions.opened1\"--><!--        uib-datepicker-popup=\"dd.MM.yyyy\" placeholder=\"dd.MM.yyyy\" ng-model=\"main.filter.valid_from\", close-text=\"Закрыть\", current-text=\'Сегодня\', clear-text=\'Очистить\')--><!--        span.input-group-btn--><!--          button.btn.btn-default(type=\"button\", ng-click=\"main.dateOptions.opened1=true\")--><!--            i.glyphicon.glyphicon-calendar--><!--  .col-md-4--><!--    .form-group--><!--      label.control-label(for=\"validTo\") Конец страховки:--><!--      .input-group.no-margin--><!--        input.form-control.datemask(type=\"text\" id=\"validTo\" name=\'validTo\' is-open=\"main.dateOptions.opened2\"--><!--        uib-datepicker-popup=\"dd.MM.yyyy\" placeholder=\"dd.MM.yyyy\" ng-model=\"main.filter.valid_to\", close-text=\"Закрыть\", current-text=\'Сегодня\', clear-text=\'Очистить\')--><!--        span.input-group-btn--><!--          button.btn.btn-default(type=\"button\", ng-click=\"main.dateOptions.opened2=true\")--><!--            i.glyphicon.glyphicon-calendar--><div class=ln_solid></div><div class=row><div class=col-md-12><button type=submit class=\"btn btn-primary btn-sm\"><!--i.fa.fa-search(aria-hidden=\'true\')--> Поиск</button> <button type=button ng-click=main.resetFilter() class=\"btn btn-primary btn-sm\">Сбросить фильтр</button></div></div></form></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_content><div class=row><div class=col-md-12><button type=button ng-click=main.getPolicies() class=\"btn btn-default btn-xs\">Обновить</button> <button type=button ng-click=main.openExpenseHistoryModal() ng-disabled=!main.checkIfSelected() class=\"btn btn-primary btn-xs\">Расходы</button></div></div><div class=row><div class=col-md-12><div ui-grid=main.policiesGridOptions ui-grid-selection ui-grid-move-columns ui-grid-auto-resize ui-grid-resize-columns class=grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/policya/main.html","<!--\nCreated by Aibek on 15/06/16.\n\n--><!--ui-sref=\'app.policy_new\',--><div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Фильтры</h2><div class=clearfix></div></div><div class=x_content><form id=policya-filters name=policya-filters ng-submit=main.getPolicies()><div class=row><div class=col-md-4><div class=form-group><label class=control-label>ФИО застрахованного:</label><input type=text ng-model=main.filter.fullname placeholder=\" Введите имя\" class=form-control></div></div><div class=col-md-4><div class=form-group><label for=policyNo class=control-label>Номер полиса:</label><input type=text id=policyNo ng-model=main.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></div><div class=col-md-4><div class=form-group><label class=control-label>Продукт:</label><select ng-options=\"prod._id as prod.name for prod in main.dirProducts\" ng-model=main.filter.product_id class=form-control></select></div></div></div><div class=row><div class=col-md-4><div class=form-group><label for=validFrom class=control-label>Начало страховки:</label><div class=\"input-group no-margin\"><input type=text id=validFrom name=validFrom is-open=main.dateOptions.opened1 uib-datepicker-popup=dd.MM.yyyy placeholder=dd.MM.yyyy ng-model=main.filter.valid_from close-text=Закрыть current-text=Сегодня clear-text=Очистить class=\"form-control datemask\"><span class=input-group-btn><button type=button ng-click=\"main.dateOptions.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-4><div class=form-group><label for=validTo class=control-label>Конец страховки:</label><div class=\"input-group no-margin\"><input type=text id=validTo name=validTo is-open=main.dateOptions.opened2 uib-datepicker-popup=dd.MM.yyyy placeholder=dd.MM.yyyy ng-model=main.filter.valid_to close-text=Закрыть current-text=Сегодня clear-text=Очистить class=\"form-control datemask\"><span class=input-group-btn><button type=button ng-click=\"main.dateOptions.opened2=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=ln_solid></div><div class=row><div class=col-md-12><button type=submit class=\"btn btn-primary btn-sm\"><!--i.fa.fa-search(aria-hidden=\'true\')--> Поиск</button> <button type=button ng-click=main.resetFilter() class=\"btn btn-primary btn-sm\">Сбросить фильтр</button></div></div></form></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_content><div class=row><div class=col-md-12><button type=button ng-click=main.getPolicies() class=\"btn btn-default btn-xs\">Обновить</button> <button type=button ng-click=main.openCreateForm() class=\"btn btn-primary btn-xs\">Добавить полис</button> <button type=button ng-click=main.opneExpenseForm() ng-disabled=!main.checkIfActive() class=\"btn btn-primary btn-xs\">Добавить расход</button> <button type=button ng-click=main.openExpenseHistoryModal() ng-disabled=!main.checkIfSelected() class=\"btn btn-primary btn-xs\">Расходы</button> <button type=button ng-click=main.openImportModal() class=\"btn btn-primary btn-xs\">Импортировать</button></div></div><div class=row><div class=col-md-12><div ui-grid=main.policiesGridOptions ui-grid-selection ui-grid-edit ui-grid-move-columns ui-grid-auto-resize ui-grid-resize-columns class=grid></div></div></div></div></div></div></div></div>");
$templateCache.put("app/policya/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Новый полис</h2><div class=clearfix></div></div><div class=x_content><form id=policya-form class=\"form-horizontal form-label-left\"><!--.form-group--><!--  label.control-label.col-md-3.col-sm-3.col-xs-12 ФИО--><!--    span.required *--><!--  .col-md-6.col-sm-6.col-xs-12--><!--    input.form-control.col-md-7.col-xs-12(type=\"text\", required=\"required\", ng-model=\"new.policya.client_fullname\")--><!--.form-group--><!--  label.control-label.col-md-3.col-sm-3.col-xs-12 Дата рождения--><!--    span.required *--><!--  .col-md-6.col-sm-6.col-xs-12--><!--    //input.date-picker.form-control.col-md-7.col-xs-12(type=\"text\", required=\"required\")--><!--    .input-group.no-margin--><!--      span.input-group-btn--><!--        button.btn.btn-default(type=\"button\", ng-click=\"new.dateOptions.opened1 = true\")--><!--          i.glyphicon.glyphicon-calendar--><!--      input.form-control.col-md-7.col-xs-12(type=\"text\", name=\"birthday\", ng-model=\"new.policya.client_birthday\", uib-datepicker-popup=\"dd.MM.yyyy\", datepicker-options=\"new.dateOptions\", is-open=\"new.dateOptions.opened1\", close-text=\"Закрыть\", current-text=\'Сегодня\', clear-text=\'Очистить\')--><!--.form-group--><!--  label.control-label.col-md-3.col-sm-3.col-xs-12 Прикреплен к--><!--    //span.required *--><!--  .col-md-6.col-sm-6.col-xs-12--><!--    input.form-control.col-md-7.col-xs-12(type=\"text\", ng-model=\"new.policya.relative_fullname\")--><!--.form-group--><!--  label.control-label.col-md-3.col-sm-3.col-xs-12 Степень родства--><!--    //span.required *--><!--  .col-md-6.col-sm-6.col-xs-12--><!--    select.form-control(ng-model=\"new.policya.relative_degree_id\",--><!--    ng-options=\"rdegree._id as rdegree.name for rdegree in new.cache.relativeDegree\")--><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Номер полиса<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text required ng-model=new.policya.policy_no class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Сумма лимит<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text ng-model=new.policya.amount required class=form-control></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Действителен от<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--input.date-picker.form-control.col-md-7.col-xs-12(type=\"text\", required=\"required\")--><div class=\"input-group no-margin\"><span class=input-group-btn><button type=button ng-click=\"new.dateOptions.opened2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span> <input type=text name=valid_from ng-model=new.policya.valid_from uib-datepicker-popup=dd.MM.yyyy datepicker-options=new.dateOptions is-open=new.dateOptions.opened2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=\"form-control col-md-7 col-xs-12\"></div></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Действителен до<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--input.date-picker.form-control.col-md-7.col-xs-12(type=\"text\", required=\"required\")--><div class=\"input-group no-margin\"><span class=input-group-btn><button type=button ng-click=\"new.dateOptions.opened3 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span> <input type=text name=valid_to ng-model=new.policya.valid_to uib-datepicker-popup=dd.MM.yyyy datepicker-options=new.dateOptions is-open=new.dateOptions.opened3 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=\"form-control col-md-7 col-xs-12\"></div></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Продукт<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><select ng-model=new.policya.product_id ng-options=\"prod._id as prod.name for prod in new.cache.products\" class=form-control></select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Клиентская компания<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><select required ng-model=new.policya.client_company_id ng-options=\"clientComp._id as clientComp.name for clientComp in new.cache.clientCompanies\" class=form-control></select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Страховая компания<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><select required ng-model=new.policya.insurance_company_id ng-options=\"insCompany._id as insCompany.name for insCompany in new.cache.insCompanies\" class=form-control></select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Страховая программа<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><select required ng-model=new.policya.insurance_programme_id ng-options=\"insProgram._id as insProgram.name for insProgram in new.cache.insProgrammes\" class=form-control></select></div></div><div class=ln_solid></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=new.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=new.savePolicya() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/prod/entry.html","<!--Created by jaynakus on 7/16/16.\n--><barcode-listener on-scan=entry.handleScan scan-duration=500 prefix=~></barcode-listener><panel title=\"Ввод товара/услуги\"><form name=product class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=form-group><label for=name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Наименование <span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=name required ng-model=entry.entity.data.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label for=price class=\"control-label col-md-3 col-sm-3 col-xs-12\">Цена</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=price required ng-model=entry.entity.data.price class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label for=ean class=\"control-label col-md-3 col-sm-3 col-xs-12\">Штрих-код</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=ean ng-model=entry.entity.data.ean class=\"form-control col-md-7 col-xs-12\"></div></div><div class=ln_solid></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button onclick=history.go(-1) class=\"btn btn-primary\">Отмена</button> <button ng-click=entry.save() ng-disabled=product.$invalid class=\"btn btn-success\">Сохранить</button></div></div></div></div></form></panel>");
$templateCache.put("app/prod/import.html","<!--\nCreated by jaynakus on 7/16/16.\n\n--><panel title=\"Импорт данных\"><div></div><uib-alert ng-repeat=\"a in import.alerts\" type={{a.type}}>{{a.message}}+sadasd</uib-alert><wizard><wz-step wz-title=\"Загрузка файла\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=form-group><label for=file class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите файл</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=file type=file ng-model=import.fileData class=form-control></div></div><div class=actionBar><a ui-sref=app.prod.list class=\"btn btn-default\">Отмена</a><a wz-next=import.read() ng-disabled=!import.fileData class=\"btn btn-success\">Дальше</a></div></div></div></form></wz-step><wz-step wz-title=\"Просмотр данных\"><div dynamic=html></div><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=actionBar><a ui-sref=app.prod.list class=\"btn btn-default\">Отмена</a><a wz-next ng-disabled=import.alerts.length&gt;0 class=\"btn btn-success\">Дальше</a><a wz-previous=import.clear() class=\"btn btn-primary\">Назад</a></div></div></div></form></wz-step><wz-step wz-title=\"Настройка полей\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div ng-repeat=\"f in import.columns\" class=form-group><label for={{f.name}} class=\"control-label col-md-3 col-sm-3 col-xs-12\">{{f.name}}</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><select id={{f.name}} ng-model=f.bind class=form-control><option selected value={{f.name}}>Новое поле</option><option value=id>Уникальный код</option><option value=name>Наименование</option><option value=price>Цена</option><option value=ean>Штрих-код</option></select></div></div><div class=actionBar><a ui-sref=app.prod.list class=\"btn btn-default\">Отмена</a><a wz-next ng-disabled=import.alerts.length&gt;0 class=\"btn btn-success\">Дальше</a><a wz-previous class=\"btn btn-primary\">Назад</a></div></div></div></form></wz-step><wz-step wz-title=\"Настройка полей\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12\"><uib-progressbar value=import.progress type=warning ng-if=import.progress class=progress-striped></uib-progressbar></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12\"><button ng-disabled=import.progress ng-click=import.write() class=\"btn btn-primary\">Начать</button></div></div><div class=actionBar><a ui-sref=app.prod.list class=\"btn btn-default\">Отмена</a><a wz-next ng-disabled=import.progress&lt;gridOptions.data.length class=\"btn btn-success\">Дальше</a><a wz-previous class=\"btn btn-primary\">Назад</a></div></div></div></form></wz-step><wz-step wz-title=Финиш></wz-step></wizard></panel>");
$templateCache.put("app/prod/list.html","<!--Created by jaynakus on 7/16/16.\n--><panel title=\"Товары и услуги\"><div class=btn-group><button uib-tooltip=Обновить ng-click=list.refresh() class=\"btn btn-default\"><i class=\"glyphicon glyphicon-refresh\"></i></button></div><div class=btn-group><a uib-tooltip=Добавить ui-sref=app.prod.entry class=\"btn btn-default\"><i class=\"glyphicon glyphicon-plus\"></i></a> <button uib-tooltip=Редактировать ng-click=list.editRow() class=\"btn btn-default\"><i class=\"glyphicon glyphicon-edit\"></i></button> <button uib-tooltip=Удалить ng-click=list.removeRow() class=\"btn btn-default\"><i class=\"glyphicon glyphicon-remove\"></i></button></div><div class=btn-group><a uib-tooltip=Импортировать ui-sref=app.prod.import class=\"btn btn-default\"><i class=\"glyphicon glyphicon-import\"></i></a></div><div class=ln_solid></div><paged-table options=list.gridOptions page=list.page page-count=list.page_count query=list.search></paged-table></panel>");
$templateCache.put("app/prod/stock.html","<!--Created by jaynakus on 7/20/16.\n-->");
$templateCache.put("app/product/additionally.html","<div style=\"min-height: 500px\" class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукт</h3></div><div class=box-body><form><div class=row><div class=col-md-8><div class=row><div stock-dict=additionally.tmp_factors dict-table=Factors class=col-md-10><div class=form-group><label>Выбрать фактор</label><ui-select ng-model=additionally.current_F.factor on-select=additionally.clearFactorValues() ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in additionally.tmp_factors track by type._id | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Коэффициент</label><input type=number ng-model=additionally.current_F.coefficient class=form-control><!--coefficient_type--></div></div></div><div class=row><div stock-dict=additionally.tmp_coefficients dict-table=Enums dict-filter={name:&quot;coefficient_type&quot;} class=col-md-10><div class=form-group><label>Вид коэффициента</label><ui-select ng-model=additionally.current_F.coefficient_type class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in additionally.tmp_coefficients track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><div class=radio><label><input type=radio name=optradio ng-model=additionally.current_F.is_default ng-value=false> Опциональный</label></div><div class=radio><label><input type=radio name=optradio ng-model=additionally.current_F.is_default ng-value=true checked> Включен по умолчанию</label></div></div></div></div><div class=\"col-md-4 pull-left\"><div class=form-group><label>Значения фактора</label><ui-select ng-model=additionally.current_F.values ng-required=true multiple class=form-control><ui-select-match>{{$item}}</ui-select-match><ui-select-choices repeat=\"type in additionally.current_F.factor.values| filter:$select.search| filter:additionally.factorValueFilter | orderBy:additionally.sortFactorValues\">{{type}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><button type=button ng-click=additionally.confirmActionF() class=\"btn btn-success btn-sm pull-right\">Сохранить фактор</button></div></div><span ng-init=additionally.initMS2() style=display:none></span></form><h2>Список факторов</h2><div style=\"height:200px; overflow-y:auto\" class=panel-group><div ng-repeat=\"x in additionally.factorListTS track by x.factor_name\" class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-target=#collapse22{{$index}} class=\"btn btn-info\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i><!--span(ng-repeat=\"y in x.countries.items\")  {{$index+1}}.{{y.name}}--> {{x.factor_name}}</a> <button type=button ng-click=additionally.confirmActionFDeleteAll(x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span> Remove</button></h4></div><panel-collapse id=collapse22{{$index}} class=collapse><div class=panel-body><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><table class=\"table table-striped\"><thead><tr><th>Значения</th><th>Коэффициент</th><th>Тип коэффициента</th><th>По умолчанию</th><th></th></tr></thead><tbody><tr ng-repeat=\"y in x.data\"><td><span ng-repeat=\"z in y.values\">{{$index + 1}}: \"{{z}}\",<br></span></td><td>{{y.coefficient}}</td><td>{{y.coefficient_type}}</td><td>{{y.is_default}}</td><td><button type=button ng-click=additionally.confirmActionFdelete($index,y,x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></div></div></panel-collapse></div></div></div></div>");
$templateCache.put("app/product/base.html","<div style=\"min-height: 500px\" class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукт</h3></div><div class=box-body><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><form><br><div class=row><div class=\"col col-md-12 pull-left\"><div class=row><div class=\"col-md-4 pull-left\"><div class=form-group><label>Минимальная страховая сумма</label><input type=number ng-model=base.current_BF.insurance_amount ng-disabled=true class=form-control></div></div><div stock-dict=base.tmp_countries dict-table=Countries class=\"col-md-8 pull-left\"><div class=form-group><label>Список всех стран</label><ui-select ng-model=base.current_BF.countries_id on-remove=base.getInsAmount() on-select=base.getInsAmount() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in base.tmp_countries | filter:{name:$select.search}| orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices><!--ui-select-choices(repeat=\'type._id as type in base.tmp_countries | filter:{name:$select.search}| filter:base.countryFilter| orderBy:\"name\"\') {{type.name}}--></ui-select></div></div></div><div class=row><div class=\"col-md-2 pull-left\"><div class=form-group><label>От</label><div class=input-group><span class=input-group-addon><span>дни</span></span> <input type=number min=0 ng-model=base.BFitem.from_day ng-trim class=form-control></div></div></div><div class=\"col-md-2 pull-left\"><div class=form-group><label>До</label><div class=input-group><span class=input-group-addon><span>дни</span></span> <input type=number min=0 ng-model=base.BFitem.to_day ng-trim class=form-control></div></div></div><div class=\"col-md-3 pull-left\"><div class=form-group><label>Сумма страхового взноса</label><div class=input-group><span class=input-group-addon><span>УЕ</span></span> <input type=number min=0 ng-model=base.BFitem.base_price ng-trim class=form-control></div></div></div><div class=\"col-md-2 pull-left\"><div class=radio><label><input type=radio name=optradio ng-model=base.BFitem.is_per_day ng-value=true> За день</label></div><div class=radio><label><input type=radio name=optradio ng-model=base.BFitem.is_per_day checked ng-value=false> За период</label></div></div><div stock-dict=base.insurance_amounts dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=\"col-md-3 pull-left\"><div class=form-group><label>Страховая сумма:</label><ui-select ng-model=base.insurance_amount ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in base.insurance_amounts track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label style=visibility:hidden>Сумма страхового взноса</label><a ng-click=base.addBF() class=\"pull-right btn btn-primary\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить</a></div></div></div><div class=row><div class=col-md-12><table class=\"table table-striped\"><thead><tr><th>Интервал</th><th>базовая цена</th><th>за каждый день</th><th></th><th></th></tr></thead><tbody><tr ng-if=\"base.current_BF.values.length == 0\"><td colspan=3 style=\"color: red\" class=text-center><h2>Данных нет.</h2></td></tr><tr ng-repeat=\"item in base.current_BF.values\"><td>{{item.from_day}} - {{item.to_day}}</td><td>{{item.base_price}} у.е.</td><td>{{item.is_per_day}}</td><td ng-if=item._id><a data-target=# ng-click=base.basefactorRowEdit(item) class=\"btn btn-primary pull-right\"><span class=\"glyphicon glyphicon-edit\"></span> Edit</a></td><td ng-if=\"item._id==null\"><a ng-click=base.deleteBF($index) class=btn><i aria-hidden=true class=\"fa fa-trash\"></i></a></td><td ng-if=\"item._id!=null\"><a ng-click=\"base.deleteBFandDB($index, item)\" class=btn><i aria-hidden=true class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div><div class=row><div class=col-md-12><button type=button ng-click=base.resetForm() class=\"btn btn-success btn-sm pull-left\">Сброс</button> <button type=button ng-click=base.confirmActionBF() class=\"btn btn-success btn-sm pull-left\">Сохранить</button></div></div></div></div></form><h2>Список факторов</h2><div class=panel-group><div ng-repeat=\"x in base.basefactorListTS\" class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><span class=input-group-btn><a data-toggle=collapse data-target=#collapse33{{$index}} class=\"btn btn-info\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i></a> <button style=\"margin-left: 20px\" popover-trigger=click popover-placement=top uib-popover-template=&quot;myPopoverTemplate.html&quot; popover-title=\"Список стран\" type=button class=\"btn btn-info\">Список стран</button><a data-target=# ng-click=base.basefactorEdit(x) class=\"btn btn-primary pull-right\"><span class=\"glyphicon glyphicon-edit\"></span> Edit</a><a data-target=# ng-click=\"base.confirmActionBFdelete($index, x)\" class=\"btn btn-primary pull-right\"><span class=\"glyphicon glyphicon-remove\"></span> Remove</a></span></h4></div><panel-collapse id=collapse33{{$index}} class=collapse><div class=panel-body><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><table class=\"table table-striped\"><thead><tr><th>Интервал</th><th>базовая цена</th><th>страховая сумма</th><th>за каждый день</th></tr></thead><tbody><tr ng-repeat=\"z in x.data\"><td>{{z.interval.from_day}} - {{z.interval.to_day}}</td><td>{{z.base_price}} у.е.</td><td>{{z.insurance_amount}} у.е.</td><td>{{z.is_per_day}}</td></tr><tr ng-if=\"x.data.length == 0\"><td colspan=3 style=\"color: red\" class=text-center><h2>Данных нет.</h2></td></tr></tbody></table></div></div></div></panel-collapse></div></div></div></div></div></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"max-width: 200px; max-height: 500px; overflow-y: auto;\">\n  <ul class=\"list-group\">\n  <li ng-repeat=\"y in x.countries\" class=\"list-group-item\">\n          {{$index+1}}: \"{{y.name}}\"\n  </li>\n  </ul>\n  </div></script>");
$templateCache.put("app/product/list.html","<div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукты</h3></div><div class=\"box-body pad table-responsive\"><!--button.btn.btn-primary.btn-sm(ng-click=\'list.newProduct()\') Добавить--> <button ui-sref=app.product.new class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!list.selected_product\' ng-click=\'list.editProduct()\')--> <button ng-click=list.gotoedit(list.selected_product) ng-disabled=\"list.selected_product == null\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=list.gotoview(list.selected_product) ng-disabled=\"list.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=list.confirmAction() ng-disabled=\"list.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button> <button ng-click=list.getProducts() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=list.productsGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/product/main.html","<div style=\"min-height: 500px\" class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукт</h3></div><div class=box-body><div class=row><col-responsive><div class=form-group><label for=first-name>Название<span class=required>*</span></label><input id=first-name type=text ng-model=main.new_product.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label stock-dict=main.insurancetypes dict-table=InsuranceTypes>Вид страхования<span class=required>*</span></label><ui-select ng-model=main.new_product.insurance_type ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.code as type in main.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label for=middle-name class=control-label>Начало</label><div class=\"input-group no-margin\"><input id=middle-name type=text min-date=main.today max-date=main.new_product.date_end uib-datepicker-popup=dd-MM-yyyy ng-click=\"main.popup_delivery_date.opened=true\" ng-model=main.new_product.date_start is-open=main.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"main.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label for=middle-name2 class=control-label>Конец</label><div class=\"input-group no-margin\"><input id=middle-name2 type=text uib-datepicker-popup=dd-MM-yyyy min-date=main.new_product.date_start ng-click=\"main.popup_delivery_date.opened1=true\" ng-model=main.new_product.date_end is-open=main.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"main.popup_delivery_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label for=middle-name22 class=control-label>Описание</label><textarea id=middle-name22 rows=4 ng-model=main.new_product.description class=form-control></textarea></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label class=control-label>Порядок</label><input type=number ng-model=main.new_product.data.order class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=input-group><button ng-click=main.saveProduct() class=\"btn btn-primary btn-sm pull-right\">Сохранить</button></div></col-responsive></div></div></div>");
$templateCache.put("app/product/new.html","<div class=content><div class=row><div class=\"col-md-3 col-lg-3\"><div class=list-group><a ui-sref=\"app.product_main({product: new_product.new_product})\" ui-sref-active=active class=list-group-item>Основные данные</a><a ui-sref=\"app.product_service({product: new_product.new_product})\" ui-sref-active=active class=list-group-item>Сервисы</a><a ui-sref=\"app.product_base({product: new_product.new_product})\" ui-sref-active=active class=list-group-item>Базовые факторы</a><a ui-sref=\"app.product_additionally({product: new_product.new_product})\" ui-sref-active=active class=list-group-item>Дополнительные факторы</a></div></div><div class=\"col-md-9 col-lg-9\"><ui-view class=page-container></ui-view></div></div></div>");
$templateCache.put("app/product/news.html","<div class=content><div class=row><div class=col-md-4><div class=list-group><a class=list-group-item>Основные данные</a><a class=list-group-item>Сервисы</a><a class=list-group-item>Базовые факторы</a><a class=list-group-item>Дополнительные факторы</a></div></div><div class=col-md-8><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукт</h3></div><div class=\"box-body pad table-responsive\"><wizard hide-indicators=false indicators-position=top><wz-step wz-title=\"Основные данные\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Основные данные</h2><!--pre.text-left {{new_product.new_product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next=\"import.read()\" ng-disabled=\"!import.fileData\") Дальше--><a wz-next=new_product.saveProduct() class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=form-group><label for=first-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=first-name type=text ng-model=new_product.new_product.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label stock-dict=new_product.insurancetypes dict-table=InsuranceTypes class=\"control-label col-md-3 col-sm-3 col-xs-12\">Вид страхования<span class=required>*</span></label><div class=\"col-md-3 col-sm-3 col-xs-12\"><ui-select ng-model=new_product.new_product.insurance_type ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.code as type in new_product.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label for=middle-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Начало</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name type=text min-date=new_product.today max-date=new_product.new_product.date_end uib-datepicker-popup=dd-MM-yyyy ng-click=\"profile.popup_delivery_date.opened=true\" ng-model=new_product.new_product.date_start is-open=profile.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name2 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Конец</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name2 type=text uib-datepicker-popup=dd-MM-yyyy min-date=new_product.new_product.date_start ng-click=\"profile.popup_delivery_date.opened1=true\" ng-model=new_product.new_product.date_end is-open=profile.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name22 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><textarea id=middle-name22 rows=4 ng-model=new_product.new_product.description class=form-control></textarea></div></div></div></form></wz-step><wz-step wz-title=Сервисы><div dynamic=html></div><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><form><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Сервисы</h2></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><a wz-previous=import.clear() class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a wz-next=new_product.saveProduct() class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=row><div stock-dict=new_product.tmp_services dict-table=Services class=\"col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Сервисы</label><div class=input-group><ui-select ng-model=new_product.new_product.services_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in new_product.tmp_services | filter:{name:$select.search} | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" style=visibility:hidden ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></form></div></div></wz-step><wz-step wz-title=\"Базовые факторы\"><div dynamic=html></div><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><form><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Базовые факторы</h2><!--pre.text-left {{new_product.current_BF|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous=\"import.clear()\") Назад--><a wz-previous=import.clear() class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a wz-next class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=row><div class=\"col col-md-12 pull-left\"><div class=row><div class=\"col-md-4 pull-left\"><div class=form-group><label>Минимальная страховая сумма</label><input type=number ng-model=new_product.current_BF.insurance_amount ng-disabled=true class=form-control></div></div><div stock-dict=new_product.tmp_countries dict-table=Countries class=\"col-md-8 pull-left\"><div class=form-group><label>Список всех стран</label><ui-select ng-model=new_product.current_BF.countries_id on-remove=new_product.getInsAmount() on-select=new_product.getInsAmount() ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in new_product.tmp_countries | filter:{name:$select.search}| orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices><!--ui-select-choices(repeat=\'type._id as type in new_product.tmp_countries | filter:{name:$select.search}| filter:new_product.countryFilter| orderBy:\"name\"\') {{type.name}}--></ui-select></div></div></div><div class=row><div class=\"col-md-2 pull-left\"><div class=form-group><label>От</label><div class=input-group><span class=input-group-addon><span>дни</span></span> <input type=number min=0 ng-model=new_product.BFitem.from_day ng-trim class=form-control></div></div></div><div class=\"col-md-2 pull-left\"><div class=form-group><label>До</label><div class=input-group><span class=input-group-addon><span>дни</span></span> <input type=number min=0 ng-model=new_product.BFitem.to_day ng-trim class=form-control></div></div></div><div class=\"col-md-3 pull-left\"><div class=form-group><label>Сумма страхового взноса</label><div class=input-group><span class=input-group-addon><span>УЕ</span></span> <input type=number min=0 ng-model=new_product.BFitem.base_price ng-trim class=form-control></div></div></div><div class=\"col-md-2 pull-left\"><div class=radio><label><input type=radio name=optradio ng-model=new_product.BFitem.is_per_day ng-value=true> За день</label></div><div class=radio><label><input type=radio name=optradio ng-model=new_product.BFitem.is_per_day checked ng-value=false> За период</label></div></div><div stock-dict=new_product.insurance_amounts dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=\"col-md-3 pull-left\"><div class=form-group><label>Страховая сумма:</label><ui-select ng-model=new_product.insurance_amount ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in new_product.insurance_amounts track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label style=visibility:hidden>Сумма страхового взноса</label><a ng-click=new_product.addBF() class=\"pull-right btn btn-primary\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить</a></div></div></div><div class=row><div class=col-md-12><table class=\"table table-striped\"><thead><tr><th>Интервал</th><th>базовая цена</th><th>за каждый день</th><th></th><th></th></tr></thead><tbody><tr ng-if=\"new_product.current_BF.values.length == 0\"><td colspan=3 style=\"color: red\" class=text-center><h2>Данных нет.</h2></td></tr><tr ng-repeat=\"item in new_product.current_BF.values\"><td>{{item.from_day}} - {{item.to_day}}</td><td>{{item.base_price}} у.е.</td><td>{{item.is_per_day}}</td><td ng-if=item._id><a data-target=# ng-click=new_product.basefactorRowEdit(item) class=\"btn btn-primary pull-right\"><span class=\"glyphicon glyphicon-edit\"></span> Edit</a></td><td ng-if=\"item._id==null\"><a ng-click=new_product.deleteBF($index) class=btn><i aria-hidden=true class=\"fa fa-trash\"></i></a></td><td ng-if=\"item._id!=null\"><a ng-click=\"new_product.deleteBFandDB($index, item)\" class=btn><i aria-hidden=true class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div><div class=row><div class=col-md-12><button type=button ng-click=new_product.resetForm() class=\"btn btn-success btn-sm pull-left\">Сброс</button> <button type=button ng-click=new_product.confirmActionBF() class=\"btn btn-success btn-sm pull-left\">Сохранить</button></div></div></div></div></form><h2>Список факторов</h2><div class=panel-group><div ng-repeat=\"x in new_product.basefactorListTS\" class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><span class=input-group-btn><a data-toggle=collapse data-target=#collapse33{{$index}} class=\"btn btn-info\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i></a> <button style=\"margin-left: 20px\" popover-trigger=click popover-placement=top uib-popover-template=&quot;myPopoverTemplate.html&quot; popover-title=\"Список стран\" type=button class=\"btn btn-info\">Список стран</button><a data-target=# ng-click=new_product.basefactorEdit(x) class=\"btn btn-primary pull-right\"><span class=\"glyphicon glyphicon-edit\"></span> Edit</a><a data-target=# ng-click=\"new_product.confirmActionBFdelete($index, x)\" class=\"btn btn-primary pull-right\"><span class=\"glyphicon glyphicon-remove\"></span> Remove</a></span></h4></div><panel-collapse id=collapse33{{$index}} class=collapse><div class=panel-body><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><table class=\"table table-striped\"><thead><tr><th>Интервал</th><th>базовая цена</th><th>страховая сумма</th><th>за каждый день</th></tr></thead><tbody><tr ng-repeat=\"z in x.data\"><td>{{z.interval.from_day}} - {{z.interval.to_day}}</td><td>{{z.base_price}} у.е.</td><td>{{z.insurance_amount}} у.е.</td><td>{{z.is_per_day}}</td></tr><tr ng-if=\"x.data.length == 0\"><td colspan=3 style=\"color: red\" class=text-center><h2>Данных нет.</h2></td></tr></tbody></table></div></div></div></panel-collapse></div></div></div></div></wz-step><wz-step wz-title=\"Дополнительные факторы\"><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><form><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Дополнительные факторы</h2><!--pre.text-left {{new_product.current_F|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous) Назад--><a wz-previous class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a ng-click=new_product.confirmActionFinish() class=\"btn btn-success\">Готово</a></div></div></div><br><div class=row><div class=col-md-8><div class=row><div stock-dict=new_product.tmp_factors dict-table=Factors class=col-md-10><div class=form-group><label>Выбрать фактор</label><ui-select ng-model=new_product.current_F.factor on-select=new_product.clearFactorValues() ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in new_product.tmp_factors track by type._id | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Коэффициент</label><input type=number ng-model=new_product.current_F.coefficient class=form-control><!--coefficient_type--></div></div></div><div class=row><div stock-dict=new_product.tmp_coefficients dict-table=Enums dict-filter={name:&quot;coefficient_type&quot;} class=col-md-10><div class=form-group><label>Вид коэффициента</label><ui-select ng-model=new_product.current_F.coefficient_type class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in new_product.tmp_coefficients track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><div class=radio><label><input type=radio name=optradio ng-model=new_product.current_F.is_default ng-value=false> Опциональный</label></div><div class=radio><label><input type=radio name=optradio ng-model=new_product.current_F.is_default ng-value=true checked> Включен по умолчанию</label></div></div></div></div><div class=\"col-md-4 pull-left\"><div class=form-group><label>Значения фактора</label><ui-select ng-model=new_product.current_F.values ng-required=true multiple class=form-control><ui-select-match>{{$item}}</ui-select-match><ui-select-choices repeat=\"type in new_product.current_F.factor.values| filter:$select.search| filter:new_product.factorValueFilter | orderBy:new_product.sortFactorValues\">{{type}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><button type=button ng-click=new_product.confirmActionF() class=\"btn btn-success btn-sm pull-right\">Сохранить фактор</button></div></div><span ng-init=new_product.initMS2() style=display:none></span></form><h2>Список факторов</h2><div style=\"height:200px; overflow-y:auto\" class=panel-group><div ng-repeat=\"x in new_product.factorListTS track by x.factor_name\" class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-target=#collapse22{{$index}} class=\"btn btn-info\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i><!--span(ng-repeat=\"y in x.countries.items\")  {{$index+1}}.{{y.name}}--> {{x.factor_name}}</a> <button type=button ng-click=new_product.confirmActionFDeleteAll(x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span> Remove</button></h4></div><panel-collapse id=collapse22{{$index}} class=collapse><div class=panel-body><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><table class=\"table table-striped\"><thead><tr><th>Значения</th><th>Коэффициент</th><th>Тип коэффициента</th><th>По умолчанию</th><th></th></tr></thead><tbody><tr ng-repeat=\"y in x.data\"><td><span ng-repeat=\"z in y.values\">{{$index + 1}}: \"{{z}}\",<br></span></td><td>{{y.coefficient}}</td><td>{{y.coefficient_type}}</td><td>{{y.is_default}}</td><td><button type=button ng-click=new_product.confirmActionFdelete($index,y,x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></div></div></panel-collapse></div></div></div></div></wz-step></wizard></div></div></div></div></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"max-width: 200px; max-height: 500px; overflow-y: auto;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"y in x.countries\" class=\"list-group-item\">\n        {{$index+1}}: \"{{y.name}}\"\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/product/product.html","<div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукты</h3></div><div class=\"box-body pad table-responsive\"><!--button.btn.btn-primary.btn-sm(ng-click=\'product.newProduct()\') Добавить--> <button ui-sref=app.product_new class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!product.selected_product\' ng-click=\'product.editProduct()\')--> <button ng-click=product.gotoedit(product.selected_product) ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=product.gotoview(product.selected_product) ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=product.confirmAction() ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button> <button ng-click=product.getProducts() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=product.productsGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/product/service.html","<div style=\"min-height: 500px\" class=\"box box-danger\"><div class=box-header><h3 class=box-title>Продукт</h3></div><div class=box-body><div class=row><div stock-dict=service.tmp_services dict-table=Services class=\"col col-xs-12 col-sm-3\"><div class=form-group><label>Сервисы</label><ui-select ng-model=service.service ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type as type in service.tmp_services | filter:{name:$select.search} | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select></div></div><div stock-dict=\"service.insurance_amounts \" dict-table=Enums dict-filter={name:&quot;insurance_amount&quot;} class=\"col col-xs-12 col-sm-3\"><div class=form-group><label>Страховая сумма:</label><ui-select ng-model=service.new_product.insurance_sum ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in service.insurance_amounts track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div><div class=\"col col-xs-12 col-sm-3\"><div class=form-group><label>Лимит</label><input type=number ng-model=service.service_limit ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-3\"><div class=form-group><label></label><button ng-click=service.saveProductsService() class=\"btn btn-primary btn-sm form-control\">Добавить сервис</button></div></div></div><div class=row><div class=margin><button ng-click=service.removeService() ng-disabled=\"service.selected_service == null\" class=\"btn btn-danger btn-sm\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button><div class=margin></div></div></div><div class=row><paged-table options=service.servicesGridOptions disable-search=true></paged-table></div><div class=row><col-responsive><div class=input-group><button ng-click=service.saveProduct() class=\"btn btn-primary btn-sm pull-right\">Сохранить</button></div></col-responsive></div></div></div>");
$templateCache.put("app/product/view.html","<!--\nCreated by troy on 28.11.2016.\n\n--><div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Просмотр продукта</h3></div><div class=\"box-body pad table-responsive\"><button type=button ui-sref=app.product class=\"btn btn-default\">Назад</button><div class=margin></div><ul class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer>Основные Данные</a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer>Сервисы</a></li><li><a data-toggle=tab data-target=#basefactor style=cursor:pointer>Базовые факторы</a></li><li><a data-toggle=tab data-target=#factor style=cursor:pointer>Факторы</a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><hr><div class=row><div class=col-md-7><table class=\"table table-striped\"><tbody><tr><td>Название продукта</td><td>{{view_product.product.name}}</td></tr><tr><td>Компания продукта</td><td>{{view_product.product.company.name}}</td></tr><tr><td>Код продукта</td><td>{{view_product.product.code}}</td></tr><tr><td>Тип страхования</td><td>{{view_product.product.insurance_type}}</td></tr><tr><td>Начало</td><td>{{view_product.toDate(view_product.product.date_start)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Конец</td><td>{{view_product.toDate(view_product.product.date_end)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Описание</td><td>{{view_product.product.description}}</td></tr></tbody></table></div></div></div><div id=service class=\"tab-pane fade\"><hr><ul class=list-group><li ng-repeat=\"service in view_product.product.services\" class=list-group-item>{{$index + 1}}. {{service.name}}</li></ul></div><div id=basefactor class=\"tab-pane fade\"><hr><div class=row><div class=col-md-12><table class=\"table table-striped\"><thead><tr class=row><th class=col-md-4>Страны</th><th class=col-md-2>Сумма страховки</th><th class=col-md-2>Интервал</th><th class=col-md-2>Цена за день</th><th class=col-md-2>Цена</th></tr></thead><tbody><tr ng-repeat=\"basefactor in view_product.product.basefactors\" class=row><td class=col-md-4><span ng-repeat=\"country in basefactor.countries\"><span style=\"color: red\">{{country.name[0]}}</span><span>{{country.name.substring(1)}}</span><br ng-if=\"($index + 1)%4 == 0\"></span></td><td class=col-md-2>{{basefactor.insurance_amount}}</td><td class=col-md-2>{{basefactor.interval.from_day}} - {{basefactor.interval.to_day}}</td><td class=col-md-2>{{basefactor.is_per_day}}</td><td class=col-md-2>{{basefactor.base_price}}</td></tr></tbody></table></div></div></div><div id=factor class=\"tab-pane fade\"><hr><table class=\"table table-striped\"><thead><tr class=row><th class=col-md-3>Фактор</th><th class=col-md-1>Коэффицент</th><th class=col-md-2>Тип коэффицента</th><th class=col-md-6>Значения</th></tr></thead><tbody><tr ng-repeat=\"factor in view_product.product.factors\" class=row><td class=col-md-3>{{factor.factor.name}}</td><td class=col-md-1>{{factor.coefficient}}</td><td class=col-md-2>{{factor.coefficient_type}}</td><td class=col-md-6><span ng-repeat=\"value in factor.values\"><span ng-if=\"factor.factor.usage != \'age\'\">{{$index + 1}}).</span><span> {{value}}</span><br ng-if=\"($index + 1)%4 == 0\"></span></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/productm/new.html","<!--\nCreated by troy on 13.10.2016.\n\n--><panel title=\"Мобильный продукт\"><wizard hide-indicators=false indicators-position=top><wz-step wz-title=\"Основные данные\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.productm class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Основные данные</h2><!--pre.text-left {{new_productm.product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next=\"import.read()\" ng-disabled=\"!import.fileData\") Дальше--><a wz-next=\"\" class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=form-group><label for=first-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=first-name type=text ng-model=new_productm.product.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label stock-dict=new_productm.insurancetypes dict-table=InsuranceTypes class=\"control-label col-md-3 col-sm-3 col-xs-12\">Вид страхования<span class=required>*</span></label><div class=\"col-md-3 col-sm-3 col-xs-12\"><ui-select ng-model=new_productm.product.insurance_type ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.code as type in new_productm.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label for=middle-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Начало</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name type=text min-date=new_productm.today max-date=new_productm.product.date_end uib-datepicker-popup=dd-MM-yyyy ng-click=\"profile.popup_delivery_date.opened=true\" ng-model=new_productm.product.date_start is-open=profile.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name2 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Конец</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name2 type=text uib-datepicker-popup=dd-MM-yyyy min-date=new_productm.product.date_start ng-click=\"profile.popup_delivery_date.opened1=true\" ng-model=new_productm.product.date_end is-open=profile.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name22 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><textarea id=middle-name22 rows=4 ng-model=new_productm.product.description class=form-control></textarea></div></div></div></form></wz-step><wz-step wz-title=Сервисы><div dynamic=html></div><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.productm class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Сервисы</h2><!--pre.text-left {{new_productm.product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous=\"import.clear()\") Назад--><a wz-previous=\"\" class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a wz-next=\"\" class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=row><div stock-dict=new_productm.tmp_services dict-table=Services class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Сервисы</label><div class=input-group><ui-select ng-model=new_productm.product.services_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in new_productm.tmp_services | filter:{name:$select.search} | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" style=visibility:hidden ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></form></wz-step><wz-step wz-title=\"Объект страхования\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.productm class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Объект страхования</h2><!--pre.text-left {{new_productm.currentField|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous) Назад--><a wz-previous class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a wz-next class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=row><div class=col-md-8><div class=row><div class=col-md-10><div class=form-group><label>Ключ</label><input type=text ng-model=new_productm.currentField.key class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Название</label><input type=text ng-model=new_productm.currentField.label class=form-control></div></div></div><div class=row><div stock-dict=new_productm.input_types dict-table=Enums dict-filter={name:&quot;input_type&quot;} class=col-md-10><div class=form-group><label>Тип поля</label><ui-select ng-model=new_productm.currentField.controlType class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in new_productm.input_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Заполнитель</label><input type=text ng-model=new_productm.currentField.placeholder class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Шаг</label><input type=number ng-model=new_productm.currentField.step class=form-control></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><div class=row><div class=col-md-6><div class=form-group><label>Минимум</label><input type=number ng-model=new_productm.currentField.min class=form-control></div></div><div class=col-md-6><div class=form-group><label>Максимум</label><input type=number ng-model=new_productm.currentField.max class=form-control></div></div></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><div class=row><div class=col-md-6><div class=form-group><label>displayFormat</label><input type=text ng-model=new_productm.currentField.displayFormat class=form-control></div></div><div class=col-md-6><div class=form-group><label>pickerFormat</label><input type=text ng-model=new_productm.currentField.pickerFormat class=form-control></div></div></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Обязательный</label><div class=btn-group><button type=button ng-class=\"{\'btn-primary\': new_productm.currentField.required}\" ng-model=new_productm.currentField.required ng-click=\"new_productm.currentField.required=true\" class=\"btn btn-default\">Да</button> <button type=button ng-class=\"{\'btn-primary\': !new_productm.currentField.required}\" ng-model=new_productm.currentField.required ng-click=\"new_productm.currentField.required=false\" class=\"btn btn-default\">Нет</button></div></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><button type=button ng-click=new_productm.saveField() class=\"btn btn-success btn-sm pull-right\">Сохранить поле</button> <button type=button ng-click=new_productm.resetField() class=\"btn btn-default btn-sm pull-right\">Сбросить</button></div></div><br></div><div class=\"col-md-4 pull-left\"><h2>Список полей</h2><ul class=list-group><li ng-repeat=\"(key, field) in new_productm.fields\" class=list-group-item><label>{{field.label}}</label><div class=input-group><input type={{field.controlType}} placeholder={{field.placeholder}} class=form-control><span class=input-group-btn><button type=button ng-click=new_productm.selectField(key) class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-pencil\"></i></button></span><span class=input-group-btn> <button type=button ng-click=new_productm.removeField(key) class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span></div></li></ul><!--button.btn.btn-success.btn-sm(type=\'button\' ng-click=\"new_productm.addField()\") Добавить поле--></div></div></form></wz-step><wz-step wz-title=\"Сроки и цены\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.productm class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Сроки и цены</h2><!--pre.text-left {{new_productm.product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous) Назад--><a wz-previous class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a ng-click=new_productm.confirmAction() class=\"btn btn-success\">Готово</a></div></div></div><br><div class=row><div stock-dict=new_productm.currencies dict-table=Currencies class=col-md-8><div class=form-group><label>Валюта</label><ui-select ng-model=new_productm.product.data.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in new_productm.currencies track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-8><div class=row><div class=\"col-md-10 pull-left\"><div class=row><div class=col-md-6><div class=form-group><label>Дней</label><input type=number ng-model=new_productm.priceRule.days class=form-control></div></div><div class=col-md-6><div class=form-group><label>Цена</label><input type=number ng-model=new_productm.priceRule.price class=form-control></div></div></div></div></div><div class=row><div class=col-md-10><button type=button ng-click=new_productm.addPricing() class=\"btn btn-success btn-sm pull-right\">Добавить</button></div></div></div><div class=\"col-md-4 pull-left\"><h2>Список цен</h2><ul class=list-group><li ng-repeat=\"price in new_productm.pricing\" class=list-group-item><label><h2><span class=text-primary>{{price.days}}</span> дней -<span class=text-primary>- {{price.price}}</span> сом</h2></label><button type=button ng-click=new_productm.removePricing($index) class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-times\"></i></button><!--.input-group--><!--  input.form-control(type=\'{{field.type}}\', placeholder=\'{{field.placeholder}}\')--><!--  span.input-group-btn--><!--    button.btn.btn-primary(type=\'button\' ng-click=\'new_productm.selectField($index)\')--><!--      i.fa.fa-pencil(aria-hidden=\'true\')--><!--  span.input-group-btn--><!--    button.btn.btn-danger(type=\'button\' ng-click=\'new_productm.removeField($index)\')--><!--      i.fa.fa-times(aria-hidden=\'true\')--></li></ul></div></div></form></wz-step></wizard></panel>");
$templateCache.put("app/productm/product.html","<div class=content><div class=row><div class=col-md-12><panel title=\"Мобильный продукт\"><!--button.btn.btn-primary.btn-sm(ng-click=\'productm.newProduct()\') Добавить--> <button ui-sref=app.productm_new class=\"btn btn-primary btn-sm\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!productm.selected_product\' ng-click=\'productm.editProduct()\')--> <button ng-click=productm.gotoedit(productm.selected_product) ng-disabled=\"productm.selected_product == null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button><!--button.btn.btn-default.btn-sm(ng-click=\"productm.gotoview(productm.selected_product)\" ng-disabled=\"productm.selected_product == null\")--><!--  i.fa.fa-eye(aria-hidden=\'true\')--><!--  span  Просмотр--> <button ng-click=productm.confirmAction() ng-disabled=\"productm.selected_product == null\" class=\"btn btn-default btn-sm\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button> <button ng-click=productm.getProducts() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=productm.productsGridOptions disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/productm/view.html","<!--\nCreated by troy on 28.11.2016.\n\n--><div class=container><button type=button ui-sref=app.product class=\"btn btn-warning\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Назад</button><ul class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer>Основные Данные</a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer>Сервисы</a></li><li><a data-toggle=tab data-target=#basefactor style=cursor:pointer>Базовые факторы</a></li><li><a data-toggle=tab data-target=#factor style=cursor:pointer>Факторы</a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><hr><div class=row><div class=col-md-7><table class=\"table table-striped\"><tbody><tr><td>Название продукта</td><td>{{view_product.product.name}}</td></tr><tr><td>Компания продукта</td><td>{{view_product.product.company.name}}</td></tr><tr><td>Код продукта</td><td>{{view_product.product.code}}</td></tr><tr><td>Тип страхования</td><td>{{view_product.product.insurance_type}}</td></tr><tr><td>Начало</td><td>{{view_product.toDate(view_product.product.date_start)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Конец</td><td>{{view_product.toDate(view_product.product.date_end)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Описание</td><td>{{view_product.product.description}}</td></tr></tbody></table></div></div></div><div id=service class=\"tab-pane fade\"><hr><ul class=list-group><li ng-repeat=\"service in view_product.product.services\" class=list-group-item>{{$index + 1}}. {{service.name}}</li></ul></div><div id=basefactor class=\"tab-pane fade\"><hr><div class=row><div class=col-md-12><table class=\"table table-striped\"><thead><tr class=row><th class=col-md-4>Страны</th><th class=col-md-2>Сумма страховки</th><th class=col-md-2>Интервал</th><th class=col-md-2>Цена за день</th><th class=col-md-2>Цена</th></tr></thead><tbody><tr ng-repeat=\"basefactor in view_product.product.basefactors\" class=row><td class=col-md-4><span ng-repeat=\"country in basefactor.countries\"><span style=\"color: red\">{{country.name[0]}}</span><span>{{country.name.substring(1)}}</span><br ng-if=\"($index + 1)%4 == 0\"></span></td><td class=col-md-2>{{basefactor.insurance_amount}}</td><td class=col-md-2>{{basefactor.interval.from_day}} - {{basefactor.interval.to_day}}</td><td class=col-md-2>{{basefactor.is_per_day}}</td><td class=col-md-2>{{basefactor.base_price}}</td></tr></tbody></table></div></div></div><div id=factor class=\"tab-pane fade\"><hr><table class=\"table table-striped\"><thead><tr class=row><th class=col-md-3>Фактор</th><th class=col-md-1>Коэффицент</th><th class=col-md-2>Тип коэффицента</th><th class=col-md-6>Значения</th></tr></thead><tbody><tr ng-repeat=\"factor in view_product.product.factors\" class=row><td class=col-md-3>{{factor.factor.name}}</td><td class=col-md-1>{{factor.coefficient}}</td><td class=col-md-2>{{factor.coefficient_type}}</td><td class=col-md-6><span ng-repeat=\"value in factor.values\"><span ng-if=\"factor.factor.usage != \'age\'\">{{$index + 1}}).</span><span> {{value}}</span><br ng-if=\"($index + 1)%4 == 0\"></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/profile/edit.html","<!--Created by troy on 09.09.2016.--><div ng-controller=\"ProfileEditController as profile\" class=container><div class=ln_solid></div><div class=\"row-striped row-v-padding\"><div class=col-md-4><div class=row><h4><b>Основная информация</b></h4></div><div class=row><label>Эта информация будет видна в вашем профиле</label></div></div><div class=col-md-8><div class=row><div class=form-group><label>Фамилия</label><input ng-model=profile.profile.data.surname type=text placeholder=\"Введите Фамилию\" class=form-control></div></div><div class=row><div class=form-group><label>Имя</label><input ng-model=profile.profile.data.name type=text placeholder=\"Введите Имя\" class=form-control></div></div><div class=row><div class=form-group><label>Отчество</label><input ng-model=profile.profile.data.middleName type=text placeholder=\"Введите Отчество\" class=form-control></div></div><div class=row><div class=form-group><label>Адрес</label><input ng-model=profile.profile.data.address type=text placeholder=\"Введите Адрес\" class=form-control></div></div><div class=row><div class=form-group><label>Дата рждения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy ng-model=profile.profile.data.birthDate is-open=profile.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=row><div class=form-group><label>Телефон</label><div class=input-group><input ng-model=profile.tempPhone type=text placeholder=\"Введите Телефон и нажмите знак плюса справа\" class=form-control><span class=input-group-btn><button type=button ng-click=profile.addPhone() class=\"btn btn-success\"><span class=\"glyphicon glyphicon-plus\"></span></button></span></div><div ng-repeat=\"x in profile.profile.data.phones\" class=input-group><span class=input-group-addon>{{($index+1) + \' \'}}</span> <input type=text value={{x}} readonly class=form-control><span class=input-group-btn><button type=button ng-click=profile.deletePhone($index) class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove\"></span></button></span></div></div></div><div class=\"row pull-right\"><button ng-click=profile.putData() type=button class=\"btn btn-primary btn-sm\">Сохранить</button></div></div></div></div>");
$templateCache.put("app/profile/profile.html","<!--\nCreated by troy on 13.09.2016.\n\n--><ui-view></ui-view>");
$templateCache.put("app/profile/view.html","<!--Created by troy on 09.09.2016.\n--><div ng-controller=\"ProfileViewController as profile\" class=container><div class=ln_solid></div><div class=\"row-striped row-v-padding\"><div class=col-md-5><h3>Авторизация</h3><div class=\"well well-sm\"><div class=row><!--.col-md-4--><!--  h1 Picture--><div class=col-md-12><div class=form-group><div class=input-group><input ng-model=profile.profile.username type=text placeholder=\"Имя пользователя\" disabled class=form-control><span class=input-group-btn><button type=button ng-click=profile.changeUsername() class=\"btn btn-secondary\"><span class=\"glyphicon glyphicon-pencil\"></span></button></span></div></div><div class=form-group><div class=input-group><input ng-model=profile.profile.email type=text placeholder=Email disabled class=form-control><span class=input-group-btn><button type=button ng-click=profile.changeEmail() class=\"btn btn-secondary\"><span class=\"glyphicon glyphicon-pencil\"></span></button></span></div></div><button type=button ng-click=profile.changePassword() class=\"btn btn-primary btn-sm\">Изменить Пароль</button></div><div class=col-md-6></div></div></div></div><div class=col-md-7><h3>Личные данные</h3><div class=\"well well-sm\"><div class=row><div class=col-md-12><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Фамилия</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.surname></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Имя</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.name></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Отчество</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.middleName></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Адрес</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.address></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Дата рждения</b></h5><div class=col-md-8><h5 ng-bind=\"profile.profile.data.birthDate | date:\'dd-MM-yyyy\'\"></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Телефон</b></h5><div class=col-md-8><h5><span ng-repeat=\"x in profile.profile.data.phones\"><span ng-if=$index&gt;0>{{\" \"+\"; \"}}</span><span>{{x}}</span></span></h5></div></div></div><div class=ln_solid></div><div class=row><button type=button ui-sref=app.profile.edit class=\"btn btn-primary btn-sm pull-right\">Изменить</button></div></div></div></div></div></div><div class=ln_solid><script type=text/ng-template id=changePassword.html><form ng-submit=\"$ctrl.passwordSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение пароля</h3>\n          <pre>{{$ctrl.password|json}}</pre>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Текущий пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" minlength=\"3\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Новый пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.newPswd\" type=\"password\" minlength=\"6\" id=\"inputPassword\" placeholder=\"Минимум 6 символов\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Подтверждение</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.confirmPswd\" type=\"password\" id=\"inputPasswordConfirm\" data-match=\"#inputPassword\" data-match-error=\"Пароль не подтвержден\" required class=\"form-control\">\n                <h5 style=\"color:red;\" ng-if=\"($ctrl.password.confirmPswd.length &gt;5)&amp;&amp;($ctrl.password.confirmPswd!=$ctrl.password.newPswd)\">Пароль не прдтвержден</h5>\n              </div>\n            </div>\n          </div>\n          <div class=\"ln_solid\"></div>\n          <div class=\"row pull-right\"></div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script><script type=text/ng-template id=changeUsername.html><form ng-submit=\"$ctrl.usernameSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение имени пользователя</h3>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-4\"><b>Пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-4\"><b>Имя пользователя</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.username\" type=\"text\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script><script type=text/ng-template id=changeEmail.html><form ng-submit=\"$ctrl.emailSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение E-mail\'a</h3>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Email</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.email\" type=\"email\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script></div></div>");
$templateCache.put("app/report/report.html","<div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=row><col-responsive stock-dict=report.report_categories dict-table=ReportCategories><div class=form-group><label>Категория</label><ui-select ng-model=report.report_category_id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in report.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Отчет</label><ui-select ng-model=report.selected_report><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"report in report.reports|filter:{name:$select.search}\">{{report.name}}</ui-select-choices></ui-select></div></col-responsive></div><div id=reportViewer></div></div></div></div>");
$templateCache.put("app/report/reporta.html","<div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Документы</h3></div><div class=\"box-body pad table-responsive\"><div class=row><col-responsive><div class=form-group><label>Категория</label><ui-select ng-model=reporta.search.report_category_id on-select=reporta.getReportList()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in reporta.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Отчет</label><ui-select ng-model=reporta.selected_report on-select=reporta.setSelected($select.selected)><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"reporta in reporta.reports|filter:{name:$select.search}\">{{reporta.name}}</ui-select-choices></ui-select></div></col-responsive></div><div id=viewerContent></div><div id=designerContent></div></div></div></div></div></div>");
$templateCache.put("app/report_template/query_edit.html","<form ng-submit=edit.save()><div class=modal-header><h3>Запрос</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.query.code ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.query.name ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Ключ возврата</label><input type=text ng-model=edit.query.result_key ng-required=true class=form-control></div></col-responsive></div><div class=form-group><label>Запрос</label><textarea rows=10 ng-required=true ng-model=edit.query.query class=form-control></textarea></div></div><div class=modal-footer><button ng-disabled=edit.saving type=button ng-click=edit.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=edit.saving type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/report_template/report_template.html","<div class=content><div class=row><div class=\"col-md-12 col-lg-12 col-xs-12\"><panel title=\"Шаблоны отчетов\"><div class=form-group><button ng-click=report_template.newTemplate() class=\"btn btn-primary\">Новый шаблон</button> <button ng-click=report_template.editTemplate() ng-disabled=!report_template.selected_template class=\"btn btn-default\">Редактировать</button> <button ng-click=report_template.getTemplates() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><paged-table options=report_template.gridOptions disable-paging=true disable-search=true></paged-table></panel><div class=ln_solid></div><panel title=\"Запросы отчетов\"><div class=form-group><button ng-click=report_template.newQuery() class=\"btn btn-primary\">Новый запрос</button> <button ng-click=report_template.editQuery() ng-disabled=!report_template.selected_query class=\"btn btn-default\">Редактировать</button> <button ng-click=report_template.getQueries() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><paged-table options=report_template.queriesGridOptions disable-paging=true disable-search=true></paged-table></panel></div></div></div>");
$templateCache.put("app/report_template/template_edit.html","<form ng-submit=edit.save()><div class=modal-header><h3>Шаблон отчета</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.template.code ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.template.name ng-required=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.report_categories dict-table=DirReportCategories><div class=form-group><label>Категория</label><ui-select ng-model=edit.template.report_category_id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in edit.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=form-group><label>Шаблон</label><textarea rows=10 ng-required=true ng-model=edit.template.template class=form-control></textarea></div></div><div class=modal-footer><button ng-disabled=edit.saving type=button ng-click=edit.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=edit.saving type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/reportperiod/reportperiod.html","<div class=content><div class=row><div class=col-md-12><panel title=\"Фильтр полисов\"><form><div class=row><!--pre {{reportperiod.filter | json}}--><col-responsive ng-if=\"reportperiod.company.company_type != \'agent\'\"><div class=form-group><label>Агенты:</label><ui-select ng-model=reportperiod.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true placeholder=\"Все полисы\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in reportperiod.agents | filter: $select.search\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=reportperiod.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=reportperiod.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=reportperiod.date_start ng-model=reportperiod.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=margin></div><button type=button ng-click=reportperiod.getPolicies() class=\"btn btn-primary btn-sm\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=reportperiod.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-click=reportperiod.downloadPDFRPA() class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет</button> <button type=button ng-click=reportperiod.downloadExcelRPA() ng-disabled=!reportperiod.agent_id class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Excel</button> <button type=button ng-click=reportperiod.downloadPDFRPAP() ng-disabled=\"reportperiod.company.company_type!=\'agent\' &amp;&amp; reportperiod.company._id == reportperiod.filter.agent_id \" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения</button> <button type=button ng-click=reportperiod.downloadExcelRPAP() ng-disabled=!reportperiod.agent_id class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения Excel</button></form><div class=margin></div><paged-table options=reportperiod.policiesGridOptions disable-search=true height=700></paged-table></panel></div></div></div>");
$templateCache.put("app/reporttehnika/reporttehnika.html","<!--\nCreated by Aibek on 15/06/16.\n\n--><div class=content><div class=row><div class=col-md-12><panel title=\"Фильтр полисов\"><form><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=reporttehnika.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=reporttehnika.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=reporttehnika.date_start ng-model=reporttehnika.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><button type=button ng-click=reporttehnika.getEquipments() class=\"btn btn-primary btn-sm\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=reporttehnika.getEquipments() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><!--button.btn.btn-default.btn-xs(type=\'button\' ng-click=\"reporttehnika.downloadPDFRPA()\")--><!--  i.fa.fa-print(aria-hidden=\'true\')--><!--  |   Отчет--></form><div class=margin></div><paged-table options=reporttehnika.policiesGridOptions disable-search=true height=700></paged-table></panel></div></div></div>");
$templateCache.put("app/role/edit.html","<!--\nCreated by Aibek on 25/08/16.\n\n--><form ng-submit=role.saveRole()><div class=modal-header><h3>Роль</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=role.role.name ng-required=true ng-trim=true class=form-control></div><div class=form-group><label>Имя роли для одобрения</label><input type=text ng-model=role.role.data.approval_name ng-required=true ng-trim=true class=form-control></div><div class=form-group><label>Тип</label><input type=text ng-model=role.role.data.type ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><label>Права</label><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.read disabled><span>&nbsp;Чтение</span></label></div><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.write><span>&nbsp;Редактирование</span></label></div><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.delete><span>&nbsp;Удаление</span></label></div></col-responsive><col-responsive><div class=form-group><label>Меню</label><ui-select ng-model=role.role.menus_id multiple><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"menu._id as menu in role.menus | filter: $select.search\" group-by=role.menuParentGroup>{{menu.name}}</ui-select-choices></ui-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=\"role.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"role.saving===true\" type=button ng-click=role.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/role/role.html","<!--\nCreated by Aibek on 10/06/16.\n\n--><div class=content><div class=row><div class=col-md-12><panel title=Роли><button ng-click=role.newRole() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!role.selected_role ng-click=role.editRole() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=role.removeRole() ng-disabled=!role.selected_role class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=role.getRoles() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=role.rolesGridOptions disable-search=true disable-paging=true></paged-table></panel></div></div></div>");
$templateCache.put("app/tehnika/create.html","<div class=content><div class=row><div class=col-md-12><panel title=\"Создание полиса\"><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input ng-model=create.policy.client ng-trim=true type=text class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Модель, Марка</label><input ng-model=create.policy.model ng-trim=true type=text class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Идентификационный номер</label><input ng-model=create.policy.data.id_number ng-trim=true type=text class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Стоимость</label><input ng-model=create.policy.price ng-trim=true type=number allow-clear=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><ui-select ng-model=create.policy.sum><ui-select-match allow-clear=true><span ng-bind=$select.selected.summ></span></ui-select-match><ui-select-choices repeat=\"currency.summ as currency in create.insure_sum | filter:{name:$select.search}\"><span ng-bind=currency.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input ng-model=create.policy.premium ng-trim=true type=number ng-disabled=true class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label for=middle-name class=control-label>Начало</label><div class=\"input-group no-margin\"><input id=middle-name type=text ng-disabled=true min-date=create.today max-date=create.policy.period.end uib-datepicker-popup=dd-MM-yyyy ng-click=\"create.popup_delivery_date.opened=true\" ng-model=create.policy.period.start is-open=create.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"create.popup_delivery_date.opened=true\" ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label for=middle-name2 class=control-label>Конец</label><div class=\"input-group no-margin\"><input id=middle-name2 ng-disabled=true type=text uib-datepicker-popup=dd-MM-yyyy min-date=create.policy.period.start ng-click=\"create.popup_delivery_date.opened1=true\" ng-model=create.policy.period.end is-open=create.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"create.popup_delivery_date.opened1=true\" ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Дата выписки</label><div class=input-group><input type=text ng-model=create.policy.data.created uib-datepicker-popup=dd-MM-yyyy is-open=create.datepicker.start ng-disabled=true class=form-control><div class=input-group-btn><button type=button ng-click=\"create.datepicker.start=true\" ng-disabled=true class=\"btn btn-default\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>ФИО продавца</label><input ng-model=create.policy.employee_id ng-trim=true type=text ng-disabled=true class=form-control></div></col-responsive></div><div class=ln_solid></div><div class=row><button ng-disabled=create.saving type=button ui-sref=app.tehnika.list class=\"btn btn-warning btn-sm pull-right\">Отмена</button> <button ng-disabled=create.saving type=button ng-click=create.putPolicy() class=\"btn btn-primary btn-sm pull-right\">Сохранить</button></div></panel></div></div></div>");
$templateCache.put("app/tehnika/edit.html","");
$templateCache.put("app/tehnika/list.html","<!--\nCreated by ilias on 14.04.17.\n\n--><div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Техника</h3></div><div class=\"box-body pad table-responsive\"><form ng-submit=list.getEquipments()><div uib-collapse=!list.filter class=row><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.status ng-required=true class=form-control><ui-select-match allow-clear=true placeholder=\"Все статусы\">{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses | filter:{name:$select.search}\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.list_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.name placeholder=\" Введите ФИО\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter=list.filter ? null : {}\" class=\"btn btn-default\">{{list.filter ? \'Скрыть\':\'Показать\'}} фильтры</button> <button type=button ng-show=list.filter ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button type=button ng-click=list.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!list.selected_list\' ng-click=\'list.editBranch()\')--> <button ng-click=list.goToShow() ng-disabled=!list.selected_equipment class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'list.delete()\' ng-disabled=\"!list.selected_list\")--> <button ng-click=list.confirmAction() ng-disabled=\"!list.selected_equipment || list.selected_equipment.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_equipment || list.selected_equipment.list_no == \'00000\' || (list.selected_equipment.status != \'Оформлен\' &amp;&amp; list.selected_equipment.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getEquipments() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=list.equipmentsGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/tehnika/prev.html","<!--\nCreated by ilias on 14.04.17.\n\n--><div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Техника</h3></div><div class=\"box-body pad table-responsive\"><form ng-submit=prev.getEquipments()><div uib-collapse=!prev.filter class=row><col-responsive stock-dict=prev.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=prev.filter.status ng-required=true class=form-control><ui-select-match allow-clear=true placeholder=\"Все статусы\">{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in prev.policy_statuses | filter:{name:$select.search}\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=prev.filter.list_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=prev.filter.name placeholder=\" Введите ФИО\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"prev.filter=prev.filter ? null : {}\" class=\"btn btn-default\">{{prev.filter ? \'Скрыть\':\'Показать\'}} фильтры</button> <button type=button ng-show=prev.filter ng-click=\"prev.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button ng-click=prev.goToShow() ng-disabled=!prev.selected_equipment class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=prev.downloadPDF() ng-disabled=\"!prev.selected_equipment || prev.selected_equipment.list_no == \'00000\' || (prev.selected_equipment.status != \'Оформлен\' &amp;&amp; prev.selected_equipment.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=prev.getEquipments() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=prev.equipmentsGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/tehnika/show.html","<!--\nCreated by ilias on 06.06.2017.\n\n--><div class=content><div class=row><div class=col-md-12><panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=row><col-responsive><div class=form-group><h4 style=display:inline-block><span>Номер полиса:<span>{{show.policy.policy_no}}</span></span></h4></div></col-responsive><col-responsive><h5>ФИО Клиента:<span class=text-info> {{show.policy.client}}</span></h5></col-responsive><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><h5>Продукт:<span class=text-info> {{show.policy.model}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Идентификационный номер:<span class=text-info> {{show.policy.data.id_number}}</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>Начало :<span class=text-info> {{show.policy.period.start|date:\'dd-MM-yyyy\'}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Конец :<span class=text-info> {{show.policy.period.end|date:\'dd-MM-yyyy\'}}</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>Стоимость:<span class=text-info> {{show.policy.price}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая сумма :<span class=text-info> {{show.policy.sum}} {{show.currency_name}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая премия :<span class=text-info> {{show.policy.premium}} {{show.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>ФИО Продавца:<span class=text-info> {{show.policy.employee_id}}</span></h5></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=col-md-12><button type=button ui-sref=app.tehnika.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"show.confirmAction()\" ng-if=\"show.policy.status && show.policy.status == \'Оформлен\'\" ng-disabled=\"!show.policy.status || show.policy.status != \'Оформлен\'\")--><!--  i.fa.fa-scissors(aria-hidden=\'true\')--><!--  |   Испортить--><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"show.confirmActionTerm()\" ng-if=\"show.policy.status && show.policy.status == \'Оформлен\'\" ng-disabled=\"!show.policy.status || show.policy.status != \'Оформлен\'\")--><!--  i.fa.fa-thumbs-o-down(aria-hidden=\'true\')--><!--  |   Расторгнуть--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.goToForm()\" ng-if=\"show.policy.status != \'Истек\' && show.policy.status != \'Оформлен\' && show.policy.status != \'Испорчен\' && show.policy.status != \'Расторгнут\'\" ng-disabled=\"show.policy.status == \'Оформлен\' || show.policy.status == \'Испорчен\'|| show.policy.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil(aria-hidden=\'true\')--><!--  |   Изменить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"show.confirmActionForm()\" ng-if=\"show.policy.status != \'Истек\' && show.policy.status != \'Оформлен\' && show.policy.status != \'Испорчен\' && show.policy.status != \'Расторгнут\'\" ng-disabled=\"show.policy.status == \'Оформлен\' || show.policy.status == \'Испорчен\'|| show.policy.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil-square-o(aria-hidden=\'true\')--><!--  |   Выдать--></div></div></div></panel></div></div></div>");
$templateCache.put("app/tehnika/slide.html","<!--\nCreated by ilias on 06.06.2017.\n\n--><div class=content><div class=row><div class=col-md-12><panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"slide.policy.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"slide.policy.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"slide.policy.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"slide.policy.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"slide.policy.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=row><col-responsive><div class=form-group><h4 style=display:inline-block><span>Номер полиса:<span>{{slide.policy.policy_no}}</span></span></h4></div></col-responsive><col-responsive><h5>ФИО Клиента:<span class=text-info> {{slide.policy.client}}</span></h5></col-responsive><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><h5>Продукт:<span class=text-info> {{slide.policy.model}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Идентификационный номер:<span class=text-info> {{slide.policy.data.id_number}}</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>Начало :<span class=text-info> {{slide.policy.period.start|date:\'dd-MM-yyyy\'}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Конец :<span class=text-info> {{slide.policy.period.end|date:\'dd-MM-yyyy\'}}</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>Стоимость:<span class=text-info> {{slide.policy.price}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая сумма :<span class=text-info> {{slide.policy.sum}} {{slide.currency_name}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая премия :<span class=text-info> {{slide.policy.premium}} {{slide.currency_name}} / {{slide.policy.data.insurance_premium_kgs}} KGS</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>ФИО Продавца:<span class=text-info> {{slide.policy.employee_id}}</span></h5></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=col-md-12><button type=button ng-click=slide.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=slide.downloadPDF() ng-if=\"slide.policy.policy_no != \'00000\'\" ng-disabled=\"slide.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"slide.confirmAction()\" ng-if=\"slide.policy.status && slide.policy.status == \'Оформлен\'\" ng-disabled=\"!slide.policy.status || slide.policy.status != \'Оформлен\'\")--><!--  i.fa.fa-scissors(aria-hidden=\'true\')--><!--  |   Испортить--><!--button.btn.btn-danger.pull-right(type=\'button\' ng-click=\"slide.confirmActionTerm()\" ng-if=\"slide.policy.status && slide.policy.status == \'Оформлен\'\" ng-disabled=\"!slide.policy.status || slide.policy.status != \'Оформлен\'\")--><!--  i.fa.fa-thumbs-o-down(aria-hidden=\'true\')--><!--  |   Расторгнуть--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"slide.goToForm()\" ng-if=\"slide.policy.status != \'Истек\' && slide.policy.status != \'Оформлен\' && slide.policy.status != \'Испорчен\' && slide.policy.status != \'Расторгнут\'\" ng-disabled=\"slide.policy.status == \'Оформлен\' || slide.policy.status == \'Испорчен\'|| slide.policy.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil(aria-hidden=\'true\')--><!--  |   Изменить--><!--button.btn.btn-success.pull-right(type=\'button\' ng-click=\"slide.confirmActionForm()\" ng-if=\"slide.policy.status != \'Истек\' && slide.policy.status != \'Оформлен\' && slide.policy.status != \'Испорчен\' && slide.policy.status != \'Расторгнут\'\" ng-disabled=\"slide.policy.status == \'Оформлен\' || slide.policy.status == \'Испорчен\'|| slide.policy.status == \'Расторгнут\'\")--><!--  i.fa.fa-pencil-square-o(aria-hidden=\'true\')--><!--  |   Выдать--></div></div></div></panel></div></div></div>");
$templateCache.put("app/tehnika/view.html","<!--\nCreated by ilias on 14.04.17.\n\n--><div class=content><div class=row><div class=col-md-12><panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=row><col-responsive><div class=form-group><h4 style=display:inline-block><span>Номер полиса:<span>{{view.policy.policy_no}}</span></span></h4></div></col-responsive><col-responsive><h5>ФИО Клиента:<span class=text-info> {{view.policy.client}}</span></h5></col-responsive><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><col-responsive><div class=form-group><h5>Продукт:<span class=text-info> {{view.policy.model}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Начало :<span class=text-info> {{view.policy.period.start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=form-group><h5>Конец :<span class=text-info> {{view.policy.period.end|date:\'dd-MM-yyyy\'}}</span></h5></div></col-responsive><col-responsive></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>Идентификационный номер:<span class=text-info> {{view.policy.data.id_number}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Стоимость:<span class=text-info> {{view.policy.price}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая сумма :<span class=text-info> {{view.policy.sum}} {{view.currency_name}}</span></h5></div></col-responsive><col-responsive><div class=form-group><h5>Страховая премия :<span class=text-info> {{view.policy.premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS</span></h5></div></col-responsive></div><div class=row><col-responsive><div class=form-group><h5>ФИО Продавца:<span class=text-info> {{view.policy.employee_id}}</span></h5></div></col-responsive></div><div class=ln_solid></div><div class=row><div class=col-md-12><button type=button ng-click=view.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.status &amp;&amp; view.policy.status == \'Оформлен\'\" ng-disabled=\"!view.policy.status || view.policy.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.status &amp;&amp; view.policy.status == \'Оформлен\'\" ng-disabled=\"!view.policy.status || view.policy.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.status != \'Истек\' &amp;&amp; view.policy.status != \'Оформлен\' &amp;&amp; view.policy.status != \'Испорчен\' &amp;&amp; view.policy.status != \'Расторгнут\'\" ng-disabled=\"view.policy.status == \'Оформлен\' || view.policy.status == \'Испорчен\'|| view.policy.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.status != \'Истек\' &amp;&amp; view.policy.status != \'Оформлен\' &amp;&amp; view.policy.status != \'Испорчен\' &amp;&amp; view.policy.status != \'Расторгнут\'\" ng-disabled=\"view.policy.status == \'Оформлен\' || view.policy.status == \'Испорчен\'|| view.policy.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div></panel></div></div></div>");
$templateCache.put("app/templates/branch-multiple-select.html","<ui-select ng-model=branch.branches_id on-select=branch.toggleParent($item) close-on-select=false multiple remove-selected=false ng-disabled=branch.disabled><ui-select-match allow-clear=true placeholder={{placeholder}}>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item._id as item in branch.ordered_branches | filter:{name:$select.search}\"><span ng-style=\"{&quot;padding-left&quot;: (branch.parentCount(item)*8)+&quot;px&quot;}\"><span>{{item.name}}</span></span><span ng-show=branch.hasChild(item) class=\"fa fa-chevron-right pull-right\"></span></ui-select-choices></ui-select>");
$templateCache.put("app/templates/branch-select.html","<ui-select ng-model=branch.branch_id on-select=branch.toggleParent($item) ui-level-select close-on-select=false ng-disabled=branch.disabled><ui-select-match allow-clear=true placeholder={{placeholder}}>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item._id as item in branches | filter:{name:$select.search} | filter:branch.isVisible track by item._id\" group-by=branch.group group-filter=branch.groupFilter><span>{{item.name}}</span><span ng-show=branch.hasChild(item) class=\"fa fa-chevron-right pull-right\"></span></ui-select-choices></ui-select>");
$templateCache.put("app/templates/company-select.html","<!--\nCreated by Aibek on 26/08/16.\n\n--><div class=modal-header><h3>Выбрать компанию</h3></div><div class=modal-body><form ng-submit=company.searchCompanies() class=form-horizontal><div class=form-group><div class=input-group><input type=search ng-model=company.search_name placeholder=\"Найти по e-mail или наименовании\" class=form-control><div class=input-group-btn><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search\"></span></button></div></div></div></form><label ng-show=\"company.totalItems &gt; 0\">{{company.limit}} из {{company.totalItems}}</label><div ng-show=company.loading class=\"loading-spinner fadeIn fadeOut animated\"><div id=circularG><div id=circularG_1 class=circularG></div><div id=circularG_2 class=circularG></div><div id=circularG_3 class=circularG></div><div id=circularG_4 class=circularG></div><div id=circularG_5 class=circularG></div><div id=circularG_6 class=circularG></div><div id=circularG_7 class=circularG></div></div><div id=circularG_8 class=circularG></div></div><div class=list-group><a ng-click=\"company.selected_company = company_item\" ng-repeat=\"company_item in company.companies track by company_item._id\" ng-class=\"{active: company.selected_company == company_item}\" class=list-group-item><div class=media><div class=media-left><div class=media-object><img ng-src={{app.api}}{{company_item.data.image}} class=company-image-sm></div></div><div class=media-body><h4 class=media-heading>{{company_item.name}}</h4><span>{{company_item.email}}</span></div></div></a></div><nav aria-label=\"Страничная навигация\" ng-show=\"company.pages.length &gt; 0\"><ul class=\"pagination pagination-sm\"><li><a ng-click=company.previousPage() aria-label=Назад><span aria-hidden=true>«</span></a></li><li ng-repeat=\"page in company.pages\" ng-class=\"{active: page==company.page}\"><a ng-click=company.toPage(page)>{{page}}</a></li><li><a ng-click=company.nextPage() aria-label=Далее><span aria-hidden=true>»</span></a></li></ul></nav></div><div class=modal-footer><button type=button ng-click=company.cancel() class=\"btn btn-default\">Отмена</button> <button ng-disabled=!company.selected_company ng-click=company.selectCompany() class=\"btn btn-primary\">Принять</button></div>");
$templateCache.put("app/templates/confirm-modal.html","<div ng-if=confirm.title class=modal-header><h4>{{confirm.title}}</h4></div><div class=modal-body><div ng-show=confirm.description ng-class=confirm.options.classes.description>{{confirm.description}}</div><div ng-if=confirm.options.comment class=form-group><label>Комментарий</label><textarea rows=10 ng-model=confirm.comment class=form-control></textarea></div></div><div class=modal-footer><button type=button ng-click=confirm.cancel() class=\"btn btn-sm btn-default\">Отмена</button> <button type=button ng-class=confirm.options.classes.ok_btn ng-click=confirm.ok() class=\"btn btn-sm btn-primary\">Принять</button></div>");
$templateCache.put("app/trip/list.html","<!--\nCreated by ilias on 14.04.17.\n\n--><div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-header><h3 class=box-title>Прокат самокатов</h3></div><div class=\"box-body pad table-responsive\"><form ng-submit=list.getEquipments()><div uib-collapse=!list.filter class=row><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.status ng-required=true class=form-control><ui-select-match allow-clear=true placeholder=\"Все статусы\">{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses | filter:{name:$select.search}\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.list_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.name placeholder=\" Введите ФИО\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter=list.filter ? null : {}\" class=\"btn btn-default\">{{list.filter ? \'Скрыть\':\'Показать\'}} фильтры</button> <button type=button ng-show=list.filter ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=margin></div><button type=button ng-click=list.getEquipments() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=margin></div><paged-table options=list.equipmentsGridOptions disable-search=true></paged-table></div></div></div></div></div>");
$templateCache.put("app/users/create.html","<!--\nCreated by troy on 15.11.2016.\n\n--><form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/users/edit.html","<!--\nCreated by Aibek on 25/08/16.\n\n--><form ng-submit=user.updateUser()><div class=modal-header><h3>Пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div stock-dict=user.roles dict-table=Roles class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Роли</label><ui-select ng-model=user.user.roles_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.roles\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/users/users.html","<!--\nCreated by Aibek on 13/06/16.\n\n--><div class=content><div class=row><div class=col-md-12><div class=\"box box-danger\"><div class=box-box><h3 class=box-title>Пользователи</h3></div><div class=\"box-body pad table-responsive\"><form ng-submit=users.getUsers()><div class=row><col-responsive><div class=form-group><label>Логин:</label><input type=text ng-model=users.filter.username placeholder=\" Введите логин\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Email:</label><input type=text ng-model=users.filter.email placeholder=\"Введите email\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Фамилия:</label><input type=text ng-model=users.filter.data.surname placeholder=\"Введите фамилию\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Имя:</label><input type=text ng-model=users.filter.data.name placeholder=\"Введите имя\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Отчество:</label><input type=text ng-model=users.filter.data.patronymic placeholder=\"Введите отчество\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"users.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button> <button ng-click=users.newUser() class=\"btn btn-primary btn-sm\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!product.selected_product\' ng-click=\'product.editProduct()\')--> <button ng-click=users.editUser() ng-disabled=\"users.selected_user == null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=users.removeUser(users.selected_user) ng-disabled=\"users.selected_user == null\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=product.getProducts() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><div class=margin></div><paged-table options=users.usersGridOptions disable-search=true></paged-table></form></div></div></div></div></div>");
$templateCache.put("app/components/fileLoad/file-link.html","<a ng-href={{file_link}} target=_blank>{{file_name}}</a>");
$templateCache.put("app/components/fileLoad/file-load.html","<div class=file-load><div class=\"bdr bdr-v\"><div class=bdr-h></div></div><div tabindex=0 flow-init flow-object=file.flow class=file-content><div class=file-thumbnail><img ng-src=assets/images/pdf_icon.svg></div><div class=file-opt><div class=file-icon><span class=\"glyphicon glyphicon-file\"></span></div><div class=file-info><div ng-repeat=\"file_item in $flow.files | limitTo: 1\"><uib-progressbar max=file_item.size value=file_item.sizeUploaded() ng-class=\"{active: file_item.isUploading(), success: file_item.isComplete()}\" class=progress-xs></uib-progressbar><div><div class=file-name><span>{{file_item.name}}</span></div><div class=file-size><span>{{file_item.size|fileSize}}</span></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn ng-hide=file.isUploading() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span></button> <button type=button uib-tooltip=Отмена tooltip-append-to-body=true ng-click=file_item.cancel() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove\"></span></button> <button type=button uib-tooltip=Повторить tooltip-append-to-body=true ng-click=file_item.retry() ng-show=file_item.error class=\"btn btn-warning\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></div></div><div ng-if=\"$flow.files.length==0 &amp;&amp; file.file\"><div><div class=file-name><span>{{file.file.name}}</span></div><div class=file-size><span>{{file.file.size|fileSize}}</span></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span></button><a href=\"{{file.api + fileSrc}}\" target=_blank uib-tooltip=Скачать tooltip-append-to-body=true class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-download-alt\"></span></a> <button type=button uib-tooltip=Удалить tooltip-append-to-body=true ng-click=file.rmFile() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div></div><div ng-if=\"$flow.files.length==0 &amp;&amp; !file.file\"><div><div class=file-name><span>Выберите файл</span></div><div class=file-size></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span> Выбрать</button></div></div></div></div></div></div></div>");
$templateCache.put("app/dictionary/assistance/edit.html","<!--Created by Aibek on 25/08/16.\n--><div ng-controller=\"AssistanceController as assistance1\" class=content><form ng-submit=assistance1.createEmployee()><div class=\"bs-callout bs-callout-info text-info\"></div><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основные данные</a></li><li><a data-toggle=tab data-target=#menu1>Дополнительные</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Официальное имя</label><input type=text ng-model=edit.dictionary.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Краткое имя</label><input type=text ng-model=edit.dictionary.data.name_short ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=assistance1.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=assistance1.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in edit.dictionary.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=assistance1.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=text ng-model=assistance1.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=assistance1.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in edit.dictionary.data.email\" class=list-group-item><label>{{x}}</label><a ng-click=assistance1.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=assistance1.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=assistance1.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in edit.dictionary.data.website\" class=list-group-item><label>{{x}}</label><a ng-click=assistance1.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=text ng-model=assistance1.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=assistance1.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in edit.dictionary.data.phone\" class=list-group-item><label>{{x}}</label><a ng-click=assistance1.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Менеджер</label><input type=text ng-model=edit.dictionary.data.manager ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Оценка</label><input type=number ng-model=edit.dictionary.data.rating ng-trim=true class=form-control></div></div><div stock-dict=assistance1.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;} class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Статус</label><ui-select ng-model=edit.dictionary.assistance_status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in assistance1.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Тип</label><input type=text ng-model=edit.dictionary.assistance_type ng-trim=true class=form-control></div></div><div stock-dict=assistance1.countries dict-table=Countries class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Территория</label><ui-select ng-model=edit.dictionary.data.territory ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type in assistance1.countries\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Логотип</label><div class=input-group><input type=text ng-model=branch.branch.name ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></div><div stock-dict=assistance1.services dict-table=Services class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Сервисы</label><ui-select ng-model=edit.dictionary.services_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in assistance1.services track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Описание</label><textarea rows=5 ng-model=edit.dictionary.data.description ng-trim=true class=form-control></textarea></div></div></div></div></div></form></div>");
$templateCache.put("app/dictionary/assistance/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/countries/edit.html","<div ng-controller=\"CountriesController as countries\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Название(Англ)</label><input type=text ng-model=edit.dictionary.data.name_eng ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=countries.regions dict-table=Enums dict-filter={name:&quot;regions&quot;}><div class=form-group><label>Регион</label><ui-select ng-model=edit.dictionary.region ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in countries.regions track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=countries.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=edit.dictionary.currency_id ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in countries.currencies track by type._id\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сраховая сумма при въезде</label><input type=number ng-model=edit.dictionary.min_insurance ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/countries/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/currencies/edit.html","<div ng-controller=\"CurrencyController as currency\" class=row><div class=\"col col-md-4\"><div class=form-group><label>Государство</label><input type=text ng-model=edit.dictionary.data.country class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Намименование</label><input type=text ng-model=edit.dictionary.name ng-required=true class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Знак</label><input type=text ng-model=edit.dictionary.data.symbol class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label for=code>Код</label><input id=code type=text ng-model=edit.dictionary.data.code class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label for=short_name>Короткое название</label><input id=short_name type=text ng-model=edit.dictionary.data.short_name class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Намименование (ISO 4217)</label><input type=text ng-model=edit.dictionary.data.name class=form-control></div></div></div>");
$templateCache.put("app/dictionary/currencies/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/dirreportcategories/edit.html","<div ng-controller=\"DirReportCategoriesController as category\" class=row><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in category.dirReportCategories | filter: {name:$select.search} track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></div></div>");
$templateCache.put("app/dictionary/enums/edit.html","<div ng-controller=\"EnumController as enum\" class=row><col-responsive><div class=form-group><label>Тип</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.data.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Ключ</label><input type=text ng-model=edit.dictionary.data.key ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/enums/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/factors/edit.html","<div ng-controller=\"FactorsController as factors\" class=content><div class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Название EN</label><input type=text ng-model=edit.dictionary.data.name_en ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=factors.parents dict-table=Factors><div class=form-group><label>Родитель</label><ui-select ng-model=edit.dictionary.parent_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in factors.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Использование</label><input type=text ng-model=edit.dictionary.usage ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=factors.factor_types1 dict-table=Enums dict-filter={name:&quot;factor_type&quot;}><div class=form-group><label>Тип</label><ui-select ng-model=edit.dictionary.factor_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in factors.factor_types1 track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=factors.insurancetypes dict-table=InsuranceTypes><div class=form-group><label>Тип страхования</label><ui-select ng-model=edit.dictionary.insurance_type_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in factors.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=factors.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=edit.dictionary.factor_status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in factors.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Комапания</label><div class=input-group><input type=text ng-disabled=true class=form-control><div class=input-group-btn><button type=button class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></div></div></div></col-responsive><col-responsive><div class=form-group><label>Описание</label><textarea type=text ng-model=edit.dictionary.description rows=5 ng-trim=true class=form-control></textarea></div></col-responsive></div><div class=row><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Значение</label><div class=input-group><input type=text ng-model=factors.value ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=factors.addValue() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><h2>Список значений</h2><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in edit.dictionary.values\" class=list-group-item><label>{{x}}</label><a ng-click=factors.deleteValue($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div>");
$templateCache.put("app/dictionary/factors/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/industries/edit.html","<div ng-controller=\"IndustryController as industry\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.industries dict-table=Industries dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родетельская индустрия</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (edit.industries | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive ng-show=\"app.ua.role&gt;=10\"><div class=form-group><label>Основная индустрия</label><input type=number ng-model=edit.dictionary.data.base_industry class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/industries/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insuranceprogramme/edit.html","<div class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/insuranceprogramme/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insurancetypes/edit.html","<div ng-controller=\"InsurancetypesController as insurancetypes\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Описание</label><input type=text ng-model=edit.dictionary.description ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.dictionary.code ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceTypes><div class=form-group><label>Родитель</label><ui-select ng-model=edit.dictionary.parent_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=insurancetypes.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=edit.dictionary.status class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in insurancetypes.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label><br><input type=checkbox ng-model=edit.dictionary.mandatory> Обязательное</label><label style=margin-left:10px><br><input type=checkbox ng-model=edit.dictionary.is_used> Используется</label></div></col-responsive></div>");
$templateCache.put("app/dictionary/insurancetypes/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/relativedegree/edit.html","<div class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/relativedegree/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reportcategories/edit.html","<div ng-controller=\"ReportCategoryController as category\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=category.categories dict-table=ReportCategories dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (category.categories | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/reportcategories/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/services/edit.html","<div ng-controller=\"ServiceController as service\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=service.insurancetypes dict-table=InsuranceTypes><div class=form-group><label>Тип страховки</label><ui-select ng-model=edit.dictionary.insurance_type_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in service.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=service.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=edit.dictionary.service_status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in service.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Описание</label><textarea type=text ng-model=edit.dictionary.data.description rows=5 ng-trim=true class=form-control></textarea></div></col-responsive></div>");
$templateCache.put("app/dictionary/services/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/clientcompany/edit.html","<div ng-controller=\"ClientCompanyController as clientcompany\"><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Адрес</label><input type=text ng-model=edit.dictionary.address ng-required=false ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/clientcompany/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirdiagnosis/edit.html","<div ng-controller=\"DirDiagnosisController as diagnosisa\"><!--pre {{edit.dictionary|json}}--><div class=row><div class=col-md-12><div class=form-group><label>Название диагноза</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-8><div class=form-group><label>Код диагноза</label><input type=text ng-model=edit.dictionary.code ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-8><div class=form-group><label>Код родителя</label><input type=text ng-model=edit.dictionary.parent_code ng-required=false ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirdiagnosis/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirdoctor/edit.html","<div ng-controller=\"DirDoctorController as doctor\"><div class=row><div class=col-md-12><div class=form-group><label>ФИО</label><input type=text ng-model=edit.dictionary.fullname ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Специальность</label><input type=text ng-model=edit.dictionary.speciality ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirdoctor/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirinsuranceprogramme/edit.html","<div ng-controller=\"DirInsuranceProgrammeController as insProgramme\"><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirinsuranceprogramme/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirorganization/edit.html","<div ng-controller=\"DirOrganizationController as organization\"><!--pre {{edit.dictionary|json}}--><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Адрес</label><input type=text ng-model=edit.dictionary.address ng-required=false ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirorganization/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirpolicyastatus/edit.html","<div ng-controller=\"DirPolicyaStatusController as producta\"><!--pre {{edit.dictionary|json}}--><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Код</label><input type=text ng-model=edit.dictionary.code ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Цвет</label><input type=text ng-model=edit.dictionary.color ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirpolicyastatus/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirproducta/edit.html","<div ng-controller=\"DirProductAController as producta\"><!--pre {{edit.dictionary|json}}--><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><!--.row--><!--  .col-md-12--><!--    .form-group--><!--      label Сумма лимит--><!--      input.form-control(type=\'number\' min=\"0\" ng-model=\'edit.dictionary.amount\' ng-required=\'true\' ng-trim=\'true\')--></div>");
$templateCache.put("app/dictionarya/dirproducta/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirrelativedegree/edit.html","<div ng-controller=\"DirRelativeDegreeController as relDegree\"><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirrelativedegree/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirreportcategories/edit.html","<div ng-controller=\"DirReportCategoriesController as category\" class=row><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in category.dirReportCategories | filter: {name:$select.search} track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></div></div>");
$templateCache.put("app/dictionarya/dirservice/edit.html","<div ng-controller=\"DirServiceController as servicea\"><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><!--.row--><!--  .col-md-12--><!--    .form-group--><!--      label Стоимость--><!--      input.form-control(type=\'number\' min=\"0\" ng-model=\'edit.dictionary.cost\' ng-required=\'true\' ng-trim=\'true\')--><div class=row><div class=col-md-12><div class=form-group><label>Категория</label><ui-select ng-model=edit.dictionary.category_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"categ._id as categ in servicea.dirServiceCategories track by categ.name\">{{categ.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div stock-dict=servicea.dirUnits class=col-md-12><div class=form-group><label>Ед. измерения</label><ui-select ng-model=edit.dictionary.unit_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in servicea.dirUnits track by unit.name\">{{unit.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Влияет на лимит</label><p>Да <input type=radio name=limitable ng-model=edit.dictionary.limitable ng-value=true class=flat></p><p>Нет <input type=radio name=limitable ng-model=edit.dictionary.limitable ng-value=false class=flat></p></div></div></div></div>");
$templateCache.put("app/dictionarya/dirservice/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirservicecategory/edit.html","<div ng-controller=\"DirServiceCategoryController as serviceCateg\"><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirservicecategory/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/dirunit/edit.html","<div ng-controller=\"DirUnitController as unit\"><!--pre {{edit.dictionary|json}}--><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-maxlength=25 ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/dirunit/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionarya/insurancecompany/edit.html","<div ng-controller=\"InsuranceCompanyController as insCompany\"><div class=row><div class=col-md-12><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Адрес</label><input type=text ng-model=edit.dictionary.address ng-required=true ng-trim=true class=form-control></div></div></div></div>");
$templateCache.put("app/dictionarya/insurancecompany/view.html","<pre>{{edit.dictionary|json:true}}</pre>");}]);